import { SvgIcon } from '@mui/material';

export function ProgressJourney(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 93.022,
    height: 74.937,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 93.022 74.937"
      {...rest}
      sx={rootSx}
    >
      <g
        id="progress_journey"
        data-name="progress journey"
        transform="translate(23)"
      >
        <path
          id="Path_6879"
          data-name="Path 6879"
          d="M.225,19.847s6.706.434,14.959.426,18.054-.459,18.054-.459S33.97,31.3,34,44.773s-.646,28.936-.646,28.936a148.71,148.71,0,0,1-16.335,1.067A161.358,161.358,0,0,1,.266,73.8S1.295,59.5,1.285,46.01.225,19.847.225,19.847Z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          id="Path_6880"
          data-name="Path 6880"
          d="M46.333,2.2A6.088,6.088,0,0,1,48.169.35a1.883,1.883,0,0,1,1.755.224S55.161-.62,58.417,2.34c1.879,1.708,2.706,4.441,3.4,6.751a9.6,9.6,0,0,0,1.49,2.81c1.307,1.436,3.031,1.8,4.106,4.284.381.879.137,4.562.47,5.474.554,1.515,1.767,3.418,1.943,4.856.239,1.959-2.013,5.007-1.857,6.111a5.187,5.187,0,0,0,.845,1.856c.016.086-.518.136-1.115-.181a5.026,5.026,0,0,1-1.047-.885l-24.682-12.4a6.326,6.326,0,0,1-.708-2.193c.087-1.059,1.047-1.9,1.7-4.728.184-.793-1.4-5.686-1.167-6.574a6.978,6.978,0,0,1,1.862-3.3A9.931,9.931,0,0,1,46.333,2.2Z"
          fillRule="evenodd"
        />
        <path
          id="Path_6881"
          data-name="Path 6881"
          d="M40.265,59.733,64.171,58.62A28.53,28.53,0,0,1,66.307,65a72.567,72.567,0,0,1,1.139,8.837,142.771,142.771,0,0,1-15.312,1.1,62.68,62.68,0,0,1-11.932-1.1s-.17-5.393-.155-8.918A50.027,50.027,0,0,1,40.265,59.733Z"
          fill="#3a6061"
          fillRule="evenodd"
        />
        <path
          id="Path_6882"
          data-name="Path 6882"
          d="M39.333,31.422s-1.582-.434-2.967-.7-2.576-.361-2.576-.361l-.216-5.183,2.6-3.756s2.978-.276,6.064-.272,6.28.287,6.28.287l12.149.23s2.122.169,3.888.5c2.014.372,3.712,1.076,3.837,4.208.054,1.347-1.313,4.791-1.313,4.791s-.537,2.2-1.223,4.675a121.414,121.414,0,0,0-2.916,12.038,10.948,10.948,0,0,0,.314,5.244c.381,1.563.835,3.617,1.061,4.433s-.685,1.257-.685,1.257a23.441,23.441,0,0,1-7.041,2.432,35.4,35.4,0,0,1-13.634-.473A5.513,5.513,0,0,1,40.143,59.4c-.509-.5-.363-1.242-.3-3.3.093-3.165.359-8.14.16-9.562-.328-2.34-1.3-5.762-1.32-7.828-.009-.964.4-3.147.47-3.981C39.54,29.8,39.333,31.422,39.333,31.422Z"
          fill="#ada0ec"
          fillRule="evenodd"
        />
        <path
          id="Path_6883"
          data-name="Path 6883"
          d="M45.8,6.343c.879-.9,3.4-1.372,5.035-.867.621.192.9,1.8,2.1,3.2A5.8,5.8,0,0,0,55.1,10.524a4.882,4.882,0,0,0,3.454-.429,1.705,1.705,0,0,1,1.518,1.751,2.863,2.863,0,0,1-1.708,2.4A19.619,19.619,0,0,0,58.6,19.83a2.485,2.485,0,0,0,2.077,1.956,12.087,12.087,0,0,1-2.73,2.606,9.909,9.909,0,0,1-4.99,1.787,4.552,4.552,0,0,1-3.37-1.459,6.492,6.492,0,0,1-1.221-3.1l1.6-.322-.047-1.173a2.571,2.571,0,0,1-1.7-.841A8.3,8.3,0,0,1,45.972,15.8c-.545-1.82-.342-3.021-.574-4.667C45.19,9.665,44.427,7.737,45.8,6.343Z"
          fill="#ffd7b5"
          fillRule="evenodd"
        />
        <path
          id="Path_6884"
          data-name="Path 6884"
          d="M26,16.638l1.528-.066,4.449.783s2.233,2.353,3.762,3.713A10.866,10.866,0,0,0,38.1,22.8a14.75,14.75,0,0,0-.965,1.869,17.208,17.208,0,0,0-.695,2.093,7.184,7.184,0,0,0-1.462-.975,3.657,3.657,0,0,0-1.393-.314l-.365-5.627-3.921.188a1.415,1.415,0,0,0-.253.752c.052.586.441,1.3.231,1.6-.391.559-1.1-.318-1.1-.318s-.262.773-.781.519a5.6,5.6,0,0,1-1.3-1.534s-.092,1.377-.671,1.119c-.464-.207-1.085-2.136-1.085-2.136s-.964.873-1.389.5c-.764-.667,2.243-2.781,2.243-2.781Z"
          fill="#ffd7b5"
          fillRule="evenodd"
        />
        <path
          id="Path_6885"
          data-name="Path 6885"
          d="M4.53,18.147c1.05-1.813,1.9-1.33,1.9-1.33l.786-.293.768.305s.433-.353.677-.281a9.878,9.878,0,0,1,3.158,1.527,17.806,17.806,0,0,1,1.445,2.152l-3.056.031-2.353.1A4.058,4.058,0,0,1,7.461,22c-.319.349-.884-.25-.884-.25s-.229.467-.5.5-.58-.376-.58-.376-.251.426-.532.314-.593-.762-.593-.762-.461.809-.8.492a3.122,3.122,0,0,1-.14-2.622C3.471,19.21,4.49,18.216,4.53,18.147Z"
          fill="#ffd7b5"
          fillRule="evenodd"
        />
        <path
          id="Path_6886"
          data-name="Path 6886"
          d="M29.662,19.468a2.5,2.5,0,0,1,.8.034l.5.3-1.524.059S29.372,19.535,29.662,19.468Z"
          fillRule="evenodd"
        />
        <path
          id="Path_6887"
          data-name="Path 6887"
          d="M9.635,23.316a7.467,7.467,0,0,1,4.949.078,7.779,7.779,0,0,1,3.507,2.4l-5.638,5.341L6.346,25.628A7.143,7.143,0,0,1,9.635,23.316Z"
          fill="#ffd071"
          fillRule="evenodd"
        />
        <path
          id="Path_6888"
          data-name="Path 6888"
          d="M4.387,31.014A7.993,7.993,0,0,1,6.345,25.66L12.3,31.184,6.956,36.119S4.375,33.633,4.387,31.014Z"
          fill="#9cd278"
          fillRule="evenodd"
        />
        <path
          id="Path_6889"
          data-name="Path 6889"
          d="M12.189,31.169,17.4,35.9a8.479,8.479,0,0,1-4.856,2.2c-2.6.062-5.56-1.955-5.56-1.955Z"
          fill="#a09de0"
          fillRule="evenodd"
        />
        <path
          id="Path_6890"
          data-name="Path 6890"
          d="M12.3,31.122l5.686-5.276a8.1,8.1,0,0,1,1.8,4.857c-.145,2.514-2.38,5.2-2.38,5.2Z"
          fill="#f37061"
          fillRule="evenodd"
        />
        <path
          id="Path_6891"
          data-name="Path 6891"
          d="M28.863,22.766a.687.687,0,0,1-.248-.048c-.664-.256-1.161-1.549-1.3-1.939a4.489,4.489,0,0,1,.416-2.539l.058-.16c.265-.744,1.174-.667,2.434-.56.193.016.4.034.608.049a.211.211,0,1,1-.031.421c-.214-.016-.418-.033-.613-.049-1.209-.1-1.847-.137-2,.28l-.058.162a4.364,4.364,0,0,0-.414,2.258c.257.736.681,1.542,1.049,1.684a.228.228,0,0,0,.2-.011c.258-.138.152-.535-.027-1.08a1.945,1.945,0,0,1-.157-.787,1.666,1.666,0,0,1,.741-1.181c.493-.208.987,0,1.613.274l.293.125a.21.21,0,0,1,.114.276.214.214,0,0,1-.279.113l-.3-.126c-.574-.247-.954-.41-1.276-.272a1.3,1.3,0,0,0-.486.851,1.94,1.94,0,0,0,.141.6c.175.534.414,1.266-.176,1.581A.662.662,0,0,1,28.863,22.766Z"
        />
        <path
          id="Path_6892"
          data-name="Path 6892"
          d="M38.075,23.094a.213.213,0,0,1-.111-.031,17.588,17.588,0,0,1-2.955-2.372c-.392-.388-.782-.808-1.159-1.213a7.971,7.971,0,0,0-2.127-1.9,16.066,16.066,0,0,0-2.069-.363l-.15-.019c-1.411-.183-2.424-.277-2.6.19-.658,1.7-.963,2.538-.725,3.092a6.244,6.244,0,0,0,1.17,1.88.263.263,0,0,0,.285.067.547.547,0,0,0,.241-.508.212.212,0,0,1,.213-.209h0a.212.212,0,0,1,.211.213.958.958,0,0,1-.488.886.683.683,0,0,1-.736-.127,6.689,6.689,0,0,1-1.289-2.037c-.3-.705,0-1.555.719-3.408.315-.813,1.586-.648,3.058-.457l.149.019a16.374,16.374,0,0,1,2.129.375,7.485,7.485,0,0,1,2.327,2.024c.374.4.761.819,1.146,1.2a17.514,17.514,0,0,0,2.875,2.31.21.21,0,0,1,.071.29A.212.212,0,0,1,38.075,23.094Z"
        />
        <path
          id="Path_6893"
          data-name="Path 6893"
          d="M25.526,22.417a.635.635,0,0,1-.448-.2,4.692,4.692,0,0,1-.843-2.331,8.126,8.126,0,0,1,1.395-3.072c.427-.658,1.811-.407,3.033-.186.385.07.749.136,1,.153a.211.211,0,1,1-.029.421c-.273-.019-.631-.083-1.046-.159-.926-.167-2.326-.421-2.6,0a7.9,7.9,0,0,0-1.327,2.834,4.446,4.446,0,0,0,.721,2.045.178.178,0,0,0,.213.056c.141-.075.36-.455.175-1.361a.211.211,0,0,1,.167-.248.214.214,0,0,1,.251.165c.185.91.039,1.589-.393,1.816A.573.573,0,0,1,25.526,22.417Z"
        />
        <path
          id="Path_6894"
          data-name="Path 6894"
          d="M23.167,20.778a.558.558,0,0,1-.384-.134c-.538-.48.275-1.383.543-1.68a5.524,5.524,0,0,1,1.3-1.077c.175-.113.363-.234.582-.392a.214.214,0,0,1,.3.046.21.21,0,0,1-.047.295c-.226.163-.42.288-.6.4a5.115,5.115,0,0,0-1.215,1c-.552.613-.687.987-.576,1.086.147.131.761-.173,1.212-.531a.214.214,0,0,1,.3.032.21.21,0,0,1-.033.3A2.834,2.834,0,0,1,23.167,20.778Z"
        />
        <path
          id="Path_6895"
          data-name="Path 6895"
          d="M36.421,26.925a.214.214,0,0,1-.13-.044A6.146,6.146,0,0,0,33.6,25.653a.211.211,0,1,1,.05-.419,6.452,6.452,0,0,1,2.9,1.314.21.21,0,0,1,.038.3A.214.214,0,0,1,36.421,26.925Z"
        />
        <path
          id="Path_6896"
          data-name="Path 6896"
          d="M7.107,22.294a.609.609,0,0,1-.421-.167c-.409-.379-.451-1.324-.459-2.342,0-.121,0-.231,0-.327a4.629,4.629,0,0,1,1.782-2.9c.506-.438,1.8.015,3.836,1.348A7.528,7.528,0,0,1,13.393,20a.21.21,0,0,1-.09.285.214.214,0,0,1-.288-.089,6.989,6.989,0,0,0-1.409-1.937c-1.935-1.266-3.063-1.608-3.321-1.383a4.355,4.355,0,0,0-1.637,2.577c0,.1,0,.211,0,.334.005.612.015,1.751.324,2.037a.181.181,0,0,0,.143.052c.391-.023.464-.833.512-1.369a3.631,3.631,0,0,1,.073-.546,1.668,1.668,0,0,1,.879-1.084c.4-.115,1.254.37,1.507.521a.21.21,0,0,1,.072.29.214.214,0,0,1-.292.072A2.9,2.9,0,0,0,8.7,19.278a1.3,1.3,0,0,0-.586.787,3.551,3.551,0,0,0-.06.474C8,21.22,7.9,22.248,7.146,22.292Z"
        />
        <path
          id="Path_6897"
          data-name="Path 6897"
          d="M6,22.441A.7.7,0,0,1,5.5,22.2a7.071,7.071,0,0,1-.82-2.883c-.086-.869.842-1.809,1.587-2.564a1.315,1.315,0,0,1,1.8-.095.21.21,0,0,1,.03.3.214.214,0,0,1-.3.029.893.893,0,0,0-1.225.063c-.647.656-1.534,1.554-1.468,2.228a7,7,0,0,0,.707,2.635.246.246,0,0,0,.259.095.582.582,0,0,0,.314-.5.213.213,0,0,1,.422.054.986.986,0,0,1-.6.845A.631.631,0,0,1,6,22.441Z"
        />
        <path
          id="Path_6898"
          data-name="Path 6898"
          d="M5.022,22.418a.654.654,0,0,1-.51-.276A6.911,6.911,0,0,1,3.9,19.2a3.984,3.984,0,0,1,1.39-2.328,1.194,1.194,0,0,1,1.268-.224.21.21,0,0,1,.1.281.214.214,0,0,1-.283.1.767.767,0,0,0-.8.155,3.627,3.627,0,0,0-1.251,2.055,6.8,6.8,0,0,0,.529,2.645A.233.233,0,0,0,5.036,22c.076-.01.159-.105.222-.255a.214.214,0,0,1,.279-.113.21.21,0,0,1,.114.276.73.73,0,0,1-.56.51A.55.55,0,0,1,5.022,22.418Z"
        />
        <path
          id="Path_6899"
          data-name="Path 6899"
          d="M3.772,22.207H3.747c-.722-.033-.672-1.243-.655-1.641a3.324,3.324,0,0,1,1.3-2.653.214.214,0,0,1,.3.016.209.209,0,0,1-.017.3,2.89,2.89,0,0,0-1.162,2.357c-.034.821.1,1.195.25,1.2.084-.009.232-.129.392-.515a.213.213,0,0,1,.278-.115.21.21,0,0,1,.116.275C4.339,21.946,4.076,22.207,3.772,22.207Z"
        />
        <path
          id="Path_6900"
          data-name="Path 6900"
          d="M33.19,74.081h-.014a.212.212,0,0,1-.2-.224c.009-.141.885-14.242.885-27.6,0-12.428-.759-24.514-.871-26.236-.5.027-1.836.1-3.7.175a.211.211,0,1,1-.018-.422c2.362-.1,3.884-.185,3.9-.186a.213.213,0,0,1,.225.2c.009.129.886,13.1.886,26.473s-.877,27.483-.886,27.624A.212.212,0,0,1,33.19,74.081Z"
        />
        <path
          id="Path_6901"
          data-name="Path 6901"
          d="M.213,74.081H.194A.211.211,0,0,1,0,73.852c.012-.13,1.162-13.159,1.162-26.512S.012,19.959,0,19.819a.209.209,0,0,1,.06-.164.222.222,0,0,1,.164-.064s1.188.063,3.1.142a.211.211,0,1,1-.018.421C1.9,20.1.884,20.047.444,20.024.6,21.941,1.588,34.93,1.588,47.34,1.588,60.712.437,73.759.425,73.889A.212.212,0,0,1,.213,74.081Z"
        />
        <path
          id="Path_6902"
          data-name="Path 6902"
          d="M17.078,20.469c-3.947,0-6.983-.01-9.026-.03a.211.211,0,1,1,0-.422c2.041.02,5.076.03,9.022.03,1.773,0,3.67-.022,5.64-.064h0a.211.211,0,0,1,0,.422C20.755,20.447,18.854,20.469,17.078,20.469Z"
        />
        <path
          id="Path_6903"
          data-name="Path 6903"
          d="M56.947,41.058c-2.232,0-4.554-1.552-6.406-2.79-.216-.145-.427-.286-.63-.419-5.22-3.429-8.839-5.732-11.234-7.255-.6-.385-1.138-.724-1.608-1.024-1.459-.933-.725-4.154.34-6.023.571-1,1.141-1.431,1.6-1.207.44.213,1.105.573,1.948,1.03,1.611.873,3.819,2.069,6.19,3.177A68.119,68.119,0,0,0,55.5,29.638a4.907,4.907,0,0,1,2.743,2.917.21.21,0,0,1-.131.268.213.213,0,0,1-.271-.13c-.008-.021-.775-2.15-2.463-2.651a67.177,67.177,0,0,1-8.414-3.114c-2.383-1.113-4.6-2.312-6.213-3.188-.838-.454-1.5-.813-1.93-1.021-.178-.086-.593.243-1.045,1.036-.982,1.724-1.657,4.708-.479,5.461.469.3,1,.639,1.607,1.024,2.4,1.524,6.017,3.828,11.239,7.259.2.134.416.276.634.421,2.586,1.729,6.127,4.1,8.846,1.665,2.881-2.577,6.062-5.758,7.816-9.812,1.107-2.56.836-4.237.413-5.194a3.215,3.215,0,0,0-1.828-1.765,17.891,17.891,0,0,0-3.979-.756c-1.4-.154-2.5-.275-2.961-.794-1.45-1.626-1.016-5.655-1-5.826a.213.213,0,0,1,.423.047c0,.04-.433,4.014.893,5.5.353.4,1.435.515,2.689.654a18.23,18.23,0,0,1,4.074.778,3.639,3.639,0,0,1,2.076,1.993c.457,1.033.756,2.83-.412,5.529-1.786,4.129-5.007,7.351-7.922,9.959A4.309,4.309,0,0,1,56.947,41.058Z"
        />
        <path
          id="Path_6904"
          data-name="Path 6904"
          d="M50.622,61.966c-5.439,0-10.434-1.446-10.853-2.787A16.232,16.232,0,0,1,39.7,54.89a81.6,81.6,0,0,0,.063-8.6,21.949,21.949,0,0,0-.536-3.045,23.516,23.516,0,0,1-.7-4.551,21.571,21.571,0,0,1,.291-3.107,19.021,19.021,0,0,0,.253-4.719.213.213,0,0,1,.424-.039,19.39,19.39,0,0,1-.255,4.818,21.214,21.214,0,0,0-.287,3.047,23.248,23.248,0,0,0,.692,4.461,22.154,22.154,0,0,1,.545,3.111,81.891,81.891,0,0,1-.063,8.643,16.351,16.351,0,0,0,.054,4.145c.321,1.028,5.572,2.773,11.913,2.454,5.092-.255,10.784-2,11.871-3.249a.452.452,0,0,0,.143-.295,31,31,0,0,0-.783-3.949,18.35,18.35,0,0,1-.757-4.586,46.1,46.1,0,0,1,2.2-10.348c.679-2.333,1.448-4.978,2.144-8.089a.214.214,0,0,1,.254-.16.211.211,0,0,1,.162.252c-.7,3.124-1.47,5.775-2.151,8.114a45.8,45.8,0,0,0-2.18,10.256,18.16,18.16,0,0,0,.746,4.463,31.271,31.271,0,0,1,.793,4.007.82.82,0,0,1-.244.611c-1.148,1.319-6.834,3.128-12.172,3.4C51.613,61.955,51.116,61.966,50.622,61.966Z"
        />
        <path
          id="Path_6905"
          data-name="Path 6905"
          d="M40.236,74.184a.212.212,0,0,1-.212-.2,108.666,108.666,0,0,1,0-14.36.213.213,0,0,1,.424.043,108.255,108.255,0,0,0,0,14.289.211.211,0,0,1-.2.224Z"
        />
        <path
          id="Path_6906"
          data-name="Path 6906"
          d="M39.212,31.719a.214.214,0,0,1-.076-.014,33.579,33.579,0,0,0-5.365-1.172.211.211,0,1,1,.059-.418,33.229,33.229,0,0,1,5.458,1.2.21.21,0,0,1,.123.272A.212.212,0,0,1,39.212,31.719Z"
        />
        <path
          id="Path_6907"
          data-name="Path 6907"
          d="M48.219,21.653c-.72,0-1.51-.054-2.361-.112-.869-.059-1.767-.121-2.723-.135-1.187-.018-2.43.029-3.632.074-1.3.049-2.522.1-3.5.05a.211.211,0,0,1-.2-.22.222.222,0,0,1,.223-.2c.955.044,2.172,0,3.459-.05,1.207-.046,2.455-.093,3.655-.074.967.015,1.871.077,2.745.136a15.1,15.1,0,0,0,3.962-.035.214.214,0,0,1,.254.16.211.211,0,0,1-.161.252A8.017,8.017,0,0,1,48.219,21.653Z"
        />
        <path
          id="Path_6908"
          data-name="Path 6908"
          d="M53.3,52.717a10.5,10.5,0,0,1-1.973-.167.211.211,0,1,1,.084-.414,12.959,12.959,0,0,0,8.783-1.794.214.214,0,0,1,.3.058.21.21,0,0,1-.058.293A13.1,13.1,0,0,1,53.3,52.717Z"
        />
        <path
          id="Path_6909"
          data-name="Path 6909"
          d="M57.848,14.573a.211.211,0,0,1-.028-.42,2.307,2.307,0,0,0,2-2.62,1.236,1.236,0,0,0-.709-1.018,1.413,1.413,0,0,0-1.344.145.214.214,0,0,1-.3-.057.209.209,0,0,1,.058-.293,1.841,1.841,0,0,1,1.757-.18,1.665,1.665,0,0,1,.956,1.348,2.725,2.725,0,0,1-2.362,3.092Z"
        />
        <path
          id="Path_6910"
          data-name="Path 6910"
          d="M58.064,12.793A.213.213,0,0,1,58,12.782a.21.21,0,0,1-.136-.266,1.3,1.3,0,0,1,.773-.834.214.214,0,0,1,.283.1.21.21,0,0,1-.1.28.884.884,0,0,0-.549.583A.212.212,0,0,1,58.064,12.793Z"
        />
        <path
          id="Path_6911"
          data-name="Path 6911"
          d="M50.058,20.393h-.024c-1.794-.025-3.664-2.632-4.215-4.49a11.237,11.237,0,0,1-.4-2.622c-.031-.439-.062-.894-.124-1.43-.046-.4-.131-.829-.22-1.279a7.348,7.348,0,0,1-.118-3.556.213.213,0,0,1,.266-.14.21.21,0,0,1,.141.263,6.936,6.936,0,0,0,.128,3.351c.091.459.177.892.225,1.313.063.545.1,1.025.126,1.448a10.745,10.745,0,0,0,.385,2.532c.49,1.652,2.261,4.165,3.812,4.187h.017c1.018,0,3.665-1.167,5.546-3.019a.215.215,0,0,1,.3,0,.21.21,0,0,1,0,.3C54.069,19.059,51.317,20.393,50.058,20.393Z"
        />
        <path
          id="Path_6912"
          data-name="Path 6912"
          d="M48.56,14.961a.212.212,0,0,1-.117-.035c-.558-.364-.836-.672-.9-1a1.19,1.19,0,0,1,.3-.9c.066-.1.136-.2.2-.311a1.411,1.411,0,0,0,.157-.749,3.584,3.584,0,0,0-.458-1.437.21.21,0,0,1,.093-.284.214.214,0,0,1,.287.092,3.975,3.975,0,0,1,.5,1.61,1.822,1.822,0,0,1-.208.969c-.069.126-.144.238-.218.346-.172.254-.275.418-.241.586.041.2.283.445.719.73a.21.21,0,0,1,.061.292A.213.213,0,0,1,48.56,14.961Z"
        />
        <path
          id="Path_6913"
          data-name="Path 6913"
          d="M51.834,11.089c-.044-.479-.367-.861-.721-.853s-.605.4-.561.881.367.86.721.852S51.879,11.568,51.834,11.089Z"
          fillRule="evenodd"
        />
        <path
          id="Path_6914"
          data-name="Path 6914"
          d="M45.619,9.189a.213.213,0,0,1-.166-.079.209.209,0,0,1,.032-.3,1.715,1.715,0,0,1,1.983-.133.21.21,0,0,1,.06.292.214.214,0,0,1-.3.059,1.286,1.286,0,0,0-1.48.11A.214.214,0,0,1,45.619,9.189Z"
        />
        <path
          id="Path_6915"
          data-name="Path 6915"
          d="M52.394,8.895a.214.214,0,0,1-.1-.026,2.288,2.288,0,0,0-2.314-.03.214.214,0,0,1-.3-.054.21.21,0,0,1,.054-.293A2.691,2.691,0,0,1,52.5,8.5a.21.21,0,0,1,.083.287A.213.213,0,0,1,52.394,8.895Z"
        />
        <path
          id="Path_6916"
          data-name="Path 6916"
          d="M42.062,21.354a.213.213,0,0,1-.183-.1c-1.332-2.191-.69-3.434-.011-4.751a5.856,5.856,0,0,0,.872-3.011,13.148,13.148,0,0,0-.625-3.067,7.574,7.574,0,0,1-.495-3.2,8.484,8.484,0,0,1,3.45-4.556.214.214,0,0,1,.3.041.21.21,0,0,1-.042.3,8.078,8.078,0,0,0-3.291,4.309,7.4,7.4,0,0,0,.488,3,13.425,13.425,0,0,1,.641,3.171,6.283,6.283,0,0,1-.919,3.213c-.651,1.262-1.214,2.352,0,4.341a.21.21,0,0,1-.073.29A.213.213,0,0,1,42.062,21.354Z"
        />
        <path
          id="Path_6917"
          data-name="Path 6917"
          d="M55.995,10.839c-2.368,0-3.512-2.141-4.622-4.217A18.47,18.47,0,0,0,50,4.326c-.466-.624-.931-.883-1.384-.768A2.359,2.359,0,0,0,47.3,5.293a.214.214,0,0,1-.24.18.211.211,0,0,1-.182-.238,2.755,2.755,0,0,1,1.63-2.086c.437-.111,1.11-.041,1.832.925a18.811,18.811,0,0,1,1.4,2.349c1.2,2.249,2.339,4.372,4.916,3.933a.211.211,0,1,1,.072.416A4.424,4.424,0,0,1,55.995,10.839Z"
        />
        <path
          id="Path_6918"
          data-name="Path 6918"
          d="M44.606,12.522a.213.213,0,0,1-.187-.109,5.373,5.373,0,0,1-.016-4.35,3.7,3.7,0,0,1,1.9-2.257.214.214,0,0,1,.27.133.21.21,0,0,1-.134.267A3.352,3.352,0,0,0,44.8,8.216a4.952,4.952,0,0,0-.009,3.993.21.21,0,0,1-.083.287A.213.213,0,0,1,44.606,12.522Z"
        />
        <path
          id="Path_6919"
          data-name="Path 6919"
          d="M69.067,34.9a2.537,2.537,0,0,1-2.62-1.741.213.213,0,0,1,.411-.108,1.958,1.958,0,0,0,1.824,1.412,2.784,2.784,0,0,1-.867-2.5A6.056,6.056,0,0,1,68.6,30.03a7.222,7.222,0,0,0,.917-2.3c.335-1.657-.5-3.243-1.164-4.518-.112-.214-.217-.416-.31-.6a7.158,7.158,0,0,1-.664-3.961,5.767,5.767,0,0,0-.17-2.226,7.22,7.22,0,0,0-2.958-3.437,7.351,7.351,0,0,1-1.045-.847,8.842,8.842,0,0,1-1.985-4.118c-.125-.44-.266-.939-.435-1.478a8.938,8.938,0,0,0-3.4-4.638A9.109,9.109,0,0,0,49.946.764a.213.213,0,0,1-.263-.146.211.211,0,0,1,.147-.26,9.545,9.545,0,0,1,7.794,1.2A9.369,9.369,0,0,1,61.2,6.42c.171.544.313,1.046.439,1.489a8.407,8.407,0,0,0,1.889,3.947,7.117,7.117,0,0,0,.982.791,7.569,7.569,0,0,1,3.111,3.645,6.083,6.083,0,0,1,.191,2.381,6.717,6.717,0,0,0,.621,3.754c.091.186.2.385.306.6.662,1.263,1.568,2.993,1.2,4.8a7.668,7.668,0,0,1-.962,2.418,5.72,5.72,0,0,0-.743,1.807A2.655,2.655,0,0,0,69.385,34.5a.21.21,0,0,1,.087.226.212.212,0,0,1-.184.159S69.2,34.9,69.067,34.9Z"
        />
        <path
          id="Path_6920"
          data-name="Path 6920"
          d="M49.906,20.243l.172,1.206a2.72,2.72,0,0,0,2.513-.55A9.2,9.2,0,0,0,55.3,17.451a21.221,21.221,0,0,1-3.254,2.188A6.146,6.146,0,0,1,49.906,20.243Z"
          fillRule="evenodd"
        />
        <path
          id="Path_6921"
          data-name="Path 6921"
          d="M44.852,7.748s.229,1.645.5,2.993.084,1.276.084,1.276a2.215,2.215,0,0,1-1.241-1.611A5.3,5.3,0,0,1,44.852,7.748Z"
          fillRule="evenodd"
        />
        <path
          id="Path_6922"
          data-name="Path 6922"
          d="M47.288,11.48c-.033-.479-.322-.874-.644-.883s-.556.373-.522.852.322.874.644.883S47.322,11.959,47.288,11.48Z"
          fillRule="evenodd"
        />
        <path
          id="Path_6923"
          data-name="Path 6923"
          d="M48.9,16.921a3.361,3.361,0,0,1-1.1-.169.211.211,0,0,1-.13-.269.213.213,0,0,1,.272-.129,3.916,3.916,0,0,0,3.307-.6.214.214,0,0,1,.3.035.21.21,0,0,1-.035.3A4.427,4.427,0,0,1,48.9,16.921Z"
        />
        <path
          id="Path_6924"
          data-name="Path 6924"
          d="M62.91,22.146l-.025,0a.211.211,0,0,1-.187-.234,3.025,3.025,0,0,0-1.112-2.338c-1.413-1.35-1.592-2.381-1.39-4.61A.213.213,0,0,1,60.62,15c-.205,2.266.042,3.1,1.262,4.269a3.425,3.425,0,0,1,1.24,2.691A.212.212,0,0,1,62.91,22.146Z"
        />
        <path
          id="Path_6925"
          data-name="Path 6925"
          d="M56.462,8.225a.213.213,0,0,1-.061-.009C54.239,7.577,53.04,5.7,51.77,3.709a22.788,22.788,0,0,0-2.05-2.87,1.2,1.2,0,0,0-1.41-.313,3.707,3.707,0,0,0-2.046,3.418.212.212,0,0,1-.211.212h0a.212.212,0,0,1-.213-.21A4.15,4.15,0,0,1,48.158.132a1.628,1.628,0,0,1,1.881.429,23.034,23.034,0,0,1,2.09,2.922c1.227,1.92,2.385,3.734,4.394,4.328a.211.211,0,0,1,.143.262A.213.213,0,0,1,56.462,8.225Z"
        />
        <path
          id="Path_6926"
          data-name="Path 6926"
          d="M58.967,8.91a.214.214,0,0,1-.08-.016,9.452,9.452,0,0,1-4.134-3.956.21.21,0,0,1,.073-.289.214.214,0,0,1,.292.072A9.044,9.044,0,0,0,59.048,8.5a.21.21,0,0,1,.117.275A.213.213,0,0,1,58.967,8.91Z"
        />
        <path
          id="Path_6927"
          data-name="Path 6927"
          d="M50.276,23.178a.212.212,0,0,1-.21-.178c-.24-1.493-.346-2.634-.347-2.645a.213.213,0,0,1,.424-.038c0,.011.106,1.139.343,2.617a.211.211,0,0,1-.177.241Z"
        />
        <path
          id="Path_6928"
          data-name="Path 6928"
          d="M53.058,26.383a5.476,5.476,0,0,1-1.543-.214c-1.906-.558-3.072-2.147-3.281-4.472a.211.211,0,0,1,.193-.229.214.214,0,0,1,.231.191,4.294,4.294,0,0,0,2.978,4.106c2.7.79,6.364-.923,8.923-4.163a.214.214,0,0,1,.3-.036.21.21,0,0,1,.037.3C58.646,24.707,55.667,26.383,53.058,26.383Z"
        />
        <path
          id="Path_6929"
          data-name="Path 6929"
          d="M55.928,30.158a.213.213,0,0,1-.139-.051.21.21,0,0,1-.022-.3,8.2,8.2,0,0,1,1.723-1.335,13.027,13.027,0,0,0,3.454-2.982.214.214,0,0,1,.3-.038.21.21,0,0,1,.039.3,13.39,13.39,0,0,1-3.557,3.077,7.928,7.928,0,0,0-1.635,1.259A.213.213,0,0,1,55.928,30.158Z"
        />
        <path
          id="Path_6930"
          data-name="Path 6930"
          d="M12.09,38.251A7.755,7.755,0,1,1,19.958,30.5,7.82,7.82,0,0,1,12.09,38.251Zm0-15.086A7.333,7.333,0,1,0,19.532,30.5,7.4,7.4,0,0,0,12.09,23.165Z"
        />
        <path
          id="Path_6931"
          data-name="Path 6931"
          d="M7,36.27a.212.212,0,0,1-.155-.067.209.209,0,0,1,.01-.3L17.817,25.72a.214.214,0,0,1,.139-.057l9.449-.294a.209.209,0,0,1,.22.2.212.212,0,0,1-.206.217l-9.368.292L7.144,36.213A.214.214,0,0,1,7,36.27Z"
        />
        <path
          id="Path_6932"
          data-name="Path 6932"
          d="M17.308,36.036a.213.213,0,0,1-.146-.057L6.2,25.793a.209.209,0,0,1-.01-.3.214.214,0,0,1,.3-.009l10.9,10.128,9.424-.029h0a.211.211,0,1,1,0,.422l-9.508.029Z"
        />
        <path
          id="Path_6933"
          data-name="Path 6933"
          d="M26.88,34.3H21.33a.211.211,0,1,1,0-.422h5.55a.211.211,0,1,1,0,.422Z"
        />
        <path
          id="Path_6934"
          data-name="Path 6934"
          d="M26.862,33.093h-5.55a.211.211,0,1,1,0-.422h5.55a.211.211,0,1,1,0,.422Z"
        />
        <path
          id="Path_6935"
          data-name="Path 6935"
          d="M26.831,31.832h-5.55a.211.211,0,1,1,0-.422h5.55a.211.211,0,1,1,0,.422Z"
        />
        <path
          id="Path_6936"
          data-name="Path 6936"
          d="M21.416,24.878a.211.211,0,0,1-.006-.422l5.548-.161a.211.211,0,1,1,.012.422l-5.548.161Z"
        />
        <path
          id="Path_6937"
          data-name="Path 6937"
          d="M21.35,23.623a.211.211,0,0,1-.006-.422l5.548-.161a.209.209,0,0,1,.219.2.212.212,0,0,1-.207.217l-5.548.161Z"
        />
        <path
          id="Path_6938"
          data-name="Path 6938"
          d="M5.742,51.944a.213.213,0,0,1-.2-.131l-.493-1.188-.644,1.191a.214.214,0,0,1-.288.086.21.21,0,0,1-.087-.286l.857-1.585a.214.214,0,0,1,.385.02l.664,1.6a.21.21,0,0,1-.116.275A.208.208,0,0,1,5.742,51.944Z"
        />
        <path
          id="Path_6939"
          data-name="Path 6939"
          d="M26.558,65.682a.213.213,0,0,1-.2-.128.211.211,0,0,1,.113-.277l1.192-.5-1.21-.622a.21.21,0,0,1-.091-.285.215.215,0,0,1,.287-.09l1.611.828a.21.21,0,0,1-.015.382l-1.608.679A.217.217,0,0,1,26.558,65.682Z"
        />
        <path
          id="Path_6940"
          data-name="Path 6940"
          d="M28.176,65.011h-.006L4.7,64.419a.213.213,0,0,1-.149-.066A.21.21,0,0,1,4.49,64.2l.359-13.931a.217.217,0,0,1,.218-.205.212.212,0,0,1,.207.217L4.921,64l23.26.587a.211.211,0,0,1-.006.422Z"
        />
        <path
          id="Path_6941"
          data-name="Path 6941"
          d="M4.871,64.243a.213.213,0,0,1-.092-.021.21.21,0,0,1-.1-.281L6.7,59.75a.213.213,0,0,1,.192-.12h0l4.282.044a.213.213,0,0,1,.148.061l1.406,1.386L15.5,57.9a.238.238,0,0,1,.165-.074l3.035.035.988-2.138a.211.211,0,0,1,.2-.123.213.213,0,0,1,.193.132l.642,1.584,1.247-3.392a.21.21,0,0,1,.207-.139l3.335.1,2.774-3.507a.213.213,0,0,1,.3-.036.209.209,0,0,1,.036.3l-2.84,3.591a.218.218,0,0,1-.174.081l-3.289-.1L20.928,57.98a.213.213,0,0,1-.2.139h0a.213.213,0,0,1-.2-.132l-.665-1.64-.84,1.817a.231.231,0,0,1-.2.123l-3.074-.036-2.849,3.319a.213.213,0,0,1-.153.074.207.207,0,0,1-.159-.061l-1.508-1.487-4.059-.042-1.965,4.07A.213.213,0,0,1,4.871,64.243Z"
        />
        <path
          id="Path_6942"
          data-name="Path 6942"
          d="M4.916,64.4a.212.212,0,0,1-.137-.05.209.209,0,0,1-.026-.3l2.695-3.165a.2.2,0,0,1,.174-.075.214.214,0,0,1,.165.092l.617.9,2.375-4.454a.213.213,0,0,1,.188-.112h0l2.753.04a.212.212,0,0,1,.187.116l1.079,2.128,1.42-3.892a.205.205,0,0,1,.205-.139l1.756.041,1.462-3.08a.206.206,0,0,1,.2-.121l4.208.1,1.309-1.775a.214.214,0,0,1,.3-.046.209.209,0,0,1,.046.295l-1.374,1.864a.219.219,0,0,1-.177.086l-4.18-.095L18.7,55.835a.229.229,0,0,1-.2.121l-1.741-.04-1.536,4.21a.213.213,0,0,1-.187.139.21.21,0,0,1-.2-.116L13.587,57.7l-2.493-.036-2.479,4.65a.214.214,0,0,1-.365.02l-.658-.962L5.079,64.322A.213.213,0,0,1,4.916,64.4Z"
        />
        <path
          id="Path_6943"
          data-name="Path 6943"
          d="M5.115,64.121a.213.213,0,0,1-.175-.09.21.21,0,0,1,.053-.294L9.42,60.673a.216.216,0,0,1,.272.023l1.593,1.568,3.941.005,1.9-2.35a.224.224,0,0,1,.173-.079.214.214,0,0,1,.167.089l.948,1.328,1.2-1.249a.221.221,0,0,1,.159-.066l3.577.071,4.481-5.948a.214.214,0,0,1,.3-.043.209.209,0,0,1,.043.295L23.62,60.354a.213.213,0,0,1-.175.085l-3.592-.071-1.312,1.367a.219.219,0,0,1-.17.065.214.214,0,0,1-.159-.089L17.279,60.4l-1.786,2.21a.214.214,0,0,1-.166.079h0L11.2,62.686a.213.213,0,0,1-.15-.061l-1.529-1.5L5.237,64.083A.215.215,0,0,1,5.115,64.121Z"
        />
        <path
          id="Path_6944"
          data-name="Path 6944"
          d="M25.825,52.281h-.017a.212.212,0,0,1-.2-.227l.1-1.287-1.285.625a.213.213,0,0,1-.285-.1.21.21,0,0,1,.1-.282l1.62-.788a.215.215,0,0,1,.213.015.211.211,0,0,1,.093.191l-.131,1.656A.213.213,0,0,1,25.825,52.281Z"
        />
        <path
          id="Path_6945"
          data-name="Path 6945"
          d="M28.406,52.195h-.018a.211.211,0,0,1-.194-.228L28.3,50.68l-1.289.618a.214.214,0,0,1-.284-.1.21.21,0,0,1,.1-.282l1.625-.779a.215.215,0,0,1,.213.016.21.21,0,0,1,.092.191L28.618,52A.212.212,0,0,1,28.406,52.195Z"
        />
        <path
          id="Path_6946"
          data-name="Path 6946"
          d="M28.154,55.563h-.018a.211.211,0,0,1-.194-.228l.109-1.286-1.289.618a.213.213,0,0,1-.284-.1.21.21,0,0,1,.1-.281l1.625-.779a.214.214,0,0,1,.213.016.21.21,0,0,1,.091.191l-.141,1.655A.212.212,0,0,1,28.154,55.563Z"
        />
        <path
          id="Path_6947"
          data-name="Path 6947"
          d="M28.175,70.809H28.17L4.294,70.215A.212.212,0,0,1,4.086,70a.2.2,0,0,1,.218-.206l23.876.593a.211.211,0,0,1-.005.422Z"
        />
        <path
          id="Path_6948"
          data-name="Path 6948"
          d="M28.221,68.16h-.005L4.294,67.566a.211.211,0,1,1,.011-.422l23.922.594a.211.211,0,0,1-.005.422Z"
        />
        <path
          id="Path_6949"
          data-name="Path 6949"
          d="M27.906,73.132H27.9L4.024,72.539a.212.212,0,0,1-.207-.216.205.205,0,0,1,.218-.206l23.876.593a.211.211,0,0,1-.005.422Z"
        />
        <path
          id="Path_6950"
          data-name="Path 6950"
          d="M5.381,46.554a.211.211,0,1,1,0-.422l23.235-.094h0a.211.211,0,1,1,0,.422l-23.235.094Z"
        />
        <path
          id="Path_6951"
          data-name="Path 6951"
          d="M5.471,44.278a.211.211,0,1,1,0-.422l23.235-.095h0a.211.211,0,1,1,0,.422l-23.235.095Z"
        />
        <path
          id="Path_6952"
          data-name="Path 6952"
          d="M5.516,42a.211.211,0,1,1,0-.422l23.235-.094h0a.211.211,0,1,1,0,.422L5.517,42Z"
        />
        <g id="Shape" transform="translate(-33.134 21.432)">
          <rect
            id="Rectangle_46314"
            data-name="Rectangle 46314"
            width="2.732"
            height="10.758"
            rx="1.366"
            transform="translate(20.441 17.226) rotate(73.356)"
            fill="#dad2ff"
          />
          <rect
            id="Rectangle_46315"
            data-name="Rectangle 46315"
            width="2.732"
            height="10.767"
            rx="1.366"
            transform="matrix(0.848, 0.531, -0.531, 0.848, 27.457, 27.643)"
            fill="#dad2ff"
          />
          <rect
            id="Rectangle_46316"
            data-name="Rectangle 46316"
            width="2.732"
            height="10.801"
            rx="1.366"
            transform="translate(23.756 6.691) rotate(118.314)"
            fill="#dad2ff"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export function ReportPdfImage(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 68,
    height: 70,
    ...rootStyle,
  };

  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 68 70"
    {...rest}
    sx={rootSx}
  >
    <g id="PDF_image" data-name="PDF image" transform="translate(-28 -239)">
      <rect
        id="Rectangle_55903"
        data-name="Rectangle 55903"
        width="68"
        height="70"
        rx="6"
        transform="translate(28 239)"
        fill="#f44f5a"
      />
      <path
        id="icons8-document_1_"
        data-name="icons8-document (1)"
        d="M10.25,4A2.261,2.261,0,0,0,8,6.25v15.5A2.261,2.261,0,0,0,10.25,24h11.5A2.261,2.261,0,0,0,24,21.75V11.25a.75.75,0,0,0-.22-.53l-.008-.008L17.28,4.22A.75.75,0,0,0,16.75,4Zm0,1.5H16V9.75A2.261,2.261,0,0,0,18.25,12H22.5v9.75a.739.739,0,0,1-.75.75H10.25a.739.739,0,0,1-.75-.75V6.25A.739.739,0,0,1,10.25,5.5ZM17.5,6.561,21.439,10.5H18.25a.739.739,0,0,1-.75-.75ZM12.75,14.5a.75.75,0,1,0,0,1.5h6.5a.75.75,0,1,0,0-1.5Zm0,3.5a.75.75,0,1,0,0,1.5h4.5a.75.75,0,1,0,0-1.5Z"
        transform="translate(46 256)"
        fill="#fff"
      />
    </g>
  </SvgIcon>;
}

export function MyCircleBg(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 283.561,
    height: 252.692,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      // width={283.561}
      // height={252.692}
      viewBox="0 0 283.561 252.692"
      {...rest}
      sx={rootSx}
    >
      <defs>
        <clipPath id="a">
          <rect
            data-name="Rectangle 56002"
            width={30.481}
            height={59.485}
            rx={4}
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={0.2}
          />
        </clipPath>
        <clipPath id="b">
          <path
            data-name="Rectangle 56017"
            fill="#92e3a9"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={0.2}
            d="M0 0H27.771V51.915H0z"
          />
        </clipPath>
        <clipPath id="c">
          <path
            data-name="Path 98425"
            d="M.052 0s-.85 13.495 4.3 18.641c0 0 5.429-3.727 5.429-18.479z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={0.2}
          />
        </clipPath>
        <clipPath id="d">
          <circle
            data-name="Ellipse 129782"
            cx={44}
            cy={44}
            r={44}
            transform="translate(3265.692 6136.692)"
            fill="#fff"
            stroke="#007965"
            strokeWidth={1}
          />
        </clipPath>
        <clipPath id="e">
          <circle
            data-name="Ellipse 129788"
            cx={29}
            cy={29}
            r={29}
            transform="translate(3466 6531)"
            fill="#fff"
            stroke="#707070"
            strokeWidth={1}
          />
        </clipPath>
        <clipPath id="f">
          <path
            data-name="Path 98693"
            d="M1.531.154c-.08.852-.165 1.739-.232 2.336-.167 1.5-1.416 9.45-1.291 10.034a.872.872 0 001.331.582c.54-.369.749-.54.833-1.04a6.914 6.914 0 00.11-1.331c0-.443 1.939-7.116 2.981-10.735a5.119 5.119 0 01-3.732.154z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={0.1}
          />
        </clipPath>
        <clipPath id="g">
          <path
            data-name="Path 98697"
            d="M22.242 10.771c0 6.585-4.981 9.825-11.121 9.825S0 17.364 0 10.771 4.979 0 11.121 0s11.121 4.19 11.121 10.771z"
            fill="#92e3a9"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={0.1}
          />
        </clipPath>
        <clipPath id="h">
          <path
            data-name="Path 98703"
            d="M18.606 30.003a4.99 4.99 0 00-2.587-.116 26.4 26.4 0 01-4.08.042s.125-4.163.125-4.372 4.621-3.372 4.621-3.372 3.042 8.161 3.747 8.494 1.665.665 1.331-1.749a46.335 46.335 0 00-2.374-7.827c-.584-1.582-2.58-2.914-3.58-4.331s-1.082-1.791-.951-2.331 1.291-1.331 1.291-1.331l-2.205-1.835a2.5 2.5 0 01-1.414 1.5c-1.034.333-1.749-1.291-1.956-2.623s2.414-7.494 2.414-7.494l10.271-.916a1.156 1.156 0 00.084 1.042c.333.458.916 1.456 1.04 1.582s.251.291.416.207-.38-1.207-.38-1.207 1.749 1.665 2.04 1.874.916.582.916.416-.791-.874-1.124-1.331-1.582-2.331-2-3A2.13 2.13 0 0022.54.576c-.295 0-10.243-.749-10.456-.542a61.932 61.932 0 00-4.1 8.247 20.4 20.4 0 00-1.042 5.12c-.042 1.789-1.331 4.331-1.54 6.245S3.488 23.935 2.741 25.1.65 27.056.161 29.514s.165 4.287 1.456 5.078 7.119.874 8.7.833a21.763 21.763 0 007.3-2"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={0.1}
          />
        </clipPath>
        <clipPath id="i">
          <path
            data-name="Path 98717"
            d="M10.252 3.197a42.725 42.725 0 01-4.87.456c-1.458-.042-2.456-.165-2.456-.165a5.513 5.513 0 00-.249-1.374A18.372 18.372 0 011.917.2c-.093-.458-.458-.042-.458.416s-.082 2.456-.082 2.456A9.854 9.854 0 01.252 1.656c-.125-.333-.416.042-.124.542s.624 1.5.914 1.956 1.167.584 1.542.709 4.454.914 5.952 1.082 3.54-.042 3.665-.333a10.475 10.475 0 00-.458-2.333"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={0.1}
          />
        </clipPath>
        <clipPath id="j">
          <circle
            data-name="Ellipse 129783"
            cx={43.5}
            cy={43.5}
            r={43.5}
            transform="translate(3645.642 6168.642)"
            fill="#fff"
            stroke="#707070"
            strokeWidth={1}
          />
        </clipPath>
      </defs>
      <g data-name="Group 105829">
        <g data-name="Earth and Moon-bro">
          <path
            data-name="Path 98376"
            d="M227.14 88.265a122.941 122.941 0 00-6.352-11.124c-27-41.158-99.3-63.57-135.125-21.018-8.542 10.14-11.516 22.4-17.277 34.027-13.068 26.457-37.47 42.27-52.809 66.743-11.867 18.993-10.286 43.325-3.664 63.857 7.2 22.306 19.859 37.885 40.116 49.723 22.71 13.278 47 9.59 71.544 4.971 11.036-2.078 22.417-4.2 33.705-3.4 14.133.989 28.1 4.988 42.106 6.932 14.578 2.026 29.706 2.5 43.752-1.9 44.981-14.11 55.619-80.208 37.142-118.105-6.545-13.407-17.646-23.752-27.95-34.25-11.113-11.304-17.928-22.393-25.188-36.456z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(6.79 33.221) translate(-6.79 -33.22)"
            fill="#ccf3ec"
          />
          <path
            data-name="Path 98377"
            d="M227.14 88.265a122.941 122.941 0 00-6.352-11.124c-27-41.158-99.3-63.57-135.125-21.018-8.542 10.14-11.516 22.4-17.277 34.027-13.068 26.457-37.47 42.27-52.809 66.743-11.867 18.993-10.286 43.325-3.664 63.857 7.2 22.306 19.859 37.885 40.116 49.723 22.71 13.278 47 9.59 71.544 4.971 11.036-2.078 22.417-4.2 33.705-3.4 14.133.989 28.1 4.988 42.106 6.932 14.578 2.026 29.706 2.5 43.752-1.9 44.981-14.11 55.619-80.208 37.142-118.105-6.545-13.407-17.646-23.752-27.95-34.25-11.113-11.304-17.928-22.393-25.188-36.456z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(6.79 33.221) translate(-6.79 -33.22)"
            fill="#fff"
            opacity={0.7}
          />
          <path
            data-name="Path 98378"
            d="M182.29 94.975l-.855 4.848 3.513 3.448-4.877.685-2.2 4.4-2.16-4.42-4.865-.732 3.542-3.419-.814-4.848 4.344 2.307z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-85.166 -65.363)"
            fill="#fff"
          />
          <path
            data-name="Path 98379"
            d="M177.669 108.443a.293.293 0 01-.263-.164l-2.09-4.28-4.713-.708a.3.3 0 01-.24-.2.31.31 0 01.076-.3l3.431-3.314-.8-4.713a.287.287 0 01.117-.287.3.3 0 01.31 0l4.209 2.236 4.227-2.2a.293.293 0 01.422.31l-.826 4.684 3.4 3.343a.293.293 0 01.07.3.3.3 0 01-.234.2l-4.725.662-2.125 4.268a.293.293 0 01-.246.163zm-6.393-5.644l4.28.644a.275.275 0 01.217.158l1.9 3.887 1.938-3.87a.275.275 0 01.217-.158l4.286-.585-3.085-3.039a.3.3 0 01-.082-.258l.749-4.262-3.841 2a.275.275 0 01-.269 0l-3.823-2.032.714 4.268a.281.281 0 01-.088.258z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-84.959 -65.154)"
            fill="#263238"
          />
          <path
            data-name="Path 98380"
            d="M386.77 415.805l-.855 4.848 3.507 3.448-4.871.691-2.2 4.4-2.155-4.426-4.865-.726 3.536-3.419-.808-4.853 4.344 2.307z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-169.931 -198.359)"
            fill="#fff"
          />
          <path
            data-name="Path 98381"
            d="M382.141 429.293a.287.287 0 01-.258-.164l-2.1-4.286-4.713-.708a.293.293 0 01-.234-.2.287.287 0 01.076-.3l3.425-3.314-.785-4.684a.293.293 0 01.427-.3l4.209 2.236 4.227-2.2a.293.293 0 01.427.31l-.826 4.684 3.4 3.343a.29.29 0 01-.164.5l-4.719.662-2.131 4.268a.293.293 0 01-.261.153zm-6.393-5.65l4.28.644a.3.3 0 01.222.158l1.9 3.893 1.932-3.876a.287.287 0 01.222-.158l4.286-.585-3.085-3.033a.293.293 0 01-.082-.263l.749-4.262-3.841 2a.287.287 0 01-.275 0l-3.817-2.032.708 4.268a.293.293 0 01-.082.263z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-169.722 -198.164)"
            fill="#263238"
          />
          <path
            data-name="Path 98382"
            d="M356.87 44.925l-.855 4.848 3.513 3.454-4.877.685-2.2 4.4-2.16-4.42-4.865-.732 3.542-3.419-.814-4.853L352.5 47.2z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-157.536 -44.615)"
            fill="#fff"
          />
          <path
            data-name="Path 98383"
            d="M352.258 58.413a.293.293 0 01-.252-.187l-2.09-4.286-4.713-.708a.275.275 0 01-.234-.2.293.293 0 01.07-.3l3.419-3.29-.785-4.684a.293.293 0 01.427-.3l4.209 2.236 4.227-2.2a.3.3 0 01.31 0 .287.287 0 01.111.287l-.826 4.684 3.4 3.343a.293.293 0 01.07.3.3.3 0 01-.234.2l-4.725.667-2.125 4.256a.3.3 0 01-.263.187zm-6.393-5.644l4.28.638a.281.281 0 01.217.164l1.9 3.887 1.938-3.876a.3.3 0 01.217-.158l4.286-.585-3.085-3.033a.3.3 0 01-.082-.258l.749-4.262-3.841 2a.293.293 0 01-.269 0l-3.823-2.026.732 4.245a.287.287 0 01-.088.258z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-157.339 -44.421)"
            fill="#263238"
          />
          <path
            data-name="Path 98384"
            d="M232.656 423.029l-.585 3.343 2.418 2.377-3.361.474-1.516 3.033-1.487-3.05-3.355-.5 2.441-2.359-.562-3.347 3 1.592z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-107.518 -201.356)"
            fill="#fff"
          />
          <path
            data-name="Path 98385"
            d="M229.366 432.329a.369.369 0 01-.263-.164l-1.417-2.927-3.2-.48a.287.287 0 01-.234-.2.293.293 0 01.07-.3l2.342-2.254-.533-3.191a.293.293 0 01.427-.31l2.857 1.522 2.875-1.493a.293.293 0 01.422.31l-.585 3.185 2.313 2.272a.3.3 0 01.07.3.287.287 0 01-.234.193l-3.208.451-1.411 2.9a.3.3 0 01-.291.186zm-4.209-4.046l2.763.416a.287.287 0 01.222.158l1.229 2.517 1.247-2.506a.31.31 0 01.222-.158l2.769-.386-2-1.967a.3.3 0 01-.082-.258l.486-2.758-2.482 1.294a.322.322 0 01-.275 0l-2.471-1.317.462 2.763a.287.287 0 01-.088.258z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-107.296 -201.136)"
            fill="#263238"
          />
          <path
            data-name="Path 98386"
            d="M96.245 315.574l-1.961 2.763 1.171 3.185-3.243-1.007-2.664 2.1-.041-3.4-2.817-1.885 3.214-1.089.925-3.261 2.026 2.717z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-50.279 -155.749)"
            fill="#fff"
          />
          <path
            data-name="Path 98387"
            d="M89.339 322.7a.316.316 0 01-.129-.029.293.293 0 01-.164-.263l-.041-3.238-2.687-1.8a.293.293 0 01.07-.521l3.068-1.036.884-3.115a.281.281 0 01.228-.2.293.293 0 01.287.111l1.932 2.594 3.238-.117a.293.293 0 01.252.463l-1.873 2.64 1.112 3.039a.293.293 0 01-.059.3.287.287 0 01-.3.076l-3.091-.96-2.547 2a.3.3 0 01-.181.064zm-2.2-5.492l2.342 1.563a.293.293 0 01.129.24l.035 2.8 2.2-1.756a.3.3 0 01.263-.053l2.676.837-.966-2.629a.293.293 0 01.035-.269l1.592-2.225-2.8.1a.3.3 0 01-.246-.117l-1.639-2.272-.76 2.689a.293.293 0 01-.187.193z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-50.071 -155.542)"
            fill="#263238"
          />
          <path
            data-name="Path 98388"
            d="M457.791 184.244l-1.967 2.769 1.171 3.185-3.238-1.013-2.67 2.1-.041-3.39L448.23 186l3.214-1.089.931-3.261 2.026 2.722z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-200.151 -101.307)"
            fill="#fff"
          />
          <path
            data-name="Path 98389"
            d="M450.882 191.388a.293.293 0 01-.123 0 .287.287 0 01-.17-.263l-.035-3.238-2.693-1.8a.3.3 0 01.07-.521l3.069-1.04.89-3.115a.281.281 0 01.228-.2.293.293 0 01.287.111l1.932 2.6 3.238-.123a.275.275 0 01.269.152.3.3 0 010 .31l-1.873 2.64 1.118 3.039a.3.3 0 01-.064.3.281.281 0 01-.3.076l-3.091-.96-2.547 2a.3.3 0 01-.205.032zm-2.2-5.486l2.342 1.557a.281.281 0 01.129.24l.035 2.8 2.2-1.756a.3.3 0 01.269-.053l2.67.837-.978-2.588a.275.275 0 01.035-.269l1.616-2.284-2.8.1a.263.263 0 01-.246-.117l-1.669-2.242-.767 2.693a.293.293 0 01-.187.2z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-199.945 -101.121)"
            fill="#263238"
          />
          <path
            data-name="Path 98390"
            d="M124.5 156.174l-1.961 2.763 1.171 3.185-3.238-1.007-2.67 2.1-.041-3.4-2.816-1.891 3.214-1.083.925-3.261 2.026 2.717z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-61.994 -89.671)"
            fill="#fff"
          />
          <path
            data-name="Path 98391"
            d="M117.6 163.293a.345.345 0 01-.129-.029.3.3 0 01-.164-.263l-.035-3.238-2.693-1.8a.3.3 0 01.07-.521l3.068-1.036.884-3.115a.31.31 0 01.228-.211.287.287 0 01.287.117l1.938 2.594 3.238-.117a.269.269 0 01.263.152.3.3 0 010 .31l-1.873 2.64 1.118 3.039a.3.3 0 01-.064.3.287.287 0 01-.3.076l-3.109-.966-2.547 2a.3.3 0 01-.181.064zm-2.2-5.492l2.342 1.563a.281.281 0 01.129.24l.035 2.8 2.2-1.756a.293.293 0 01.269-.047l2.67.831-.966-2.623a.31.31 0 01.041-.275l1.616-2.283-2.8.105a.287.287 0 01-.246-.117L119.026 154l-.767 2.693a.281.281 0 01-.187.193z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-61.79 -89.461)"
            fill="#263238"
          />
          <path
            data-name="Path 98392"
            d="M98.515 422.724l-1.961 2.763 1.165 3.185-3.238-1.007-2.664 2.09-.041-3.39-2.816-1.891 3.214-1.083.925-3.261 2.026 2.717z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-51.22 -200.166)"
            fill="#fff"
          />
          <path
            data-name="Path 98393"
            d="M91.609 429.847a.316.316 0 01-.129-.029.3.3 0 01-.164-.263l-.041-3.238-2.687-1.786a.293.293 0 01.07-.521l3.044-1.054.907-3.109a.3.3 0 01.228-.211.287.287 0 01.287.117l1.938 2.594 3.232-.117a.293.293 0 01.252.463l-1.873 2.64 1.112 3.039a.293.293 0 01-.059.3.287.287 0 01-.3.076l-3.091-.966-2.545 2.018a.3.3 0 01-.181.047zm-2.2-5.492l2.342 1.563a.293.293 0 01.129.24l.035 2.8 2.2-1.756a.281.281 0 01.263-.047l2.676.831-.966-2.623a.3.3 0 01.035-.275l1.622-2.283-2.8.105a.293.293 0 01-.246-.117l-1.674-2.242-.761 2.693a.3.3 0 01-.187.193z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-51.012 -199.96)"
            fill="#263238"
          />
          <path
            data-name="Path 98394"
            d="M34.555 227.434l-1.962 2.766 1.165 3.179-3.238-1.007-2.664 2.1-.041-3.4L25 229.184l3.208-1.083.931-3.261 2.026 2.717z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-24.706 -119.211)"
            fill="#fff"
          />
          <path
            data-name="Path 98395"
            d="M27.649 234.548a.316.316 0 01-.129 0 .293.293 0 01-.164-.263l-.041-3.238-2.687-1.8a.293.293 0 01.07-.521l3.068-1.077.884-3.115a.293.293 0 01.515-.094l1.932 2.594 3.238-.117a.287.287 0 01.269.152.3.3 0 010 .31l-1.873 2.64 1.112 3.039a.29.29 0 01-.363.381l-3.091-.966-2.547 2a.293.293 0 01-.193.075zm-2.2-5.492l2.342 1.563a.293.293 0 01.129.24l.029 2.8 2.2-1.756a.281.281 0 01.269-.053l2.67.831-.96-2.623a.293.293 0 01.035-.269l1.622-2.283-2.8.1a.281.281 0 01-.246-.117l-1.691-2.189-.761 2.7a.293.293 0 01-.187.193z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-24.498 -118.996)"
            fill="#263238"
          />
          <path
            data-name="Path 98396"
            d="M381.811 321.657l-1.253 1.762.744 2.032-2.067-.644-1.7 1.341-.023-2.166-1.8-1.206 2.049-.691.589-2.085 1.294 1.733z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-170.089 -158.659)"
            fill="#fff"
          />
          <path
            data-name="Path 98397"
            d="M377.339 326.234a.294.294 0 01-.123-.029.287.287 0 01-.17-.263v-2.008l-1.669-1.118a.31.31 0 01-.129-.287.3.3 0 01.2-.234l1.9-.644.55-1.938a.281.281 0 01.228-.2.3.3 0 01.287.111l1.2 1.616 2.014-.076a.293.293 0 01.263.152.287.287 0 010 .31l-1.171 1.639.691 1.885a.293.293 0 01-.064.3.287.287 0 01-.3.076l-1.92-.585-1.581 1.241a.3.3 0 01-.211.053zm-1.171-3.577l1.306.872a.31.31 0 01.129.24v1.575l1.235-.972a.293.293 0 01.269-.047l1.5.468-.539-1.475a.287.287 0 01.035-.275l.908-1.282-1.569.059a.31.31 0 01-.246-.117l-.937-1.259-.433 1.51a.281.281 0 01-.187.2z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-169.896 -158.452)"
            fill="#263238"
          />
          <path
            data-name="Path 98398"
            d="M276.681 422.437l-1.253 1.768.744 2.032-2.061-.644-1.7 1.335-.029-2.166-1.8-1.206 2.055-.691.591-2.084 1.294 1.739z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-126.508 -200.436)"
            fill="#fff"
          />
          <path
            data-name="Path 98399"
            d="M272.218 427.035a.317.317 0 01-.129 0 .287.287 0 01-.164-.258v-2.014l-1.674-1.118a.3.3 0 01-.123-.281.287.287 0 01.193-.24l1.909-.644.55-1.938a.281.281 0 01.228-.2.3.3 0 01.287.111l1.2 1.616 2.008-.076a.293.293 0 01.252.463l-1.171 1.639.691 1.891a.281.281 0 01-.059.3.3.3 0 01-.3.082l-1.92-.585-1.581 1.241a.3.3 0 01-.2.018zm-1.171-3.577l1.306.878a.281.281 0 01.129.24v1.569l1.241-.972a.281.281 0 01.263-.047l1.5.468-.544-1.475a.31.31 0 01.035-.269l.913-1.282-1.575.059a.322.322 0 01-.246-.117l-.937-1.265-.427 1.51a.3.3 0 01-.187.2z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-126.32 -200.25)"
            fill="#263238"
          />
          <path
            data-name="Path 98400"
            d="M72.051 403.3l-1.251 1.759.744 2.032-2.067-.644-1.7 1.341-.023-2.166-1.8-1.206 2.046-.692.6-2.084 1.288 1.739z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-41.681 -192.501)"
            fill="#fff"
          />
          <path
            data-name="Path 98401"
            d="M67.583 407.874a.316.316 0 01-.123-.029.31.31 0 01-.17-.263v-2.008l-1.669-1.124a.293.293 0 01.07-.515l1.909-.644.533-1.938a.3.3 0 01.228-.2.31.31 0 01.293.111l1.171 1.61 2.008-.07a.287.287 0 01.269.152.3.3 0 010 .31l-1.17 1.634.714 1.885a.281.281 0 01-.064.3.287.287 0 01-.3.076l-1.92-.585-1.581 1.241a.3.3 0 01-.198.057zm-1.171-3.574l1.311.861a.275.275 0 01.129.234v1.575l1.235-.972a.3.3 0 01.269-.047l1.5.468-.539-1.475a.3.3 0 01.035-.275l.925-1.265-1.569.059a.287.287 0 01-.246-.117l-.937-1.259-.427 1.51a.3.3 0 01-.193.2z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-41.494 -192.295)"
            fill="#263238"
          />
          <path
            data-name="Path 98402"
            d="M111.085 174.227l-1.247 1.768.744 2.032-2.067-.644-1.7 1.335-.023-2.16-1.8-1.206 2.049-.7.591-2.084 1.294 1.739z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-57.865 -97.543)"
            fill="#fff"
          />
          <path
            data-name="Path 98403"
            d="M106.618 178.824a.258.258 0 01-.129 0 .287.287 0 01-.164-.258v-2.008l-1.669-1.124a.287.287 0 01-.129-.281.3.3 0 01.2-.24l1.9-.644.55-1.932a.3.3 0 01.228-.211.287.287 0 01.287.117l1.171 1.61 2.008-.076a.275.275 0 01.269.158.287.287 0 010 .3l-1.171 1.639.7 1.891a.3.3 0 01-.064.3.31.31 0 01-.3.076l-1.92-.585-1.581 1.241a.293.293 0 01-.186.027zm-1.171-3.571l1.306.872a.322.322 0 01.129.24v1.569l1.235-.966a.3.3 0 01.269-.053l1.5.468-.539-1.475a.281.281 0 01.035-.269l.907-1.282-1.569.059a.293.293 0 01-.246-.117l-.943-1.259-.427 1.51a.316.316 0 01-.187.2z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-57.672 -97.358)"
            fill="#263238"
          />
          <path
            data-name="Path 98404"
            d="M412.955 411.461l-1.253 1.768.749 2.032-2.067-.644-1.7 1.335-.023-2.16-1.8-1.206 2.049-.7.591-2.078 1.294 1.733z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-183.001 -195.888)"
            fill="#fff"
          />
          <path
            data-name="Path 98405"
            d="M408.49 416.046a.258.258 0 01-.129-.029.287.287 0 01-.164-.258v-2.014l-1.71-1.095a.3.3 0 01-.129-.281.281.281 0 01.2-.24l1.932-.65.55-1.932a.3.3 0 01.228-.211.293.293 0 01.287.117l1.2 1.61 2.008-.076a.31.31 0 01.269.152.3.3 0 010 .31l-1.171 1.639.7 1.891a.293.293 0 01-.064.3.3.3 0 01-.3.082l-1.92-.585-1.581 1.241a.292.292 0 01-.206.029zm-1.171-3.577l1.3.878a.3.3 0 01.135.24v1.569l1.235-.966a.316.316 0 01.269-.053l1.5.468-.539-1.475a.281.281 0 01.035-.269l.907-1.282-1.569.059a.287.287 0 01-.246-.117l-.943-1.259-.427 1.51a.293.293 0 01-.187.193z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-182.793 -195.69)"
            fill="#263238"
          />
          <path
            data-name="Path 98406"
            d="M326.561 56.457l-1.253 1.768.744 2.032-2.067-.644-1.7 1.335-.023-2.16-1.8-1.206 2.049-.7.589-2.082 1.294 1.739z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-147.185 -48.723)"
            fill="#fff"
          />
          <path
            data-name="Path 98407"
            d="M322.073 61.048a.223.223 0 01-.123 0 .281.281 0 01-.17-.258v-2.013l-1.692-1.124a.293.293 0 01.07-.521l1.9-.644.55-1.932a.287.287 0 01.515-.094l1.2 1.61 2.018-.072a.3.3 0 01.246.463l-1.171 1.637.7 1.9a.293.293 0 01-.064.3.3.3 0 01-.3.076l-1.92-.585-1.581 1.241a.293.293 0 01-.178.016zm-1.173-3.577l1.306.878a.3.3 0 01.129.24v1.569l1.235-.966a.281.281 0 01.269-.053l1.5.468-.539-1.475a.281.281 0 01.035-.269l.907-1.282-1.569.059a.287.287 0 01-.246-.117l-.937-1.259-.433 1.51a.269.269 0 01-.187.193z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-146.977 -48.531)"
            fill="#263238"
          />
          <path
            data-name="Path 98408"
            d="M373.971 211.251l-1.253 1.768.749 2.032-2.067-.644-1.7 1.335-.029-2.16-1.8-1.206 2.055-.7.591-2.078 1.294 1.733z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-166.839 -112.894)"
            fill="#fff"
          />
          <path
            data-name="Path 98409"
            d="M369.518 215.822a.258.258 0 01-.129-.029.287.287 0 01-.164-.258v-2.008l-1.669-1.124a.281.281 0 01-.129-.281.287.287 0 01.193-.24l1.909-.644.55-1.932a.287.287 0 01.515-.094l1.171 1.61 2.008-.076a.293.293 0 01.269.158.287.287 0 010 .3l-1.171 1.639.7 1.891a.3.3 0 01-.064.3.3.3 0 01-.3.076l-1.92-.585-1.581 1.241a.293.293 0 01-.187.047zm-1.171-3.571l1.306.872a.287.287 0 01.129.24v1.575l1.235-.972a.3.3 0 01.269-.053l1.5.468-.544-1.475a.3.3 0 01.041-.269l.925-1.259-1.575.059a.293.293 0 01-.246-.117l-.937-1.259-.427 1.51a.316.316 0 01-.187.2z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-166.654 -112.681)"
            fill="#263238"
          />
          <path
            data-name="Path 98410"
            d="M320.231 112.831l-1.253 1.768.744 2.032-2.067-.644-1.7 1.335-.029-2.16-1.8-1.206 2.049-.7.591-2.078 1.294 1.733z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-144.561 -72.095)"
            fill="#fff"
          />
          <path
            data-name="Path 98411"
            d="M315.768 117.413a.316.316 0 01-.129-.029.3.3 0 01-.164-.263v-2.008l-1.674-1.124a.3.3 0 01.07-.521l1.909-.644.544-1.932a.3.3 0 01.234-.2.293.293 0 01.287.111l1.2 1.61 2.008-.07a.275.275 0 01.269.152.287.287 0 010 .3l-1.171 1.645.691 1.885a.293.293 0 01-.363.381l-1.914-.585-1.587 1.241a.281.281 0 01-.211.053zm-1.171-3.577l1.306.872a.287.287 0 01.129.24v1.575l1.235-.972a.3.3 0 01.269-.053l1.5.468-.544-1.475a.3.3 0 01.035-.269l.907-1.282-1.564.06a.281.281 0 01-.246-.117l-.937-1.259-.427 1.51a.316.316 0 01-.187.2z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-144.372 -71.888)"
            fill="#263238"
          />
          <path
            data-name="Path 98412"
            d="M105.875 88.087l-1.247 1.768.744 2.032-2.067-.644-1.7 1.335-.023-2.166-1.8-1.206 2.049-.691.591-2.084 1.294 1.739z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-55.705 -61.835)"
            fill="#fff"
          />
          <path
            data-name="Path 98413"
            d="M101.393 92.662a.222.222 0 01-.123-.029.281.281 0 01-.17-.258v-2.014l-1.692-1.118a.293.293 0 01.07-.521l1.9-.644.55-1.932a.287.287 0 01.515-.094l1.171 1.61 2.014-.076a.293.293 0 01.246.463l-1.171 1.639.691 1.891a.3.3 0 01-.064.3.31.31 0 01-.3.076l-1.92-.585-1.581 1.247a.293.293 0 01-.136.045zm-1.171-3.577l1.306.878a.293.293 0 01.129.24v1.569l1.235-.966a.281.281 0 01.269-.053l1.5.468-.539-1.475a.281.281 0 01.035-.269l.907-1.282-1.569.059a.287.287 0 01-.246-.117l-.937-1.259-.433 1.51a.269.269 0 01-.187.193z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-55.497 -61.627)"
            fill="#263238"
          />
          <path
            data-name="Path 98414"
            d="M429.965 184.187l-1.247 1.768.744 2.032-2.067-.644-1.7 1.335-.023-2.16-1.8-1.206 2.049-.7.591-2.084 1.294 1.739z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-190.053 -101.672)"
            fill="#fff"
          />
          <path
            data-name="Path 98415"
            d="M425.519 188.762a.258.258 0 01-.129-.029.287.287 0 01-.164-.258v-2.014l-1.669-1.118a.293.293 0 01.07-.521l1.9-.644.55-1.932a.287.287 0 01.515-.094l1.2 1.61 2.014-.076a.287.287 0 01.263.152.3.3 0 010 .31l-1.171 1.639.691 1.891a.3.3 0 01-.064.3.31.31 0 01-.3.076l-1.92-.585-1.581 1.241a.293.293 0 01-.205.052zm-1.171-3.577l1.306.878a.3.3 0 01.129.24v1.569l1.235-.966a.281.281 0 01.269-.053l1.5.468-.539-1.475a.281.281 0 01.035-.269l.907-1.282-1.569.059a.287.287 0 01-.246-.117l-.937-1.259-.433 1.51a.269.269 0 01-.187.193z"
            transform="translate(-46.439 -198) translate(39.649 168.823) translate(17.157 39.778) translate(-189.869 -101.464)"
            fill="#263238"
          />
          <g>
            <path
              data-name="Path 98416"
              d="M158.633 296.782c-1.95 0-3.917-.082-5.855-.2V296c1.938.111 3.9.176 5.855.193zm5.855-.111v-.585c1.938-.088 3.893-.222 5.82-.41l.059.585c-1.95.164-3.917.3-5.866.386zm-17.564-.585a114.852 114.852 0 01-5.8-.8l.094-.585c1.909.31 3.846.585 5.773.8zm29.273-.539l-.088-.585c1.914-.287 3.852-.626 5.755-1.007l.111.585c-1.926.357-3.87.7-5.8.984zm-40.813-1.364c-1.9-.416-3.817-.884-5.691-1.393l.152-.585c1.868.509 3.77.978 5.661 1.388zm52.317-.948l-.146-.585a112.354 112.354 0 005.62-1.581l.17.556a125.077 125.077 0 01-5.661 1.587zm-63.622-2.135c-1.856-.585-3.712-1.276-5.521-1.979l.211-.544c1.8.7 3.647 1.358 5.492 1.967zm74.81-1.341l-.187-.585a109.91 109.91 0 005.427-2.155l.228.539a110.798 110.798 0 01-5.468 2.199zm-85.764-2.927a118.64 118.64 0 01-5.269-2.535l.263-.521a127.73 127.73 0 005.269 2.523zm96.554-1.692l-.258-.527a101.86 101.86 0 005.175-2.7l.281.515a104.48 104.48 0 01-5.2 2.722zm-106.993-3.64a120.504 120.504 0 01-5-3.062l.316-.492c1.622 1.048 3.3 2.073 4.976 3.044zm117.262-2.061l-.31-.5a117.42 117.42 0 004.877-3.226l.334.474a115.62 115.62 0 01-4.906 3.249zM92.839 275.12a124.646 124.646 0 01-4.684-3.56l.363-.457a118.174 118.174 0 004.643 3.542zm136.729-2.42l-.363-.463c1.528-1.171 3.05-2.447 4.514-3.718l.381.445c-1.441 1.279-3 2.536-4.532 3.736zm-145.874-4.939c-1.458-1.3-2.927-2.652-4.28-4.016l.41-.422a110.86 110.86 0 004.256 4zM238.437 265l-.41-.422c1.4-1.347 2.781-2.746 4.1-4.157l.427.4a115.899 115.899 0 01-4.117 4.179zm-163.086-5.5a102.479 102.479 0 01-3.841-4.444l.451-.375c1.229 1.5 2.512 2.986 3.823 4.42zm171.107-3.068l-.445-.381a112.667 112.667 0 003.653-4.555l.468.357a108.27 108.27 0 01-3.676 4.585zm-178.566-6.007a100.591 100.591 0 01-3.361-4.818l.486-.322c1.071 1.616 2.2 3.232 3.349 4.795zm185.668-3.331l-.486-.328c1.095-1.6 2.16-3.249 3.167-4.906l.5.3a108.738 108.738 0 01-3.173 4.93zm-192.131-6.475a115.554 115.554 0 01-2.845-5.146l.521-.269a118.39 118.39 0 002.828 5.117zm198.243-3.513l-.515-.281c.925-1.71 1.815-3.46 2.646-5.2l.527.252a114.032 114.032 0 01-2.658 5.193zM56.013 230.2a106.18 106.18 0 01-2.289-5.4l.544-.217c.708 1.8 1.475 3.606 2.277 5.375zm208.706-3.706l-.539-.222a115.012 115.012 0 002.1-5.445l.556.2a150.978 150.978 0 01-2.117 5.465zM51.71 219.285a260.664 260.664 0 01-1.721-5.609l.585-.158c.527 1.868 1.1 3.747 1.715 5.579zm216.943-3.835l-.585-.17c.585-1.856 1.071-3.747 1.528-5.626l.585.141a101.135 101.135 0 01-1.528 5.656zm-220.1-7.465l-.088-.386a107.22 107.22 0 01-1.06-5.369l.585-.1c.31 1.756.662 3.577 1.054 5.339l.088.386zm222.874-3.923l-.585-.105c.357-1.9.673-3.835.937-5.755l.585.082a107.43 107.43 0 01-.937 5.779zm-224.875-7.61a114.514 114.514 0 01-.55-5.855l.585-.041c.129 1.932.316 3.887.55 5.814zm226.457-3.969l-.585-.047c.158-1.932.269-3.893.334-5.855h.585c-.059 1.967-.17 3.94-.334 5.878zM45.75 184.719v-1.9c0-1.317 0-2.652.07-3.964h.585c-.047 1.306-.07 2.635-.07 3.946v1.9zm227.042-3.975c-.035-1.932-.129-3.9-.269-5.855l.585-.041c.141 1.944.234 3.917.269 5.855zm-226.047-7.7l-.585-.053c.17-1.938.392-3.893.662-5.82l.585.082a105.4 105.4 0 00-.662 5.792zm225.21-3.94c-.24-1.914-.527-3.858-.867-5.773l.585-.105c.34 1.926.638 3.882.872 5.8zm-223.594-7.61l-.585-.111c.369-1.909.8-3.835 1.265-5.72l.585.141a99.51 99.51 0 00-1.265 5.7zm221.767-3.115c-.416-1.891-.89-3.8-1.405-5.667l.585-.152c.515 1.873 1 3.788 1.417 5.691zm-218.963-8.2l-.585-.17c.585-1.862 1.171-3.735 1.844-5.562l.55.193c-.638 1.832-1.224 3.694-1.809 5.544zM267 147.126c-.585-1.838-1.276-3.688-1.979-5.492l.544-.217a120.514 120.514 0 011.991 5.521zm-211.891-7.91l-.539-.228a108.1 108.1 0 012.406-5.345l.527.252a104.4 104.4 0 00-2.391 5.322zm207.64-2.962c-.8-1.756-1.651-3.513-2.535-5.269l.521-.269c.89 1.756 1.756 3.513 2.553 5.269zM60.182 128.7l-.515-.281c.937-1.71 1.926-3.413 2.927-5.076l.5.31a141.391 141.391 0 00-2.924 5.047zm197.237-2.828a113.18 113.18 0 00-3.074-4.976l.486-.322a112.15 112.15 0 013.091 5zm-191.137-7.111l-.486-.334c1.107-1.6 2.266-3.2 3.448-4.748l.468.357a114.942 114.942 0 00-3.43 4.725zM251 116.091c-1.171-1.563-2.342-3.121-3.571-4.625l.451-.369a116.197 116.197 0 013.595 4.649zm-177.624-6.6l-.445-.375c1.265-1.487 2.582-2.927 3.917-4.373l.427.4a116.619 116.619 0 00-3.897 4.344zm170.247-2.453a110.389 110.389 0 00-4.034-4.227l.416-.416c1.376 1.376 2.74 2.8 4.051 4.25zM81.393 101l-.4-.427a114.961 114.961 0 014.35-3.946l.381.445A84.094 84.094 0 0081.393 101zm153.977-2.209a104.951 104.951 0 00-4.444-3.794l.369-.457a126.452 126.452 0 014.467 3.811zM90.263 93.369l-.357-.463a174.14 174.14 0 014.736-3.478l.334.48a102.25 102.25 0 00-4.731 3.46zm136.032-1.932c-1.563-1.171-3.179-2.254-4.807-3.314l.322-.492a115.218 115.218 0 014.83 3.331zM99.835 86.7l-.31-.5a106.833 106.833 0 015.076-2.968l.281.509a134.74 134.74 0 00-5.041 2.957zM216.5 85.056c-1.674-.972-3.4-1.92-5.117-2.8l.269-.521c1.727.89 3.46 1.838 5.14 2.822zm-106.425-3.993l-.258-.527a118.29 118.29 0 015.345-2.424l.228.539a114.556 114.556 0 00-5.315 2.412zm96.057-1.352c-1.756-.8-3.577-1.563-5.375-2.266l.211-.544c1.809.708 3.63 1.475 5.4 2.277zm-85.3-3.185l-.2-.585c1.827-.662 3.7-1.288 5.568-1.856l.17.585a112.54 112.54 0 00-5.534 1.855zm74.436-1.048a188.13 188.13 0 00-5.579-1.7l.158-.585a113.61 113.61 0 015.609 1.71zm-63.312-2.342l-.141-.585c1.013-.252 2.037-.5 3.056-.72q1.335-.3 2.67-.585l.117.585c-.89.176-1.756.363-2.664.585-.98.198-2.004.444-3.035.72zm52.106-.79c-1.891-.416-3.817-.79-5.726-1.112l.1-.585c1.914.322 3.852.7 5.749 1.124zm-40.631-1.493l-.082-.585c1.932-.281 3.893-.515 5.825-.7l.059.585c-1.923.184-3.878.418-5.799.699zm29.109-.439a114.56 114.56 0 00-5.814-.515l.035-.585c1.944.123 3.911.3 5.855.521zm-17.482-.644v-.585a115.18 115.18 0 014.684-.094h1.171v.585h-1.224a120.22 120.22 0 00-4.627.093z"
              transform="translate(-46.439 -198) translate(39.649 168.823) translate(29.35 54.177) translate(-45.75 -69.09)"
              fill="#263238"
            />
          </g>
        </g>
        <g data-name="Group 105827">
          <g
            data-name="Ellipse 129766"
            transform="translate(-46.439 -198) translate(-4 10) translate(157 296)"
            fill="#e9fbf9"
            stroke="#007965"
            strokeWidth={1}
          >
            <circle cx={30.5} cy={30.5} r={30.5} stroke="none" />
            <circle cx={30.5} cy={30.5} r={30} fill="none" />
          </g>
          <text
            transform="translate(-46.439 -198) translate(-4 10) translate(188 332)"
            fill="#007965"
            fontSize={16}
            fontFamily="Poppins-SemiBold, Poppins"
            fontWeight={600}
          >
            <tspan x={-15} y={0}>
              You
            </tspan>
          </text>
        </g>
        <g
          data-name="Ellipse 129792"
          transform="translate(-46.439 -198) translate(210 198)"
          fill="#e9fbf9"
          stroke="#263238"
          strokeWidth={0.5}
          strokeDasharray="4 2"
        >
          <circle cx={36} cy={36} r={36} stroke="none" />
          <circle cx={36} cy={36} r={35.75} fill="none" />
        </g>
        <g
          transform="translate(-46.439 -198) translate(124.003 88.302)"
          strokeWidth={0.2}
        >
          <rect
            data-name="Rectangle 56001"
            width={30.481}
            height={59.485}
            rx={4}
            transform="translate(107.08 115.68)"
            fill="#263238"
            stroke="#707070"
          />
          <g
            data-name="Group 105819"
            transform="translate(107.08 115.68)"
            clipPath="url(#a)"
          >
            <path
              data-name="Path 98417"
              d="M2.623 0A2.627 2.627 0 00-.004 2.627v54.231a2.619 2.619 0 00.942 2.014L18.722 0z"
              fill="#fff"
              stroke="#707070"
              opacity={0.2}
            />
            <path
              data-name="Path 98418"
              d="M16.278 57.764a1.036 1.036 0 10-1.036 1.036 1.036 1.036 0 001.036-1.036z"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <rect
            data-name="Rectangle 56003"
            width={30.481}
            height={59.485}
            rx={4}
            transform="translate(107.08 115.68)"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            data-name="Rectangle 56004"
            transform="translate(108.437 119.72)"
            fill="#92e3a9"
            stroke="#707070"
            d="M0 0H27.771V51.915H0z"
          />
          <g
            data-name="Group 105821"
            transform="translate(108.437 119.72)"
            clipPath="url(#b)"
          >
            <path
              data-name="Path 98419"
              d="M22.561 25.617l-4.4-3.978-4.274.074-4.274-.074-4.4 3.978-10.41 6.856v20.228h38.172V32.473z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98420"
              d="M13.531 40.582l-1.9 2.691s2.261-1.025 4.44-1.913a15.756 15.756 0 005.531-4.711c.614-1.023 1.508-2.527 1.508-2.527l-2.737-2.105h2.942a22.572 22.572 0 00-.957-5.806"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98421"
              d="M12.662 41.758c-.318-.134-.641-.268-.963-.4a15.7 15.7 0 01-5.531-4.711C5.554 35.624 4.66 34.12 4.66 34.12l2.738-2.103H4.47a22.573 22.573 0 01.957-5.806"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98422"
              d="M9.232 21.941s-.85 13.495 4.3 18.641c0 0 5.429-3.727 5.429-18.479z"
              fill="#fff"
              stroke="#707070"
            />
            <g
              data-name="Group 105820"
              transform="translate(9.18 21.941)"
              clipPath="url(#c)"
              stroke="#707070"
            >
              <path
                data-name="Path 98423"
                d="M2.926-15.356h4.378a4.732 4.732 0 014.732 4.732v9.82A6.353 6.353 0 015.685 5.55H4.552A6.353 6.353 0 01-1.801-.803v-9.822a4.732 4.732 0 014.732-4.732z"
                fill="#92e3a9"
              />
              <path
                data-name="Path 98424"
                d="M2.926-15.356h4.378a4.732 4.732 0 014.732 4.732v9.82A6.353 6.353 0 015.685 5.55H4.552A6.353 6.353 0 01-1.801-.803v-9.822a4.732 4.732 0 014.732-4.732z"
                fill="#fff"
                opacity={0.5}
              />
            </g>
            <path
              data-name="Path 98426"
              d="M9.232 21.941s-.85 13.495 4.3 18.641c0 0 5.429-3.727 5.429-18.479z"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98427"
              d="M11.397 20.791s-.471 5.889 2.373 8.135c0 0 3-1.626 3-8.064z"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98428"
              d="M10.447 30.775l3.322-1.849 3.729 2.578"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98429"
              d="M14.665 31.906l.648-1.864-1.548-1.116-2.026 1.119 1.053 1.7-1.662 4.992a11.412 11.412 0 002.393 3.842 10.2 10.2 0 002.842-3.974z"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle
              data-name="Ellipse 129767"
              cx={2.708}
              cy={2.708}
              r={2.708}
              transform="rotate(-9.26 238.397 -91.056)"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle
              data-name="Ellipse 129768"
              cx={1.947}
              cy={1.947}
              r={1.947}
              transform="rotate(-67.65 39.36 6.562)"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98430"
              d="M20.865 39.827a.415.415 0 01-.415-.415v-15.91a.415.415 0 11.829 0v15.911a.413.413 0 01-.415.415z"
              fill="#263238"
              stroke="#707070"
            />
            <path
              data-name="Path 98431"
              d="M7.781 45.596h-.04c-.377-.064-3.993-3.58-4.334-4.523a7.627 7.627 0 01-.241-2.506.208.208 0 01.415.026 7.728 7.728 0 00.217 2.344c.277.79 3.5 3.942 4 4.249a4.483 4.483 0 001.7-1.969.208.208 0 11.386.153c-.392 1.009-1.626 2.226-2.103 2.226zm.059-.405zm-.051-.009z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98432"
              d="M4.568 45.597c-.479 0-1.711-1.217-2.111-2.237a.208.208 0 11.386-.153 4.449 4.449 0 001.7 1.969c.509-.307 3.727-3.46 4-4.249a7.664 7.664 0 00.217-2.344.208.208 0 01.415-.026 8.018 8.018 0 01-.241 2.506c-.332.942-3.94 4.466-4.334 4.523zm-.059-.406zm.051-.009z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98433"
              d="M6.225 31.533a.416.416 0 01-.415-.415v-6.94a.415.415 0 01.829 0v6.94a.415.415 0 01-.414.415z"
              fill="#263238"
              stroke="#707070"
            />
            <path
              data-name="Path 98434"
              d="M8.932 39.404a.416.416 0 01-.415-.415v-4.994a2.378 2.378 0 00-4.756 0v4.99a.415.415 0 11-.829 0v-4.997a3.204 3.204 0 016.407 0v5a.417.417 0 01-.407.416z"
              fill="#263238"
              stroke="#707070"
            />
            <rect
              data-name="Rectangle 56005"
              width={1.053}
              height={1.464}
              rx={0.527}
              transform="rotate(-37.84 63.446 19.1)"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <rect
              data-name="Rectangle 56006"
              width={1.053}
              height={1.464}
              rx={0.527}
              transform="rotate(-142.16 12.434 20.374)"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <rect
              data-name="Rectangle 56007"
              width={2.143}
              height={3.733}
              rx={1.071}
              transform="translate(5.857 13.22)"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <rect
              data-name="Rectangle 56008"
              width={2.143}
              height={3.733}
              rx={1.071}
              transform="translate(20.337 13.22)"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98435"
              d="M12.106 3.867h4.378a4.732 4.732 0 014.732 4.732v9.82a6.353 6.353 0 01-6.353 6.353h-1.131a6.353 6.353 0 01-6.353-6.353v-9.82a4.732 4.732 0 014.727-4.732z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <rect
              data-name="Rectangle 56009"
              width={2.895}
              height={0.776}
              rx={0.388}
              transform="translate(10.129 12.13)"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <rect
              data-name="Rectangle 56010"
              width={2.895}
              height={0.776}
              rx={0.388}
              transform="translate(15.848 12.13)"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98436"
              d="M12.385 14.497c0 .448-.205.81-.46.81s-.458-.362-.458-.81.205-.812.458-.812.46.36.46.812z"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98437"
              d="M17.545 14.497c0 .448-.205.81-.46.81s-.46-.362-.46-.81.205-.812.46-.812.46.36.46.812z"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98438"
              d="M16.77 3.867h-4.95a4.445 4.445 0 00-4.445 4.445v10.446a6.013 6.013 0 006.013 6.013h1.824a6.011 6.011 0 006.013-6.013V8.312a4.445 4.445 0 00-4.455-4.445zm3.392 13.419a3.94 3.94 0 01-1.27 2.542s-1.342-1.766-1.907-1.907a17.891 17.891 0 00-2.65-.034 17.7 17.7 0 00-2.638.034c-.565.141-1.907 1.907-1.907 1.907a3.94 3.94 0 01-1.27-2.542v-5.791l.661-.871a1.962 1.962 0 00.092-2.288 1.873 1.873 0 01.266-2.369l.013-.011a1.873 1.873 0 012.308-.234l.987.775a2.45 2.45 0 003.015 0l.984-.775a1.884 1.884 0 012.322.234l.011.011a1.894 1.894 0 01.249 2.4 1.956 1.956 0 00.111 2.261l.684.871z"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98439"
              d="M15.355 17.045s.848-.113.848.377-.5.846-1.483.494"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98440"
              d="M15.282 13.048v4.1a.848.848 0 01-.846.848h-.754c-.539.038-.727-.094-.791-.322a.565.565 0 01.072-.45h0c0-.211.9-.211.9-.211"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98441"
              d="M14.395 20.33a4.494 4.494 0 01-2.244-.586.311.311 0 01.332-.526 3.989 3.989 0 003.859-.019.311.311 0 11.292.548 4.711 4.711 0 01-2.239.582z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Line 1567"
              transform="translate(16.664 15.722)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M0 0L1.368 0"
            />
            <path
              data-name="Line 1568"
              transform="translate(11.23 15.722)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M0 0L1.368 0"
            />
            <circle
              data-name="Ellipse 129769"
              cx={2.446}
              cy={2.446}
              r={2.446}
              transform="translate(3.364 45.823)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98442"
              d="M5.806 48.874h0a.494.494 0 01-.494-.494v-1.564a.494.494 0 01.494-.494h0a.494.494 0 01.494.494v1.564a.494.494 0 01-.494.494z"
              fill="#263238"
              stroke="#707070"
            />
            <path
              data-name="Path 98443"
              d="M5.81 49.23a.874.874 0 01-.872-.873v-.735a.091.091 0 01.09-.09.089.089 0 01.09.09v.735a.693.693 0 001.385 0v-.735a.089.089 0 01.09-.09.09.09 0 01.09.09v.735a.874.874 0 01-.874.872z"
              fill="#263238"
              stroke="#707070"
            />
            <path
              data-name="Path 98444"
              d="M5.809 50.168a.089.089 0 01-.089-.09v-.942a.094.094 0 11.188 0v.942a.089.089 0 01-.1.09z"
              fill="#263238"
              stroke="#707070"
            />
            <path
              data-name="Path 98445"
              d="M6.413 50.217h-1.2a.092.092 0 01-.09-.09.09.09 0 01.09-.09h1.2a.09.09 0 01.09.09.092.092 0 01-.09.09z"
              fill="#263238"
              stroke="#707070"
            />
            <circle
              data-name="Ellipse 129770"
              cx={2.446}
              cy={2.446}
              r={2.446}
              transform="translate(19.561 45.823)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98446"
              d="M23.516 47.553l-.714.413v-.34a.292.292 0 00-.292-.29h-1.613a.29.29 0 00-.292.29v1.3a.29.29 0 00.292.292h1.613a.292.292 0 00.292-.292v-.33l.714.413z"
              fill="#263238"
              stroke="#707070"
            />
            <circle
              data-name="Ellipse 129771"
              cx={2.446}
              cy={2.446}
              r={2.446}
              transform="translate(11.463 45.823)"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98447"
              d="M15.148 47.753h-2.476a.467.467 0 00-.46.552l.072.388a.117.117 0 00.113.094h.754a.117.117 0 00.117-.117v-.42h1.3v.42a.117.117 0 00.117.117h.754a.117.117 0 00.115-.094l.072-.388a.467.467 0 00-.477-.552z"
              fill="#92e3a9"
              stroke="#707070"
            />
            <path
              data-name="Rectangle 56011"
              transform="translate(24.376 .539)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M0 0H2.303V1.263H0z"
            />
            <path
              data-name="Rectangle 56012"
              transform="translate(24.376 .539)"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M0 0H1.796V1.263H0z"
            />
            <path
              data-name="Rectangle 56013"
              transform="translate(26.673 .891)"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M0 0H0.324V0.556H0z"
            />
            <path
              data-name="Rectangle 56014"
              transform="translate(.477 .929)"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M0 0H0.422V0.724H0z"
            />
            <path
              data-name="Rectangle 56015"
              transform="translate(1.14 .677)"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M0 0H0.422V0.978H0z"
            />
            <path
              data-name="Rectangle 56016"
              transform="translate(1.803 .375)"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M0 0H0.422V1.278H0z"
            />
          </g>
          <path
            data-name="Rectangle 56018"
            transform="translate(108.437 119.72)"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M0 0H27.771V51.915H0z"
          />
        </g>
        <g
          data-name="Ellipse 129790"
          transform="translate(-46.439 -198) translate(48 352)"
          fill="#e9fbf9"
          stroke="#263238"
          strokeWidth={0.5}
          strokeDasharray="4 2"
        >
          <circle cx={44} cy={44} r={44} stroke="none" />
          <circle cx={44} cy={44} r={43.75} fill="none" />
        </g>
        <g
          data-name="Ellipse 129791"
          transform="translate(-46.439 -198) translate(53 237)"
          fill="#e9fbf9"
          stroke="#263238"
          strokeWidth={0.5}
          strokeDasharray="4 2"
        >
          <circle cx={30} cy={30} r={30} stroke="none" />
          <circle cx={30} cy={30} r={29.75} fill="none" />
        </g>
        <g
          data-name="Mask Group 35"
          transform="translate(-46.439 -198) translate(-3217.692 -5784.692)"
          clipPath="url(#d)"
        >
          <g transform="translate(3276.271 6148.12)" strokeWidth={0.2}>
            <path
              data-name="Path 98607"
              d="M37.904 46.964s-3.315 12.149-3.682 17.3 0 10.921.49 12.251 4.424 20.739 4.424 20.739-1.96 2.576-2.7 3.679-3.189 2.947-3.311 3.682 2.944.368 4.54-.123 3.189-2.086 3.927-2.454 2.331-.49 2.331-1.841-.984-3.927-.984-5.646-.252-13.218-.252-15.44-1.841-5.275-1.841-5.275l3.8-13.007s.613 14.6 1.361 16.934a171.371 171.371 0 012.947 19.755 12.892 12.892 0 01-.245 3.311s-2.825 3.8-3.927 5.152-2.331 1.841-1.361 2.7 6.749.245 8.1-3.437 1.841-8.712 2.331-11.656 1.474-6.994.98-10.676-2.331-5.887-1.96-7.487 3.311-20.368 3.311-23.315a9.674 9.674 0 00-.735-4.291s-8.954 2.831-17.544-.855z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98608"
              d="M56.186 52.119a9.692 9.692 0 00-.735-4.291s-8.957 2.821-17.547-.861c0 0-3.315 12.149-3.682 17.3s0 10.921.49 12.251c.374 1.021 2.723 12.384 3.829 17.843a5.891 5.891 0 004.394.15c0-1.855-.245-13.225-.245-15.416s-1.841-5.275-1.841-5.275l3.8-13.007s.613 14.6 1.361 16.934a171.368 171.368 0 012.947 19.755v.463a6.6 6.6 0 004.217.245c.276-1.746.487-3.379.681-4.635.49-2.944 1.474-6.994.98-10.676s-2.331-5.888-1.96-7.487 3.311-20.345 3.311-23.293z"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98609"
              d="M38.15 44.023s-.613 2.944-.613 3.556 2.821 3.192 8.219 3.682 8.957-.49 9.941-.98.123-5.523.123-5.523-8.345 2.576-11.533 1.6a57.347 57.347 0 01-6.136-2.331z"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98610"
              d="M2.447 39.865S.266 43.221.021 44.922 1.831 48.58 3.06 47.6s1.964-6.51 1.964-7.245-.246-2.213-2.577-.49z"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98611"
              d="M6.252 33.351s-2.209.248-2.58 1.229a57.358 57.358 0 00-2.086 6.017c-.123.984 2.457 1.229 2.457 1.229z"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98612"
              d="M14.35 23.778s-6.262 4.176-7.613 7.123-4.172 13.385-4.666 15.471 1.719 3.682 4.424 4.543 5.033 1.229 8.1-1.361 2.955-8.848 2.955-11.911-.613-12.646-.858-13.507-2.342-.358-2.342-.358z"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98613"
              d="M12.309 45.749a59.853 59.853 0 00-1.045 12.023 73.685 73.685 0 01-.391 11.765c-.262 2.743-1.307 6.534-1.307 10.846s2.222 14.508 2.222 15.815-1.177 6.534-1.177 8.508.783 5.357 3.4 4.183 1.307-6.806 1.307-10.455a124.471 124.471 0 011.436-14.378c.653-4.574 1.045-12.544 1.307-13.592s2.09-8.886 2.222-10.455a43.668 43.668 0 011.96-6.4v12.41c0 4.836.653 7.97.653 11.5s-.262 6.667 0 9.8-.262 10.455-.262 12.677-.262 2.222 1.569 3.4 1.569 2.222 2.743 3.134 3.4 1.569 3.662-.259-2.484-6.667-3.138-7.974 1.307-11.23 1.96-14.634a66.622 66.622 0 00.653-14.246c-.391-2.876 3.658-14.246 3.529-18.3.001-.008-12.938.121-21.303-5.368z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98614"
              d="M33.613 51.109s-12.932.129-21.3-5.36a59.853 59.853 0 00-1.045 12.023 73.687 73.687 0 01-.391 11.765c-.262 2.743-1.307 6.534-1.307 10.846 0 2.828.953 8.168 1.613 11.911.735.606 2.083 1.089 4.492.415.289-2.893.708-6.034 1.082-8.661.653-4.574 1.045-12.544 1.307-13.592s2.09-8.886 2.222-10.455a43.669 43.669 0 011.96-6.4v12.418c0 4.836.653 7.97.653 11.5s-.262 6.667 0 9.8c.071.871.085 2.059.065 3.373a8.525 8.525 0 005.095.562c.476-2.927 1.079-6 1.389-7.606a66.623 66.623 0 00.653-14.246c-.395-2.873 3.641-14.243 3.512-18.293z"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98615"
              d="M27.296 16.73s-5.966-.119-8.038.854-3.652 18.265-3.652 18.265l-3.4 10.472s7.307 5.1 11.326 5.483a95.937 95.937 0 0010.21.119l.487-11.69s4.387-13.272 5.36-16.676-1.582-4.628-4.142-5.6-8.151-1.227-8.151-1.227z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98616"
              d="M21.385 29.121L17.461 44.83l12.874 4.2 4.019-16.073z"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98617"
              d="M21.727 17.026l-7.74 24.189 9.825-24.557z"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98618"
              d="M20.113 16.366s-3.533.364-4.383 1.7-5.847 13.517-5.969 15.1 11 12.65 11 12.65l2.382-1.324s-3.529-5.847-4.261-8.038a16.264 16.264 0 00-2.345-4.23l3.441-9.41"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98619"
              d="M23.154 44.497a9.219 9.219 0 012.8-.245c.487.242 3.168 2.559 3.168 2.559s.242.487-.609.487a8.973 8.973 0 01-2.682-.977l1.828 3.9a1.178 1.178 0 010 .977c-.242.487-1.218.242-1.7.242a5.439 5.439 0 01-2.678-.242c-.977-.487-2.518-5.374-2.518-5.374z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98620"
              d="M39.865 22.182c.119.732-1.582 12.418-1.582 14.7s-.64 6.3-2.382 8.222-6.827 4.383-6.827 4.383l-.562-2.185s6.126-10.138 6.211-10.414 1.916-11.23 1.916-11.23"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98621"
              d="M25.592 47.113a16.623 16.623 0 01-2.192.824c-.548.088-1.644 1.46-2.559 1.916s-.728 1.188-.272 1.28a4.858 4.858 0 001.644-.368s-1.188 1.463-1.1 1.827.912.548 1.28.456 1.644.276 2.92.184 3.744-3.743 3.744-3.743l-.456-2.467z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98622"
              d="M43.917 18.622a14.992 14.992 0 00-5.033.248c-1.719.616-2.944 8.709-2.086 11.166a23.3 23.3 0 01.371 10.55c-.735 3.063-.248 5.156 5.765 7.116s9.815.861 11.778-.613 2.951-20.981 2.951-23.189-6.871-4.662-9.189-5.03a24.162 24.162 0 00-4.557-.248z"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98623"
              d="M48.474 18.87s-5.785 12.881-5.785 13.987v2.576l7.487 12.639.123-1.7-6.5-11.533V32.63l6.013-13.613z"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98624"
              d="M54.223 31.874s-3.8 10.921-4.172 13.868a5.926 5.926 0 003.315 6.5c2.576 1.348 4.662 2.457 8.59 1.106s5.52-7.239 4.662-11.911-2.454-11.149-4.05-14.212-3.682-3.8-5.4-2.454-2.945 7.103-2.945 7.103z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98625"
              d="M58.133 37.629s-3.679 10.087-4.213 12.35 3.087 4.063 5.363 3.9"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98626"
              d="M66.583 46.565a12.931 12.931 0 00-4.387-2.437c-2.6-.813-5.037-1.623-5.687-1.137s-.977 2.6-.977 2.6a41.11 41.11 0 016.177 1.463 19.2 19.2 0 013.9 2.11s.651-.499.974-2.599z"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98627"
              d="M28.086 11.384s-8.1-.98-10.55.245.368 3.192 2.821 4.05a13.776 13.776 0 005.891.735c1.348-.123 2.577-3.067 1.838-5.03z"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98628"
              d="M26.738 17.764s-.123 3.8 4.295 4.662 4.785-1.719 4.785-1.719l-.49-6.126-3.927-1.719z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98629"
              d="M38.637 2.041S37.296.584 33.614.955s-5.768 6.994-6.5 9.08-2.821 7.974-2.7 8.848 3.063.735 4.54-1.474a24.421 24.421 0 002.454-4.54c.735-1.6 3.56-5.785 3.56-5.785l.735 6.013a20.759 20.759 0 00-1.964 6.5c-.368 3.434.368 6.626-.735 8.59s-1.361 3.189 1.225 2.821 5.4-5.52 5.646-8.848.49-6.013.613-10.06.122-7.242-.49-8.345a6.718 6.718 0 00-1.361-1.714z"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98630"
              d="M36.529 27.678a3.849 3.849 0 01-1.317.378"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98631"
              d="M38.864 13.078s.466.541.245 3.165.122 7.793-.854 9.743a3.655 3.655 0 01-.8 1.072"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98632"
              d="M26.078 14.661a5.18 5.18 0 002.8-1.827"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98633"
              d="M35.941 1.875s1.218 1.089.977 1.947"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98634"
              d="M44.05.833s-2.947-.248-4.172 1.7-.122 5.033-.122 9.573-.245 9.08-.861 10.917 1.474 1.229 2.454-.245 1.841-3.924 2.331-4.662 3.315-1.841 3.315-1.841-.245 4.54.49 6.126 3.8 1.229 4.785.613a24.053 24.053 0 002.576-2.083s-1.361-.616-1.361-4.172.613-9.818-1.106-13.375A5.864 5.864 0 0044.051.832z"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98635"
              d="M47.964 10.281a8.294 8.294 0 012.59 4.5c.609 2.923-.364 6.088 1.218 6.575"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98636"
              d="M46.981 3.158a11.408 11.408 0 013.332 3.464c2.192 3.533 1.582 9.869 2.069 12.667s2.069 1.337 2.069 1.337"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98637"
              d="M44.952 2.12a6.682 6.682 0 011.082.473"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98638"
              d="M43.979 1.511a7.6 7.6 0 00-1.535 2.144"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98639"
              d="M42.322 15.433a12.215 12.215 0 01.245 4.295c-.368 1.719 1.1 3.189 2.331 2.086a7.379 7.379 0 002.086-4.424 17.946 17.946 0 01.49-2.7s-4.539 1.231-5.152.743z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98640"
              d="M43.913 100.22a9.458 9.458 0 00-.313-1.93c-1.446.609-3 1.317-3 1.317a2.164 2.164 0 00-.98-1.229 2.93 2.93 0 00-1.133-.255c-.64.851-1.593 2.134-2.042 2.831-.735 1.106-3.189 2.947-3.311 3.682s2.944.368 4.54-.123 3.189-2.086 3.927-2.454 2.312-.488 2.312-1.839z"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98641"
              d="M51.537 105.249a27.227 27.227 0 00.963-3.4l-1.7.943s0-.49-.984-1.474a2.256 2.256 0 00-1.079-.585.977.977 0 01-.024.1s-2.825 3.8-3.927 5.152-2.331 1.841-1.361 2.7 6.751.247 8.112-3.436z"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Line 1571"
              transform="translate(42.934 56.785)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M1.719 4.046L0 0"
            />
            <path
              data-name="Path 98642"
              d="M22.321 12.979s4.54 5.4 4.54 6.5-3.91 1.957-5.152 1.841-5.278-5.033-6.013-6.626 1.1-2.576 2.331-2.825a14.294 14.294 0 012.454-.245"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98643"
              d="M29.192 23.41s.32 1.021.408 1.5a11.638 11.638 0 00.133 1.776c.177.446-.133 1.419-.841.708a2.284 2.284 0 01-.4-2.307 13.727 13.727 0 01.7-1.681z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98644"
              d="M25.754 18.87s-2.454 0-3.189.613-.123 1.841-.123 1.841a11.517 11.517 0 00.592 1.77c.636 1.181 1.331 1.29 1.331 1.29s.041 2.093.776 2.093a13.9 13.9 0 003.192 0c.616-.245.858-2.209.858-3.063s-2.694-4.792-3.437-4.544z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Line 1572"
              transform="translate(25.755 23.533)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M0.248 0L0 2.821"
            />
            <path
              data-name="Line 1573"
              transform="translate(26.932 23.58)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M0.493 0L0 2.944"
            />
            <path
              data-name="Path 98645"
              d="M28.511 23.764s-.34 1.821-.493 2.658"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98646"
              d="M14.01 108.874c-2.614 1.174-3.4-2.222-3.4-4.183s1.178-7.187 1.178-8.508a7.654 7.654 0 00-.085-.81 3.426 3.426 0 003.706.476c-.058.932-.092 1.8-.092 2.556 0 3.69 1.307 9.292-1.307 10.469zm12.932-2.355c1.178.915 3.4 1.569 3.662-.259s-2.484-6.667-3.138-7.974a10.266 10.266 0 01.089-3.743 4.679 4.679 0 01-4.707-.272c-.1 2.382-.218 4.656-.218 5.724 0 2.222-.262 2.222 1.569 3.4s1.572 2.209 2.746 3.121z"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98647"
              d="M24.204 103.385c1.831 1.174 1.569 2.222 2.743 3.134s3.4 1.569 3.662-.259v-.136c-1.8.766-2.61.048-3.56-.742-1.1-.915-1.46-2.284-2.92-2.923a2.9 2.9 0 01-1.5-2.474c.006 2.222-.256 2.222 1.575 3.4z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98648"
              d="M15.637 104.923c-.368 1.038-.97 2.43-2.011 2.831-1.1.432-2.205-.538-2.811-1.222.374 1.654 1.307 3.189 3.2 2.341 1.224-.554 1.585-2.092 1.622-3.95z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98649"
              d="M42.444 3.655s-2.086 1.593-2.331 2.576a28.331 28.331 0 00.368 7.116 5.738 5.738 0 002.661 3.345c1.7 1 4.332-1.994 4.332-1.994l.49-4.424s-5.52-4.9-5.52-6.619z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98650"
              d="M42.083 9.12c0 .34-.15.6-.34.6s-.34-.265-.34-.6.15-.592.34-.592.34.265.34.592z"
              fill="#263238"
              stroke="#707070"
            />
            <path
              data-name="Path 98651"
              d="M45.198 9.12c0 .34-.146.6-.34.6s-.34-.265-.34-.6.15-.592.34-.592.34.265.34.592z"
              fill="#263238"
              stroke="#707070"
            />
            <path
              data-name="Path 98652"
              d="M42.75 9.345a12.654 12.654 0 00-.813 1.7c-.075.371.446.742 1.113.681"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98653"
              d="M40.988 7.639a1.143 1.143 0 011.409-.15"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98654"
              d="M43.567 7.565a1.562 1.562 0 012 .371"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98655"
              d="M42.883 13.078s1.409.664 2.723-1.079"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98656"
              d="M36.676 4.683a2.487 2.487 0 00-2.828.807c-1.348 1.487-1.361 3.631-2.556 5.1a8.745 8.745 0 01-1.882 1.885s.269 3.362 2.42 4.843 4.574-1.212 6.592-4.843c0 .011-2.151-5.642-1.746-7.792z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98657"
              d="M36.246 10.839a10.04 10.04 0 00-.936 1.991c-.153.681-1.218.456-1.3-.153"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98658"
              d="M32.187 12.448a2.147 2.147 0 001.678 1.446"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98659"
              d="M33.558 8.338a1.235 1.235 0 011.753.381"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98660"
              d="M36.683 9.481s1.065-.153 1.674 1.446"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98661"
              d="M33.266 10.342s.912-.681 1.657.5"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98662"
              d="M36.417 11.669s.827-.415.994.745"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98663"
              d="M48.702 34.576a41.645 41.645 0 00-3.927-2.331 9.291 9.291 0 00-3.189-.248.735.735 0 00-.616.861l.245.49a2.552 2.552 0 00.493 2.454c.984.858 4.169.861 4.169.861l1.964.98z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Line 1574"
              transform="translate(51.085 31.003)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M0 0L2.26 0.708"
            />
            <path
              data-name="Path 98664"
              d="M52.262 29.42l2.7 5.891a21.709 21.709 0 01-4.785-.858c-1.474-.613-2.576.123-2.7.98s-.613 3.311.368 3.8 5.768 1.47 9.325 2.086 5.646-.616 5.891-1.841-3.311-11.656-4.295-13.865-2.454-4.05-4.05-4.05"
              fill="#92e3a9"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              data-name="Path 98665"
              d="M54.958 35.311a6.214 6.214 0 014.308 1.361"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
        <g
          data-name="Mask Group 37"
          transform="translate(-46.439 -198) translate(-3412 -6293)"
          clipPath="url(#e)"
        >
          <g data-name="Online Personal Trainer-bro">
            <g
              transform="translate(3459.229 6534.431) translate(40.43 19.634)"
              strokeWidth={0.1}
            >
              <path
                data-name="Rectangle 56019"
                transform="translate(5.384)"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H11.288V7.047H0z"
              />
              <path
                data-name="Rectangle 56020"
                transform="translate(5.095)"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H11.288V7.047H0z"
              />
              <path
                data-name="Rectangle 56021"
                transform="translate(5.62 .504)"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H10.237V6.216H0z"
              />
              <path
                data-name="Line 1575"
                transform="translate(6.659 .521)"
                fill="none"
                stroke="#263238"
                d="M0 3.407L0 0"
              />
              <path
                data-name="Line 1576"
                transform="translate(8.568 .521)"
                fill="none"
                stroke="#263238"
                d="M0 3.407L0 0"
              />
              <path
                data-name="Line 1577"
                transform="translate(10.479 .521)"
                fill="none"
                stroke="#263238"
                d="M0 3.407L0 0"
              />
              <path
                data-name="Line 1578"
                transform="translate(12.389 .521)"
                fill="none"
                stroke="#263238"
                d="M0 3.407L0 0"
              />
              <path
                data-name="Line 1579"
                transform="translate(14.298 .521)"
                fill="none"
                stroke="#263238"
                d="M0 3.407L0 0"
              />
              <path
                data-name="Line 1580"
                transform="translate(5.627 2.146)"
                fill="none"
                stroke="#263238"
                d="M0 0L10.195 0"
              />
              <path
                data-name="Line 1581"
                transform="translate(5.532 3.893)"
                fill="none"
                stroke="#263238"
                d="M0 0L10.311 0"
              />
              <ellipse
                data-name="Ellipse 129784"
                cx={0.932}
                cy={0.852}
                rx={0.932}
                ry={0.852}
                transform="translate(9.577 4.313)"
                fill="#92e3a9"
                stroke="#263238"
              />
              <path
                data-name="Path 98666"
                d="M10.077 4.185a.656.656 0 00-.477 0c-.274.1-.4.548-.4.624s.236 1.068.236 1.068-.26.165-.274.217.4-.076.439-.133.032-1.171.032-1.171a1.477 1.477 0 00.439-.013 1.426 1.426 0 00.2-.114l.413.013a2.852 2.852 0 00.314.177.937.937 0 00.2.051l.057.808a3.238 3.238 0 00.051.38 3.279 3.279 0 00.35.07c.063 0-.236-.222-.236-.222s.2-1.082.19-1.217a.38.38 0 00-.133-.285.832.832 0 00-.38-.146h-.15a.882.882 0 01-.458.011 1.369 1.369 0 00-.306-.114z"
                fill="#fff"
                stroke="#263238"
              />
              <path
                data-name="Path 98667"
                d="M11.489 4.428a.833.833 0 00-.38-.146h-.15a.882.882 0 01-.458.011 1.369 1.369 0 00-.306-.114h-.114a.656.656 0 00-.477 0c-.274.1-.4.547-.4.624a1.239 1.239 0 00.027.133h.407V4.78a1.476 1.476 0 00.439-.013 1.429 1.429 0 00.2-.114l.413.013a2.852 2.852 0 00.314.177.941.941 0 00.2.051v.038h.392a1.39 1.39 0 00.019-.217.38.38 0 00-.126-.287z"
                fill="#263238"
                stroke="#263238"
              />
              <path
                data-name="Path 98668"
                d="M9.606 5.949a.129.129 0 00.01-.048l-.061.015-.114-.051s-.26.165-.274.217.401-.071.439-.133z"
                fill="#fff"
                stroke="#263238"
              />
              <path
                data-name="Path 98669"
                d="M11.433 5.935l-.057.044-.078-.023.021.131a3.264 3.264 0 00.35.07c.062 0-.236-.222-.236-.222z"
                fill="#fff"
                stroke="#263238"
              />
              <path
                data-name="Path 98670"
                d="M10.923 2.682l-.076-.133s-.038-.152-.057-.211a1.045 1.045 0 00-.038-.1l.317-.624.854.1a.761.761 0 00.087.108.613.613 0 00.165.07c.019 0-.063-.1-.063-.1a.97.97 0 00.141.068c.019 0 .044.065.063.065s-.025-.127-.051-.165a1.9 1.9 0 00-.355-.2 5.306 5.306 0 00-.951-.293c-.053.038-.4.808-.485.987a1.624 1.624 0 00-.146.54c0 .089-.1.694-.1.783s-.019.3-.019.3l-.133.306a1.545 1.545 0 00.445.211 1.271 1.271 0 00.485-.108l-.051-.281.439-.6a3.04 3.04 0 00.439.426c.059 0 .1 0 .076-.146a2.585 2.585 0 00-.35-.591 1.672 1.672 0 00-.363-.19l-.255-.158z"
                fill="#fff"
                stroke="#263238"
              />
              <path
                data-name="Path 98671"
                d="M11.208 2.907h-.011l-.255-.158-.019-.065-.068-.12c-.106.08-.361.27-.547.394-.027.213-.078.553-.078.618s-.019.3-.019.3l-.133.306a1.545 1.545 0 00.445.211 1.272 1.272 0 00.485-.108l-.051-.281.352-.477a1.689 1.689 0 01-.101-.62z"
                fill="#92e3a9"
                stroke="#263238"
              />
              <path
                data-name="Path 98672"
                d="M10.959 2.526a.493.493 0 01-.1.181.19.19 0 00.019.281c.1.057.19-.04.23-.084a2.714 2.714 0 00.146-.279l-.255-.154z"
                fill="#fff"
                stroke="#263238"
              />
              <path
                data-name="Path 98673"
                d="M11.095 2.039s.027-.1-.063-.019-.068.148-.032.167.095-.148.095-.148z"
                fill="#fff"
                stroke="#263238"
              />
              <path
                data-name="Path 98674"
                d="M11.585 2.336s.078-.059.042.051-.112.122-.143.093.101-.144.101-.144z"
                fill="#fff"
                stroke="#263238"
              />
              <path
                data-name="Path 98675"
                d="M11.211 1.861s-.139.2-.211.327a.367.367 0 00-.04.338.274.274 0 00.222.162c.127.025.247-.1.264-.12s.2-.291.247-.38a.314.314 0 00-.078-.321.262.262 0 00-.4-.006z"
                fill="#fff"
                stroke="#263238"
              />
              <path
                data-name="Path 98676"
                d="M11.608 1.867a.262.262 0 00-.4 0s-.061.089-.124.19v.017l.044.027a.69.69 0 00.133-.165c.032-.07.07-.141.141-.076s.025.158.133.19.2.044.141.1-.076.057-.1.116a.5.5 0 01-.089.133l.051.03c.057-.084.12-.19.144-.226a.314.314 0 00-.074-.336z"
                fill="#263238"
                stroke="#263238"
              />
              <path
                data-name="Path 98677"
                d="M11.75 3.713l-.38.542a.784.784 0 00-.243-.025c-.057.019-.125.044-.1.057a2.717 2.717 0 00.312.1.382.382 0 00.1-.025s.509-.458.548-.529-.171-.331-.171-.331"
                fill="#fff"
                stroke="#263238"
              />
              <path
                data-name="Rectangle 56022"
                transform="translate(0 7.049)"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H16.762V0.557H0z"
              />
              <path
                data-name="Rectangle 56023"
                transform="translate(10.764 7.049)"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H5.998V0.557H0z"
              />
              <path
                data-name="Path 98678"
                d="M10.863.254a.125.125 0 11-.124-.125.124.124 0 01.124.125z"
                fill="#263238"
                stroke="#707070"
              />
            </g>
            <g
              transform="translate(3459.229 6534.431) translate(16.782 27.214)"
              strokeWidth={0.1}
            >
              <path
                data-name="Path 98679"
                d="M51.974.245l5.384 20.187h-5.444z"
                fill="#92e3a9"
                stroke="#707070"
              />
              <path
                data-name="Path 98680"
                d="M51.974.245l5.384 20.187h-5.444z"
                fill="#fff"
                stroke="#707070"
                opacity={0.5}
              />
              <path
                data-name="Rectangle 56024"
                transform="translate(4.895)"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H47.019V20.421H0z"
              />
              <path
                data-name="Rectangle 56025"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H47.019V20.421H0z"
              />
              <path
                data-name="Rectangle 56026"
                transform="translate(1.013 .76)"
                fill="#bfbfbf"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H44.992V18.9H0z"
              />
              <path
                data-name="Rectangle 56027"
                transform="translate(34.061 .76)"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H1.013V9.125H0z"
              />
              <path
                data-name="Rectangle 56028"
                transform="translate(23.13 .76)"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H1.013V9.125H0z"
              />
              <path
                data-name="Rectangle 56029"
                transform="translate(24.098 .76)"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H4.838V9.125H0z"
              />
              <path
                data-name="Rectangle 56030"
                transform="translate(18.474 10.482)"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H4.838V9.125H0z"
              />
              <path
                data-name="Rectangle 56031"
                transform="translate(1.017 10.482)"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H4.838V9.125H0z"
              />
              <path
                data-name="Rectangle 56032"
                transform="translate(31.7 10.482)"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H4.838V9.125H0z"
              />
              <path
                data-name="Rectangle 56033"
                transform="translate(12.117 .76)"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H4.838V9.125H0z"
              />
              <path
                data-name="Rectangle 56034"
                transform="translate(1.017 .76)"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H4.838V9.125H0z"
              />
              <path
                data-name="Rectangle 56035"
                transform="translate(35.063 .76)"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H4.838V9.125H0z"
              />
              <path
                data-name="Rectangle 56036"
                transform="translate(11.058 .76)"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H1.013V9.125H0z"
              />
              <path
                data-name="Rectangle 56037"
                transform="translate(17.427 10.519)"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H1.013V9.125H0z"
              />
              <path
                data-name="Rectangle 56038"
                transform="translate(30.687 10.519)"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H1.013V9.125H0z"
              />
              <path
                data-name="Rectangle 56039"
                transform="translate(1.032 9.741)"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0 0H44.973V0.785H0z"
              />
              <circle
                data-name="Ellipse 129785"
                cx={0.441}
                cy={0.441}
                r={0.441}
                transform="translate(42.013 15.762)"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                data-name="Path 98681"
                d="M44.958 19.663a2.045 2.045 0 00.264-1 2.241 2.241 0 00-1-1.817h-3.53a2.238 2.238 0 00-1 1.817 2.066 2.066 0 00.264 1z"
                fill="#fff"
                stroke="#263238"
              />
              <rect
                data-name="Rectangle 56040"
                width={4.38}
                height={0.475}
                rx={0.238}
                transform="translate(40.264 16.338)"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                data-name="Path 98682"
                d="M37.291 16.714a.38.38 0 10-.38.38.38.38 0 00.38-.38z"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                data-name="Path 98683"
                d="M39.047 19.661a1.74 1.74 0 00.226-.854 1.9 1.9 0 00-.854-1.547H35.41a1.9 1.9 0 00-.854 1.547 1.739 1.739 0 00.226.854z"
                fill="#fff"
                stroke="#263238"
              />
              <rect
                data-name="Rectangle 56041"
                width={3.732}
                height={0.405}
                rx={0.202}
                transform="translate(35.05 16.83)"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                data-name="Path 98684"
                d="M43.466 7.406l.272.135a2.163 2.163 0 01.272.171s.169.238.338.238.238-.1.238-.272-.272-.57-.3-.679-.171-.747-.306-.816a2.717 2.717 0 00-.475-.135v-.475a1.9 1.9 0 00-1.732.848 2.9 2.9 0 00-.509 2.072c.034.3.238 1.154.238 1.154h2.612a1.787 1.787 0 00-.272-1.019c-.342-.68-.376-.579-.376-1.222z"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                data-name="Path 98685"
                d="M43.504 6.047a2.258 2.258 0 00-1.869 2.281"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                data-name="Path 98686"
                d="M26.702 12.518h-.542l-.205 1.445-.437.464a2.036 2.036 0 00-.517 1.793l.665 3.378h1.373l.825-3.247a2.044 2.044 0 00-.418-1.817l-.479-.57z"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <g transform="translate(3459.229 6534.431)">
              <path
                data-name="Line 1582"
                transform="translate(0 47.728)"
                fill="none"
                stroke="#263238"
                strokeWidth={0.1}
                d="M71.911 0L0 0"
              />
              <path
                data-name="Line 1583"
                transform="translate(73.824 47.728)"
                fill="none"
                stroke="#263238"
                strokeWidth={0.1}
                d="M1.785 0L0 0"
              />
              <ellipse
                data-name="Ellipse 129786"
                cx={13.252}
                cy={2.53}
                rx={13.252}
                ry={2.53}
                transform="translate(10.811 49.051)"
                fill="#92e3a9"
                stroke="#707070"
                strokeWidth={0.1}
              />
              <ellipse
                data-name="Ellipse 129787"
                cx={13.252}
                cy={2.53}
                rx={13.252}
                ry={2.53}
                transform="translate(10.811 49.051)"
                fill="#fff"
                stroke="#707070"
                strokeWidth={0.1}
                opacity={0.5}
              />
              <path
                data-name="Path 98687"
                d="M14.321 28.434s-2.082.125-2.582 1.833a8.5 8.5 0 00-.027 3.161 13.108 13.108 0 00.656 3.661c.236.544.844 1 1.359.57.643-.534.789-1.819.926-2.566.743-4.083 1.036-7.039-.332-6.659z"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.1}
              />
              <path
                data-name="Path 98688"
                d="M14.321 28.434s-2.082.125-2.582 1.833a8.5 8.5 0 00-.027 3.161c0 .106.021.219.032.331a8.5 8.5 0 003.108.213c.584-3.491.706-5.882-.531-5.538z"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.1}
              />
              <path
                data-name="Path 98689"
                d="M29.527 47.239a5.6 5.6 0 001.447 1.061c.951.5 1.722.487 1.749 1.053s-.532 1.066-1.827 1.249-1.312.57-2.393.589-1.814-.468-1.606-1.274.641-2.631.641-2.631 1.33 1.679 1.989-.047z"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.1}
              />
              <path
                data-name="Path 98690"
                d="M29.337 33.716s-.291 3.331-.458 4.831-1.416 9.45-1.291 10.034a.872.872 0 001.331.582c.54-.369.749-.54.833-1.04a8.961 8.961 0 00-.125-1.458c0-.542 3.247-10.2 3.705-12.49s.167-3.538-.333-3.992a3.1 3.1 0 00-2.582-.38"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.1}
              />
              <path
                data-name="Path 98691"
                d="M29.118 36.209c-.08.852-.165 1.739-.232 2.336-.167 1.5-1.416 9.45-1.291 10.034a.872.872 0 001.331.582c.54-.369.749-.54.833-1.04a6.914 6.914 0 00.11-1.331c0-.443 1.939-7.116 2.981-10.735a5.119 5.119 0 01-3.732.154z"
                fill="#fff"
                stroke="#707070"
                strokeWidth={0.1}
              />
              <g
                data-name="Group 105822"
                transform="translate(27.587 36.055)"
                clipPath="url(#f)"
              >
                <path
                  data-name="Path 98692"
                  d="M1.531.154c-.08.852-.165 1.739-.232 2.336-.167 1.5-1.416 9.45-1.291 10.034a.872.872 0 001.331.582c.54-.369.749-.54.833-1.04a6.914 6.914 0 00.11-1.331c0-.443 1.939-7.116 2.981-10.735a5.119 5.119 0 01-3.732.154z"
                  stroke="#707070"
                  strokeWidth={0.1}
                  opacity={0.18}
                />
              </g>
              <path
                data-name="Path 98694"
                d="M29.118 36.209c-.08.852-.165 1.739-.232 2.336-.167 1.5-1.416 9.45-1.291 10.034a.872.872 0 001.331.582c.54-.369.749-.54.833-1.04a6.914 6.914 0 00.11-1.331c0-.443 1.939-7.116 2.981-10.735a5.119 5.119 0 01-3.732.154z"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.1}
              />
              <path
                data-name="Path 98695"
                d="M30.407 43.56c0 6.585-4.981 9.825-11.121 9.825S8.165 50.153 8.165 43.56s4.979-10.771 11.121-10.771 11.121 4.19 11.121 10.771z"
                fill="#92e3a9"
                stroke="#707070"
                strokeWidth={0.1}
              />
              <g
                data-name="Group 105823"
                transform="translate(8.165 32.789)"
                clipPath="url(#g)"
              >
                <path
                  data-name="Path 98696"
                  d="M11.121 0a11.5 11.5 0 00-7.57 2.661c.825.981 2.507 2.238 5.931 3.078 6.355 1.559 9.771 3.641 10.313 8.154.47 3.909-3.831 6.083-9.739 6.675.35.021.705.034 1.065.034 6.14 0 11.121-3.232 11.121-9.825S17.261 0 11.121 0z"
                  stroke="#707070"
                  strokeWidth={0.1}
                  opacity={0.18}
                />
              </g>
              <path
                data-name="Path 98698"
                d="M30.407 43.56c0 6.585-4.981 9.825-11.121 9.825S8.165 50.153 8.165 43.56s4.979-10.771 11.121-10.771 11.121 4.19 11.121 10.771z"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.1}
              />
              <path
                data-name="Path 98699"
                d="M32.098 30.003a4.99 4.99 0 00-2.587-.116 26.4 26.4 0 01-4.08.042s.125-4.163.125-4.372 4.621-3.372 4.621-3.372 3.042 8.161 3.747 8.494 1.665.665 1.331-1.749a46.335 46.335 0 00-2.374-7.827c-.584-1.582-2.58-2.914-3.58-4.331s-1.082-1.791-.951-2.331 1.291-1.331 1.291-1.331l-2.205-1.835a2.5 2.5 0 01-1.414 1.5c-1.034.333-1.749-1.291-1.956-2.623s2.414-7.494 2.414-7.494l10.271-.916a1.156 1.156 0 00.084 1.042c.333.458.916 1.456 1.04 1.582s.251.291.416.207-.38-1.207-.38-1.207 1.749 1.665 2.04 1.874.916.582.916.416-.791-.874-1.124-1.331-1.582-2.331-2-3a2.13 2.13 0 00-1.711-.749c-.295 0-10.243-.749-10.456-.542a61.932 61.932 0 00-4.1 8.247 20.4 20.4 0 00-1.042 5.12c-.042 1.789-1.331 4.331-1.54 6.245s-1.914 4.289-2.661 5.454-2.091 1.956-2.58 4.414.165 4.287 1.456 5.078 7.119.874 8.7.833a21.763 21.763 0 007.3-2"
                fill="#fff"
                stroke="#707070"
                strokeWidth={0.1}
              />
              <g
                data-name="Group 105825"
                transform="translate(13.491)"
                clipPath="url(#h)"
              >
                <g
                  data-name="Group 105824"
                  opacity={0.18}
                  stroke="#707070"
                  strokeWidth={0.1}
                >
                  <path
                    data-name="Path 98700"
                    d="M16.888 3.494a93.365 93.365 0 01-2-3 1.39 1.39 0 00-.57-.5c0 .12-.156.243-.781.243-1.211 0-10.442.559-10.442.559S-.182 8.628.008 9.748s.838 2.517 1.585 2.517a1.88 1.88 0 00.909-.38c-.686-.331-1.141-1.542-1.312-2.578-.209-1.331 2.414-7.494 2.414-7.494L13.885.906a1.156 1.156 0 00.084 1.042c.333.458.916 1.456 1.04 1.582s.251.291.416.207-.38-1.207-.38-1.207 1.749 1.665 2.04 1.874.916.582.916.416-.781-.868-1.113-1.326z"
                    transform="translate(9.374 .829)"
                  />
                  <path
                    data-name="Path 98701"
                    d="M10.017 20.273c-.582-1.582-2.58-2.914-3.58-4.331s-1.082-1.791-.951-2.331 1.291-1.331 1.291-1.331l-.719-.6a6.956 6.956 0 00-1.66 1.988c-.19.838.466 2.051 1.492 3.355s2.238 2.426 3.076 3.73c.612.951 2.266 6.273 3.19 9.224.262-.19.4-.722.241-1.88a46.976 46.976 0 00-2.38-7.824z"
                    transform="translate(9.374 .829)"
                  />
                  <path
                    data-name="Path 98702"
                    d="M5.791 21.036a25.792 25.792 0 00-4.291 4.1c-.374.745 1.065 3.962 1.065 3.962s.125-4.163.125-4.372 4.621-3.372 4.621-3.372-.868-.689-1.52-.318z"
                    transform="translate(9.374 .829)"
                  />
                </g>
              </g>
              <path
                data-name="Path 98704"
                d="M32.098 30.003a4.99 4.99 0 00-2.587-.116 26.4 26.4 0 01-4.08.042s.125-4.163.125-4.372 4.621-3.372 4.621-3.372 3.042 8.161 3.747 8.494 1.665.665 1.331-1.749a46.335 46.335 0 00-2.374-7.827c-.584-1.582-2.58-2.914-3.58-4.331s-1.082-1.791-.951-2.331 1.291-1.331 1.291-1.331l-2.205-1.835a2.5 2.5 0 01-1.414 1.5c-1.034.333-1.749-1.291-1.956-2.623s2.414-7.494 2.414-7.494l10.271-.916a1.156 1.156 0 00.084 1.042c.333.458.916 1.456 1.04 1.582s.251.291.416.207-.38-1.207-.38-1.207 1.749 1.665 2.04 1.874.916.582.916.416-.791-.874-1.124-1.331-1.582-2.331-2-3a2.13 2.13 0 00-1.711-.749c-.295 0-10.243-.749-10.456-.542a61.932 61.932 0 00-4.1 8.247 20.4 20.4 0 00-1.042 5.12c-.042 1.789-1.331 4.331-1.54 6.245s-1.914 4.289-2.661 5.454-2.091 1.956-2.58 4.414.165 4.287 1.456 5.078 7.119.874 8.7.833a21.763 21.763 0 007.3-2"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.1}
              />
              <path
                data-name="Path 98705"
                d="M23.807 35.422a21.764 21.764 0 007.3-2L32.099 30a4.99 4.99 0 00-2.587-.116 26.393 26.393 0 01-4.08.042l.108-3.66-7.156-4.859a25.717 25.717 0 01-2.154 3.688c-.749 1.165-2.091 1.956-2.58 4.414s.165 4.287 1.456 5.078 7.119.881 8.701.835z"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.1}
              />
              <path
                data-name="Path 98706"
                d="M25.43 29.929s.125-4.163.125-4.372a6.814 6.814 0 011.141-.932 5.722 5.722 0 01-.485-4.272 7.7 7.7 0 013.247-3.359q-.086-.11-.165-.222c-.131-.19-.245-.352-.346-.5-1.253.314-4.053.861-4.15-.494a7.022 7.022 0 01.663-3 1.378 1.378 0 01-.624-.5 14.568 14.568 0 01-5.2 4.447 16.415 16.415 0 00-.76 2.93c-.209 1.916-1.914 4.289-2.661 5.454-.622.968-1.643 1.681-2.258 3.3 1.566 2.142 3.26 2.622 6.922 2.7a9.357 9.357 0 004.857-1.141z"
                fill="gray"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.1}
              />
              <path
                data-name="Path 98707"
                d="M23.827 21.4a5.324 5.324 0 00.279 1.785"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.1}
              />
              <path
                data-name="Path 98708"
                d="M23.93 19.957s-.03.162-.059.428"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.1}
              />
              <path
                data-name="Path 98709"
                d="M29.47 7.07s.207-1.165-.874-.5a1.293 1.293 0 00-.458 1.956c.251.086 1.332-1.456 1.332-1.456z"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.1}
              />
              <path
                data-name="Path 98710"
                d="M32.017 5.294a4.2 4.2 0 00-2.131 1.07 8.5 8.5 0 00-2.281 3.2c-.791 2.207-.333 3.707 1.042 3.914s3.538-.951 5-2.872 1.249-3.872.207-4.912a2.064 2.064 0 00-1.837-.4z"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.1}
              />
              <path
                data-name="Path 98711"
                d="M32.424 6.988s-.54-.416-.749.165.125 1.207-.333 2.914-.874 2.623 0 4.538 2.5 1.749 3.163 2.54 0 2.249-.749 2.249a1.314 1.314 0 01-1.082-.5 2.934 2.934 0 002.247 1.749c1.54.084 3.831-.584 4.082-3.956s-1.042-4.454-3.165-5.787a11.1 11.1 0 01-3.414-3.912z"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.1}
              />
              <path
                data-name="Path 98712"
                d="M31.666 8.308s-.509 1.785 1.616 3.741 5.612 2.04 5.528 5.612"
                fill="none"
                stroke="#5e5e5e"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.1}
              />
              <path
                data-name="Path 98713"
                d="M31.837 10.093s-.19 3.739 1.871 4.848c2.38 1.276 4.082 3.146 2.471 4.753"
                fill="none"
                stroke="#5e5e5e"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.1}
              />
              <path
                data-name="Path 98714"
                d="M33.71 29.096a42.725 42.725 0 01-4.87.456c-1.458-.042-2.456-.165-2.456-.165a5.513 5.513 0 00-.249-1.374 18.372 18.372 0 01-.76-1.914c-.093-.458-.458-.042-.458.416s-.082 2.456-.082 2.456a9.854 9.854 0 01-1.125-1.416c-.125-.333-.416.042-.124.542s.624 1.5.914 1.956 1.167.584 1.542.709 4.454.914 5.952 1.082 3.54-.042 3.665-.333a10.475 10.475 0 00-.458-2.333"
                fill="#fff"
                stroke="#707070"
                strokeWidth={0.1}
              />
              <g
                data-name="Group 105826"
                transform="translate(23.458 25.899)"
                clipPath="url(#i)"
                stroke="#707070"
                strokeWidth={0.1}
              >
                <path
                  data-name="Path 98715"
                  d="M10.983 3.237c.011.268 0 1.059-.38 1.215a53.243 53.243 0 01-6.9.559.586.586 0 00-.264.042c1.367.283 3.975.76 5.108.892 1.5.167 3.54-.042 3.665-.333a10.476 10.476 0 00-.458-2.333z"
                  opacity={0.18}
                />
                <path
                  data-name="Path 98716"
                  d="M1.841 3.146c1.025 0 1.089.342 1.089.342a5.512 5.512 0 00-.249-1.374A18.372 18.372 0 011.921.2c-.093-.458-.458-.042-.458.416s-.082 2.456-.082 2.456A9.857 9.857 0 01.256 1.656c-.087-.236-.259-.116-.247.152.747.828.927 1.338 1.832 1.338z"
                  opacity={0.18}
                />
              </g>
              <path
                data-name="Path 98718"
                d="M33.71 29.096a42.725 42.725 0 01-4.87.456c-1.458-.042-2.456-.165-2.456-.165a5.513 5.513 0 00-.249-1.374 18.372 18.372 0 01-.76-1.914c-.093-.458-.458-.042-.458.416s-.082 2.456-.082 2.456a9.854 9.854 0 01-1.125-1.416c-.125-.333-.416.042-.124.542s.624 1.5.914 1.956 1.167.584 1.542.709 4.454.914 5.952 1.082 3.54-.042 3.665-.333a10.475 10.475 0 00-.458-2.333"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.1}
              />
            </g>
          </g>
        </g>
        <g data-name="Group 105828">
          <g
            data-name="Ellipse 129789"
            transform="translate(-46.439 -198) translate(-3575 -5019) translate(3817 5338)"
            fill="#e9fbf9"
            stroke="#263238"
            strokeWidth={0.5}
            strokeDasharray="4 2"
          >
            <circle cx={44} cy={44} r={44} stroke="none" />
            <circle cx={44} cy={44} r={43.75} fill="none" />
          </g>
          <g
            data-name="Mask Group 36"
            transform="translate(-46.439 -198) translate(-3575 -5019) translate(171.358 -830.642)"
            clipPath="url(#j)"
          >
            <g data-name="Sport family-bro" strokeWidth={0.2}>
              <path
                data-name="Path 98533"
                d="M11.769 1.364S10.243.123 10.024.651s.809 1.09.809 1.09-2.458-.611-2.685-.142.515.936.515.936-1.614.1-1.588.528a.711.711 0 00.294.578s-2.052.417-1.906.92a.819.819 0 00.746.521s-1.455.761-1.413 1.485c.026.482.783.861.92 1.049 0 0-1.6 1.212-.489 2.165s1.869.735 1.869.735-.726.654-.153 1.175.888.087.888.087-.076 1.029.358 1.143 1.016-.576 1.016-.576.085.872.711.892a1.114 1.114 0 00.916-.371s.262.523.571.475a.892.892 0 00.5-.26 2.759 2.759 0 001.963.417c.951-.26 1.134-.5 1.134-.5s1.04.249 1.37.057a2.383 2.383 0 00.541-.436.761.761 0 00.916.083 1.241 1.241 0 00.414-1.079s.567.393.82-.081a.938.938 0 00.122-.776s1.012.249 1.239-.218-.465-1.023-.465-1.023a.593.593 0 00.872-.284c.3-.617-.371-1.8-.371-1.8s.722.153.794-.478a1.37 1.37 0 00-.436-1.09s.794-.052.495-.715a2.135 2.135 0 00-1.143-.951 1.5 1.5 0 00-.037-1.479c-.473-.711-2.312-.534-2.312-.534s1.06-.353.436-.824-2.277-.024-2.277-.024.388-.6-.467-.6a2.032 2.032 0 00-1.258.336s.7-1.125-.218-1.09-1.775 1.167-1.775 1.167-.218-.726-.436-.486-.055.691-.055.691z"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(3653.983 6190.761) translate(40.2 3.135)"
              />
              <path
                data-name="Path 98534"
                d="M11.427 12.455a21.08 21.08 0 01-.286 3.164c-.218.687-1.7 1.346-2.545 1.435a3.062 3.062 0 00-2.735 2.879 31.017 31.017 0 001.69 8.091 4.339 4.339 0 01.63 2.807c-.085 1.049-1.455 2.955-2 5.016-1.319 5.016-1.513 10.758 1.058 15.47.829 1.527.641 3.053.632 4.715a16.974 16.974 0 001.047 5.618 58.447 58.447 0 011.723 8.723 2.739 2.739 0 01-.635 1.869 4.144 4.144 0 01-1.57 1.308c-.748.338-1.16.6-.711.824s5.328-.094 5.421 0 .336-.218.111-1.385a17.429 17.429 0 01-.037-3.439s-.035-4.9.087-8.723a48.516 48.516 0 00-.185-7.063c-.085-.371-.218-8.108.135-9.015a11.249 11.249 0 00.456-2.593 27.613 27.613 0 013.816 1.779c2.05 1.143 8.357 3.489 9.922 3.328s1.867-3-.68-6-6.978-5.426-7.185-5.831-.292-2.573-.848-3.829a4.241 4.241 0 01-.547-2.3c-.026-.933 2.6-5.371 2.552-7.851s-.554-3.607-1.09-4.176-3.258-1.005-3.727-1.308-.96-2.994-1.1-3.43-3.399-.083-3.399-.083z"
                fill="#d6d6d6"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(3653.983 6190.761) translate(40.2 3.135)"
              />
              <path
                data-name="Path 98535"
                d="M13.854 13.5l-2.669 1.7.246-2.748z"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(3653.983 6190.761) translate(40.2 3.135)"
              />
              <path
                data-name="Path 98536"
                d="M20.223 24.052l-3.243-7.643-.386-.087a4.656 4.656 0 01-.037 2.514c-.713 1.745-2.438 2.1-4.084 1.923-1.481-.159-2.48-1.9-2.353-4.13a5.825 5.825 0 01-.563.218c-.528 1.354-2.316 5.4-2.645 6.677-.177.683-.3 1.239-.375 1.646a24.531 24.531 0 001.018 2.844 11.477 11.477 0 01.469 1.106l10.265-.27c.294-.962 1.3-2.938 1.934-4.798z"
                fill="#92e3a9"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(3653.983 6190.761) translate(40.2 3.135)"
              />
              <path
                data-name="Path 98537"
                d="M19.6 35.429c-.148-.307-.24-1.627-.517-2.8-5.851 1.463-9.813.617-11.578.028a17.283 17.283 0 00-1.308 3.2c-1.319 5.016-1.513 10.758 1.058 15.47.829 1.527.641 3.053.632 4.715a16.971 16.971 0 001.047 5.618 25.348 25.348 0 01.833 3.249l3.489-.092c0-1.3.031-2.7.072-3.982a48.194 48.194 0 00-.185-7.063c-.085-.371-.218-8.108.135-9.015a11.249 11.249 0 00.456-2.593 27.617 27.617 0 013.8 1.769c2.05 1.143 8.357 3.489 9.922 3.328s1.867-3-.68-6-6.977-5.429-7.176-5.832z"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(3653.983 6190.761) translate(40.2 3.135)"
              />
              <path
                data-name="Path 98538"
                d="M11.824 4.803a10.515 10.515 0 01-.715 1.557 4.1 4.1 0 01-1.337 1.324s.375 3.029.567 3.539a6.293 6.293 0 001.47 2.46c.491.425 1.542.994 2.261.6a4.859 4.859 0 002.288-3.925c.074-.731-.024-3.2-.024-3.2a3.807 3.807 0 01-.927-.818 4.673 4.673 0 01-.277-.526s-.244.408-.495.273a13.781 13.781 0 01-1.346-1.666 6.891 6.891 0 01-1.01 1.243c-.32.197-.455-.861-.455-.861z"
                fill="#d6d6d6"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(3653.983 6190.761) translate(40.2 3.135)"
              />
              <path
                data-name="Path 98539"
                d="M9.992 9.24s-.654-.774-.89-.218a1.551 1.551 0 00.395 1.455 1.42 1.42 0 00.75.375z"
                fill="#d6d6d6"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(3653.983 6190.761) translate(40.2 3.135)"
              />
              <path
                data-name="Path 98540"
                d="M16.41 8.761s.484-.776.789-.253a1.546 1.546 0 01-.207 1.494 1.345 1.345 0 01-.621.469z"
                fill="#d6d6d6"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(3653.983 6190.761) translate(40.2 3.135)"
              />
              <path
                data-name="Path 98541"
                d="M12.545 10.461a1.151 1.151 0 00.728.371.916.916 0 00.82-.4"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(3653.983 6190.761) translate(40.2 3.135)"
              />
              <path
                data-name="Path 98542"
                d="M12.111 11.465a1.747 1.747 0 002.58-.166"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(3653.983 6190.761) translate(40.2 3.135)"
              />
              <path
                data-name="Path 98543"
                d="M12.131 8.824c.015.242-.074.436-.2.454s-.244-.181-.26-.425.076-.436.2-.454.245.179.26.425z"
                fill="#263238"
                stroke="#707070"
                transform="translate(3653.983 6190.761) translate(40.2 3.135)"
              />
              <path
                data-name="Path 98544"
                d="M14.72 8.655c.018.242-.074.436-.2.454s-.242-.181-.26-.425.076-.436.205-.454.235.184.255.425z"
                fill="#263238"
                stroke="#707070"
                transform="translate(3653.983 6190.761) translate(40.2 3.135)"
              />
              <path
                data-name="Path 98545"
                d="M10.927 8.135s.3-.693 1.433-.465"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(3653.983 6190.761) translate(40.2 3.135)"
              />
              <path
                data-name="Path 98546"
                d="M13.675 7.561a1.5 1.5 0 011.564.133"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(3653.983 6190.761) translate(40.2 3.135)"
              />
              <path
                data-name="Path 98547"
                d="M8.836 17.181a9 9 0 00-3.11.181c-.983.4-1.372 1.93-1.455 2.584S.623 26.292.564 26.608s-.491 1.232.569 1.727a2.133 2.133 0 002.63-.7c.4-.672 2.713-5.029 2.713-5.029"
                fill="#d6d6d6"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(3653.983 6190.761) translate(40.2 3.135)"
              />
              <path
                data-name="Path 98548"
                d="M17.722 16.945a9.226 9.226 0 013.114.017c1 .338 1.472 1.849 1.59 2.508s3.975 6.145 4.05 6.457.554 1.206-.478 1.745a2.146 2.146 0 01-2.663-.556c-.434-.65-3.241-4.769-3.241-4.769"
                fill="#d6d6d6"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(3653.983 6190.761) translate(40.2 3.135)"
              />
              <path
                data-name="Path 98549"
                d="M2.708 26.416a24.958 24.958 0 003.668.672 31.623 31.623 0 005.29-.314 3.3 3.3 0 00.5-1.058c.257-1.7.547-2.074.654-2.946.188-1.526.419-1.337.465-.872s0 3.627.037 4.008a8.013 8.013 0 01.116 1.764c-.1.238-.059.872-.927.94l-.735.055s-4.841.58-6.514.654-3.814.478-4.73.222-.436-2.325-.042-2.927a1.882 1.882 0 01.955-.759"
                fill="#d6d6d6"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(3653.983 6190.761) translate(40.2 3.135)"
              />
              <path
                data-name="Path 98550"
                d="M24.077 25.851a25.136 25.136 0 01-3.629.872 31.471 31.471 0 01-5.3-.035 3.3 3.3 0 01-.55-1.031c-.347-1.681-.654-2.041-.809-2.907-.268-1.527-.489-1.308-.51-.857s.2 3.62.172 4a7.686 7.686 0 00-.022 1.769c.111.242.107.872.977.89.349 0 .737.015.737.015s4.867.316 6.534.316 3.842.284 4.741-.02.32-2.344-.113-2.927a1.884 1.884 0 00-.994-.7"
                fill="#d6d6d6"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(3653.983 6190.761) translate(40.2 3.135)"
              />
              <path
                data-name="Path 98551"
                d="M26.062 44.68s-8.6.58-9.894.615-2.789-.318-3.33-.031a1.471 1.471 0 00-.425 1.745 3.431 3.431 0 01.174 2.111 4.657 4.657 0 00-.094 2.429c.216.776.552 1.592 1.021 1.542s.3-.517.371-.794a22.707 22.707 0 01.717-2.525 5.413 5.413 0 011.232-2.266c.613-.486 5.877.039 8.91.7s4.867.382 5.6-.109.855-1.745-.563-3.472-3-3.363-3-3.363"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(3653.983 6190.761) translate(40.2 3.135)"
              />
              <path
                data-name="Path 98552"
                d="M19.434 45.111c-1.527.1-2.824.17-3.271.183-1.291.033-2.789-.318-3.33-.031a1.472 1.472 0 00-.425 1.745 3.43 3.43 0 01.174 2.111 4.657 4.657 0 00-.094 2.429c.216.776.552 1.592 1.021 1.542s.3-.517.371-.794a22.69 22.69 0 01.717-2.525 5.411 5.411 0 011.232-2.266c.316-.251 1.862-.233 3.707-.065a11.913 11.913 0 01-.102-2.329z"
                fill="#d6d6d6"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(3653.983 6190.761) translate(40.2 3.135)"
              />
              <g transform="translate(3653.983 6190.761)">
                <path
                  data-name="Path 98553"
                  d="M8.653 16.855a7.336 7.336 0 00-2.4 2.817 48.083 48.083 0 01-3.925 6.217c-1.223 1.52-1.963 2.34-1.274 3.284a64.2 64.2 0 005.543 4.723 4.256 4.256 0 00.329 1.149c.205.329.451.7.451.7s-.576.041-.246.369a3.739 3.739 0 001.191.739 14.879 14.879 0 001.191-3.121c-.083-.166-2.181-1.725-2.628-2.711s-1.437-2.955-1.437-2.955l1.963-2.384a32.011 32.011 0 01.534-6.078c.536-1.89.955-2.832.708-2.749z"
                  fill="#e3e3e3"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98554"
                  d="M5.203 27.662a6.877 6.877 0 00-1.725-1.479"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Line 1570"
                  transform="translate(7.38 35.745)"
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M0 0L0.451 0.41"
                />
                <path
                  data-name="Path 98555"
                  d="M18.976 9.539a16.706 16.706 0 00-.785 3.962c-.048 1.751 2.165 1.2 3.64 2.163s1.843 1.843 1.889 3.823-3.592 8.843-3.731 9.765.414 4.466.46 5.572a34.716 34.716 0 00.369 4.283 50.249 50.249 0 01.6 9.443c-.137 4.237-.46 4.843-.185 5.934a15.6 15.6 0 01.508 7.646c-.691 4.146-1.526 7.923-1.526 8.474s.183 2.257.183 2.257h-3.125a12.85 12.85 0 01-.231-2.809c0-1.889.094-3.594-.046-5.3s-.92-3.777-1.151-6.034a20.7 20.7 0 01.094-4.466l-1.474-6.634s-1.014 6.863-1.06 7.277a8.589 8.589 0 00.323 3.408 10.84 10.84 0 01-.185 5.3c-.323.968-1.383 6.132-1.383 6.132l-.185 3.409s-1.151.966-1.7.872a2.688 2.688 0 01-1.526-1.06c-.052-.277-.231-11.7-.323-12.94s-.137-4.054-.137-4.054a37.589 37.589 0 01-.872-5.855 58.457 58.457 0 01.51-11.048 48.12 48.12 0 00-.231-10.363c-.277-1.888-1.151-3.363-.783-7s1.934-5.389 3.317-5.943 2.855-.506 3.315-1.335a5.717 5.717 0 00.364-2.438z"
                  fill="#e3e3e3"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98556"
                  d="M13.965 12.852c.384-.1 4.287-.155 4.287-.155l.724-3.158z"
                  fill="#263238"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98557"
                  d="M17.051 70.674h3.175c.013.608.183 2.194.183 2.194h-3.138a11.524 11.524 0 01-.22-2.194z"
                  fill="#d6d6d6"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98558"
                  d="M12.109 70.673l-.135 2.471s-1.151.966-1.7.872a2.689 2.689 0 01-1.526-1.06c-.013-.074-.035-.981-.063-2.285z"
                  fill="#d6d6d6"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98559"
                  d="M13.433 2.708s-1.3 5.072-1.564 5.833-.076 1.106.421 2.4.724 1.745 1.677 1.906a5.759 5.759 0 003.354-.99 7.345 7.345 0 002.022-2.288 43.912 43.912 0 001.3-4.348 2.589 2.589 0 00-1.106-2.477 5.166 5.166 0 00-3.583-1.145 11.2 11.2 0 00-2.521 1.109z"
                  fill="#e3e3e3"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98560"
                  d="M14.576 5.073a4.651 4.651 0 01-.611 1.984c-.571.953-.77 1.1-.541 1.448a1.187 1.187 0 001.934-.065"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98561"
                  d="M16.061 9.153a2.315 2.315 0 01-2.44.953"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98562"
                  d="M15.985 5.073a1.428 1.428 0 011.487.8"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98563"
                  d="M14.465 4.654s-.458-.8-1.106-.305"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98564"
                  d="M16.137 6.83c-.068.218-.022.419.1.46s.286-.1.353-.312.024-.421-.1-.462-.283.101-.353.314z"
                  fill="#263238"
                  stroke="#707070"
                />
                <path
                  data-name="Path 98565"
                  d="M13.706 6.006c-.07.218-.022.421.1.462s.286-.1.353-.314.022-.419-.1-.46-.286.1-.353.312z"
                  fill="#263238"
                  stroke="#707070"
                />
                <path
                  data-name="Path 98566"
                  d="M20.105 8.771s2.019-3.707 1.677-4.728-5.07-4.46-7.587-4-.5 1.029-.5 1.029-2.1 1.029-2.1 1.79 5.157-.221 5.157-.221-1.029.837-.458 1.029 1.793.456 1.908.5 1.485 1.143.99 1.143-1.066-.218-.8.268a6.4 6.4 0 00.611.914s-.305 2.022-.268 2.211.724-.5.724-.5z"
                  fill="#263238"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98567"
                  d="M18.782 9.203s1.007-1.431 1.6-1.09-.183 2.211-.593 2.471-1.555-.218-1.555-.218"
                  fill="#e3e3e3"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98568"
                  d="M20.145 31.924c.126 1.154.281 2.34.3 2.9a34.722 34.722 0 00.369 4.283 50.249 50.249 0 01.6 9.443 72.385 72.385 0 01-.1 2.137h-6.178l-.675-3.053s-.218 1.452-.451 3.053H7.453a15.712 15.712 0 01-.041-.578 58.458 58.458 0 01.51-11.048 42.711 42.711 0 00.079-7.138z"
                  fill="#263238"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98569"
                  d="M7 23.356c.783-2.578 1.843-3.36 2.765-4.606a19.33 19.33 0 001.681-3.365c.388-.094.757-.177 1.079-.281a10.1 10.1 0 00-1.241 3.74c-.462 2.855.872 2.855 2.763 2.163s3.454-4.8 3.96-5.711c.218-.388.379-.678.5-.885a2.31 2.31 0 001.09.506 11 11 0 00-2.92 5.031c-.831 3.363 1.38 6.034 2.992 6.265a3.913 3.913 0 001.7-.2 27.782 27.782 0 00-1.376 3.243 22.082 22.082 0 00.255 3.546H8.06c-.087-1.723-.244-3.227-.373-4.1a30.854 30.854 0 01-.861-4.8q.098-.26.174-.546z"
                  fill="#92e3a9"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle
                  data-name="Ellipse 129774"
                  cx={4.423}
                  cy={4.423}
                  r={4.423}
                  transform="translate(0 11.979)"
                  fill="#878787"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle
                  data-name="Ellipse 129775"
                  cx={4.423}
                  cy={4.423}
                  r={4.423}
                  transform="translate(.46 11.979)"
                  fill="#263238"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle
                  data-name="Ellipse 129776"
                  cx={1.084}
                  cy={1.084}
                  r={1.084}
                  transform="translate(3.799 15.318)"
                  fill="#878787"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98570"
                  d="M21.831 15.667a3.683 3.683 0 012.117 2.811c.183 1.982-.321 4.972-2.117 6.586s-4.837 6.494-5.67 6.4-7.986-6.132-9.336-7.556a50.649 50.649 0 01-3.79-3.958 8.48 8.48 0 01-1.014-2.717c-.046-.369 1.568-1.889 2.074-1.841s1.243 1.289 1.243 1.289.968.323 1.06.654-.185.735-.185 1.058.185.968.046 1.291-.275.737-.275.737a12.534 12.534 0 002.117 1.38c.92.414 6.68 2.442 6.68 2.442a19.625 19.625 0 011.151-2.442 5.655 5.655 0 011.38-1.2 5.009 5.009 0 01.554-1.8"
                  fill="#e3e3e3"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98571"
                  d="M14.785 24.233a3.536 3.536 0 00.6 1.38"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98572"
                  d="M6.551 20.835a9.625 9.625 0 001.555.955c.2.089.628.255 1.175.46L7.77 24.806a20.114 20.114 0 01-.94-.9 46.844 46.844 0 00-1.26-1.269z"
                  fill="#92e3a9"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle
                  data-name="Ellipse 129777"
                  cx={4.423}
                  cy={4.423}
                  r={4.423}
                  transform="translate(1.795 11.979)"
                  fill="#878787"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle
                  data-name="Ellipse 129778"
                  cx={4.423}
                  cy={4.423}
                  r={4.423}
                  transform="translate(2.257 11.979)"
                  fill="#878787"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle
                  data-name="Ellipse 129779"
                  cx={1.084}
                  cy={1.084}
                  r={1.084}
                  transform="translate(5.596 15.318)"
                  fill="#878787"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98573"
                  d="M17.339 71.749s.715-1.217 1.716-1.108a1.294 1.294 0 011.073 1.431c0 .323.752 1.428.822 1.823a3.49 3.49 0 00.573 1.215 2.4 2.4 0 01.75.752 2.344 2.344 0 01.358 1.359c-.078.393-.536.358-.929.393s-4.579 0-4.579 0a2.18 2.18 0 01-.465-1c-.109-.608.07-1.609 0-2.431s-.323-1.644-.072-2a1.227 1.227 0 01.753-.434z"
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98574"
                  d="M16.722 76.862h5.9a1.157 1.157 0 010 .358c-.072.393-.536.358-.929.393s-4.58 0-4.58 0a2.18 2.18 0 01-.391-.751z"
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98575"
                  d="M12.404 72.25s.107 4.041.072 4.433a.71.71 0 01-.5.715c-.323.107-2.573.035-3.182.179a20.728 20.728 0 01-3.576.218c-.536-.068-1.217.109-1.324-.536a1.391 1.391 0 01.323-1.215 28.3 28.3 0 002.617-1.359 5.833 5.833 0 001.465-1.537c.179-.358.144-1.4.608-1.361s.894.654 1.038.966l.142.323a14.5 14.5 0 001.644-.251c.281-.11.243-.895.673-.575z"
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98576"
                  d="M5.216 77.791c-.536-.07-1.217.109-1.324-.536a.915.915 0 010-.109 13.9 13.9 0 003.764-.033c1.276-.194 3.775-.475 4.835-.591v.161a.712.712 0 01-.5.715c-.323.107-2.573.035-3.182.179a20.457 20.457 0 01-3.593.214z"
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <g transform="translate(3653.983 6190.761) translate(18.052 13.515)">
                <path
                  data-name="Path 98577"
                  d="M23.275 16.15s-.207 2.157-.207 3.982.29 4.9.29 4.9.29 3.271.29 5.352a40.3 40.3 0 01-.29 4.362 17.658 17.658 0 01-.124 2.366 8.259 8.259 0 01-1.287 1.494c-.331.373-.7.373-.7.249a1.067 1.067 0 01.29-.622 2.914 2.914 0 00.58-.872c.041-.166 0-1.411 0-1.411a3.1 3.1 0 00-.5.872c-.124.414-.373 1.2-.582 1.077s-.041-.953.083-1.243-.083-1.494.251-1.91.5-.249.621-.953a52.429 52.429 0 00-1.038-6.309c-.207-1.121-.331-3.195-.331-3.195l-.622-5.934z"
                  fill="#e3e3e3"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98578"
                  d="M8.871 45.984s-.087 1.705-.218 2.536a12.061 12.061 0 00-.395 4.987 64.4 64.4 0 01.482 6.911c0 .262-.087 1.226-.087 1.226h2.362a16.012 16.012 0 00.569-2.8 38.628 38.628 0 01.436-5.731 40.207 40.207 0 00.7-4.593c.087-.918.308-2.536.308-2.536z"
                  fill="#e3e3e3"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98579"
                  d="M10.973 59.869s-.508-.861-1.217-.787-.761.787-.761 1.016-.534 1.014-.584 1.293a2.491 2.491 0 01-.406.872 1.668 1.668 0 00-.532.532 1.725 1.725 0 00-.255.964c.052.279.382.255.654.279s3.247 0 3.247 0a1.552 1.552 0 00.329-.711c.076-.436-.05-1.141 0-1.725s.229-1.167.05-1.42a.872.872 0 00-.525-.313z"
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98580"
                  d="M11.415 63.498h-4.2a.823.823 0 000 .253c.052.279.382.255.654.279s3.247 0 3.247 0a1.528 1.528 0 00.299-.532z"
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98581"
                  d="M17.182 46.497l.133 1.707a15.365 15.365 0 00.262 4.111c.438 1.531 2.144 9.187 2.144 9.187l2.181-.044s-.436-7.436-.307-9.406a27.522 27.522 0 00-.436-5.031c0-.131-.218-1.618-.218-1.618z"
                  fill="#e3e3e3"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98582"
                  d="M21.779 59.703s-.613-.569-1.182-.174a1.561 1.561 0 00-.569 1.182s-.872-.089-.918.262a14.579 14.579 0 00.305 2.931 12.5 12.5 0 001.963.305 7.65 7.65 0 002.931-.131c.656-.349.087-.787-.262-1.308s-1.4-1.308-1.664-1.705a9.116 9.116 0 01-.604-1.362z"
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98583"
                  d="M20.943 63.513a5.694 5.694 0 00-1.655-.172 1.938 1.938 0 00.124.567 12.529 12.529 0 001.963.305 7.65 7.65 0 002.931-.131c.355-.19.351-.406.218-.654a6.733 6.733 0 01-3.581.085z"
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98584"
                  d="M7.952 35.65L6.644 45.666a11.251 11.251 0 003.587 1.226 12.649 12.649 0 003.587.044l.744-5.424.218 5.424a12.562 12.562 0 004.2.305 12.029 12.029 0 003.936-1.354l-1.836-10.28h-13z"
                  fill="#263238"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98585"
                  d="M20.617 18.726l3.57-2.7a3.828 3.828 0 00-1.37-1.91 25.944 25.944 0 00-3.984-1.245 2.635 2.635 0 01-1.452-.994 10.885 10.885 0 01-.29-1.786l-3.528-.414a8.09 8.09 0 01-.6 2.137c-.334.456-.5.707-2.488 1.245a11.338 11.338 0 00-2.344.6 6.786 6.786 0 00-1.869 1.292l1.062 1.09a14.459 14.459 0 01-1.642 2.855c-.116.164-1.577 2.7-1.577 2.7l4.979 4.316s-1.527 9.377-1.577 9.877l-.041.5a36.363 36.363 0 007.753.89 27.522 27.522 0 006.274-.848s-1.038-11.619-1.038-13.444.162-4.161.162-4.161z"
                  fill="#92e3a9"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98586"
                  d="M15.201 16.398c1.7 0 3.125-1.5 3.552-3.55a2.584 2.584 0 01-1.374-.973 11.522 11.522 0 01-.29-1.786l-3.528-.414a8.088 8.088 0 01-.6 2.137 2.129 2.129 0 01-1.339.9c.392 2.114 1.846 3.686 3.579 3.686z"
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98587"
                  d="M17.897 12.414a1.4 1.4 0 01-.517-.539 10.922 10.922 0 01-.29-1.786l-3.528-.414a8.088 8.088 0 01-.6 2.137 1.7 1.7 0 01-.589.571c.552 1.158 1.631 3.053 2.809 3.142 1.3.097 2.257-1.94 2.715-3.111z"
                  fill="#e3e3e3"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98588"
                  d="M16.455 10.458l-3.8 1.878a6.492 6.492 0 00.907-2.66c-.084-.961 2.893.782 2.893.782z"
                  fill="#263238"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98589"
                  d="M9.081 25.9l-.29-7.8-1.47-2.067a14.459 14.459 0 01-1.642 2.855c-.116.164-1.577 2.7-1.577 2.7z"
                  fill="#e3e3e3"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle
                  data-name="Ellipse 129780"
                  cx={4.357}
                  cy={4.357}
                  r={4.357}
                  transform="matrix(.974 -.224 .224 .974 0 20.762)"
                  fill="#b2b2b2"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98590"
                  d="M5.787 19.717a6.255 6.255 0 000 8.631 4.361 4.361 0 000-8.631z"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98591"
                  d="M.865 24.033a4.324 4.324 0 001.182 2.979 4.342 4.342 0 00.207-6.161 4.338 4.338 0 00-1.389 3.182z"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98592"
                  d="M5.881 24.199a4.348 4.348 0 001.745 3.467 4.348 4.348 0 00.229-7.109 4.362 4.362 0 00-1.974 3.642z"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98593"
                  d="M1.175 22.323a1.865 1.865 0 00-.635.436 1.23 1.23 0 00.146 1.2c.179.07.979.9 1.173.539s-.342-.831-.414-.979-.393-.654-.393-.654z"
                  fill="#e3e3e3"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98594"
                  d="M.442 23.523s-.465.979-.318 1.151 1.173.587 1.42.39a.419.419 0 00.072-.512l-.929-.589z"
                  fill="#e3e3e3"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98595"
                  d="M.344 24.866a.769.769 0 00.122.637 1.455 1.455 0 001.149.048c.146-.1-.072-.488-.072-.488a8.041 8.041 0 01-1.199-.197z"
                  fill="#e3e3e3"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98596"
                  d="M.687 25.723s.074.342.318.417a.935.935 0 00.807-.27c.05-.146-.2-.318-.2-.318a4 4 0 01-.925.171z"
                  fill="#e3e3e3"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98597"
                  d="M14.977 1.783a4.479 4.479 0 00-3.09 1.527 3.35 3.35 0 00-.436 1.745c.135.711.307 4.041.7 4.745a4.788 4.788 0 003.125 2.163c1.409.142 2.907-1.457 3.26-2.351a22.629 22.629 0 00.441-4.229s-.312-1.055-.471-1.479a4.231 4.231 0 00-3.529-2.121z"
                  fill="#e3e3e3"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98598"
                  d="M14.462.513s-.872-.72-1.627-.423.238.72.238.72-1.627-.17-1.9.338.517.89.517.89-1.151.3-1.151.8a.615.615 0 00.515.593 1.44 1.44 0 000 .846c.118.628.622 2.414.622 2.414s.172-.129.253-.678-.039-.678.039-.846.635-.593.833-.89a5.017 5.017 0 01.794-.763s-.674.678-.238.72a4.994 4.994 0 002.222-1.014c.2-.294-.12.676.2.591s.713-1.058.713-1.058.2.89.478.89a.951.951 0 00.475-.129 2.214 2.214 0 00.556.89 2.532 2.532 0 01.6.678l.338 1.511a4.211 4.211 0 00.574-.918 4.778 4.778 0 00-.039-1.145l.081-.8a.4.4 0 00.355-.506c-.079-.467-.951-1.09-.951-1.09s.475-.423.039-.763-1.984-.168-1.984-.168.517-1.06-.436-1.186a2.872 2.872 0 00-1.825.508"
                  fill="#263238"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98599"
                  d="M11.67 6.696s-.4-.894-.927-.048 1.191 2.4 1.191 2.4z"
                  fill="#e3e3e3"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98600"
                  d="M18.928 6.598s.624-1.077 1.021-.185-1.145 2.209-1.145 2.209z"
                  fill="#e3e3e3"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <ellipse
                  data-name="Ellipse 129781"
                  cx={0.264}
                  cy={0.469}
                  rx={0.264}
                  ry={0.469}
                  transform="translate(13.828 6.227)"
                  fill="#263238"
                  stroke="#707070"
                />
                <path
                  data-name="Path 98601"
                  d="M16.735 6.696c0 .257-.118.469-.264.469s-.264-.218-.264-.469.118-.471.264-.471.264.212.264.471z"
                  fill="#263238"
                  stroke="#707070"
                />
                <path
                  data-name="Path 98602"
                  d="M14.841 7.447s-.266.377-.133.471.654.423.872.327.571-.188.571-.375a1.271 1.271 0 00-.264-.517"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98603"
                  d="M14.048 8.668a2.858 2.858 0 001.542.517 1.825 1.825 0 001.232-.844"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98604"
                  d="M13.167 5.802a1.34 1.34 0 011.409-.281"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98605"
                  d="M16.03 5.473a1.744 1.744 0 011.452.283"
                  fill="none"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  data-name="Path 98606"
                  d="M14.953 20.257c-.722 0-1.175.393-1.175 1.426v1.548h-2.15v-1.4c0-2.314 1.158-3.635 3.389-3.635s3.387 1.322 3.387 3.635c0 4.545-4.523 6.237-4.523 8.612a1.667 1.667 0 00.02.312h4.3v2.065h-6.574v-1.777c0-4.239 4.5-4.952 4.5-9.124.003-1.311-.45-1.662-1.174-1.662z"
                  fill="#fff"
                  stroke="#263238"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
export function PageNotFoundBackGroundImage(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 540,
    height: 399,
    ...rootStyle,
  };
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 540 399"
    {...rest}
    sx={rootSx}
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_56091"
          data-name="Rectangle 56091"
          width="540"
          height="399"
          transform="translate(413 100)"
          fill="#fff"
          stroke="#707070"
          strokeWidth="1"
        />
      </clipPath>
      <linearGradient
        id="linear-gradient"
        x1="0.5"
        y1="0.126"
        x2="0.5"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#f8f9fa" />
        <stop offset="1" stopColor="#f8f9fa" stopOpacity="0.212" />
      </linearGradient>
    </defs>
    <g
      id="Mask_Group_40"
      data-name="Mask Group 40"
      transform="translate(-413 -100)"
      clipPath="url(#clip-path)"
    >
      <g
        id="Group_105880"
        data-name="Group 105880"
        transform="translate(163.61 60.897)"
      >
        <g
          id="Group_105874"
          data-name="Group 105874"
          transform="translate(1487.258 -8792.351)"
        >
          <g
            id="Group_105870"
            data-name="Group 105870"
            transform="translate(-1206.824 8831.883)"
          >
            <path
              id="Path_98741"
              data-name="Path 98741"
              d="M311.991,69.942s117.373,22.337,106.445,62.411,58.408-14.234,86.078.217c19.7,10.286,11.824,41.6,21.354,54.217,21.85,28.93,44.2-7.5,72.007,14.358s-4.181,261.056-15.5,261.027l-414.327.014s-30.684-54.8-2.212-89.09,8.924-89.482,5.466-102.735c-3.973-15.216-18.2-58.656,22.329-77.673C223,178.9,223.787,130.713,222.594,121.969,222.591,121.969,211.23,52.815,311.991,69.942Z"
              transform="translate(-147.194 -67.215)"
              stroke="rgba(233,236,239,0.25)"
              strokeWidth="0.724"
              fill="url(#linear-gradient)"
            />
            <path
              id="Path_98742"
              data-name="Path 98742"
              d="M1366.467,325.18a13.078,13.078,0,0,0-2.938.434v71.508h2.938Z"
              transform="translate(-1011.317 -262.029)"
              fill="#343a40"
            />
            <g
              id="Group_105858"
              data-name="Group 105858"
              transform="translate(51.947 210.961)"
              opacity="0.5"
            >
              <path
                id="Rectangle_56057"
                data-name="Rectangle 56057"
                d="M.485,0h.55A.486.486,0,0,1,1.52.486V7.539a.486.486,0,0,1-.486.486H.486A.486.486,0,0,1,0,7.539V.485A.485.485,0,0,1,.485,0Z"
                transform="translate(64.984 8.024) rotate(180)"
                fill="#ced4da"
              />
              <path
                id="Rectangle_56058"
                data-name="Rectangle 56058"
                d="M.485,0h.551A.485.485,0,0,1,1.52.485V7.539a.485.485,0,0,1-.485.485H.486A.486.486,0,0,1,0,7.539V.485A.485.485,0,0,1,.485,0Z"
                transform="translate(61.943 8.024) rotate(180)"
                fill="#ced4da"
              />
              <path
                id="Rectangle_56059"
                data-name="Rectangle 56059"
                d="M.486,0h.55A.485.485,0,0,1,1.52.485V7.539a.486.486,0,0,1-.486.486H.486A.486.486,0,0,1,0,7.539V.486A.486.486,0,0,1,.486,0Z"
                transform="translate(47.499 8.024) rotate(180)"
                fill="#ced4da"
              />
              <path
                id="Rectangle_56060"
                data-name="Rectangle 56060"
                d="M1.484,0H30.257a1.484,1.484,0,0,1,1.484,1.484V15.616A1.485,1.485,0,0,1,30.256,17.1H1.485A1.485,1.485,0,0,1,0,15.616V1.484A1.484,1.484,0,0,1,1.484,0Z"
                transform="translate(72.23 52.873) rotate(180)"
                fill="#eee"
              />
              <path
                id="Rectangle_56061"
                data-name="Rectangle 56061"
                d="M1.419,0H24.088a1.42,1.42,0,0,1,1.42,1.42v9.952a1.42,1.42,0,0,1-1.42,1.42H1.42A1.42,1.42,0,0,1,0,11.372V1.419A1.419,1.419,0,0,1,1.419,0Z"
                transform="translate(70.207 50.718) rotate(180)"
                fill="#d1d1d1"
              />
              <rect
                id="Rectangle_56062"
                data-name="Rectangle 56062"
                width="34.445"
                height="24.815"
                rx="1.82"
                transform="translate(73.582 29.551) rotate(180)"
                fill="#eee"
              />
              <path
                id="Rectangle_56063"
                data-name="Rectangle 56063"
                d="M1.419,0h23.8a1.42,1.42,0,0,1,1.42,1.42V17.775a1.42,1.42,0,0,1-1.42,1.42H1.42A1.42,1.42,0,0,1,0,17.775V1.419A1.419,1.419,0,0,1,1.419,0Z"
                transform="translate(70.776 26.741) rotate(180)"
                fill="#d1d1d1"
              />
              <path
                id="Path_98745"
                data-name="Path 98745"
                d="M737.705,752.9l15.811,14.466v2.159a2.57,2.57,0,0,1-2.57,2.57L730.16,752.9Z"
                transform="translate(-682.743 -745.348)"
                fill="#f3f7fc"
                opacity="0.1"
              />
              <path
                id="Path_98746"
                data-name="Path 98746"
                d="M733.6,785.679l-15.4-14.044v2.342l12.784,11.7Z"
                transform="translate(-674.074 -758.934)"
                fill="#f3f7fc"
                opacity="0.1"
              />
              <rect
                id="Rectangle_56064"
                data-name="Rectangle 56064"
                width="3.041"
                height="24.815"
                rx="1.52"
                transform="translate(42.178 29.551) rotate(180)"
                fill="#e0e0e0"
              />
              <rect
                id="Rectangle_56065"
                data-name="Rectangle 56065"
                width="2.281"
                height="17.101"
                rx="1.141"
                transform="translate(42.769 52.873) rotate(180)"
                fill="#e0e0e0"
              />
              <path
                id="Path_98749"
                data-name="Path 98749"
                d="M745.565,876.183l-11.318-12.792h-2.872l11.618,12.792Z"
                transform="translate(-683.624 -825.466)"
                fill="#f3f7fc"
                opacity="0.1"
              />
              <path
                id="Path_98750"
                data-name="Path 98750"
                d="M759.72,863.4l11.418,11.049a2.253,2.253,0,0,1-2.193,1.744h-1.23L755.327,863.4Z"
                transform="translate(-700.989 -825.466)"
                fill="#f3f7fc"
                opacity="0.1"
              />
              <path
                id="Rectangle_56067"
                data-name="Rectangle 56067"
                d="M.485,0h.55A.486.486,0,0,1,1.52.486V8.024H0V.485A.485.485,0,0,1,.485,0Z"
                transform="translate(25.326 12.225)"
                fill="#ced4da"
              />
              <path
                id="Rectangle_56068"
                data-name="Rectangle 56068"
                d="M2,0H27.961a2,2,0,0,1,2,2V17.74a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
                transform="translate(29.958 36.434) rotate(180)"
                fill="#eee"
              />
              <rect
                id="Rectangle_56069"
                data-name="Rectangle 56069"
                width="3.407"
                height="19.737"
                rx="1.704"
                transform="translate(3.407 36.434) rotate(180)"
                fill="#e0e0e0"
              />
              <rect
                id="Rectangle_56070"
                data-name="Rectangle 56070"
                width="21.99"
                height="1.275"
                rx="0.638"
                transform="translate(27.902 20.887) rotate(180)"
                fill="#e0e0e0"
              />
              <rect
                id="Rectangle_56071"
                data-name="Rectangle 56071"
                width="21.99"
                height="1.275"
                rx="0.638"
                transform="translate(27.902 24.985) rotate(180)"
                fill="#e0e0e0"
              />
              <rect
                id="Rectangle_56072"
                data-name="Rectangle 56072"
                width="21.99"
                height="1.275"
                rx="0.638"
                transform="translate(27.902 29.084) rotate(180)"
                fill="#e0e0e0"
              />
              <rect
                id="Rectangle_56073"
                data-name="Rectangle 56073"
                width="21.99"
                height="1.275"
                rx="0.638"
                transform="translate(27.902 33.182) rotate(180)"
                fill="#e0e0e0"
              />
              <g id="Group_105876" data-name="Group 105876">
                <path
                  id="Path_98743"
                  data-name="Path 98743"
                  d="M798.314,944.26h1.143V931.036a6.125,6.125,0,0,0-6.117-6.117h-8.983a4.981,4.981,0,0,1-4.975-4.975v-4.573h-1.143v4.573a6.125,6.125,0,0,0,6.117,6.118h8.983a4.98,4.98,0,0,1,4.975,4.975Z"
                  transform="translate(-717.6 -863.154)"
                  fill="#ced4da"
                />
                <path
                  id="Path_98744"
                  data-name="Path 98744"
                  d="M747.164,953.668h1.143V931.325a6.414,6.414,0,0,0-6.407-6.406,5.27,5.27,0,0,1-5.264-5.264v-4.284h-1.143v4.284a6.414,6.414,0,0,0,6.406,6.407,5.27,5.27,0,0,1,5.264,5.264Z"
                  transform="translate(-686.609 -863.154)"
                  fill="#ced4da"
                />
                <rect
                  id="Rectangle_56052"
                  data-name="Rectangle 56052"
                  width="1.52"
                  height="8.024"
                  transform="translate(64.984 37.166) rotate(180)"
                  fill="#ced4da"
                />
                <rect
                  id="Rectangle_56053"
                  data-name="Rectangle 56053"
                  width="1.52"
                  height="8.024"
                  transform="translate(61.943 37.166) rotate(180)"
                  fill="#ced4da"
                />
                <rect
                  id="Rectangle_56054"
                  data-name="Rectangle 56054"
                  width="1.52"
                  height="10.742"
                  transform="translate(28.895 25.991) rotate(-90)"
                  fill="#ced4da"
                />
                <rect
                  id="Rectangle_56055"
                  data-name="Rectangle 56055"
                  width="1.52"
                  height="10.742"
                  transform="translate(28.895 22.95) rotate(-90)"
                  fill="#ced4da"
                />
                <rect
                  id="Rectangle_56056"
                  data-name="Rectangle 56056"
                  width="1.52"
                  height="8.024"
                  transform="translate(47.499 37.166) rotate(180)"
                  fill="#ced4da"
                />
                <path
                  id="Path_98747"
                  data-name="Path 98747"
                  d="M820.4,804.61h7.454V776.736h-6.1v-1.52h6.861a.761.761,0,0,1,.761.761v29.4a.76.76,0,0,1-.761.76H820.4Z"
                  transform="translate(-748.174 -761.536)"
                  fill="#ced4da"
                />
                <path
                  id="Path_98748"
                  data-name="Path 98748"
                  d="M820.4,809.546h4.382V787.7h-3.031v-1.52h3.791a.761.761,0,0,1,.761.76v23.369a.761.761,0,0,1-.761.76H820.4Z"
                  transform="translate(-748.174 -769.48)"
                  fill="#ced4da"
                />
                <path
                  id="Path_98751"
                  data-name="Path 98751"
                  d="M590.853,873.006a2.461,2.461,0,0,0,2.461-2.461V857.96h-1.382v12.586a1.075,1.075,0,0,1-2.151,0v-5.377A2.783,2.783,0,0,0,587,862.39H576.364a2,2,0,0,1-1.993-1.993v-2.432h-1.382V860.4a3.38,3.38,0,0,0,3.376,3.375H587a1.4,1.4,0,0,1,1.4,1.4v5.381a2.461,2.461,0,0,0,2.454,2.457Z"
                  transform="translate(-568.783 -821.53)"
                  fill="#ced4da"
                />
                <path
                  id="Rectangle_56090"
                  data-name="Rectangle 56090"
                  d="M.485,0h.55A.486.486,0,0,1,1.52.486v3.92H0V.485A.485.485,0,0,1,.485,0Z"
                  transform="translate(5.153 12.225)"
                  fill="#ced4da"
                />
              </g>
            </g>
            <g
              id="Group_105859"
              data-name="Group 105859"
              transform="translate(366.577 206.291)"
              opacity="0.5"
            >
              <path
                id="Path_98755"
                data-name="Path 98755"
                d="M922,1324.594a12.1,12.1,0,0,0-8.612-3.566H882.106a12.1,12.1,0,0,0-8.612,3.566l-4.145,4.145,1.724,1.725,4.145-4.145a9.675,9.675,0,0,1,6.886-2.853h31.282a9.675,9.675,0,0,1,6.886,2.853l4.145,4.145,1.724-1.725Z"
                transform="translate(-864.747 -1156.312)"
                fill="#dee2e6"
              />
              <rect
                id="Rectangle_56074"
                data-name="Rectangle 56074"
                width="2.309"
                height="164.715"
                transform="translate(31.94)"
                fill="#dee2e6"
              />
              <path
                id="Rectangle_56075"
                data-name="Rectangle 56075"
                d="M.7,0H2.525a.7.7,0,0,1,.7.7h0a.7.7,0,0,1-.7.7H.7A.7.7,0,0,1,0,.7H0A.7.7,0,0,1,.7,0Z"
                transform="translate(31.483)"
                fill="#adb5bd"
              />
              <path
                id="Path_98756"
                data-name="Path 98756"
                d="M955.579,609.466h-.1a.442.442,0,0,0-.434.405,4.208,4.208,0,0,1-8.376,0,.441.441,0,0,0-.434-.405H934.968a.441.441,0,0,0-.434.405,4.208,4.208,0,0,1-8.377,0,.442.442,0,0,0-.434-.405h-.1a.434.434,0,0,0-.434.468,5.171,5.171,0,0,0,6.648,4.493l-.01.022a5.2,5.2,0,0,0,3.629-3.824.434.434,0,0,1,.426-.341h9.446a.434.434,0,0,1,.426.341,5.2,5.2,0,0,0,3.629,3.824l-.01-.022a5.171,5.171,0,0,0,6.649-4.493.434.434,0,0,0-.445-.468Z"
                transform="translate(-908.067 -604.134)"
                fill="#adb5bd"
              />
              <path
                id="Path_98757"
                data-name="Path 98757"
                d="M1103.131,1343.931a5.548,5.548,0,1,1-5.548-5.549,5.548,5.548,0,0,1,5.548,5.549Z"
                transform="translate(-1037.551 -1169.779)"
                fill="#e3e3e3"
              />
              <circle
                id="Ellipse_129794"
                data-name="Ellipse 129794"
                cx="2.964"
                cy="2.964"
                r="2.964"
                transform="translate(57.071 171.185)"
                fill="#adb5bd"
              />
              <path
                id="Path_98758"
                data-name="Path 98758"
                d="M859.878,1343.931a5.548,5.548,0,1,1-5.548-5.549,5.548,5.548,0,0,1,5.548,5.549Z"
                transform="translate(-848.781 -1169.779)"
                fill="#e3e3e3"
              />
              <path
                id="Path_98759"
                data-name="Path 98759"
                d="M866.247,1352.883a2.967,2.967,0,1,1-2.967-2.967A2.967,2.967,0,0,1,866.247,1352.883Z"
                transform="translate(-857.732 -1178.73)"
                fill="#adb5bd"
              />
              <path
                id="Path_98764"
                data-name="Path 98764"
                d="M927.724,612.754a4.2,4.2,0,0,1-1.57-2.882.442.442,0,0,0-.434-.405h-.1a.434.434,0,0,0-.434.468,5.182,5.182,0,0,0,2.052,3.673A1.206,1.206,0,0,0,927.724,612.754Z"
                transform="translate(-908.067 -604.135)"
                fill="#9e9e9e"
              />
            </g>
            <g
              id="Group_105877"
              data-name="Group 105877"
              transform="translate(0 14.474)"
            >
              <circle
                id="Ellipse_129795"
                data-name="Ellipse 129795"
                cx="8.697"
                cy="8.697"
                r="8.697"
                transform="translate(123.211 378.309) rotate(-76.966)"
                fill="#e3e3e3"
              />
              <circle
                id="Ellipse_129796"
                data-name="Ellipse 129796"
                cx="4.647"
                cy="4.647"
                r="4.647"
                transform="translate(128.999 367.151)"
                fill="#adb5bd"
              />
              <path
                id="Path_98771"
                data-name="Path 98771"
                d="M576.128,1308.623a7.267,7.267,0,0,0,4.292,6.68c4.628,2.351,4.632,4.632,4.632,4.632s-.448,3.508,2.09,3.583,2.687-3.21,2.461-5.9-2.239-5.449-2.649-6.121-.149-2.874-.149-2.874Z"
                transform="translate(-453.455 -950.225)"
                fill="#eee"
              />
              <rect
                id="Rectangle_56080"
                data-name="Rectangle 56080"
                width="13.287"
                height="3.06"
                transform="translate(120.956 356.346)"
                fill="#e3e3e3"
              />
              <circle
                id="Ellipse_129797"
                data-name="Ellipse 129797"
                cx="8.697"
                cy="8.697"
                r="8.697"
                transform="translate(167.702 371.798) rotate(-45)"
                fill="#e3e3e3"
              />
              <circle
                id="Ellipse_129798"
                data-name="Ellipse 129798"
                cx="4.647"
                cy="4.647"
                r="4.647"
                transform="translate(175.353 367.151)"
                fill="#adb5bd"
              />
              <path
                id="Path_98772"
                data-name="Path 98772"
                d="M744.725,1308.623a7.267,7.267,0,0,0,4.292,6.68c4.628,2.351,4.632,4.632,4.632,4.632s-.448,3.508,2.09,3.583,2.687-3.21,2.461-5.9-2.239-5.449-2.65-6.121-.149-2.874-.149-2.874Z"
                transform="translate(-575.697 -950.225)"
                fill="#eee"
              />
              <rect
                id="Rectangle_56082"
                data-name="Rectangle 56082"
                width="13.287"
                height="3.06"
                transform="translate(167.31 356.346)"
                fill="#e3e3e3"
              />
              <circle
                id="Ellipse_129799"
                data-name="Ellipse 129799"
                cx="8.695"
                cy="8.695"
                r="8.695"
                transform="translate(307.08 378.263) rotate(-76.7)"
                fill="#e3e3e3"
              />
              <circle
                id="Ellipse_129800"
                data-name="Ellipse 129800"
                cx="4.647"
                cy="4.647"
                r="4.647"
                transform="translate(312.895 367.151)"
                fill="#adb5bd"
              />
              <path
                id="Path_98773"
                data-name="Path 98773"
                d="M1192.34,1308.623a7.267,7.267,0,0,0,4.292,6.68c4.628,2.351,4.632,4.632,4.632,4.632s-.448,3.508,2.09,3.583,2.688-3.21,2.461-5.9-2.239-5.449-2.65-6.121-.149-2.874-.149-2.874Z"
                transform="translate(-885.769 -950.225)"
                fill="#eee"
              />
              <rect
                id="Rectangle_56084"
                data-name="Rectangle 56084"
                width="13.287"
                height="3.06"
                transform="translate(304.852 356.346)"
                fill="#e3e3e3"
              />
              <path
                id="Path_98774"
                data-name="Path 98774"
                d="M1350.394,1334.422a8.7,8.7,0,1,1-8.7-8.7,8.7,8.7,0,0,1,8.7,8.7Z"
                transform="translate(-987.762 -962.626)"
                fill="#e3e3e3"
              />
              <path
                id="Path_98775"
                data-name="Path 98775"
                d="M1357.616,1345.1a4.647,4.647,0,1,1-4.647-4.647A4.647,4.647,0,0,1,1357.616,1345.1Z"
                transform="translate(-998.87 -973.306)"
                fill="#adb5bd"
              />
              <path
                id="Path_98776"
                data-name="Path 98776"
                d="M1324.7,1308.623a7.267,7.267,0,0,0,4.292,6.68c4.628,2.351,4.632,4.632,4.632,4.632s-.448,3.508,2.09,3.583,2.345-3.461,2.121-6.151a14.065,14.065,0,0,0-2.308-5.871c-.41-.672-.149-2.874-.149-2.874Z"
                transform="translate(-981.744 -950.225)"
                fill="#eee"
              />
              <rect
                id="Rectangle_56086"
                data-name="Rectangle 56086"
                width="13.287"
                height="3.06"
                transform="translate(341.245 356.346)"
                fill="#e3e3e3"
              />
              <g id="Group_105882" data-name="Group 105882">
                <rect
                  id="Rectangle_56048"
                  data-name="Rectangle 56048"
                  width="4.254"
                  height="60.047"
                  transform="translate(127.305 282.975)"
                  fill="#dee2e6"
                />
                <rect
                  id="Rectangle_56049"
                  data-name="Rectangle 56049"
                  width="4.254"
                  height="60.047"
                  transform="translate(170.721 282.975)"
                  fill="#dee2e6"
                />
                <rect
                  id="Rectangle_56050"
                  data-name="Rectangle 56050"
                  width="4.254"
                  height="60.047"
                  transform="translate(309.405 282.975)"
                  fill="#dee2e6"
                />
                <rect
                  id="Rectangle_56051"
                  data-name="Rectangle 56051"
                  width="4.254"
                  height="53.891"
                  transform="translate(345.882 289.129)"
                  fill="#dee2e6"
                />
                <rect
                  id="Rectangle_56078"
                  data-name="Rectangle 56078"
                  width="251.291"
                  height="4.135"
                  rx="2.068"
                  transform="translate(110.992 287.063)"
                  fill="#dee2e6"
                />
                <rect
                  id="Rectangle_56079"
                  data-name="Rectangle 56079"
                  width="237.79"
                  height="6.381"
                  transform="translate(120.956 343.021)"
                  fill="#dee2e6"
                />
                <rect
                  id="Rectangle_56081"
                  data-name="Rectangle 56081"
                  width="2.06"
                  height="6.945"
                  transform="translate(127.371 349.402)"
                  fill="#dee2e6"
                />
                <rect
                  id="Rectangle_56083"
                  data-name="Rectangle 56083"
                  width="2.06"
                  height="6.945"
                  transform="translate(172.724 349.402)"
                  fill="#dee2e6"
                />
                <rect
                  id="Rectangle_56085"
                  data-name="Rectangle 56085"
                  width="2.06"
                  height="6.945"
                  transform="translate(310.266 349.402)"
                  fill="#dee2e6"
                />
                <rect
                  id="Rectangle_56087"
                  data-name="Rectangle 56087"
                  width="2.06"
                  height="6.945"
                  transform="translate(346.659 349.402)"
                  fill="#dee2e6"
                />
              </g>
            </g>
            <path
              id="Path_98780"
              data-name="Path 98780"
              d="M358.587,580.708a2.605,2.605,0,1,0,2.605,2.605,2.605,2.605,0,0,0-2.605-2.605Zm0,4.544a1.942,1.942,0,1,1,1.942-1.942,1.942,1.942,0,0,1-1.942,1.942Z"
              transform="translate(-293.845 -422.445)"
              fill="#ced4da"
            />
            <path
              id="Path_98783"
              data-name="Path 98783"
              d="M1747.9,717.785a2.275,2.275,0,1,0,2.275,2.275A2.275,2.275,0,0,0,1747.9,717.785Zm0,3.974a1.7,1.7,0,1,1,1.7-1.7,1.7,1.7,0,0,1-1.7,1.7Z"
              transform="translate(-1301.41 -521.834)"
              fill="#ced4da"
            />
            <path
              id="Path_98785"
              data-name="Path 98785"
              d="M1704.834,961.723a3.048,3.048,0,1,0,3.049,3.048A3.048,3.048,0,0,0,1704.834,961.723Zm0,5.324a2.275,2.275,0,1,1,2.275-2.275,2.275,2.275,0,0,1-2.275,2.275Z"
              transform="translate(-1269.627 -698.704)"
              fill="#ced4da"
            />
            <path
              id="Path_98787"
              data-name="Path 98787"
              d="M1250.525,819.243a1.942,1.942,0,1,0,1.942,1.942,1.942,1.942,0,0,0-1.942-1.942Zm0,3.392a1.447,1.447,0,1,1,1.447-1.447,1.447,1.447,0,0,1-1.447,1.447Z"
              transform="translate(-941.03 -595.398)"
              fill="#74bdc1"
            />
            <g id="Group_105878" data-name="Group 105878" opacity="0.5">
              <path
                id="Path_98777"
                data-name="Path 98777"
                d="M507.8,416.167H501.79v4.881H496.91v6.012h4.881v4.881H507.8V427.06h4.881v-6.012H507.8Zm4.074,5.687v4.4H507v4.881h-4.4v-4.881h-4.881v-4.4H502.6v-4.88H507v4.881Z"
                transform="translate(-396.021 -303.143)"
                fill="#ced4da"
              />
              <path
                id="Path_98778"
                data-name="Path 98778"
                d="M253.064,697.956h-2.1v1.705h-1.7v2.1h1.7v1.7h2.1v-1.7h1.7v-2.1h-1.7Zm1.421,1.984v1.534h-1.7v1.7h-1.535v-1.7h-1.7V699.94h1.7v-1.7h1.535v1.7Z"
                transform="translate(-216.464 -507.456)"
                fill="#ced4da"
              />
              <path
                id="Path_98779"
                data-name="Path 98779"
                d="M529.748,626.544h-3.139v2.547h-2.547v3.138h2.547v2.548h3.139v-2.548H532.3v-3.138h-2.548Zm2.127,2.967v2.3h-2.548v2.547h-2.3v-2.547h-2.547v-2.3h2.547v-2.547h2.3v2.547Z"
                transform="translate(-415.709 -455.679)"
                fill="#ced4da"
              />
              <path
                id="Path_98781"
                data-name="Path 98781"
                d="M1406.943,926.762h-4.982v4.044h-4.044v4.982h4.044v4.044h4.982v-4.044h4.044v-4.98h-4.044Zm3.375,4.713v3.644h-4.048v4.044h-3.644v-4.044h-4.044v-3.644h4.044V927.43h3.644v4.044Z"
                transform="translate(-1049.301 -673.356)"
                fill="#ced4da"
              />
              <path
                id="Path_98782"
                data-name="Path 98782"
                d="M1696.23,828.1h-1.882v1.526h-1.525v1.882h1.525v1.525h1.882v-1.525h1.525v-1.882h-1.525Zm1.274,1.777v1.375h-1.526v1.525H1694.6v-1.525h-1.525v-1.375h1.525v-1.526h1.375v1.526Z"
                transform="translate(-1263.128 -601.819)"
                fill="#ced4da"
              />
              <path
                id="Path_98784"
                data-name="Path 98784"
                d="M1593.755,638.075h-4.982v4.044h-4.042V647.1h4.044v4.044h4.982V647.1h4.044v-4.982h-4.044Zm3.376,4.713v3.644h-4.044v4.044h-3.644v-4.044H1585.4v-3.644h4.044v-4.044h3.644v4.044Z"
                transform="translate(-1184.756 -464.036)"
                fill="#ced4da"
              />
              <path
                id="Path_98788"
                data-name="Path 98788"
                d="M601,174.318h-6.36v5.163h-5.163v6.363h5.163v5.163H601v-5.163h5.163v-6.36H601Zm4.31,6.017v4.653h-5.16v5.163H595.5v-5.163h-5.163v-4.653H595.5v-5.163h4.653v5.163Z"
                transform="translate(-463.142 -127.788)"
                fill="#ced4da"
              />
              <path
                id="Path_98789"
                data-name="Path 98789"
                d="M941.394,235.005H938.76v2.138h-2.138v2.635h2.138v2.138h2.635v-2.138h2.139v-2.635h-2.139Zm1.785,2.492v1.927h-2.139v2.142h-1.927v-2.142h-2.138V237.5h2.138v-2.138h1.927V237.5Z"
                transform="translate(-714.837 -171.79)"
                fill="#ced4da"
              />
            </g>
            <path
              id="Path_98790"
              data-name="Path 98790"
              d="M1041.017,462.226a4.139,4.139,0,1,0,4.14,4.14A4.139,4.139,0,0,0,1041.017,462.226Zm0,7.229a3.089,3.089,0,1,1,3.089-3.089,3.089,3.089,0,0,1-3.089,3.089Z"
              transform="translate(-787.531 -336.538)"
              fill="#ced4da"
            />
            <path
              id="Path_98791"
              data-name="Path 98791"
              d="M477.386,204.659a4.139,4.139,0,1,0,4.139,4.139,4.139,4.139,0,0,0-4.139-4.139Zm0,7.229a3.089,3.089,0,1,1,3.089-3.089,3.089,3.089,0,0,1-3.089,3.089Z"
              transform="translate(-378.864 -149.79)"
              fill="#ced4da"
            />
            <path
              id="Path_98792"
              data-name="Path 98792"
              d="M606.5,328.354a3.034,3.034,0,1,0,3.034,3.033A3.034,3.034,0,0,0,606.5,328.354Zm0,5.3a2.264,2.264,0,1,1,2.265-2.264A2.265,2.265,0,0,1,606.5,333.652Z"
              transform="translate(-473.278 -239.474)"
              fill="#ced4da"
            />
            <path
              id="Path_98793"
              data-name="Path 98793"
              d="M857.649,331.956A2.044,2.044,0,1,0,859.693,334a2.044,2.044,0,0,0-2.044-2.044Zm0,3.569A1.525,1.525,0,1,1,859.175,334a1.525,1.525,0,0,1-1.526,1.525Z"
              transform="translate(-656.098 -242.084)"
              fill="#ced4da"
            />
            <path
              id="Path_98807"
              data-name="Path 98807"
              d="M706.38,118.846q-1.486-.217-2.938-.406V192.5h2.938Z"
              transform="translate(-589.009 -111.868)"
              fill="#343a40"
            />
            <g
              id="Group_105862"
              data-name="Group 105862"
              transform="translate(79.218 74.271)"
            >
              <path
                id="Path_98808"
                data-name="Path 98808"
                d="M700.545,438.942a7.671,7.671,0,1,1-10.088-3.99,7.671,7.671,0,0,1,10.088,3.99Z"
                transform="translate(-655.46 -431.486)"
                fill="#6c757d"
              />
              <circle
                id="Ellipse_129801"
                data-name="Ellipse 129801"
                cx="19.75"
                cy="19.75"
                r="19.75"
                transform="translate(19.051 14.045) rotate(-20.829)"
                fill="#343a40"
              />
              <ellipse
                id="Ellipse_129802"
                data-name="Ellipse 129802"
                cx="47.75"
                cy="21.386"
                rx="47.75"
                ry="21.386"
                transform="translate(0 42.991) rotate(-23.387)"
                fill="#dee2e6"
              />
              <ellipse
                id="Ellipse_129803"
                data-name="Ellipse 129803"
                cx="9.668"
                cy="5.251"
                rx="9.668"
                ry="5.251"
                transform="translate(24.689 39.057) rotate(-23.419)"
                fill="#adb5bd"
              />
              <path
                id="Path_98809"
                data-name="Path 98809"
                d="M778.131,511.293c1.153,2.661-1.882,6.538-6.785,8.66s-9.806,1.685-10.958-.976,1.882-6.539,6.785-8.661S776.98,508.632,778.131,511.293Z"
                transform="translate(-709.34 -485.615)"
                fill="#adb5bd"
              />
              <path
                id="Path_98810"
                data-name="Path 98810"
                d="M718.555,615.805c1.153,2.661-1.882,6.539-6.785,8.66s-9.806,1.685-10.958-.976,1.882-6.539,6.785-8.661S717.4,613.144,718.555,615.805Z"
                transform="translate(-666.144 -561.393)"
                fill="#adb5bd"
              />
              <path
                id="Path_98811"
                data-name="Path 98811"
                d="M806.839,577.567c1.153,2.661-1.882,6.539-6.785,8.66s-9.806,1.685-10.958-.976,1.882-6.539,6.785-8.66S805.681,574.906,806.839,577.567Z"
                transform="translate(-730.154 -533.668)"
                fill="#adb5bd"
              />
              <path
                id="Path_98812"
                data-name="Path 98812"
                d="M848.147,518.051c1.152,2.661-1.882,6.539-6.785,8.66s-9.806,1.685-10.958-.976,1.882-6.539,6.785-8.66S847,515.39,848.147,518.051Z"
                transform="translate(-760.105 -490.515)"
                fill="#adb5bd"
              />
              <path
                id="Path_98813"
                data-name="Path 98813"
                d="M651.089,603.4c1.153,2.661-1.882,6.538-6.785,8.66s-9.806,1.685-10.958-.976,1.882-6.539,6.785-8.66S649.936,600.742,651.089,603.4Z"
                transform="translate(-617.227 -552.401)"
                fill="#adb5bd"
              />
              <path
                id="Path_98814"
                data-name="Path 98814"
                d="M634.79,480.468c22.671-9.819,44.659-10.184,51.2-1.277a9.863,9.863,0,0,0-.646-2.122c-4.693-10.837-28.112-11.125-52.307-.646s-40,27.76-35.311,38.6a9.872,9.872,0,0,0,1.106,1.922C596.811,506.075,612.119,490.287,634.79,480.468Z"
                transform="translate(-590.981 -456.452)"
                fill="#6c757d"
              />
            </g>
            <g
              id="Group_105863"
              data-name="Group 105863"
              transform="translate(284.798 122.308) rotate(-4)"
            >
              <path
                id="Path_98815"
                data-name="Path 98815"
                d="M1336.631,497.724a7.671,7.671,0,1,0,10.088-3.99,7.671,7.671,0,0,0-10.088,3.99Z"
                transform="translate(-1277.104 -493.099)"
                fill="#6c757d"
              />
              <path
                id="Path_98816"
                data-name="Path 98816"
                d="M1270.1,515.538a19.749,19.749,0,1,0,25.972-10.276A19.749,19.749,0,0,0,1270.1,515.538Z"
                transform="translate(-1228.137 -500.736)"
                fill="#343a40"
              />
              <ellipse
                id="Ellipse_129804"
                data-name="Ellipse 129804"
                cx="21.382"
                cy="47.741"
                rx="21.382"
                ry="47.741"
                transform="translate(0 41.451) rotate(-66.581)"
                fill="#dee2e6"
              />
              <path
                id="Path_98817"
                data-name="Path 98817"
                d="M1339.722,608.312c-1.153,2.661,1.882,6.538,6.785,8.661s9.806,1.685,10.958-.976-1.882-6.539-6.785-8.66S1340.872,605.652,1339.722,608.312Z"
                transform="translate(-1279.625 -574.952)"
                fill="#adb5bd"
              />
              <path
                id="Path_98818"
                data-name="Path 98818"
                d="M1251.439,570.075c-1.153,2.661,1.882,6.539,6.785,8.66s9.806,1.685,10.958-.976-1.882-6.539-6.785-8.66S1252.59,567.414,1251.439,570.075Z"
                transform="translate(-1215.616 -547.229)"
                fill="#adb5bd"
              />
              <path
                id="Path_98819"
                data-name="Path 98819"
                d="M1311.013,674.586c-1.153,2.661,1.882,6.538,6.785,8.66s9.806,1.685,10.958-.976-1.882-6.538-6.785-8.66S1312.171,671.925,1311.013,674.586Z"
                transform="translate(-1258.813 -623.005)"
                fill="#adb5bd"
              />
              <ellipse
                id="Ellipse_129805"
                data-name="Ellipse 129805"
                cx="5.251"
                cy="9.668"
                rx="5.251"
                ry="9.668"
                transform="translate(25.844 45.886) rotate(-66.581)"
                fill="#adb5bd"
              />
              <path
                id="Path_98820"
                data-name="Path 98820"
                d="M1181.423,576.833c-1.153,2.661,1.882,6.538,6.785,8.66s9.806,1.685,10.958-.976-1.882-6.538-6.785-8.661S1182.581,574.172,1181.423,576.833Z"
                transform="translate(-1164.852 -552.128)"
                fill="#adb5bd"
              />
              <path
                id="Path_98821"
                data-name="Path 98821"
                d="M1378.482,662.185c-1.153,2.661,1.882,6.538,6.785,8.66s9.805,1.685,10.958-.976-1.882-6.538-6.785-8.661S1379.633,659.524,1378.482,662.185Z"
                transform="translate(-1307.729 -614.013)"
                fill="#adb5bd"
              />
              <path
                id="Path_98822"
                data-name="Path 98822"
                d="M1207.924,539.251c-22.671-9.82-44.659-10.184-51.2-1.277a9.877,9.877,0,0,1,.645-2.122c4.694-10.836,28.112-11.125,52.307-.646s40,27.76,35.311,38.6a9.864,9.864,0,0,1-1.106,1.922C1245.9,564.859,1230.59,549.07,1207.924,539.251Z"
                transform="translate(-1147.116 -518.065)"
                fill="#6c757d"
              />
            </g>
            <rect
              id="Rectangle_56089"
              data-name="Rectangle 56089"
              width="477.91"
              height="2.122"
              transform="translate(0 393.907)"
              fill="#dee2e6"
            />
          </g>
        </g>
        <g
          id="Group_105879"
          data-name="Group 105879"
          transform="translate(1446.439 -8833.339)"
        >
          <g
            id="Group_105871"
            data-name="Group 105871"
            transform="translate(-1027.604 9070.741) rotate(-4.012)"
          >
            <path
              id="Path_98866"
              data-name="Path 98866"
              d="M39.226,74.172l16.146-.29-.417-12.79L62.592,61,62.1,46.566l-7.62.034L53.088,3.75l-17.853-.3L6.074,47.816,6.408,61.66l32.436-.381ZM23.515,46.737,38.8,21.78l.746,24.886Z"
              transform="translate(-5.01 -2.96)"
              fill="#abd2cd"
            />
            <path
              id="Path_98867"
              data-name="Path 98867"
              d="M39.226,74.172l16.146-.29-.417-12.79L62.592,61,62.1,46.566l-7.62.034L53.088,3.75l-17.853-.3L6.074,47.816,6.408,61.66l32.436-.381ZM23.515,46.737,38.8,21.78l.746,24.886Z"
              transform="translate(-0.542 -2.96)"
              fill="#007965"
            />
          </g>
          <g
            id="Group_105873"
            data-name="Group 105873"
            transform="translate(-953.05 9048.252)"
          >
            <path
              id="Path_98868"
              data-name="Path 98868"
              d="M2.327,34.277a61.155,61.155,0,0,0,.351,13.2A29.2,29.2,0,0,0,6.142,58a17.891,17.891,0,0,0,7.232,6.96,24.549,24.549,0,0,0,11.672,2.461,27.093,27.093,0,0,0,12.129-2.687,22.434,22.434,0,0,0,8.317-7.285A34.106,34.106,0,0,0,50.364,46.49a63.656,63.656,0,0,0,1.9-13.649,58.83,58.83,0,0,0-.8-13.252A27.618,27.618,0,0,0,47.585,9.408,17.356,17.356,0,0,0,40.15,3.039,24.706,24.706,0,0,0,28.7,1.2a27.393,27.393,0,0,0-11.55,2.921,22.507,22.507,0,0,0-7.884,6.931A33.462,33.462,0,0,0,4.487,21.315a62.388,62.388,0,0,0-2.16,12.962Zm34.688-1a71.958,71.958,0,0,1-.676,7.4,24.214,24.214,0,0,1-1.676,6.151,10.044,10.044,0,0,1-3.3,4.227,9.575,9.575,0,0,1-5.509,1.63,8.472,8.472,0,0,1-5.305-1.433,8.093,8.093,0,0,1-2.785-4.074,21.953,21.953,0,0,1-.974-6.026,70.7,70.7,0,0,1,.145-7.3,68.572,68.572,0,0,1,.734-7.081,23.729,23.729,0,0,1,1.681-5.914,10.132,10.132,0,0,1,3.218-4.121,9.587,9.587,0,0,1,5.364-1.694,8.35,8.35,0,0,1,5.237,1.282,7.869,7.869,0,0,1,2.822,3.926,21.093,21.093,0,0,1,1.059,5.883,66.85,66.85,0,0,1-.039,7.143Z"
              transform="translate(3.966 2.338)"
              fill="#abd2cd"
            />
            <path
              id="Path_98869"
              data-name="Path 98869"
              d="M2.4,34.272a61.051,61.051,0,0,0,.317,13.162A29.048,29.048,0,0,0,6.146,57.928a17.734,17.734,0,0,0,7.19,6.933,24.346,24.346,0,0,0,11.627,2.434,27.047,27.047,0,0,0,12.091-2.7,22.5,22.5,0,0,0,8.311-7.276,34.192,34.192,0,0,0,4.882-10.934A63.669,63.669,0,0,0,52.173,32.77a58.7,58.7,0,0,0-.761-13.22A27.461,27.461,0,0,0,47.57,9.4a17.2,17.2,0,0,0-7.394-6.343A24.554,24.554,0,0,0,28.771,1.239,27.355,27.355,0,0,0,17.252,4.167a22.569,22.569,0,0,0-7.874,6.926A33.55,33.55,0,0,0,4.583,21.337,62.419,62.419,0,0,0,2.4,34.272Zm34.573-1.046a71.939,71.939,0,0,1-.692,7.386A24.249,24.249,0,0,1,34.6,46.75,10.076,10.076,0,0,1,31.3,50.972a9.567,9.567,0,0,1-5.494,1.64,8.412,8.412,0,0,1-5.283-1.424,8.033,8.033,0,0,1-2.766-4.061,21.879,21.879,0,0,1-.955-6.01,70.615,70.615,0,0,1,.16-7.283,68.56,68.56,0,0,1,.749-7.063,23.766,23.766,0,0,1,1.69-5.9,10.163,10.163,0,0,1,3.217-4.116,9.581,9.581,0,0,1,5.355-1.7,8.292,8.292,0,0,1,5.216,1.271A7.807,7.807,0,0,1,36,20.234,21.017,21.017,0,0,1,37.037,26.1a66.768,66.768,0,0,1-.062,7.125Z"
              fill="#007965"
            />
          </g>
          <g
            id="Group_105872"
            data-name="Group 105872"
            transform="translate(-891.973 9071.705)"
          >
            <path
              id="Path_98870"
              data-name="Path 98870"
              d="M29.93,71.028l15.669,1.8,1.3-12.606,7.621.816L56,46.647l-7.62-.749L52.794,3.283,35.316,2.026,2.691,42.358,1.306,55.34l29.928,3.207ZM18.685,42.98,36.346,20.167l-2.539,24.3Z"
              transform="translate(4.818 0.292)"
              fill="#abd2cd"
            />
            <path
              id="Path_98871"
              data-name="Path 98871"
              d="M29.816,70.972l15.61,1.8,1.31-12.6,7.593.814,1.485-14.379-7.592-.749L52.642,3.273,35.231,2.018,2.7,42.328,1.31,55.3l29.816,3.2ZM18.632,42.946l17.612-22.8L33.7,44.428Z"
              fill="#007965"
            />
          </g>
        </g>
      </g>
      <path
        id="Rectangle_56077"
        data-name="Rectangle 56077"
        d="M5.138,0H231.763A5.138,5.138,0,0,1,236.9,5.138h0a5.138,5.138,0,0,1-5.138,5.138H5.138A5.138,5.138,0,0,1,0,5.138H0A5.138,5.138,0,0,1,5.138,0Z"
        transform="translate(561.239 392.498)"
        fill="#adb5bd"
      />
    </g>
  </SvgIcon>;
}
export function NoMembers(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 119.891,
    height: 125.574,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 119.891 125.574"
      sx={rootSx}
      {...rest}
    >
      <g data-name="Group 105666" transform="translate(-127.554 -348.926)">
        <path
          data-name="Path 20580"
          d="M37.539 7S17.165 17.387 7.007 33.385A44.148 44.148 0 009.994 85.23c12.351 15.282 35.952 13.26 55.715 22.943s41.579 7.685 50.914-12.816-4.746-28.157-7.183-51.886S85.646-15 37.539 7z"
          fill="#c5e7e1"
          transform="rotate(93 -44.662 294.85)"
        />
        <path
          data-name="Path 20581"
          d="M37.539 7S17.165 17.387 7.007 33.385A44.148 44.148 0 009.994 85.23c12.351 15.282 35.952 13.26 55.715 22.943s41.579 7.685 50.914-12.816-4.746-28.157-7.183-51.886S85.646-15 37.539 7z"
          fill="#fff"
          opacity={0.7}
          transform="rotate(93 -44.662 294.85)"
        />
        <g
          data-name="Group 105665"
          fontSize={69}
          fontFamily="Poppins-Bold, Poppins"
          fontWeight={700}
        >
          <text
            data-name={0}
            transform="translate(0 2) translate(165 439)"
            fill="#7ba59d"
          >
            <tspan x={0} y={0}>
              0
            </tspan>
          </text>
          <text
            data-name={0}
            transform="translate(0 2) translate(169 439)"
            fill="#9bbcb6"
          >
            <tspan x={0} y={0}>
              0
            </tspan>
          </text>
        </g>
        <path
          data-name="Line 1559"
          transform="translate(160.5 440.5)"
          fill="none"
          stroke="#7ba59d"
          strokeWidth={1}
          d="M0 0L56 0"
        />
      </g>
    </SvgIcon>
  );
}
export function CreateAccountIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 256.025,
    height: 164.145,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256.025 164.145"
      {...rest}
      sx={rootSx}
    >
      <g data-name="Group 102579" transform="translate(-59.737 -47)">
        <circle
          data-name="Ellipse 39441"
          cx={18}
          cy={18}
          r={18}
          transform="translate(279 137)"
          fill="rgba(90,197,179,0.1)"
        />
        <g data-name="Signup illustration" transform="translate(59.737 44)">
          <path
            data-name="Path 4343"
            d="M240.589 4.27a2.54 2.54 0 014.4 0l17.968 31.12a2.541 2.541 0 01-2.2 3.811h-35.935a2.541 2.541 0 01-2.2-3.811z"
            transform="translate(-34.051)"
            fill="rgba(90,197,179,0.1)"
          />
          <circle
            data-name="Ellipse 39439"
            cx={25.404}
            cy={25.404}
            r={25.404}
            transform="translate(0 102.077)"
            fill="rgba(90,197,179,0.1)"
          />
          <circle
            data-name="Ellipse 39440"
            cx={16.089}
            cy={16.089}
            r={16.089}
            transform="translate(36.413 12.315)"
            fill="rgba(90,197,179,0.1)"
          />
          <g data-name="Group 5561">
            <path
              data-name="Path 4344"
              d="M29.515 138.09A4.22 4.22 0 0028 135.5c-1.514-1.514-2.485-2.379-2.485-2.379s-.758 2.487.647 4a26.6 26.6 0 003.346 2.92z"
              transform="translate(12.671 113.185) translate(-16.548 -133.118)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4345"
              d="M26.923 146.065a4.225 4.225 0 00-1.511-2.6c-1.511-1.514-2.487-2.379-2.487-2.379s-.756 2.487.65 4A26.629 26.629 0 0026.923 148z"
              transform="translate(12.671 113.185) translate(-16.151 -134.339)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4346"
              d="M30.125 140.348a4.217 4.217 0 011.779-2.421c1.665-1.344 2.724-2.1 2.724-2.1s.491 2.551-1.068 3.9a26.528 26.528 0 01-3.642 2.549z"
              transform="translate(12.671 113.185) translate(-17.254 -133.533)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4347"
              d="M26.949 149.841s.229-1.057 2.024-2.231 2.931-1.8 2.931-1.8.217 2.59-1.472 3.776a26.712 26.712 0 01-3.9 2.153z"
              transform="translate(12.671 113.185) translate(-16.735 -135.062)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4348"
              d="M27.618 159.948a4.223 4.223 0 011.514-2.6c1.514-1.514 2.487-2.379 2.487-2.379s.756 2.488-.65 4a26.531 26.531 0 01-3.346 2.919z"
              transform="translate(12.671 113.185) translate(-16.902 -136.466)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4349"
              d="M26.917 162.36a4.257 4.257 0 00-1.115-2.789c-1.269-1.718-2.122-2.708-2.122-2.708s-1.115 2.354.072 4.052a26.637 26.637 0 002.9 3.366z"
              transform="translate(12.671 113.185) translate(-16.225 -136.755)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4350"
              d="M25.826 169.88a4.214 4.214 0 011.514-2.594c1.514-1.512 2.487-2.379 2.487-2.379s.756 2.485-.65 4a26.537 26.537 0 01-3.346 2.92z"
              transform="translate(12.671 113.185) translate(-16.627 -137.988)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4351"
              d="M27.018 176.46a4.19 4.19 0 01.806-2.894c1.085-1.849 1.8-2.931 1.8-2.931s1.361 2.214.385 4.035a26.426 26.426 0 01-2.51 3.673z"
              transform="translate(12.671 113.185) translate(-16.805 -138.865)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4352"
              d="M13.104 4.696a30.954 30.954 0 01-.413 3.346c-.6 3.09-2.094 5.087-2.694 7.878s1.115 6.388.661 9.975S8.801 31.472 9.2 33.87s2.493 8.874 2.493 8.874"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(12.671 113.185)"
            />
            <path
              data-name="Path 4353"
              d="M12.858 7.531l1.631-1.249"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(12.671 113.185)"
            />
            <path
              data-name="Path 4354"
              d="M12.934 6.09l-.683-1.213"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(12.671 113.185)"
            />
            <path
              data-name="Path 4355"
              d="M10.088 15.803s1.364-1.024 2.769-2.05"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(12.671 113.185)"
            />
            <path
              data-name="Path 4356"
              d="M10.771 13.665a21.829 21.829 0 00-2.426-3.712"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(12.671 113.185)"
            />
            <path
              data-name="Path 4357"
              d="M10.772 25.018a16.861 16.861 0 012.92-3.9"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(12.671 113.185)"
            />
            <path
              data-name="Path 4358"
              d="M10.492 26.538a19.218 19.218 0 00-1.478-2.808c-.8-1.177-.912-1.328-.912-1.328"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(12.671 113.185)"
            />
            <path
              data-name="Path 4359"
              d="M9.199 33.88a17.979 17.979 0 011.23-2.487 15.8 15.8 0 011.592-2.086"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(12.671 113.185)"
            />
            <path
              data-name="Path 4360"
              d="M10.705 39.477a4.646 4.646 0 01.41-2.391c.558-1.1 1.213-2.54 1.478-3.109"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(12.671 113.185)"
            />
            <path
              data-name="Path 4361"
              d="M18.571 155.4a2.7 2.7 0 01.666-1.794 38.714 38.714 0 011.3-1.759 2.9 2.9 0 01.028 2.579 16.822 16.822 0 01-1.785 2.192z"
              transform="translate(12.671 113.185) translate(-15.515 -135.988)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4362"
              d="M21.064 160.134a2.691 2.691 0 01.667-1.793c.784-1.113 1.313-1.771 1.313-1.771a2.89 2.89 0 01.025 2.577 16.894 16.894 0 01-1.785 2.194z"
              transform="translate(12.671 113.185) translate(-15.897 -136.711)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4363"
              d="M18.279 156.972s-.19-.661-1.378-1.324-1.938-1.024-1.938-1.024a2.9 2.9 0 001.1 2.337 16.993 16.993 0 002.56 1.2z"
              transform="translate(12.671 113.185) translate(-14.963 -136.412)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4364"
              d="M21.224 162.6s-.257-.639-1.509-1.171-2.033-.814-2.033-.814a2.888 2.888 0 001.333 2.205 16.785 16.785 0 002.674.929z"
              transform="translate(12.671 113.185) translate(-15.38 -137.331)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4365"
              d="M22.056 168.978s-.117-.677-1.23-1.461-1.818-1.222-1.818-1.222a2.911 2.911 0 00.837 2.438 16.927 16.927 0 002.418 1.467z"
              transform="translate(12.671 113.185) translate(-15.58 -138.2)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4366"
              d="M22.9 170.346a2.673 2.673 0 01.4-1.868c.619-1.213 1.037-1.93 1.037-1.93a2.9 2.9 0 01.4 2.549 16.986 16.986 0 01-1.456 2.426z"
              transform="translate(12.671 113.185) translate(-16.173 -138.239)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4367"
              d="M25.118 176.974s.078-.683 1.146-1.531 1.743-1.324 1.743-1.324a2.9 2.9 0 01-.7 2.481 16.808 16.808 0 01-2.331 1.6z"
              transform="translate(12.671 113.185) translate(-16.497 -139.399)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4368"
              d="M24.257 175.013s-.117-.677-1.23-1.464-1.818-1.221-1.818-1.221a2.907 2.907 0 00.837 2.437 16.8 16.8 0 002.412 1.467z"
              transform="translate(12.671 113.185) translate(-15.917 -139.125)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4369"
              d="M24.346 179.24a2.68 2.68 0 00-.82-1.726 41.057 41.057 0 00-1.45-1.643 2.9 2.9 0 00.2 2.571 16.929 16.929 0 001.969 2.033z"
              transform="translate(12.671 113.185) translate(-16.018 -139.667)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4370"
              d="M2.939 19.257a19.794 19.794 0 00.625 2.06c.711 1.871 1.866 2.962 2.543 4.646s0 4.13.669 6.327 1.771 3.3 1.779 4.844-.6 5.834-.6 5.834"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(12.671 113.185)"
            />
            <path
              data-name="Path 4371"
              d="M3.403 21.009l-1.157-.608"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(12.671 113.185)"
            />
            <path
              data-name="Path 4372"
              d="M3.198 20.114l.3-.837"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(12.671 113.185)"
            />
            <path
              data-name="Path 4373"
              d="M6.032 25.895s-.968-.494-1.952-.984"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(12.671 113.185)"
            />
            <path
              data-name="Path 4374"
              d="M5.377 24.631a13.8 13.8 0 011.115-2.59"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(12.671 113.185)"
            />
            <path
              data-name="Path 4375"
              d="M6.61 31.748a10.825 10.825 0 00-2.25-2.134"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(12.671 113.185)"
            />
            <path
              data-name="Path 4376"
              d="M6.941 32.67a12.28 12.28 0 01.622-1.921c.374-.822.427-.931.427-.931"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(12.671 113.185)"
            />
            <path
              data-name="Path 4377"
              d="M8.505 38.306a10.045 10.045 0 011.244-1.294 6.819 6.819 0 00.811-.705"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(12.671 113.185)"
            />
            <path
              data-name="Path 4378"
              d="M8.555 37.135a11.568 11.568 0 00-1.04-1.428 10.033 10.033 0 00-1.224-1.13"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(12.671 113.185)"
            />
            <path
              data-name="Path 4379"
              d="M8.22 40.807a2.937 2.937 0 00-.516-1.458c-.477-.627-1.037-1.462-1.266-1.79"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(12.671 113.185)"
            />
            <path
              data-name="Path 4380"
              d="M12.675 53.261H6.356a.5.5 0 01-.5-.5L4.289 42.299h10.449l-1.567 10.465a.5.5 0 01-.5.5z"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(12.671 113.185)"
            />
          </g>
          <g
            data-name="Group 5427"
            opacity={0.3}
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          >
            <path
              data-name="Path 4381"
              d="M52.871 121.524H0V25.766A25.766 25.766 0 0125.766 0a27.092 27.092 0 0127.093 27.093v94.431z"
              opacity={0.3}
              transform="translate(202.655 7.234)"
            />
            <path
              data-name="Path 4382"
              d="M46.891 121.24V27.305A20.467 20.467 0 0026.425 6.838h0A20.466 20.466 0 005.969 27.305v93.95"
              opacity={0.3}
              transform="translate(202.655 7.234)"
            />
            <path
              data-name="Path 4383"
              d="M26.436 0v121.382"
              opacity={0.3}
              transform="translate(202.655 7.234)"
            />
            <path
              data-name="Path 4384"
              d="M52.586 23.382H.353"
              opacity={0.3}
              transform="translate(202.655 7.234)"
            />
            <path
              data-name="Path 4385"
              d="M52.586 39.869H.353"
              opacity={0.3}
              transform="translate(202.655 7.234)"
            />
            <path
              data-name="Path 4386"
              d="M52.586 56.354H.353"
              opacity={0.3}
              transform="translate(202.655 7.234)"
            />
            <path
              data-name="Path 4387"
              d="M52.586 72.845H.353"
              opacity={0.3}
              transform="translate(202.655 7.234)"
            />
            <path
              data-name="Path 4388"
              d="M52.586 89.333H.353"
              opacity={0.3}
              transform="translate(202.655 7.234)"
            />
            <path
              data-name="Path 4389"
              d="M52.586 105.819H.353"
              opacity={0.3}
              transform="translate(202.655 7.234)"
            />
            <path
              data-name="Path 4390"
              d="M45.603 8.249l-4.735 4.315"
              opacity={0.3}
              transform="translate(202.655 7.234)"
            />
            <path
              data-name="Path 4391"
              d="M7.465 8.249l4.738 4.315"
              opacity={0.3}
              transform="translate(202.655 7.234)"
            />
          </g>
          <g
            data-name="Group 5428"
            opacity={0.3}
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          >
            <path
              data-name="Path 4392"
              d="M52.87 121.524H0V25.766A25.766 25.766 0 0125.766 0a27.093 27.093 0 0127.093 27.093v94.431z"
              opacity={0.3}
              transform="translate(8.468 7.234)"
            />
            <path
              data-name="Path 4393"
              d="M46.899 121.24V27.305A20.467 20.467 0 0026.433 6.823h0A20.467 20.467 0 005.95 27.305v93.95"
              opacity={0.3}
              transform="translate(8.468 7.234)"
            />
            <path
              data-name="Path 4394"
              d="M26.433 0v121.382"
              opacity={0.3}
              transform="translate(8.468 7.234)"
            />
            <path
              data-name="Path 4395"
              d="M52.586 23.382H.35"
              opacity={0.3}
              transform="translate(8.468 7.234)"
            />
            <path
              data-name="Path 4396"
              d="M52.586 39.869H.35"
              opacity={0.3}
              transform="translate(8.468 7.234)"
            />
            <path
              data-name="Path 4397"
              d="M52.586 56.354H.35"
              opacity={0.3}
              transform="translate(8.468 7.234)"
            />
            <path
              data-name="Path 4398"
              d="M52.586 72.845H.35"
              opacity={0.3}
              transform="translate(8.468 7.234)"
            />
            <path
              data-name="Path 4399"
              d="M52.586 89.332H.35"
              opacity={0.3}
              transform="translate(8.468 7.234)"
            />
            <path
              data-name="Path 4400"
              d="M52.586 105.818H.35"
              opacity={0.3}
              transform="translate(8.468 7.234)"
            />
            <path
              data-name="Path 4401"
              d="M45.603 8.249l-4.738 4.315"
              opacity={0.3}
              transform="translate(8.468 7.234)"
            />
            <path
              data-name="Path 4402"
              d="M7.465 8.249l4.734 4.315"
              opacity={0.3}
              transform="translate(8.468 7.234)"
            />
          </g>
          <path
            data-name="Path 4403"
            d="M73.463 136.164l26.09-1.79s8.7-1.709 14.1-2.374 7.487-.288 7.487-.288l5.765 3.05s1.464 1.943.656 7.39c-.567 3.823-2 9.064-3.071 13.78a155.865 155.865 0 00-1.641 8.393 8.845 8.845 0 01-3.564.4 10.219 10.219 0 01-3.511-1.32s.042-4.27-.191-8.7c-.119-2.247-.414-3.984-.572-5.695a15.858 15.858 0 01.082-3.283l-19.216 5.739s4.687 8.062 8.195 15.762c2.443 5.363 4.494 10.259 4.033 13.666a3.325 3.325 0 01-1.265 1.993c-1.28 1.3-5.4 2.924-8.476 2.4-4.058-.689-8.679-3.346-12.9-5.6a354.37 354.37 0 01-11.157-6.225 6.192 6.192 0 01-.221-3.47 12.673 12.673 0 012.026-3.854s2.836.842 5.583 1.429 5.407.92 5.407.92-2.054-2.17-4.859-4.937c-3.731-3.68-8.664-8.65-10.61-13.263a13.978 13.978 0 011.836-14.122z"
            transform="translate(-10.796 -19.701)"
            fill="#263238"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4404"
            d="M168.335 125.863c1.528-.814 4.642-.9 8.26-.981 4.689-.111 10.3-.052 15.207.191a244.229 244.229 0 0134.679 4.8l11.048 16.4 1.333 1.458a6.282 6.282 0 012.543.253c1.558.456 8.449 4.215 8.482 5.73.206 9.751-7.724 11.482-7.724 11.482l-8.6-4.827L217.89 149.8l-10.529-7.477s-1.127-.094-2.427-.058c-2.316.064-5.95.263-10.2.154-6.641-.169-13.93-.774-13.93-.774l.6 3.034 1.034 9.887s-1.5 2.02-6.068 2.195c-6.918.264-7.846-1.551-7.846-1.551a48.564 48.564 0 00-.953-6.687c-.832-4.09-2.374-9.671-2.374-9.671s.08-4.851-.391-6.237c-.741-2.181 1.47-5.651 3.533-6.751z"
            transform="translate(-25.224 -18.663)"
            fill="#263238"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4405"
            d="M111.033 63.892s-9.775.52-11.052 1.2-4.345 9.113-4.345 9.113a20.1 20.1 0 01-1.482 1.979c-.853 1-1.934 2.007-1.934 2.007l-3.047.644s-.843 2-6.226.586c-1.3-.342-3.309.513-5.231 1.934-3.707 2.742-6.91 4.888-8.321 6.065-1.541 1.285-10.256 8.064-10.971 10.622-.67 2.392 1.446 6.094 3.281 8.629a29.634 29.634 0 004.322 4.734l-1.166 1.807a15.716 15.716 0 008.461 4.491 34.411 34.411 0 0013.258-.081l1.115-2.175 3.6-4.331.822-1.47 6.856-11.837 8.161 10.357s2.028 2.324 3.493 3.7a10.643 10.643 0 002.367 1.8s2.043 1.324 8.77 3 18.141 3.716 18.141 3.716a18.913 18.913 0 005.752-.126 3.6 3.6 0 002.541-2.233 11.1 11.1 0 002.907-1.528c.647-.607.278-1.1.278-1.1s.665-.655.53-1.005-1.063-.395-1.063-.395-.1-.738-2.111-.53c-1.528.158-4.325 1.46-8.057.548-.267-.066.049-.624.6-.887a14.351 14.351 0 002.643-1.028c.638-.471.931-1.462.59-1.562-.77-.226-1.825.347-2.765.6a16.385 16.385 0 00-3.634 1.106c-1.327.677-2.468 1.853-3.909 1.594-3.4-.611-7.281-3.162-10.29-4.663-4.59-2.291-6.069-2.319-7.15-3.52-2.342-2.6-2.1-2.507-3.629-5.426-1.711-3.272-3.428-7.246-5.26-10.021-3.464-5.251-5.45-5.669-5.45-5.669l-1.874-1.553 2.256-2.329 1.07-.82s2.623 2.066 4.219 1.435c1.648-.652 2.269-4.016 2.607-4.922.562-1.51 1.948-1.211 2.037-2.256.043-.507-.6-1.081-1.07-1.759a2.5 2.5 0 01-.484-1.377c.134-1.2.75-2.7.894-3.589.213-1.319-1.055-3.472-1.055-3.472zM72.781 97.147a39.2 39.2 0 01-1.155 4.439 36.879 36.879 0 01-2.036 4.661c-.006-.026-2.653-5.591-2.659-5.618-.031-.125 5.725-3.449 5.85-3.48z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            fillRule="evenodd"
          />
          <path
            data-name="Path 4406"
            d="M97.944 92.725a18.605 18.605 0 018.824-.211 17 17 0 015.737 3.161 20.118 20.118 0 011.841 1.653 9.8 9.8 0 00-4.967 3.02 17.7 17.7 0 00-3.352 6.924c-.215 1.365.053 4.634 1.114 5.378 2.116 1.484 4.961-1.07 4.961-1.07l.75.6s-.444 4.215-2.1 6.6-2.475 1.362-3.843 2.407a4.709 4.709 0 00-1.625 1.773 20.281 20.281 0 01-4.119-.141 43.314 43.314 0 01-9.583-2.413c-5.426-2.148-6.905-5.3-6.905-5.3a40.228 40.228 0 011.491-5.7c1.006-2.9 1.46-6.725 3.029-9.373 3.165-5.338 7.047-7.019 7.047-7.019l1.693-.286z"
            transform="translate(-12.972 -13.642)"
            fill="#38c5ae"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4407"
            d="M115.988 68.126a6.873 6.873 0 00-1.919.264 7.515 7.515 0 00-2.872 1.7 2.417 2.417 0 00-2.462-.352c-1.28.459-3.049 2.2-4.263 3.809-1.482 1.966-2.215 4.775-3.048 7.838-.767 2.823-1.673 5.89-2.037 8.1-.808 4.913-5.366 10.628-5.948 13.757a7.48 7.48 0 00.879 4.571 16.14 16.14 0 011.26 6.065 7.573 7.573 0 01-2.048 4.422 3.5 3.5 0 002.388-.924 7.542 7.542 0 001.407-2.96 5.079 5.079 0 00.879 1.348 4.659 4.659 0 001.3.893 5.459 5.459 0 01-.571-4.527c.846-2.452 3.956-5.274 3.956-5.274s2.418-1.49 2.784-3.18c.549-2.534-.6-6.8-.191-10.68a36.71 36.71 0 012.842-10.226l1.51 1.421a7.208 7.208 0 002.783-.7 11.029 11.029 0 002.579-2.007 5.128 5.128 0 01-.777-1.847 2.311 2.311 0 01.308-1.758c1.937-1.669 4.067 1.111 5.508.483a11.117 11.117 0 005.083-4.454 7.221 7.221 0 01.981 3.106 37.694 37.694 0 01-.718 4.542 2.754 2.754 0 001.216-1 8 8 0 00.864-2.021l.484 1.129-.044 1.3s1.133-.442 1.391-2.491c.13-1.027-.556-2.249-1.23-3.707a35.351 35.351 0 00-1.626-3.575c-1.008-1.327-2.664-1.012-4.059-1.553a18.724 18.724 0 00-6.592-1.524zm-14.049 31.6a4.615 4.615 0 01.139 3.2 6.934 6.934 0 01-1.871 3.388 59.985 59.985 0 011.732-6.587z"
            transform="translate(-14.301 -9.976)"
            fill="#263238"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4408"
            d="M193.156 47.845a3.487 3.487 0 01.855-1.613c.632-.59 1.68-.768 3.35-.607 1.85.178 4.758-.612 6.863-.035a7.233 7.233 0 013.59 2.578 5.913 5.913 0 012.5 2.235 11.431 11.431 0 011.115 3.974l-.579.364a9.571 9.571 0 01-.375 2.688c-.437 1.683-1.37 4.041-1.37 4.041l-.086 1.443-17.879-6.925s-2.561-1.977-2.058-4.014a8.285 8.285 0 012.042-3.449 2.575 2.575 0 012.031-.682z"
            transform="translate(-28.956 -6.491)"
            fill="#263238"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4409"
            d="M236.313 148.853a7.288 7.288 0 014.03-.552 7.434 7.434 0 014.015 2.73 14.433 14.433 0 011.926 8.68 7.242 7.242 0 01-8.676 5.831 8.594 8.594 0 01-4.005-2.978l2.711-13.711z"
            transform="translate(-35.785 -22.244)"
            fill="#838fa5"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4410"
            d="M184.089 145.592a5.735 5.735 0 012.489 1.284 11.28 11.28 0 012.015 2.805l6.611-1.376-.4-2.577 11.863-.195a16.758 16.758 0 01.564 6.424 6.561 6.561 0 01-2.559 4.124c-1.4.926-4.4 2.334-6.426 1.528-2.314-.92-4.461-3.918-4.461-3.918l-4.168.514a10.481 10.481 0 01-1.086 4.919 8.334 8.334 0 01-3.655 2.923l-.252-3.356.736-.96s-.146-3.258-.464-6.292-.81-5.848-.81-5.848z"
            transform="translate(-28.2 -21.835)"
            fill="#838fa5"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4411"
            d="M225.728 159.222l11.1-3.223a4.014 4.014 0 011.385 1.884 4.372 4.372 0 01-.307 2.385l-10.887 3.039z"
            transform="translate(-34.579 -23.438)"
            fill="#acb9d3"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4412"
            d="M162.661 53.512s-.467-3.761-.427-4.809c.053-1.322-.267-3.234 1.705-3.9a7.5 7.5 0 013.384-.238c1.2.275 1.883 1.291 2.872 1.865a16.3 16.3 0 003.1 1.357 3.833 3.833 0 001.931 1.962c.882.3 2.418-.452 2.846-.393a2.06 2.06 0 011.749 2.391 4.334 4.334 0 01-1.877 2.509l1.263 1.668s1.077 5.422 2.128 6.326c1.757 1.508 2.607 1.5 5.776 2.174 3.311.7 9.1 2.44 10.752 5.533 1.918 3.6 1.9 11.885 2.107 18.833.175 5.763.725 10.667.725 10.667a71.391 71.391 0 01.465 12.731c-.221 3.117-.569 7.25-.745 10.9-.15 3.13.18 6.478.218 9.7a20.764 20.764 0 01-.615 6.273c-.426.987-1.367.646-1.928.748-.261.047-.611.8-1.248 1.086-.26.116-1.219.228-1.49.37-.285.151-.721.656-1 .752a5.249 5.249 0 01-2.06-.268l-.029-1.559.751-.207a4.677 4.677 0 00.378-2.059 10.77 10.77 0 00-.587-2.644l-1.711.386-.821-1.181.619-1.527 1.575-1.769a6.984 6.984 0 001.578-2.206 5.626 5.626 0 00.262-2.52s-.186-3.022-.684-6.066c-.447-2.735-1.191-5.343-1.512-8.238a70.294 70.294 0 01-.46-8.416 27.463 27.463 0 00-.5-3.205 76.594 76.594 0 01-1.548-7.544c-.641-4.19-1.018-9.217-1.018-9.217l-11.067-1.52-11.475 24.043-6.688-.3s-.331-9.235-.567-17.7c-.174-6.22-.5-11.268.428-15.775.683-3.3 3.97-4.8 6.7-5.831a18.953 18.953 0 004.65-2.7l-.319-1.072a3.479 3.479 0 01-4.479-.815 16.041 16.041 0 01-2.49-4.509 12.84 12.84 0 01-.612-4.085z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            fillRule="evenodd"
          />
          <path
            data-name="Path 4413"
            d="M173.684 179.727s1.067-1.452 3.236-.424 5.585 2.363 5.585 2.363 1.745 6.143 1.71 9.087c-.014 1.095-2.26.668-5.348 1.236-2.532.465-4.093 1.192-6.94 1.469-3.017.295-7.29.105-8.819-.67-1.374-.7-.648-2.843.686-3.885 1.81-1.415 4.943-1.858 7.363-3.767a8.14 8.14 0 002.18-3.114 5.021 5.021 0 00.347-2.295z"
            transform="translate(-24.873 -26.951)"
            fill="#506d7b"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4414"
            d="M276.371 179.434a10.9 10.9 0 016.035-4.266s4.714.833 6.27 2.025a.923.923 0 01.3.882 29.092 29.092 0 01-1.622 5.56l-.068 6.3a3.125 3.125 0 01-2.623 2.67c-3.26.608-8.777.31-10.111-.854-.872-.761-.047-1.657.8-2.76.777-1.009 2.375-1.518 3.021-2.7.528-.963.221-2.584-.036-3.548-.626-2.355-2.647-2.28-1.969-3.318z"
            transform="translate(-42.002 -26.374)"
            fill="#506d7b"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4415"
            d="M189.509 150.064l10.591-2.1a2.957 2.957 0 011.391 1.661 4.547 4.547 0 01-.533 2.438l-10.518 2.5-.931-4.506z"
            transform="translate(-29.031 -22.208)"
            fill="#acb9d3"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4416"
            d="M159.341 123.231l7.167.6.547 2.6-2.2.556.375 1.526.04 3.073a9.122 9.122 0 011.268-.845c.5-.241.749-.119.749-.119a3.4 3.4 0 01.773-.948.492.492 0 01.62.121s.536-.8.838-.409a4.479 4.479 0 01.276 2.33 1.029 1.029 0 01-1.3.635l-.512.652-1.144.116-1.086.89-1.2.184a3.815 3.815 0 01-1.671.751 2.511 2.511 0 01-1.522-.493l.005-2.028 1.971-.625-.517-2.62-1.226-1.6-1.2.347-1.5-2.509.454-2.189z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            fillRule="evenodd"
          />
          <path
            data-name="Path 4417"
            d="M146.392 138a42.024 42.024 0 006-.117 12.716 12.716 0 004.033-1.109l.59 17.645a2.853 2.853 0 01-1.883 1.349 5.726 5.726 0 01-2.776-.9 3.052 3.052 0 00-.5-2.064 3.466 3.466 0 00-2.093-.731L146.393 138z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            fillRule="evenodd"
          />
          <path
            data-name="Path 4418"
            d="M61.012 168.239c.509-.7 2.924-.129 2.924-.129a20.023 20.023 0 013.72.409 3.812 3.812 0 011.983 1.076l-1.148 6.97L70.773 178s-.967 1.569 0 5.376c.359 1.41 1.8 2.105 2.706 3.2.978 1.191 1.354 2.75-.153 3.275-1.982.689-10.424.644-11.735-1.1-1.032-1.376-.154-6.66-.425-11.495-.148-2.634-.839-4.729-.9-6.4a4.323 4.323 0 01.748-2.617z"
            transform="translate(-9.231 -25.26)"
            fill="#506d7b"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4419"
            d="M122.532 175.651l6.364-2.784 1.3-.024a1.731 1.731 0 01.653.763c.515 1.375.133 3.148 2.726 5.329 1.71 1.44 3.87 1.983 5.574 2.645 1.641.637 2.912 1.78 3.05 2.469.185.926 1.458 1.538-.766 2.789-1.741.981-5.566.865-5.566.865a53.062 53.062 0 01-5.779-.427c-1.244-.277-2.455-.842-4.048-1.084-1.855-.281-4 .055-4.836-.47-.884-.556-.609-1.894-.306-3.626a61.136 61.136 0 011.631-6.448z"
            transform="translate(-18.476 -26.018)"
            fill="#506d7b"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4420"
            d="M224.902 135.854s.885.119 4.676 3.36 10.493 9.609 10.493 9.609a7.768 7.768 0 01.256 2.594 2.188 2.188 0 01-.942 1.463 3.776 3.776 0 00-2.163-.954 5.6 5.6 0 00-2.554.826l-14.541-7.7a23.913 23.913 0 003.851-4.873 7.956 7.956 0 00.923-4.323z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            fillRule="evenodd"
          />
          <path
            data-name="Path 4421"
            d="M60.498 144.513l4.8 1.954a9.607 9.607 0 00-1.734 3.342 10.755 10.755 0 00-.076 3.9l-4.328-2.4s.285 0-.05-1.678a12.239 12.239 0 01-.58-2.979 2.122 2.122 0 011.97-2.139z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            fillRule="evenodd"
          />
          <path
            data-name="Path 4422"
            d="M104.931 143.851a12.915 12.915 0 003.692 1.189 8.672 8.672 0 003.416-.356l-.352 2.27a3.2 3.2 0 00-2.176.676 3.782 3.782 0 00-.6 2.333 5.684 5.684 0 01-2.778.941 2.8 2.8 0 01-1.864-1.375l.666-5.679z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            fillRule="evenodd"
          />
          <path
            data-name="Path 4423"
            d="M194.667 78.1l2.509-1a13.928 13.928 0 00-1.182 4.579c-.168 1.888-.216 4.457 1.616 5.867 1.874 1.444 8.055 2.2 11.482-.544 2.5-1.994 3.429-5.589 4.475-8.128a13.65 13.65 0 012.108-3.575l2.43.6a21.95 21.95 0 00-2.678 9.476 16.847 16.847 0 002.341 8.664l1.556 11.615 1.145 4.892.826 4.674.324 8.658a34.572 34.572 0 01-8.858 1.383 34.138 34.138 0 01-8.829-1.355s-9.186-4.458-8.4-7.953a11.087 11.087 0 00.423-2.693c-.03-1.8-1.023-4.806-1.353-6.716-.977-5.653-2.053-10.487-2.053-15.748a40.306 40.306 0 012.12-12.693z"
            transform="translate(-29.496 -11.075)"
            fill="#38c5ae"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4424"
            d="M75.976 132.919a17.108 17.108 0 008.9 4.751c5.66 1.1 12.819 0 12.819 0l-.942 2.787s-7.33 1.915-13.171.865a19.51 19.51 0 01-9.727-5.15l2.122-3.25z"
            transform="translate(-11.314 -19.902)"
            fill="#38c5ae"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4425"
            d="M162.706 192.687a1.8 1.8 0 001.138.8 17.767 17.767 0 006.491.4 73.549 73.549 0 007.763-1.7c.887-.2 2.765-.243 3.47-.4 2.253-.487 2.456-.862 2.456-.862s.809 1.768-.173 2.23a13.63 13.63 0 01-3.983.539 11.164 11.164 0 00-1.708.288 27.738 27.738 0 01-5.4 1.213 29.945 29.945 0 01-8.25.043c-3.139-.8-1.8-2.56-1.8-2.56z"
            transform="translate(-24.882 -28.789)"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4426"
            d="M287.326 176.951s1.618.113 1.73.865a10.491 10.491 0 01-.653 3.4l-1.008 2.865-.237 6.544s.91 1.257-2.747 2.218c-4.635 1.218-9.851-.65-10.113-1.116a1.558 1.558 0 01.378-1.312s.4.826 2.027 1.116c2.483.443 6.637.513 8.6-.195 1.854-.67 1.018-7.952 1.018-7.952s.6-2.4.822-3.961a14.729 14.729 0 00.182-2.468z"
            transform="translate(-42.015 -26.647)"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4427"
            d="M210.517 156.948c1.982-2.484 5.771-3.021 8.553-2.094a8.278 8.278 0 013.2 2.494l.846 1.444 1.779-.246.423 2.577-.232 1.969-.778.3a14.511 14.511 0 01-.229 2.859 7.921 7.921 0 01-1.241 2.944c-1.483 2.124-5.5 2.782-6.744 2.769a7.967 7.967 0 01-3.143-1.268 12.148 12.148 0 01-3.517-4.807c-1.058-2.983-.565-6.874 1.083-8.939z"
            transform="translate(-31.997 -23.197)"
            fill="#838fa5"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4428"
            d="M225.958 159.608l1.529-.478.442 2.495-.232 2.1-.765.24-.976-4.355z"
            transform="translate(-34.614 -23.917)"
            fill="#acb9d3"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4429"
            d="M216.5 154.736a5.567 5.567 0 014.606.529c2.4 1.41 3.921 5.468 3.921 5.468s.946 4.361-.216 7.056-4.43 3.724-4.43 3.724a9.47 9.47 0 002.634-3.889 11.94 11.94 0 00.03-5.97 9.3 9.3 0 00-2.26-4.306 11.8 11.8 0 00-4.287-2.612z"
            transform="translate(-33.165 -23.203)"
            fill="#566072"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4430"
            d="M236.163 148.988a3.323 3.323 0 012.422-.158 7.632 7.632 0 014.415 3.962 13.706 13.706 0 011.418 5.337c.042 2.191-.605 4.679-1.81 5.777a5.833 5.833 0 01-4.592 1.705 7.342 7.342 0 01-4.5-2.991l.466-.558 1.744-.529.621-1.547 2.607-.736a4.052 4.052 0 00.477-2.342 4.7 4.7 0 00-1.316-2.135l-1.656.31-.3-6.094z"
            transform="translate(-35.773 -22.317)"
            fill="#566072"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4431"
            d="M202.113 151.693a4.354 4.354 0 00.5-2.423 3.155 3.155 0 00-1.442-1.694l-3.984.8-.334-2.871 9.625.167a14.747 14.747 0 01.892 5.107 8.907 8.907 0 01-1.943 5.42 4.789 4.789 0 01-4.729 1.4 11.047 11.047 0 01-3.679-2.275l1.589-.986a1.179 1.179 0 001.094-.373 5.1 5.1 0 00.6-1.794l1.816-.48z"
            transform="translate(-30.156 -21.83)"
            fill="#566072"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4432"
            d="M187.609 155.294a14.605 14.605 0 00-1.488-5.458 6.448 6.448 0 00-1.54-2.077l-.552-2.244a5.271 5.271 0 013.451 2.337 14.3 14.3 0 012.124 5.8 11.339 11.339 0 01-1.183 5.654 6.188 6.188 0 01-3.413 2.629l-.071-.57s2.761-2.672 2.672-6.073z"
            transform="translate(-28.191 -21.832)"
            fill="#566072"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4433"
            d="M223.946 145.657a.357.357 0 01-.079-.009.309.309 0 01-.22-.377 3.881 3.881 0 011-1.688c.145-.151.293-.3.44-.45 1.346-1.363 2.618-2.651 2.553-4.894a51.148 51.148 0 00-1.473-10.859 30.872 30.872 0 01-.658-3.458 79.663 79.663 0 01-.421-6.519c-.034-1.107-.061-1.982-.16-2.818a47.786 47.786 0 00-.954-4.844c-.3-1.287-.579-2.5-.735-3.519-.389-2.54-.6-4.817-.77-6.646-.258-2.784-.445-4.8-1.039-5.653-1.839-2.65-4.141-10.548.484-18.049a.308.308 0 01.525.323c-4.464 7.24-2.266 14.831-.5 17.373.688.991.871 2.962 1.147 5.947.169 1.822.379 4.088.766 6.61.152.992.431 2.2.726 3.474a48.549 48.549 0 01.966 4.91c.1.863.13 1.75.163 2.871.049 1.592.111 3.574.418 6.473a30.4 30.4 0 00.645 3.386 51.622 51.622 0 011.489 10.978c.074 2.507-1.352 3.95-2.73 5.345l-.436.445a3.286 3.286 0 00-.843 1.415.307.307 0 01-.3.23z"
            transform="translate(-33.579 -11.141)"
          />
          <path
            data-name="Path 4434"
            d="M226.034 151.913a3.9 3.9 0 01-1.222-.23.309.309 0 01.2-.584c.464.159 1.312.365 1.77-.041a2.222 2.222 0 011.548-.719 4.319 4.319 0 00.469-.06 1.285 1.285 0 00.888-.6c.083-.1.173-.213.281-.331a1.873 1.873 0 011.174-.488c.535-.086.872-.158 1.083-.57.482-.939.648-4.416.5-7.073l-.057-1.015c-.12-2.133-.225-3.975-.212-6.68.014-2.6.243-5.517.465-8.339.23-2.933.448-5.7.426-8.018a77.625 77.625 0 00-.627-8.59c-.071-.6-.133-1.127-.174-1.558-.5-5.278-.563-11.672-.6-15.108-.068-7.041-.954-11.282-2.786-13.346-2.314-2.6-6.576-3.575-10-4.356-2.623-.6-4.889-1.114-5.79-2.214-1.734-2.114-2.1-6.205-2.111-6.379a.308.308 0 01.281-.333.311.311 0 01.334.282c0 .041.361 4.074 1.974 6.04.767.936 2.938 1.431 5.451 2 3.511.8 7.879 1.8 10.323 4.548 1.965 2.212 2.872 6.452 2.943 13.75.032 3.427.092 9.8.594 15.056.041.427.1.946.172 1.545a78.013 78.013 0 01.633 8.656c.021 2.344-.2 5.127-.428 8.072-.222 2.811-.45 5.718-.463 8.293-.014 2.685.086 4.431.211 6.642l.057 1.015c.15 2.728-.025 6.327-.569 7.389a1.8 1.8 0 01-1.535.9 1.379 1.379 0 00-.816.295c-.1.108-.181.21-.257.3a1.87 1.87 0 01-1.247.814 4.5 4.5 0 01-.537.07 1.636 1.636 0 00-1.192.567 1.7 1.7 0 01-1.157.393z"
            transform="translate(-32.363 -9.541)"
          />
          <path
            data-name="Path 4435"
            d="M225.644 159.894a.309.309 0 01-.092-.6l1.715-.534a.308.308 0 11.184.589l-1.716.534a.287.287 0 01-.091.014z"
            transform="translate(-34.519 -23.858)"
          />
          <path
            data-name="Path 4436"
            d="M236.869 161.3a.309.309 0 01-.088-.6l2.374-.7c.241-.073.614-.742.372-1.956a2.738 2.738 0 00-.881-1.712.485.485 0 00-.371-.095c-.269.057-.627.144-1.049.253a.308.308 0 01-.156-.6c.434-.113.8-.2 1.08-.261a1.1 1.1 0 01.837.185 3.269 3.269 0 011.144 2.1c.3 1.5-.176 2.48-.8 2.668l-2.376.7a.283.283 0 01-.087.013z"
            transform="translate(-36.239 -23.378)"
          />
          <path
            data-name="Path 4437"
            d="M226.975 165.052a.309.309 0 01-.086-.6l.733-.213a.308.308 0 11.171.592l-.733.213a.336.336 0 01-.086.012z"
            transform="translate(-34.723 -24.697)"
          />
          <path
            data-name="Path 4438"
            d="M227.707 164.436a.308.308 0 01-.265-.464c.579-.993.511-3.133-.166-5.2a.309.309 0 11.587-.192c.739 2.259.785 4.552.113 5.7a.308.308 0 01-.267.152z"
            transform="translate(-34.814 -23.8)"
          />
          <path
            data-name="Path 4439"
            d="M216.5 172.366c-3.249 0-6.462-2.934-7.548-7.155-1.233-4.793.739-9.459 4.4-10.4s7.637 2.194 8.87 6.988-.739 9.46-4.4 10.4a5.284 5.284 0 01-1.322.167zm-1.821-17.106a4.725 4.725 0 00-1.176.149c-3.328.855-5.1 5.184-3.954 9.649s4.789 7.4 8.119 6.543 5.1-5.185 3.953-9.649c-1.013-3.942-3.972-6.693-6.942-6.693z"
            transform="translate(-31.952 -23.23)"
          />
          <path
            data-name="Path 4440"
            d="M214.293 165.152c-.4-1.567.1-3.054 1.132-3.317s2.187.793 2.591 2.359-.1 3.054-1.131 3.319-2.185-.793-2.592-2.361z"
            transform="translate(-32.806 -24.326)"
            fill="#566072"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4441"
            d="M216.5 167.806c-1.085 0-2.159-1.07-2.562-2.634-.451-1.759.142-3.38 1.354-3.693s2.514.823 2.967 2.583-.142 3.381-1.353 3.694a1.66 1.66 0 01-.406.05zm-1.964-2.787c.355 1.377 1.371 2.357 2.217 2.138s1.263-1.566.909-2.943-1.365-2.358-2.215-2.139-1.264 1.567-.91 2.944z"
            transform="translate(-32.75 -24.269)"
          />
          <path
            data-name="Path 4442"
            d="M218.483 172.14a.309.309 0 01-.061-.611 15.059 15.059 0 002.6-.876c3.093-1.316 4.423-5.1 3.312-9.428-1.164-4.529-4.091-7.018-7.641-6.486a17.753 17.753 0 00-2.632.64.309.309 0 11-.2-.585 18.318 18.318 0 012.738-.665c3.886-.577 7.078 2.081 8.329 6.943 1.191 4.63-.284 8.709-3.668 10.149a15.231 15.231 0 01-2.717.912.373.373 0 01-.061.007z"
            transform="translate(-32.729 -23.139)"
          />
          <path
            data-name="Path 4443"
            d="M238.881 166.1a7.05 7.05 0 01-5.58-3.372.309.309 0 01.506-.353c1.671 2.4 4.048 3.535 6.2 2.96 3.2-.856 4.908-5.186 3.8-9.654-1.065-4.3-4.344-7.2-7.48-6.614a.308.308 0 11-.113-.606c3.453-.647 7.05 2.458 8.192 7.073 1.187 4.791-.716 9.455-4.24 10.4a5 5 0 01-1.291.169z"
            transform="translate(-35.731 -22.269)"
          />
          <path
            data-name="Path 4444"
            d="M240.56 165.867a.309.309 0 01-.063-.611 14.074 14.074 0 002.5-.875c2.977-1.316 4.257-5.105 3.185-9.433-1.121-4.527-3.934-7.012-7.342-6.483a15.376 15.376 0 00-1.919.445.309.309 0 01-.175-.592 15.988 15.988 0 012-.463c3.751-.579 6.83 2.08 8.035 6.945 1.147 4.628-.274 8.7-3.535 10.146a14.542 14.542 0 01-2.619.915.332.332 0 01-.064.006z"
            transform="translate(-36.233 -22.178)"
          />
          <path
            data-name="Path 4445"
            d="M224.516 152.684a.307.307 0 01-.191-.066c-6.241-4.941-11.062-8.372-15.8-10.21a.309.309 0 11.224-.575c4.812 1.866 9.675 5.324 15.962 10.3a.308.308 0 01-.191.55z"
            transform="translate(-31.913 -21.264)"
          />
          <path
            data-name="Path 4446"
            d="M253.532 166.3a1.684 1.684 0 01-.885-.229l-.041-.025c-.98-.594-3.272-1.986-5.011-2.936a58.118 58.118 0 00-2.351-1.21c-.256-.127-.511-.253-.77-.384a.308.308 0 11.277-.55c.258.13.512.255.766.381.722.358 1.47.727 2.373 1.222 1.75.957 4.052 2.353 5.034 2.95l.042.025a1.737 1.737 0 001.439-.044c2.083-.791 5.118-3.988 6.143-7.309.167-.545.638-3.358-.243-4.132a38.063 38.063 0 00-7.8-4.845 2.482 2.482 0 00-1.333-.21c-.72.038-1.468.07-2.508-1.363s-2.37-3.466-3.778-5.619c-2.326-3.557-4.963-7.59-7.468-10.768a.308.308 0 11.484-.381c2.522 3.2 5.167 7.244 7.5 10.812 1.4 2.147 2.729 4.174 3.761 5.595.845 1.163 1.321 1.141 1.98 1.109a3.07 3.07 0 011.627.269 38.7 38.7 0 017.94 4.939c1.332 1.169.437 4.741.426 4.777-1.093 3.544-4.251 6.844-6.514 7.7a3.082 3.082 0 01-1.092.225z"
            transform="translate(-36.36 -19.571)"
          />
          <path
            data-name="Path 4447"
            d="M164.845 130.495a.337.337 0 01-.107-.019.309.309 0 01-.184-.4c.941-2.567 2.684-4.467 4.439-4.84 5.051-1.072 17.165-.805 22.138-.642a.309.309 0 11-.019.617c-4.952-.164-17-.429-21.99.629-1.553.329-3.119 2.075-3.988 4.447a.31.31 0 01-.289.208z"
            transform="translate(-25.205 -18.604)"
          />
          <path
            data-name="Path 4448"
            d="M174.974 158.919c-2.987 0-6.534-.522-6.707-2.117a33.025 33.025 0 01-.067-.721 55.743 55.743 0 00-1.817-9.97c-.541-2.109-.991-3.73-1.354-5.033l-.046-.164a.309.309 0 11.6-.165l.046.165c.362 1.306.815 2.931 1.356 5.045a56.129 56.129 0 011.834 10.069c.024.265.044.5.067.708.112 1.032 3.584 1.75 7.437 1.529 3.288-.187 5.795-1.093 5.829-2.109a61.9 61.9 0 00-1.395-11.915 41.874 41.874 0 00-2.812-7.456.308.308 0 11.544-.289 42.4 42.4 0 012.861 7.578 61.525 61.525 0 011.418 12.1c-.059 1.731-3.491 2.539-6.411 2.7-.434.025-.9.038-1.378.038z"
            transform="translate(-25.272 -20.425)"
          />
          <path
            data-name="Path 4449"
            d="M199.257 145.789a104.5 104.5 0 01-15.683-1.21.309.309 0 01.091-.611 104.841 104.841 0 0021.4 1.064 35.492 35.492 0 015.475.024.31.31 0 01.267.345.313.313 0 01-.346.267 35.041 35.041 0 00-5.372-.019c-1.628.064-3.557.141-5.834.141z"
            transform="translate(-28.081 -21.594)"
          />
          <path
            data-name="Path 4450"
            d="M185.278 179.025a.307.307 0 01-.307-.285c-.22-2.965-.233-5.21-.247-7.586-.015-2.615-.032-5.58-.34-10a.309.309 0 11.616-.043c.309 4.436.326 7.41.341 10.035.014 2.366.027 4.6.246 7.544a.309.309 0 01-.285.33h-.025z"
            transform="translate(-28.246 -24.178)"
          />
          <path
            data-name="Path 4451"
            d="M176.075 176.511a.308.308 0 01-.3-.256c-.008-.048-.85-4.876-3.429-13.764a.309.309 0 11.593-.172c2.59 8.925 3.436 13.783 3.445 13.831a.308.308 0 01-.252.357.387.387 0 01-.053 0z"
            transform="translate(-26.399 -24.372)"
          />
          <path
            data-name="Path 4452"
            d="M280.636 173.027a.308.308 0 01-.213-.085c-.027-.025-2.726-2.576-5.682-5.281a110.231 110.231 0 00-9.465-7.924.308.308 0 01.359-.5 109.637 109.637 0 019.522 7.97c2.96 2.709 5.663 5.262 5.691 5.288a.309.309 0 01-.213.533z"
            transform="translate(-40.618 -23.925)"
          />
          <path
            data-name="Path 4453"
            d="M274.383 178.519a.313.313 0 01-.155-.041c-.081-.047-8.118-4.707-14.359-7.453a.308.308 0 11.248-.565c6.272 2.759 14.34 7.437 14.421 7.484a.309.309 0 01-.156.576z"
            transform="translate(-39.781 -25.649)"
          />
          <path
            data-name="Path 4454"
            d="M168.529 192.4a20.705 20.705 0 01-4.557-.443c-.984-.235-1.261-.771-1.319-1.18-.146-1.01.9-2.18 2.006-2.816a20.04 20.04 0 012.7-1.228 10.322 10.322 0 004.093-2.4 6.3 6.3 0 002.02-4.5 1.288 1.288 0 011.1-1.186 2.455 2.455 0 012.647 1.135 3.784 3.784 0 01.3 1.73c2.407 1.779 3.313.748 3.915.063.246-.281.457-.525.76-.475a.682.682 0 01.473.459 24.31 24.31 0 011.557 6.821 1.3 1.3 0 01-.268 1.009c-.487.572-1.707.861-4.5 1.068a19.346 19.346 0 00-3.447.773c-.634.174-1.371.377-2.246.607a22 22 0 01-5.24.561zm6.583-13.2a1.685 1.685 0 00-.388.044c-.185.045-.616.192-.632.609a6.97 6.97 0 01-2.185 4.895 10.791 10.791 0 01-4.319 2.556 19.615 19.615 0 00-2.624 1.189c-1.028.589-1.791 1.572-1.7 2.192.047.319.334.544.853.668a23.942 23.942 0 009.5-.114c.349-.091.677-.18.985-.262-.321-.47-.611-.844-.847-1.151-.519-.672-.863-1.115-.8-1.667.082-.664.8-1.255 1.559-1.882a6.243 6.243 0 001.56-1.6 5.878 5.878 0 00.615-4.594 1.8 1.8 0 00-1.578-.881zm2.363 3.03a7.917 7.917 0 01-.855 2.731 6.613 6.613 0 01-1.714 1.792c-.633.522-1.287 1.061-1.339 1.482-.035.286.192.6.671 1.213.266.345.6.774.97 1.331.007.009.011.018.017.027l.627-.172a19.862 19.862 0 013.565-.793c2.507-.186 3.726-.441 4.077-.854a.7.7 0 00.122-.558 24.059 24.059 0 00-1.506-6.625.432.432 0 01-.015-.032 4.967 4.967 0 00-.191.208c-.589.671-1.787 2.032-4.426.251z"
            transform="translate(-24.915 -26.899)"
          />
          <path
            data-name="Path 4455"
            d="M169.005 195.607a40.77 40.77 0 01-2.645-.091c-2.441-.158-3.883-.731-4.283-1.7a2.1 2.1 0 01.467-2 .308.308 0 11.462.409c-.005.007-.621.719-.356 1.357.172.414.887 1.136 3.751 1.32a29.145 29.145 0 0010.782-1.1 17.171 17.171 0 014.41-.705 4.468 4.468 0 002.024-.359c.561-.438.113-2.039-.088-2.567a.308.308 0 01.577-.219c.1.251.909 2.478-.11 3.273a4.512 4.512 0 01-2.366.488 16.667 16.667 0 00-4.26.677 27.531 27.531 0 01-8.37 1.216z"
            transform="translate(-24.811 -28.608)"
          />
          <path
            data-name="Path 4456"
            d="M280.67 191.857c-1.556 0-4.323-.1-5.346-.782a1.392 1.392 0 01-.683-1.059 2.556 2.556 0 011.106-1.919 10.907 10.907 0 011.1-.832 2.936 2.936 0 001.634-2.217 4.423 4.423 0 00-2.006-4.3.948.948 0 01-.412-1.128c.313-.929 1.9-1.753 3.264-1.693a3.244 3.244 0 012.066.931 2.355 2.355 0 00.585-2.683c-.118-.524-.221-.977.141-1.194.49-.293 2.954.147 5.066 1.247.907.473.5 2.521-.162 5.362-.095.4-.184.778-.254 1.108a15.865 15.865 0 00-.019 2.5 19.985 19.985 0 01-.207 4.949c-.3 1.088-1.923 1.628-5.094 1.7-.191.005-.459.008-.777.008zm-1.485-13.316a2.981 2.981 0 00-2.537 1.276c-.041.121-.051.266.179.425a5.031 5.031 0 012.263 4.894 3.54 3.54 0 01-1.894 2.636 10.175 10.175 0 00-1.038.785c-.777.69-.919 1.151-.9 1.416a.8.8 0 00.41.589c.707.472 2.971.734 5.766.67 3.647-.083 4.394-.819 4.515-1.25a7.1 7.1 0 00.2-1.437.34.34 0 01-.022-.026 3.418 3.418 0 00-1.772-1.275c-.579-.214-1.127-.417-1.077-1.462a15.421 15.421 0 00-.586-3.723c-.616-1.655-1.83-3.447-3.388-3.513h-.115zm2.638.766a8.858 8.858 0 011.445 2.535 15.8 15.8 0 01.623 3.968c-.028.594.135.655.675.854a4.014 4.014 0 011.61.972c.008-.8-.019-1.653-.043-2.418a14.9 14.9 0 01.033-2.649c.071-.334.161-.715.256-1.12.334-1.423 1.029-4.386.478-4.674a10.571 10.571 0 00-4.415-1.267 3.71 3.71 0 00.1.532 2.946 2.946 0 01-.757 3.265z"
            transform="translate(-42.072 -26.332)"
          />
          <path
            data-name="Path 4457"
            d="M280.924 193.424a16.659 16.659 0 01-5.725-.869c-.746-.314-1.158-.683-1.263-1.127a1.461 1.461 0 01.483-1.253 1.4 1.4 0 00.113-.14.309.309 0 11.533.312 1.974 1.974 0 01-.179.231c-.172.2-.406.47-.351.71s.374.477.9.7c2.569 1.08 8.82 1.15 10.614-.22 1.029-.786.983-2.971.938-5.082-.019-.845-.037-1.719.01-2.527a6.534 6.534 0 01.585-2.07 9.878 9.878 0 00.365-.992 12.251 12.251 0 00.639-3.295c-.047-.465-1.029-.657-1.5-.677a.308.308 0 11.025-.616c.2.008 1.971.113 2.086 1.23a13.154 13.154 0 01-.66 3.527 10.364 10.364 0 01-.387 1.056 6.069 6.069 0 00-.54 1.874c-.046.783-.026 1.645-.009 2.478.049 2.371.1 4.609-1.181 5.586-1.08.824-3.269 1.168-5.5 1.168z"
            transform="translate(-41.96 -26.579)"
          />
          <path
            data-name="Path 4458"
            d="M201.916 77.371a.31.31 0 01-.3-.239 23.036 23.036 0 00-1.1-3.143.308.308 0 11.565-.247 23.06 23.06 0 011.14 3.252.31.31 0 01-.232.37.3.3 0 01-.069.008z"
            transform="translate(-30.712 -10.809)"
          />
          <path
            data-name="Path 4459"
            d="M188.038 117.008a.31.31 0 01-.307-.289c-.387-6.233-.469-10.44-.555-14.9-.047-2.414-.095-4.912-.194-7.865-.155-4.646-.144-10.26 1.325-12.45 1.531-2.281 3.71-3.162 5.818-4.013a13.373 13.373 0 004.819-2.8.309.309 0 01.44.433 13.845 13.845 0 01-5.028 2.942c-2.114.854-4.111 1.66-5.536 3.785-1.387 2.066-1.361 7.887-1.221 12.086.1 2.958.146 5.457.193 7.874.086 4.448.168 8.649.555 14.868a.309.309 0 01-.289.328h-.021z"
            transform="translate(-28.634 -10.968)"
          />
          <path
            data-name="Path 4460"
            d="M212.62 126.1a23.817 23.817 0 01-12.915-3.646c-2.764-1.776-4.389-3.738-4.513-4.684a4.892 4.892 0 01.208-2.509c.233-.727.453-1.415-.141-3.708-.607-2.34-2.381-11.477-2.884-15.377-.878-6.811.468-14.278 2.182-17.846a.308.308 0 01.556.266c-1.675 3.488-2.989 10.807-2.126 17.5.5 3.883 2.265 12.974 2.869 15.3.64 2.467.382 3.272.132 4.051a4.317 4.317 0 00-.185 2.24c.077.582 1.4 2.423 4.237 4.245 3.432 2.2 10.771 5.416 21.345 2.165a.309.309 0 01.181.59 30.4 30.4 0 01-8.947 1.411z"
            transform="translate(-29.427 -11.512)"
          />
          <path
            data-name="Path 4461"
            d="M203.4 89.062a18.373 18.373 0 01-3-.265 4.691 4.691 0 01-3.442-2.147c-1.742-2.877-.179-7.629.335-9.191.061-.186.124-.38.134-.426a.308.308 0 11.606.112 5.091 5.091 0 01-.153.508c-.492 1.495-1.988 6.044-.394 8.678a4.1 4.1 0 003.016 1.858c9.341 1.55 11.518-4.2 13.266-8.823.688-1.819 1.282-3.389 2.23-4.261a.308.308 0 11.417.454 11.232 11.232 0 00-2.07 4.025c-1.539 4.07-3.585 9.478-10.94 9.478z"
            transform="translate(-30.049 -11.033)"
          />
          <path
            data-name="Path 4462"
            d="M209.943 126.479c-3.468 0-8.529-1.452-11.446-4.641a.308.308 0 11.455-.417c2.792 3.05 7.654 4.44 10.992 4.44a.309.309 0 010 .617z"
            transform="translate(-30.395 -18.126)"
          />
          <path
            data-name="Path 4463"
            d="M187.558 147.345a.312.312 0 01-.125-.027.308.308 0 01-.156-.407 6.083 6.083 0 00.433-1.911.312.312 0 01.324-.291.309.309 0 01.291.324 6.552 6.552 0 01-.486 2.13.309.309 0 01-.282.183z"
            transform="translate(-28.685 -21.708)"
          />
          <path
            data-name="Path 4464"
            d="M191.718 158.471a1.9 1.9 0 01-1.364-.527.309.309 0 11.409-.462 1.6 1.6 0 001.589.307 5.848 5.848 0 002.058-1.8c.356-.575.3-.8.275-.861a.17.17 0 00-.1-.086.309.309 0 01.107-.608.781.781 0 01.555.44 1.587 1.587 0 01-.314 1.439 6.073 6.073 0 01-2.474 2.08 4.354 4.354 0 01-.74.075z"
            transform="translate(-29.144 -23.198)"
          />
          <path
            data-name="Path 4465"
            d="M194.745 157.486a1.108 1.108 0 01-.519-.113.308.308 0 11.289-.544.933.933 0 00.648-.036 2.363 2.363 0 001.323-1.424c.4-.929.275-1.374.2-1.417-.035-.023-.351.022-.894.711a.308.308 0 11-.484-.381c.871-1.107 1.435-1.014 1.694-.86.489.291.506 1.131.047 2.192a2.965 2.965 0 01-1.684 1.761 1.908 1.908 0 01-.622.11z"
            transform="translate(-29.728 -23.029)"
          />
          <path
            data-name="Path 4466"
            d="M197.389 156.327a1.911 1.911 0 01-.552-.088.309.309 0 01.18-.591.893.893 0 00.8-.067c.288-.2.655-.735.775-2.193.03-.374-.059-.542-.124-.559-.107-.028-.422.138-.672.653a.309.309 0 01-.556-.269c.348-.718.907-1.11 1.39-.979.155.042.653.253.577 1.2-.113 1.385-.454 2.253-1.042 2.653a1.345 1.345 0 01-.774.235z"
            transform="translate(-30.12 -22.857)"
          />
          <path
            data-name="Path 4467"
            d="M199.393 155.467a1.5 1.5 0 01-.514-.1.309.309 0 01.215-.579.534.534 0 00.636-.079 2.5 2.5 0 00.207-2.164c-.063-.166-.137-.223-.163-.224-.041 0-.163.08-.288.329a.309.309 0 01-.553-.275c.3-.606.672-.684.872-.671a.843.843 0 01.709.622 3.079 3.079 0 01-.346 2.817 1.066 1.066 0 01-.774.323z"
            transform="translate(-30.435 -22.78)"
          />
          <path
            data-name="Path 4468"
            d="M193.361 155.231a1.093 1.093 0 01-.489-.126c-.791-.4-.979-1.51-1.144-2.491a7.779 7.779 0 00-.244-1.13 3.861 3.861 0 00-.868-1.358 5.491 5.491 0 01-1.477-3.092.308.308 0 11.608-.1 4.915 4.915 0 001.336 2.79 4.463 4.463 0 01.984 1.562 8.124 8.124 0 01.268 1.226c.142.837.3 1.787.813 2.042.207.1.288.052.319.03.135-.086.57-.577.479-3.242a5.516 5.516 0 00-.411-2.043 22 22 0 01-.467-1.44.309.309 0 01.594-.17c.177.621.331 1.055.454 1.4a6.067 6.067 0 01.447 2.229c.1 2.889-.389 3.542-.763 3.782a.8.8 0 01-.439.129z"
            transform="translate(-28.973 -22.009)"
          />
          <path
            data-name="Path 4469"
            d="M197.028 148.461a.308.308 0 01-.307-.276 11.843 11.843 0 00-.214-1.215 6.064 6.064 0 01-.173-1.1.309.309 0 11.617 0 5.865 5.865 0 00.159.97 12.494 12.494 0 01.224 1.28.308.308 0 01-.275.338h-.033z"
            transform="translate(-30.076 -21.839)"
          />
          <path
            data-name="Path 4470"
            d="M190.656 155.882a.309.309 0 01-.069-.61l1.7-.385a.317.317 0 01.375.228.3.3 0 01-.217.368l-1.724.39a.276.276 0 01-.069.008z"
            transform="translate(-29.159 -23.266)"
          />
          <path
            data-name="Path 4471"
            d="M199.784 152.817a.308.308 0 01-.071-.608 85.152 85.152 0 001.511-.373c.738-.2.916-1.184.711-2.059-.2-.857-.78-1.645-1.625-1.47l-5.507 1.1a.328.328 0 01-.382-.238.292.292 0 01.222-.359l5.544-1.11c1.241-.253 2.088.825 2.348 1.934.273 1.166-.036 2.5-1.155 2.8-.342.091-.877.223-1.524.378a.348.348 0 01-.072.008z"
            transform="translate(-29.782 -22.161)"
          />
          <path
            data-name="Path 4472"
            d="M189.485 150.633a.308.308 0 01-.06-.61l1.093-.219a.308.308 0 01.12.6l-1.092.219a.3.3 0 01-.061.006z"
            transform="translate(-28.98 -22.488)"
          />
          <path
            data-name="Path 4473"
            d="M185.1 161.967a.312.312 0 01-.23-.1.309.309 0 01.026-.436c1.965-1.748 2.827-4.977 2.192-8.227a10.057 10.057 0 00-2.719-5.254.309.309 0 01.431-.442 10.679 10.679 0 012.894 5.579c.675 3.461-.263 6.918-2.388 8.806a.306.306 0 01-.206.079z"
            transform="translate(-28.229 -22.123)"
          />
          <path
            data-name="Path 4474"
            d="M185.029 162.182a.308.308 0 01-.1-.6l.184-.064c3.162-1.13 4.714-4.834 3.859-9.215-.692-3.546-2.53-6-5.045-6.726a.309.309 0 01.172-.593c2.745.794 4.741 3.42 5.48 7.2.915 4.692-.8 8.677-4.261 9.915l-.186.064a.3.3 0 01-.1.017z"
            transform="translate(-28.141 -21.749)"
          />
          <path
            data-name="Path 4475"
            d="M201.776 158.144a6.822 6.822 0 01-5.232-2.921.308.308 0 11.485-.379c1.666 2.126 3.867 3.073 5.89 2.533 3.2-.854 4.907-5.185 3.8-9.653a11.32 11.32 0 00-.646-1.888.309.309 0 01.565-.251 12.107 12.107 0 01.68 1.99c1.187 4.792-.716 9.456-4.241 10.4a5.009 5.009 0 01-1.3.171z"
            transform="translate(-30.098 -21.814)"
          />
          <path
            data-name="Path 4476"
            d="M204.084 157.993a.309.309 0 01-.063-.611 14.158 14.158 0 002.5-.875c2.977-1.314 4.256-5.105 3.185-9.433a15.153 15.153 0 00-.4-1.342.309.309 0 11.582-.207c.159.445.3.917.421 1.4 1.147 4.629-.274 8.7-3.535 10.146a14.387 14.387 0 01-2.619.914.276.276 0 01-.064.007z"
            transform="translate(-31.216 -21.802)"
          />
          <path
            data-name="Path 4477"
            d="M191.912 157a.308.308 0 01-.178-.561l1-.7a.309.309 0 11.354.506l-1 .7a.306.306 0 01-.176.056z"
            transform="translate(-29.351 -23.389)"
          />
          <path
            data-name="Path 4478"
            d="M120.392 99.342a.307.307 0 01-.2-.07 74.526 74.526 0 00-3.139-2.429c-.245-.18-.5-.38-.781-.593a22.325 22.325 0 00-4.307-2.767 9.635 9.635 0 00-3.37-.85.309.309 0 11.047-.616 10.217 10.217 0 013.582.905 22.777 22.777 0 014.424 2.839c.274.211.529.408.771.586a74.292 74.292 0 013.165 2.449.308.308 0 01-.2.546z"
            transform="translate(-16.592 -13.636)"
          />
          <path
            data-name="Path 4479"
            d="M76.324 125.191a.308.308 0 01-.218-.09c-.889-.884-5.405-5.507-7.021-9.71-.963-2.5-.991-3.956 1.327-6.465 2.84-3.071 8.81-7.736 13.155-10.771 1.321-.923 2.245-1.654 2.988-2.241A12.253 12.253 0 0195 92.615l.507-.04a.308.308 0 01.052.615l-.509.04a14.414 14.414 0 00-4.168.727 14.105 14.105 0 00-3.94 2.443c-.749.592-1.68 1.329-3.018 2.263-4.318 3.015-10.246 7.646-13.055 10.683-2.1 2.268-2.141 3.388-1.2 5.824 1.218 3.169 4.467 7.095 6.879 9.493a.309.309 0 01-.218.528z"
            transform="translate(-10.489 -13.722)"
          />
          <path
            data-name="Path 4480"
            d="M135.484 120.937a.312.312 0 01-.224-.1c-1.781-1.9-3.633-5.5-5.592-9.3l-.381-.738c-1.939-3.766-3.221-6.254-4.866-8.2a16.519 16.519 0 00-2.363-2.363.308.308 0 11.392-.475 17.093 17.093 0 012.441 2.441c1.69 2 2.985 4.514 4.944 8.317l.381.738c1.94 3.767 3.773 7.324 5.494 9.162a.309.309 0 01-.014.436.306.306 0 01-.211.084z"
            transform="translate(-18.681 -14.812)"
          />
          <path
            data-name="Path 4481"
            d="M164.625 134.946a.308.308 0 01-.025-.616c3.258-.27 6.552-1.385 6.875-1.842a.222.222 0 00-.073-.161c-.1-.089-.389-.172-1.156-.065-.672.094-1.379.223-2.064.348-.889.162-1.728.315-2.463.39-.036 0-3.759.334-4.309-.34a.431.431 0 01-.081-.409c.264-.844 1.51-1.191 2.335-1.421a4.374 4.374 0 00.481-.15c.966-.455 1.232-.7 1.291-1.192a.234.234 0 000-.094 4.937 4.937 0 00-1.645.348c-.326.1-.671.2-1.02.293-.5.131-.946.224-1.339.307a6.551 6.551 0 00-2.247.752c-.272.164-.525.343-.77.516a4.039 4.039 0 01-4.038.843c-2.24-.641-8.9-4.077-10.363-4.889a21.465 21.465 0 00-3.447-1.5 7.1 7.1 0 01-3.032-1.635.308.308 0 01.451-.42 6.682 6.682 0 002.789 1.474 21.918 21.918 0 013.538 1.538c1.4.777 8.078 4.218 10.234 4.835a3.461 3.461 0 003.513-.754c.254-.18.516-.365.806-.54a7.117 7.117 0 012.44-.828c.384-.08.821-.172 1.308-.3.343-.09.68-.191 1-.287 1.064-.319 1.831-.55 2.229-.217a.667.667 0 01.207.628c-.107.89-.748 1.257-1.641 1.677a4.23 4.23 0 01-.578.185c-.56.157-1.562.435-1.851.885a13.375 13.375 0 003.679.077c.71-.072 1.538-.223 2.414-.384.691-.125 1.4-.257 2.089-.351a2.082 2.082 0 011.639.2.851.851 0 01.294.65c.031 1.109-4.87 2.225-7.443 2.438h-.026z"
            transform="translate(-21.056 -18.523)"
          />
          <path
            data-name="Path 4482"
            d="M81.333 123.644a.307.307 0 01-.271-.161 50.173 50.173 0 01-2.373-5.019 19.683 19.683 0 00-1.446-3.006.308.308 0 11.531-.314 20.029 20.029 0 011.489 3.092 49.415 49.415 0 002.342 4.953.308.308 0 01-.122.418.3.3 0 01-.148.037z"
            transform="translate(-11.826 -17.156)"
          />
          <path
            data-name="Path 4483"
            d="M79.119 117.8a.309.309 0 01-.185-.556c1.217-.913 5.7-3.582 5.89-3.695a.309.309 0 01.316.53c-.046.028-4.645 2.766-5.835 3.659a.315.315 0 01-.185.062z"
            transform="translate(-12.073 -16.928)"
          />
          <path
            data-name="Path 4484"
            d="M94.65 170.578a.3.3 0 01-.219-.092c-.067-.067-6.841-6.907-13.931-14.161-4.93-5.045-9.1-9.657-10.146-14.994-.776-3.944.252-7.957 3.143-12.264.84-1.251 1.485-2.084 2.169-2.966a74.074 74.074 0 003.422-4.729c2.114-3.146 2.476-4.43 3.82-9.2l.428-1.515q.373-1.312.7-2.472a64.086 64.086 0 012.285-7.281 18.445 18.445 0 017.628-8.043.309.309 0 11.283.549 18.164 18.164 0 00-7.349 7.748 63.993 63.993 0 00-2.253 7.194q-.325 1.16-.7 2.473l-.428 1.515c-1.331 4.726-1.733 6.152-3.9 9.381-1.607 2.393-2.584 3.652-3.446 4.763-.706.911-1.317 1.7-2.145 2.932-2.8 4.165-3.792 8.025-3.05 11.8 1.019 5.179 4.95 9.531 9.982 14.681a3270.855 3270.855 0 0013.928 14.16.308.308 0 01-.219.526z"
            transform="translate(-10.739 -13.76)"
          />
          <path
            data-name="Path 4485"
            d="M87.331 174.8a.256.256 0 01-.036 0 65.106 65.106 0 01-13.984-3.508c-.275-.108-.662-.284-1.111-.488a81.02 81.02 0 00-.847-.383.309.309 0 11.251-.564c.305.135.591.265.851.384.44.2.821.373 1.078.474a65.312 65.312 0 0013.832 3.472.308.308 0 01-.035.614z"
            transform="translate(-10.903 -25.557)"
          />
          <path
            data-name="Path 4486"
            d="M69.26 189.264c-3.007 0-6.24-.448-6.878-1.85-.574-1.261-.4-3.32-.193-5.7.088-1.031.18-2.1.217-3.169a34.826 34.826 0 00-.283-5.212c-.2-1.8-.343-3.1.13-3.977.829-1.54 2.789-1.92 5.377-1.043.452.152.828.262 1.138.355.872.256 1.4.411 1.41 1.022.009.515-.432.588-.67.627-.349.058-.744.123-1.038.9a3.535 3.535 0 00.185 2.231 6.577 6.577 0 01.335 3.074.309.309 0 01-.608-.1 6 6 0 00-.32-2.8 4.033 4.033 0 01-.17-2.62 1.733 1.733 0 011.515-1.295c.047-.007.105-.017.148-.027-.035-.133-.258-.214-.961-.421-.316-.093-.7-.207-1.161-.362-1.076-.365-3.683-1.02-4.637.751-.381.707-.247 1.927-.059 3.616a35.372 35.372 0 01.286 5.3 61.074 61.074 0 01-.219 3.2c-.189 2.2-.368 4.283.139 5.4.643 1.412 6.041 1.832 10.083 1.242.356-.052.8-.2.914-.592a1.674 1.674 0 00-.782-1.515l-.313-.258A5.307 5.307 0 0170.988 184a14.674 14.674 0 01-.677-4.022 3.342 3.342 0 01.462-2.015.309.309 0 01.5.36 2.824 2.824 0 00-.346 1.631 14.272 14.272 0 00.644 3.85c.181.54.8 1.052 1.665 1.759l.315.259a2.221 2.221 0 01.984 2.156 1.524 1.524 0 01-1.419 1.036 28.038 28.038 0 01-3.855.252z"
            transform="translate(-9.488 -25.253)"
          />
          <path
            data-name="Path 4487"
            d="M98.632 188.332a11.6 11.6 0 01-3.811-.61c-6.57-2.314-19.516-9.84-25.044-13.053l-1.165-.676c-.174-.1-.243-.068-.265-.057-.364.175-.566 1.528-.714 2.516-.2 1.344-.391 2.613-.976 3.12a3.478 3.478 0 01-1.469.694 3.587 3.587 0 00-2.446 1.855.308.308 0 11-.522-.329 4.155 4.155 0 012.8-2.12 2.9 2.9 0 001.231-.566c.413-.357.6-1.626.77-2.745.213-1.429.4-2.662 1.057-2.98a.867.867 0 01.841.08l1.165.677c5.513 3.205 18.423 10.709 24.939 13 4.326 1.523 9.847.032 11.359-3.069.286-.586.423-1.976-.554-5.274a113.59 113.59 0 00-7.074-16.556c-2.037-4.077-6.056-10.613-7.388-12.651a.308.308 0 01.517-.336c1.338 2.048 5.375 8.614 7.423 12.712 2.445 4.893 5.663 11.753 7.115 16.658.84 2.839 1.009 4.711.516 5.719-1.291 2.647-4.866 3.989-8.309 3.989z"
            transform="translate(-9.524 -22.383)"
          />
          <path
            data-name="Path 4488"
            d="M100.771 139.544a.189.189 0 01-.038 0 .309.309 0 01-.268-.346 14.469 14.469 0 012.374-6.483 29.881 29.881 0 011.977-2.543 19.54 19.54 0 002.376-3.26 5.516 5.516 0 013.2-2.8 6.544 6.544 0 001.893-1.082c1.689-1.466 2.564-6.8 2.573-6.85a.309.309 0 01.61.1c-.037.229-.922 5.608-2.778 7.217a7.051 7.051 0 01-2.059 1.186 4.883 4.883 0 00-2.9 2.528 20.025 20.025 0 01-2.446 3.364 29.062 29.062 0 00-1.937 2.49 13.868 13.868 0 00-2.275 6.217.309.309 0 01-.306.27z"
            transform="translate(-15.39 -17.297)"
          />
          <path
            data-name="Path 4489"
            d="M169.466 138.146a.308.308 0 01-.064-.61 41.4 41.4 0 006.31-1.706c1.577-.658 1.822-1.146 1.784-1.264s-.347-.228-.663-.156a.308.308 0 11-.136-.6 1.162 1.162 0 011.387.569c.146.455-.107 1.175-2.135 2.021a41.779 41.779 0 01-6.419 1.74.341.341 0 01-.065.007z"
            transform="translate(-25.913 -20.033)"
          />
          <path
            data-name="Path 4490"
            d="M169.619 139.77a.308.308 0 01-.047-.613 17.1 17.1 0 005.357-1.6c.181-.084.355-.166.525-.241 1.6-.715 1.758-1.153 1.772-1.234a.072.072 0 00-.013-.062.3.3 0 01-.06-.427.315.315 0 01.437-.062.668.668 0 01.252.6c-.06.559-.759 1.129-2.137 1.743-.168.075-.337.154-.513.236a17.651 17.651 0 01-5.525 1.647.3.3 0 01-.047 0z"
            transform="translate(-25.937 -20.293)"
          />
          <path
            data-name="Path 4491"
            d="M130.34 130.825a.31.31 0 01-.165-.047c-3-1.9-6.065-5.965-9.024-9.9-2.629-3.491-5.11-6.788-7.024-7.736a.308.308 0 11.274-.553c2.046 1.014 4.57 4.368 7.243 7.919 2.79 3.707 5.952 7.909 8.861 9.748a.309.309 0 01-.166.57z"
            transform="translate(-17.457 -16.783)"
          />
          <path
            data-name="Path 4492"
            d="M163.438 140.685c-.83 0-1.839-.048-3.115-.143a46.989 46.989 0 01-5.716-1.014 98.834 98.834 0 00-2.538-.492c-4.309-.8-12.33-2.3-17.66-4.423a9.093 9.093 0 01-1.551-.793.309.309 0 01.351-.508 8.5 8.5 0 001.429.728c5.274 2.1 13.257 3.59 17.545 4.391 1.117.208 2 .373 2.557.5a46.347 46.347 0 005.63 1 18.36 18.36 0 005.424-.085 5.465 5.465 0 002.947-2.274.309.309 0 11.522.329 6.118 6.118 0 01-3.32 2.545 10.264 10.264 0 01-2.5.244z"
            transform="translate(-20.332 -19.954)"
          />
          <path
            data-name="Path 4493"
            d="M112.517 114.265a2.586 2.586 0 01-1.42-.4c-1.532-.984-2.011-3.546-1.219-6.528 1.13-4.261 5.149-9.408 8.443-9.408a.309.309 0 110 .617c-2.947 0-6.778 4.921-7.847 8.95-.71 2.677-.326 5.028.957 5.851 1 .643 2.444.266 4.062-1.064a.308.308 0 01.391.476 5.448 5.448 0 01-3.367 1.506z"
            transform="translate(-16.774 -14.542)"
          />
          <path
            data-name="Path 4494"
            d="M92.944 125.313a.318.318 0 01-.1-.017c-7.6-2.6-8.549-5.875-8.586-6.014a.308.308 0 01.6-.16c.014.05.977 3.119 8.19 5.591a.309.309 0 01-.1.6z"
            transform="translate(-12.906 -17.754)"
          />
          <path
            data-name="Path 4495"
            d="M106.683 128.682h-.014a42.079 42.079 0 01-10.663-1.814.309.309 0 01.173-.593 41.425 41.425 0 0010.518 1.791.308.308 0 01-.014.616z"
            transform="translate(-14.673 -18.883)"
          />
          <path
            data-name="Path 4496"
            d="M94.356 108.388a.307.307 0 01-.244-.12 6.336 6.336 0 01-.84-5.827 16.008 16.008 0 012.02-4.036 24.479 24.479 0 002.288-4.335 80.627 80.627 0 003.035-10.6l.031-.129c1.361-5.549 2.109-8.606 5.191-11.891 1.507-1.607 3.128-2.334 4.447-2a2.235 2.235 0 011.638 1.669c.431 1.7-1.136 5.867-2.794 10.283a61.3 61.3 0 00-3.091 9.634 36.594 36.594 0 00-.112 8.654c.087 1.243.17 2.417.162 3.453-.019 2.41-3.2 4.157-3.341 4.231a.308.308 0 11-.292-.542c.03-.017 3-1.648 3.016-3.693.008-1.013-.074-2.175-.16-3.406a37.065 37.065 0 01.118-8.8 61.584 61.584 0 013.123-9.751c1.552-4.133 3.157-8.407 2.774-9.914a1.635 1.635 0 00-1.195-1.224c-1.092-.282-2.494.382-3.843 1.821-2.97 3.167-3.706 6.168-5.041 11.617l-.032.129a82.237 82.237 0 01-3.057 10.671 25.259 25.259 0 01-2.34 4.441 15.545 15.545 0 00-1.951 3.878 5.736 5.736 0 00.733 5.281.309.309 0 01-.244.5z"
            transform="translate(-14.238 -10.168)"
          />
          <path
            data-name="Path 4497"
            d="M98.75 100.558a.3.3 0 01-.2-.075.307.307 0 01-.032-.434 19.04 19.04 0 004.323-9.89.308.308 0 11.612.069 19.678 19.678 0 01-4.468 10.223.307.307 0 01-.234.107z"
            transform="translate(-15.08 -13.31)"
          />
          <path
            data-name="Path 4498"
            d="M93.541 124.4a2.95 2.95 0 01-.426-.026.308.308 0 01-.122-.562 5.431 5.431 0 002.184-3.375 9.959 9.959 0 00-.614-4.817c-.124-.41-.255-.842-.385-1.313-.553-2 0-4.591 1.7-7.927a.309.309 0 01.55.28c-1.622 3.191-2.162 5.639-1.651 7.482.129.466.258.894.382 1.3a10.58 10.58 0 01.634 5.082 5.633 5.633 0 01-1.747 3.22 2.963 2.963 0 001.509-.668 4.665 4.665 0 001.26-3.694.308.308 0 01.616 0 5.224 5.224 0 01-1.481 4.169 3.7 3.7 0 01-2.4.852z"
            transform="translate(-14.224 -15.811)"
          />
          <path
            data-name="Path 4499"
            d="M100.568 123.067a.342.342 0 01-.082-.011c-.038-.01-3.718-1.091-2.967-6.294a.308.308 0 01.61.088c-.421 2.921.631 4.373 1.5 5.057a5.335 5.335 0 01-.416-4.327 7.652 7.652 0 011.989-2.83c1.451-1.5 3.1-3.2 3.115-8.234a.307.307 0 01.308-.307.308.308 0 01.307.31c-.021 5.284-1.757 7.077-3.289 8.659a7.065 7.065 0 00-1.851 2.607 5.211 5.211 0 001 4.77.309.309 0 01-.231.512z"
            transform="translate(-14.923 -15.811)"
          />
          <path
            data-name="Path 4500"
            d="M101.259 112.206a.328.328 0 01-.189-.054c-.2-.145-.321-.233.5-3.072.435-1.5 1.009-3.3 1.463-4.58a.26.26 0 01.032-.065 10.51 10.51 0 00-.077-.451.308.308 0 11.605-.118c.115.592 1.038 5.857-2.12 8.274a.367.367 0 01-.218.068zm1.934-6.26c-.636 1.917-1.277 4.09-1.535 5.193a7.584 7.584 0 001.535-5.193z"
            transform="translate(-15.46 -15.413)"
          />
          <path
            data-name="Path 4501"
            d="M109.01 91.18a.308.308 0 01-.2-.546 20.9 20.9 0 003.3-3.846.308.308 0 01.509.348 21.6 21.6 0 01-3.419 3.974.31.31 0 01-.195.07z"
            transform="translate(-16.652 -12.815)"
          />
          <path
            data-name="Path 4502"
            d="M120.053 84.408a.3.3 0 01-.156-.042c-1.539-.9-2.459-2.92-1.968-4.321a2.119 2.119 0 011.377-1.346 2.455 2.455 0 012.18.436.308.308 0 01-.366.5 1.849 1.849 0 00-1.633-.343 1.511 1.511 0 00-.976.961 3.419 3.419 0 001.7 3.584.309.309 0 01-.156.575z"
            transform="translate(-18.045 -11.581)"
          />
          <path
            data-name="Path 4503"
            d="M120.627 82.608a.31.31 0 01-.307-.279 1.356 1.356 0 00-.52-1.029.308.308 0 11.341-.514 1.942 1.942 0 01.792 1.48.309.309 0 01-.277.337h-.03z"
            transform="translate(-18.331 -11.909)"
          />
          <path
            data-name="Path 4504"
            d="M129.916 83.009c.163-.5.022-.994-.315-1.105s-.743.206-.906.706-.022.994.316 1.105.743-.206.906-.706z"
            transform="translate(-19.704 -12.084)"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4505"
            d="M130.512 80.3a.308.308 0 01-.188-.064 1.763 1.763 0 00-2-.075.308.308 0 11-.32-.527 2.376 2.376 0 012.7.112.309.309 0 01-.188.553z"
            transform="translate(-19.586 -11.683)"
          />
          <path
            data-name="Path 4506"
            d="M126 94.605a7.416 7.416 0 01-3.239-1.558 17.651 17.651 0 01-2.112-2.062 4.232 4.232 0 00-.015 1.713 4.728 4.728 0 00.482 1.678l1.07-.688 3.813.917z"
            transform="translate(-18.469 -13.478)"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4507"
            d="M118.884 94.168a.309.309 0 01-.253-.485c.078-.111 1.919-2.713 3.537-2.8a2.79 2.79 0 011.467.452 4.475 4.475 0 001.6.574c.946.12 1.5-.062 2.1-1.412.3-.687.563-1.363.793-1.961.237-.618.442-1.152.645-1.574a3.169 3.169 0 011.009-1.07 2.006 2.006 0 00.746-.791c.069-.211-.116-.436-.45-.814a2.989 2.989 0 01-.963-2.619c.072-.451.19-.919.315-1.415a15.8 15.8 0 00.4-1.936 4.856 4.856 0 00-.893-3.137.309.309 0 01.523-.328 5.453 5.453 0 01.981 3.54 16.254 16.254 0 01-.416 2.011c-.121.481-.235.937-.3 1.361a2.411 2.411 0 00.817 2.114c.371.421.755.858.573 1.414a2.447 2.447 0 01-.958 1.089 2.679 2.679 0 00-.83.848c-.191.4-.392.922-.625 1.527s-.495 1.288-.8 1.989c-.645 1.463-1.388 1.945-2.738 1.776a5.05 5.05 0 01-1.815-.64 2.266 2.266 0 00-1.149-.381c-1.095.06-2.584 1.855-3.065 2.541a.31.31 0 01-.253.131z"
            transform="translate(-18.164 -10.984)"
          />
          <path
            data-name="Path 4508"
            d="M128.882 89.348s-.782 2.344-2.4 1.553c-1.292-.629-1.011-2.807-1.011-2.807a13.73 13.73 0 001.756.808 12.135 12.135 0 001.66.446z"
            transform="translate(-19.216 -13.036)"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4509"
            d="M127.073 91.316a1.783 1.783 0 01-.786-.2c-1.474-.718-1.194-3.027-1.181-3.124a.307.307 0 01.168-.237.31.31 0 01.29.007 13.423 13.423 0 001.712.788 11.942 11.942 0 001.609.433.309.309 0 01.236.4 3.256 3.256 0 01-1.455 1.806 1.514 1.514 0 01-.593.122zm-1.379-2.782c0 .614.114 1.668.863 2.032a1.009 1.009 0 00.867.06 2.241 2.241 0 00.975-1.111 10.942 10.942 0 01-1.338-.383 13.6 13.6 0 01-1.367-.597z"
            transform="translate(-19.16 -12.979)"
          />
          <path
            data-name="Path 4510"
            d="M124.028 79.567a4.03 4.03 0 01-1.151-.17.308.308 0 11.175-.591c3.025.9 5.662-2.629 6.743-4.859a.309.309 0 01.556.269c-1.033 2.129-3.416 5.35-6.324 5.35z"
            transform="translate(-18.79 -10.842)"
          />
          <path
            data-name="Path 4511"
            d="M133.049 82.13a.309.309 0 01-.252-.488 2.5 2.5 0 00.019-2.841.308.308 0 11.495-.367 2.858 2.858 0 01.52 2.239 3.634 3.634 0 00.65-1.86 4.044 4.044 0 00-.715-2.653 8.227 8.227 0 01-.766-1.666c-.86-2.738-1.208-3.462-4.185-3.657a.309.309 0 01.041-.616c3.351.22 3.832 1.222 4.733 4.088a7.647 7.647 0 00.719 1.545 4.654 4.654 0 01.793 3 4.021 4.021 0 01-1.9 3.234.309.309 0 01-.145.036z"
            transform="translate(-19.688 -10.297)"
          />
          <path
            data-name="Path 4512"
            d="M114.455 70.269a.309.309 0 01-.213-.533 7.338 7.338 0 012-1.372c2.594-1.175 5.748-.9 8.885.789l.1.055a.309.309 0 01-.284.548l-.111-.059c-3.005-1.615-5.889-1.881-8.338-.771a6.726 6.726 0 00-1.829 1.259.308.308 0 01-.213.085z"
            transform="translate(-17.486 -9.903)"
          />
          <path
            data-name="Path 4513"
            d="M112.739 86.685a1.224 1.224 0 01-.627-.115 5.237 5.237 0 01-1.147-1.122.309.309 0 01.494-.371 4.588 4.588 0 001.011.99 6.68 6.68 0 005.05-2.412.308.308 0 11.456.415 7.674 7.674 0 01-5.238 2.615z"
            transform="translate(-16.989 -12.34)"
          />
          <path
            data-name="Path 4514"
            d="M131.585 83.361a.308.308 0 01-.089-.6c1.073-.326 1.855-2.887 1.7-4.189a.309.309 0 01.613-.073c.187 1.566-.714 4.422-2.133 4.853a.311.311 0 01-.09.014z"
            transform="translate(-20.11 -11.523)"
          />
          <path
            data-name="Path 4515"
            d="M91.332 138.5c-4.69 0-10.8-.983-15.074-5.284a.308.308 0 11.437-.434c7.592 7.636 21.243 4.456 21.379 4.422a.309.309 0 01.144.6 33.1 33.1 0 01-6.887.7z"
            transform="translate(-11.668 -19.867)"
          />
          <path
            data-name="Path 4516"
            d="M88.155 142.584c-4.543 0-10.016-1.116-14.265-5.41a.309.309 0 01.439-.434c8.531 8.621 22.232 4 22.37 3.953a.308.308 0 01.2.583 29.9 29.9 0 01-8.745 1.309z"
            transform="translate(-11.305 -20.473)"
          />
          <path
            data-name="Path 4517"
            d="M100.633 153.881a.308.308 0 01-.124-.59 77.382 77.382 0 019.188-2.82c5.013-1.347 10.7-2.875 13.1-4.5a.309.309 0 11.345.511c-2.486 1.68-7.974 3.155-13.282 4.582a76.96 76.96 0 00-9.1 2.789.3.3 0 01-.123.026z"
            transform="translate(-15.369 -21.894)"
          />
          <path
            data-name="Path 4518"
            d="M123.125 172.055a.389.389 0 01-.053 0 .308.308 0 01-.252-.357 69.861 69.861 0 00.6-10.565 56.667 56.667 0 00-.484-7.186 32.536 32.536 0 01-.325-5.562.3.3 0 01.322-.295.307.307 0 01.295.321 32.039 32.039 0 00.322 5.464 57.242 57.242 0 01.489 7.257 70.375 70.375 0 01-.614 10.671.308.308 0 01-.3.252z"
            transform="translate(-18.78 -22.225)"
          />
          <path
            data-name="Path 4519"
            d="M104.261 134.64a.308.308 0 01-.07-.609 174.858 174.858 0 0117.9-2.73 19.858 19.858 0 014.352-.008.308.308 0 11-.075.612 19.355 19.355 0 00-4.215.011 174.23 174.23 0 00-17.823 2.717.337.337 0 01-.07.008z"
            transform="translate(-15.924 -19.635)"
          />
          <path
            data-name="Path 4520"
            d="M131.85 167.5a.246.246 0 01-.043 0 .308.308 0 01-.263-.348 139.37 139.37 0 012.908-14.8c.279-1.158.557-2.318.835-3.529 1.271-5.549 1.978-9.705 1.292-11.944a7.678 7.678 0 00-.52-1.241.309.309 0 01.545-.291 8.343 8.343 0 01.566 1.352c.727 2.37.014 6.616-1.28 12.264a333.608 333.608 0 01-.837 3.535 138.8 138.8 0 00-2.9 14.746.308.308 0 01-.3.265z"
            transform="translate(-20.151 -20.248)"
          />
          <path
            data-name="Path 4521"
            d="M135.825 186.285a20.866 20.866 0 01-4.518-.433c-.888-.209-1.635-.393-2.279-.55a19.382 19.382 0 00-3.5-.685c-2.821-.134-4.058-.392-4.564-.953a1.307 1.307 0 01-.295-1.009 24.885 24.885 0 011.383-6.916.686.686 0 01.462-.475c.3-.058.522.182.777.457.626.674 1.568 1.692 3.949-.169a3.828 3.828 0 01.251-1.752 2.475 2.475 0 012.635-1.214 1.3 1.3 0 011.142 1.164 6.361 6.361 0 002.159 4.48 10.407 10.407 0 004.192 2.309 20.419 20.419 0 012.76 1.165c1.132.609 2.216 1.76 2.1 2.78-.049.413-.312.96-1.3 1.223a22.23 22.23 0 01-5.359.58zm-5.38-1.273c.313.076.647.155 1 .239a24.152 24.152 0 009.577-.142c.521-.14.8-.373.843-.7.073-.628-.724-1.6-1.777-2.166a19.728 19.728 0 00-2.679-1.127 10.879 10.879 0 01-4.42-2.457 7.019 7.019 0 01-2.334-4.873c-.027-.421-.467-.56-.655-.6a1.842 1.842 0 00-1.96.9 5.928 5.928 0 00.744 4.617 6.293 6.293 0 001.616 1.573c.782.611 1.521 1.186 1.622 1.852.084.553-.25 1.01-.755 1.7-.231.315-.513.7-.824 1.184zm-7.8-9.08c0 .011-.01.024-.015.037a24.2 24.2 0 00-1.339 6.719.708.708 0 00.138.561c.366.407 1.6.631 4.135.751a20.02 20.02 0 013.615.7l.638.157a.318.318 0 01.016-.029c.359-.571.682-1.012.941-1.367.478-.653.688-.954.644-1.243-.064-.423-.738-.95-1.39-1.458a6.7 6.7 0 01-1.779-1.76 7.97 7.97 0 01-.936-2.733c-2.615 1.87-3.857.529-4.469-.13a4.468 4.468 0 00-.2-.208z"
            transform="translate(-18.485 -25.972)"
          />
          <path
            data-name="Path 4522"
            d="M135.093 189.577a27.191 27.191 0 01-7.552-1.013 16.769 16.769 0 00-4.315-.567 4.553 4.553 0 01-2.4-.427c-1.048-.773-.289-3.038-.2-3.294a.309.309 0 01.583.206c-.188.537-.6 2.166-.018 2.592a4.5 4.5 0 002.049.307 17.282 17.282 0 014.466.591 29.354 29.354 0 0010.9.815c2.137-.2 3.467-.705 3.746-1.434.251-.651-.39-1.354-.4-1.361a.309.309 0 01.451-.421 2.12 2.12 0 01.523 2c-.377.991-1.812 1.607-4.268 1.833a39.18 39.18 0 01-3.574.176z"
            transform="translate(-18.426 -27.738)"
          />
          <path
            data-name="Path 4523"
            d="M69.017 190.41a21.5 21.5 0 01-6.869-.952c-1.4-.535-1.426-2.56-1.435-3.321v-.094c-.032-1.774.023-3.66.073-5.325.051-1.739.1-3.24.023-4.069a23.157 23.157 0 00-.488-2.95 9.22 9.22 0 01-.253-4.156 2.52 2.52 0 011.039-1.7 3.455 3.455 0 012.622-.045c.136.033.268.065.4.093a.308.308 0 11-.132.6 8.635 8.635 0 01-.409-.1 3 3 0 00-2.152-.03 1.958 1.958 0 00-.761 1.313 8.754 8.754 0 00.255 3.89 23.966 23.966 0 01.5 3.025c.076.865.031 2.382-.021 4.14-.049 1.658-.1 3.537-.072 5.3v.1c.008.647.031 2.368 1.039 2.754a23.325 23.325 0 0010.809.51 1.193 1.193 0 00.848-.55 1.7 1.7 0 00-.276-1.364.308.308 0 01.548-.282 2.194 2.194 0 01.292 1.9 1.754 1.754 0 01-1.253.9 18.287 18.287 0 01-4.32.423z"
            transform="translate(-9.179 -25.208)"
          />
          <path
            data-name="Path 4524"
            d="M74.782 179.812a.308.308 0 01-.3-.246c-1.006-4.856 2.027-7.227 2.156-7.325a.308.308 0 01.374.49c-.117.09-2.851 2.248-1.927 6.709a.308.308 0 01-.239.364.267.267 0 01-.063.007z"
            transform="translate(-11.378 -25.916)"
          />
          <path
            data-name="Path 4525"
            d="M109.497 145.422a8.235 8.235 0 01-4.765-1.576.308.308 0 11.353-.506 7.052 7.052 0 006.631 1.076.308.308 0 01.249.564 6.553 6.553 0 01-2.468.441z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4526"
            d="M208.883 63.052a.309.309 0 01-.029-.616 3.03 3.03 0 002.553-2.228 2.266 2.266 0 00-.532-1.823 1.81 1.81 0 00-1.673-.178.309.309 0 01-.157-.6 2.376 2.376 0 012.229.3 2.866 2.866 0 01.748 2.35 3.612 3.612 0 01-3.11 2.786h-.03z"
            transform="translate(-31.952 -8.345)"
          />
          <path
            data-name="Path 4527"
            d="M209.618 61.187a.308.308 0 01-.252-.484 4.9 4.9 0 01.719-.838.309.309 0 01.386.481 4.365 4.365 0 00-.6.709.308.308 0 01-.254.132z"
            transform="translate(-32.064 -8.701)"
          />
          <path
            data-name="Path 4528"
            d="M197.543 71.087a2.937 2.937 0 01-1.454-.372c-1.762-.983-3.282-4.332-3.449-4.71a10.864 10.864 0 01-.945-3.579c-.014-.264-.019-.58-.025-.93-.012-.715-.027-1.606-.126-2.475a21.076 21.076 0 00-.188-1.258 13.093 13.093 0 01-.235-2.163 8.033 8.033 0 01.759-3.411c.218-.464.483-.911.941-1.028a1.326 1.326 0 011.108.322.309.309 0 01-.364.5.857.857 0 00-.591-.223c-.213.054-.4.4-.536.693a7.363 7.363 0 00-.7 3.135 12.6 12.6 0 00.228 2.073c.067.391.136.8.193 1.293.1.9.117 1.805.13 2.534.005.342.011.651.025.909a9.94 9.94 0 00.893 3.361c.748 1.69 2.064 3.8 3.186 4.421 1.17.653 2.75.219 4.972-1.365a14.025 14.025 0 001.888-1.7 9.925 9.925 0 001.9-3.455.308.308 0 11.579.212 10.448 10.448 0 01-2.021 3.654 14.678 14.678 0 01-1.987 1.793 7.7 7.7 0 01-4.177 1.774z"
            transform="translate(-29.277 -7.374)"
          />
          <path
            data-name="Path 4529"
            d="M196.172 64.778a.311.311 0 01-.172-.052c-.757-.509-1.175-.958-.916-1.629.037-.1.1-.216.163-.354a3.809 3.809 0 00.435-1.272 2.961 2.961 0 00-.635-1.856.308.308 0 11.517-.337 3.54 3.54 0 01.732 2.252 4.291 4.291 0 01-.5 1.485c-.058.118-.108.219-.141.3-.063.163-.133.347.684.9a.309.309 0 01-.173.565z"
            transform="translate(-29.871 -8.6)"
          />
          <path
            data-name="Path 4530"
            d="M199.983 66.512a19.976 19.976 0 01-2.6.629 14.637 14.637 0 01-2.516.173s.97 2.671 2.907 2.188 2.21-2.99 2.21-2.99z"
            transform="translate(-29.851 -9.729)"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4531"
            d="M197.263 69.811c-1.451 0-2.413-1.541-2.743-2.449a.306.306 0 01.041-.286.289.289 0 01.26-.127 14.579 14.579 0 002.456-.169 19.7 19.7 0 002.556-.618.308.308 0 01.4.327c-.012.111-.32 2.728-2.442 3.256a2.163 2.163 0 01-.528.067zm-1.975-2.244c.342.669 1.141 1.879 2.355 1.579a2.912 2.912 0 001.882-2.247 19.289 19.289 0 01-2.15.49 15.052 15.052 0 01-2.086.178z"
            transform="translate(-29.796 -9.673)"
          />
          <path
            data-name="Path 4532"
            d="M200.367 60.452a1.2 1.2 0 00-.9-1.138c-.445-.041-.764.4-.713.992a1.2 1.2 0 00.9 1.138c.446.04.764-.405.713-.992z"
            transform="translate(-30.446 -8.626)"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4533"
            d="M200.624 57.388a.316.316 0 01-.141-.033c-.015-.008-1.611-.808-2.678-.086a.308.308 0 11-.346-.511c1.368-.927 3.226.008 3.3.049a.309.309 0 01-.141.583z"
            transform="translate(-30.228 -8.172)"
          />
          <path
            data-name="Path 4534"
            d="M191.787 57.875a.308.308 0 01-.169-.566 2.216 2.216 0 012.156-.2.308.308 0 01-.281.549 1.6 1.6 0 00-1.537.164.307.307 0 01-.169.05z"
            transform="translate(-29.332 -8.26)"
          />
          <path
            data-name="Path 4535"
            d="M212.109 64.511c-.7 0-1.785-1.076-2.324-2.371a.309.309 0 01.57-.237 3.679 3.679 0 001.672 1.979.965.965 0 00-.025-.112c-.247-.822.171-1.86.657-3.062a15.927 15.927 0 00.746-2.13 6.569 6.569 0 00-.2-3.54.309.309 0 01.575-.225 7.091 7.091 0 01.229 3.911 16.586 16.586 0 01-.774 2.214 5.053 5.053 0 00-.639 2.653c.2.656-.169.844-.285.886a.588.588 0 01-.2.032z"
            transform="translate(-32.133 -7.908)"
          />
          <path
            data-name="Path 4536"
            d="M208.627 47.36a.308.308 0 01-.229-.1c-1.888-2.1-5.668-1.58-5.708-1.574a.309.309 0 01-.088-.611c.169-.024 4.143-.574 6.255 1.772a.308.308 0 01-.229.515z"
            transform="translate(-30.996 -6.434)"
          />
          <path
            data-name="Path 4537"
            d="M206.965 58.041c-1.106 0-1.825-.793-2.684-1.884a.309.309 0 11.484-.383c1 1.273 1.578 1.781 2.526 1.62a.308.308 0 01.1.608 2.583 2.583 0 01-.429.037z"
            transform="translate(-31.283 -8.067)"
          />
          <path
            data-name="Path 4538"
            d="M194.269 61.177a1.386 1.386 0 00-.6-1.346c-.395-.194-.766.1-.826.647a1.387 1.387 0 00.6 1.346c.395.193.766-.1.827-.646z"
            transform="translate(-29.54 -8.697)"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4539"
            d="M204.054 55.33a6.888 6.888 0 01-1.138-.1c-2.682-.453-4.717-2.714-5.586-3.681-.109-.121-.2-.223-.275-.3-.66-.692-.93-.725-1.012-.707-.184.038-.364.523-.451.756a.309.309 0 01-.579-.216c.2-.547.428-1.047.906-1.145.426-.089.914.186 1.582.887.078.082.174.189.288.315.9 1 2.759 3.068 5.229 3.485a4.854 4.854 0 002.945-.3c-1.271-.2-3.618-.7-4.889-2.325a.308.308 0 01.486-.38c1.291 1.651 4.039 2.034 4.942 2.16a2.548 2.548 0 01.388.067.311.311 0 01.2.369 3.726 3.726 0 01-3.038 1.115z"
            transform="translate(-29.871 -7.188)"
          />
          <path
            data-name="Path 4540"
            d="M191.229 57.491a.307.307 0 01-.293-.212 4.924 4.924 0 00-1.2-1.988c-.125-.14-.25-.279-.373-.429a2.731 2.731 0 01-.552-2.761 10.814 10.814 0 012.025-3.373 2.59 2.59 0 012.328-.822.308.308 0 11-.091.61 1.98 1.98 0 00-1.8.644 10.278 10.278 0 00-1.883 3.144 2.123 2.123 0 00.448 2.167c.117.142.235.274.353.407a5.5 5.5 0 011.331 2.207.308.308 0 01-.2.39.3.3 0 01-.1.015z"
            transform="translate(-28.898 -6.874)"
          />
          <path
            data-name="Path 4541"
            d="M193.967 49.236a.31.31 0 01-.307-.311 4.289 4.289 0 01.97-3.162c.55-.5 1.653-.5 2.928-.49a15.3 15.3 0 002.639-.139.308.308 0 01.108.608 15.837 15.837 0 01-2.749.148 4.758 4.758 0 00-2.508.328 3.806 3.806 0 00-.771 2.713.309.309 0 01-.31.305z"
            transform="translate(-29.666 -6.454)"
          />
          <path
            data-name="Path 4542"
            d="M214.643 56.815h-.012a.31.31 0 01-.3-.291 7 7 0 00-2.212-4.083.309.309 0 01.433-.44 8.786 8.786 0 011.861 2.618 6.25 6.25 0 00-.369-2.075 7.173 7.173 0 00-3.136-3.907.309.309 0 01.351-.509 7.762 7.762 0 013.358 4.182 9.919 9.919 0 01.329 4.236.308.308 0 01-.306.266z"
            transform="translate(-32.289 -6.905)"
          />
          <path
            data-name="Path 4543"
            d="M207.636 53.322a7.029 7.029 0 01-2.75-.587.308.308 0 01.251-.563 5.487 5.487 0 003.908.293.309.309 0 01.229.573 4.445 4.445 0 01-1.637.284z"
            transform="translate(-31.358 -7.528)"
          />
          <path
            data-name="Path 4544"
            d="M206.4 67.938a14.818 14.818 0 01-2.83 3.289 12.226 12.226 0 01-2.624 1.782l.664 1.768a5.984 5.984 0 001.57-.7 6.074 6.074 0 001.327-1.228c1.326-1.617 1.893-4.913 1.893-4.913z"
            transform="translate(-30.782 -9.948)"
            fillRule="evenodd"
          />
          <path
            data-name="Path 4545"
            d="M217.261 180.63a16.563 16.563 0 01-2.027-.124c-3.826-.471-6.857-2.2-8.532-4.867a.308.308 0 01.522-.328c1.574 2.507 4.446 4.135 8.085 4.583 4.212.52 8.664-.687 11.074-3a.309.309 0 01.428.446c-2.148 2.06-5.811 3.29-9.55 3.29z"
            transform="translate(-31.657 -26.374)"
          />
          <path
            data-name="Path 4546"
            d="M220.886 183.264a.308.308 0 01-.005-.617c4.687-.06 8.709-2.7 11.036-7.251a.308.308 0 11.549.281 13.221 13.221 0 01-11.577 7.588z"
            transform="translate(-33.79 -26.384)"
          />
          <path
            data-name="Path 4547"
            d="M63.6 122.95a.309.309 0 01-.247-.123 13.238 13.238 0 01-2.176-9.908 14.7 14.7 0 016.175-9.837.308.308 0 01.353.506 14.091 14.091 0 00-5.918 9.428 12.614 12.614 0 002.059 9.439.31.31 0 01-.247.5z"
            transform="translate(-9.344 -15.323)"
          />
          <path
            data-name="Path 4548"
            d="M63.76 128.4a.315.315 0 01-.134-.03c-4.479-2.173-6.679-8.014-6.218-12.407a.315.315 0 01.339-.274.309.309 0 01.274.34c-.438 4.18 1.639 9.732 5.873 11.787a.308.308 0 01-.135.586z"
            transform="translate(-8.785 -17.262)"
          />
          <path
            data-name="Path 4549"
            d="M240.121 87.577a.314.314 0 01-.086-.012.308.308 0 01-.212-.382 12.242 12.242 0 00-1.43-9.264 13.671 13.671 0 00-8.649-6.471.309.309 0 11.147-.6 14.287 14.287 0 019.037 6.761 12.862 12.862 0 011.488 9.744.307.307 0 01-.3.223z"
            transform="translate(-35.158 -10.392)"
          />
          <path
            data-name="Path 4550"
            d="M242.666 92.177a.308.308 0 01-.226-.518c3.116-3.338 3.059-9.09 1.2-12.721a.309.309 0 11.55-.281c1.953 3.821 2 9.886-1.3 13.422a.307.307 0 01-.224.1z"
            transform="translate(-37.127 -11.564)"
          />
          <path
            data-name="Path 4551"
            d="M204.464 62.3a.467.467 0 01-.322-.135 3.764 3.764 0 01-.329-2.476.309.309 0 01.6.15 4.283 4.283 0 00.1 1.77 1.919 1.919 0 00.123-1.08.308.308 0 11.616-.036c.025.427.092 1.563-.656 1.787a.463.463 0 01-.13.02z"
            transform="translate(-31.212 -8.648)"
          />
          <path
            data-name="Path 4552"
            d="M200.295 166.645h55.033"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4553"
            d="M8.468 166.645h186.325"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
        </g>
      </g>
    </SvgIcon>
  );
}
export function SplashScreenIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 306.772,
    height: 261.917,
    ...rootStyle,
  };
  return (
    <SvgIcon
      data-name="Splash screen"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 306.772 261.917"
      {...rest}
      sx={rootSx}
    >
      <path
        data-name="Path 5574"
        d="M49.516 93.794l-.069-4.212a6.211 6.211 0 003.02-.838l2.12 3.64a10.451 10.451 0 01-5.071 1.41zm-5.359-1.377a10.478 10.478 0 01-3.756-3.68l3.607-2.171a6.275 6.275 0 002.244 2.2l-2.096 3.654zm14.307-3.978l-3.68-2.051a6.2 6.2 0 00.783-3.024l4.212-.018a10.48 10.48 0 01-1.316 5.092zM43.122 83.4H38.91a10.487 10.487 0 011.326-5.13l3.672 2.059a6.211 6.211 0 00-.791 3.035v.036zm11.567-3.228a6.3 6.3 0 00-2.241-2.2l2.1-3.647a10.477 10.477 0 013.752 3.683l-3.614 2.164zm-8.456-2.2l-2.113-3.64a10.453 10.453 0 015.075-1.4l.058 4.212a6.193 6.193 0 00-3.024.834z"
        fill="#dff7f3"
      />
      <path
        data-name="Path 5575"
        d="M49.344 75.031a8.328 8.328 0 108.328 8.329 8.326 8.326 0 00-8.328-8.329zm0 13.637a5.308 5.308 0 115.308-5.308 5.307 5.307 0 01-5.308 5.308z"
        fill="#dff7f3"
      />
      <path
        data-name="Path 5576"
        d="M153.387 237.559c27.686 0 50.131-1.277 50.131-2.852s-22.445-2.853-50.131-2.853-50.131 1.277-50.131 2.853 22.444 2.852 50.131 2.852z"
        fill="rgba(229,225,252,0.24)"
      />
      <path
        data-name="Path 5577"
        d="M238.1 152.1a84.714 84.714 0 11-169.428 0v-.528A84.753 84.753 0 01130.886 70.4q2.782-.771 5.629-1.341a77.038 77.038 0 014.543-.787c.157-.026.314-.047.474-.069l.492-.066c.138-.022.269-.04.408-.051s.309-.044.47-.062c.324-.04.648-.08.972-.113.157-.018.31-.036.47-.051q1.307-.136 2.627-.24c.237-.015.477-.029.718-.047.7-.044 1.4-.084 2.1-.113a99.597 99.597 0 012.044-.058h.16c.284 0 .569-.007.856-.007h.54c1.657 0 3.308.047 4.94.146.616.029 1.224.073 1.84.124s1.242.106 1.861.171c.387.036.765.08 1.148.124.74.084 1.479.178 2.211.284 1.454.2 2.875.441 4.288.718q3.121.612 6.15 1.443a84.742 84.742 0 0162.281 81.71z"
        fill="#263238"
      />
      <path
        data-name="Path 5578"
        d="M236 151.043a83.66 83.66 0 01-167.319.528v-.524a83.694 83.694 0 0161.381-80.661 81.929 81.929 0 016.292-1.475.376.376 0 00.062-.015 84.331 84.331 0 014.634-.758c.171-.026.328-.044.484-.066.3-.04.6-.073.9-.109.156-.022.309-.04.47-.051.324-.04.652-.073.976-.106.157-.018.31-.029.47-.044a70.207 70.207 0 013.341-.251c.7-.044 1.4-.069 2.106-.091a59.538 59.538 0 011.985-.036 1.2 1.2 0 01.161 0h.921c1.774.007 3.53.073 5.279.2.517.029 1.038.073 1.552.117.8.069 1.6.149 2.394.244.342.036.677.08 1.016.124.383.047.754.095 1.129.149a84.86 84.86 0 014.569.783q3.006.6 5.931 1.414A83.7 83.7 0 01236 151.039z"
        fill="#425158"
      />
      <path
        data-name="Path 5579"
        d="M154.28 228.614a75.622 75.622 0 10-75.623-75.622 75.622 75.622 0 0075.623 75.622z"
        fill="#6a75a0"
      />
      <path
        data-name="Path 5580"
        d="M206.86 205.567a75.622 75.622 0 10-106.946 0 75.621 75.621 0 00106.946 0z"
        fill="#edfbf9"
      />
      <path
        data-name="Path 5581"
        d="M152.2 76.491l1.184 75.608 66.052 36.837a75.633 75.633 0 00-66.049-112.459c-.397 0-.787.007-1.187.014z"
        fill="#c6e8e2"
      />
      <g data-name="Group 5509">
        <path
          data-name="Path 5582"
          d="M157.4 81.953a73.856 73.856 0 00-4.08-.113.979.979 0 00-.977 1.006 1.034 1.034 0 001.039 1.006c1.307 0 2.612.04 3.96.113a1.008 1.008 0 00.058-2.015zM146.287 83.2a1.012 1.012 0 00-1.115-.885q-2.034.235-4.041.59a1.008 1.008 0 00.172 2 .986.986 0 00.178-.018q1.945-.339 3.92-.572a1.01 1.01 0 00.886-1.115zm23.225.5a68.378 68.378 0 00-4-.812 1.008 1.008 0 10-.346 1.986c1.308.226 2.6.5 3.887.8a1.04 1.04 0 00.233.025 1.01 1.01 0 00.226-1.993zm-35.077 1.763a1.01 1.01 0 00-1.257-.674q-1.962.59-3.873 1.286a1 1 0 00.347 1.949.933.933 0 00.342-.062c1.239-.452 2.5-.867 3.763-1.246a1.01 1.01 0 00.678-1.257zm46.721 2.08q-1.88-.809-3.8-1.508a1.008 1.008 0 00-.688 1.894c1.253.452 2.481.94 3.694 1.461a.981.981 0 00.4.084 1 1 0 00.922-.608 1.011 1.011 0 00-.524-1.323zm-58 2.222a1.006 1.006 0 00-1.351-.448q-1.821.918-3.585 1.942A1.006 1.006 0 00119.232 93q1.716-.989 3.483-1.887a1 1 0 00.441-1.352zm68.777 3.585a73.937 73.937 0 00-3.479-2.146 1.006 1.006 0 10-1.006 1.741 65.914 65.914 0 013.374 2.084 1.008 1.008 0 101.115-1.679zm-79.12 2.609a1 1 0 00-1.41-.2q-1.633 1.219-3.2 2.536a1.006 1.006 0 00-.123 1.417 1.006 1.006 0 001.417.12q1.514-1.273 3.111-2.463a1 1 0 00.2-1.41zm88.727 4.981a67.051 67.051 0 00-3.049-2.715 1.007 1.007 0 00-1.293 1.545c1.016.849 2 1.731 2.965 2.634a1 1 0 00.692.27 1.014 1.014 0 00.733-.313 1 1 0 00-.044-1.421zm-97.84 2.912a1.009 1.009 0 00-1.428.044 68.891 68.891 0 00-2.714 3.049 1.006 1.006 0 101.541 1.294c.852-1.017 1.734-2 2.645-2.962a1.012 1.012 0 00-.044-1.428zm105.993 6.216q-1.22-1.635-2.536-3.2a1.008 1.008 0 00-1.541 1.3q1.273 1.515 2.463 3.105a1 1 0 00.8.408 1.021 1.021 0 00.6-.2 1 1 0 00.2-1.41zm-113.625 3.144a1.009 1.009 0 00-1.4.284q-1.12 1.706-2.146 3.479a1.007 1.007 0 00.368 1.377 1.029 1.029 0 00.5.131 1 1 0 00.871-.5 74.72 74.72 0 012.088-3.378 1 1 0 00-.281-1.393zm120.07 7.257q-.918-1.826-1.942-3.589a1.006 1.006 0 00-1.741 1.01c.659 1.144 1.29 2.3 1.887 3.483a1.014 1.014 0 00.9.55.952.952 0 00.452-.106 1.007 1.007 0 00.448-1.352zm-125.957 3.283a1.006 1.006 0 00-1.326.524 68.686 68.686 0 00-1.508 3.8 1 1 0 00.6 1.286.927.927 0 00.342.062 1 1 0 00.944-.66 65.875 65.875 0 011.472-3.694 1.008 1.008 0 00-.525-1.322zm130.5 8.088q-.59-1.968-1.289-3.884a1.008 1.008 0 10-1.891.7q.678 1.857 1.253 3.76a1 1 0 00.962.717 1.1 1.1 0 00.288-.04 1.008 1.008 0 00.677-1.253zm-134.464 3.322a1 1 0 00-1.213.747 68.41 68.41 0 00-.82 4 1.011 1.011 0 00.82 1.17 1.413 1.413 0 00.175.014 1.016 1.016 0 00.991-.834c.226-1.308.5-2.6.8-3.884a1.006 1.006 0 00-.747-1.213zm136.953 8.66q-.241-2.043-.594-4.044a1.007 1.007 0 00-1.982.354c.226 1.3.419 2.6.572 3.927a1.007 1.007 0 001 .893c.04 0 .08 0 .124-.008a1.011 1.011 0 00.885-1.115zm-138.858 3.254a.976.976 0 00-1.064.95 75.518 75.518 0 00-.113 4.081v.259a1.005 1.005 0 002.011 0v-.259c0-1.33.04-2.656.113-3.971a1.011 1.011 0 00-.951-1.06zm138.334 3.956a1.064 1.064 0 00-1.006 1.071q0 1.929-.105 3.84a1.017 1.017 0 001 1.064 1 1 0 001.005-.951q.109-1.962.11-3.953v-.131a.952.952 0 00-1.005-.94zM86.213 164.2q-.35-1.945-.583-3.92a.993.993 0 00-1.122-.885 1 1 0 00-.878 1.122c.157 1.355.361 2.7.6 4.04a1.012 1.012 0 00.987.831.92.92 0 00.179-.018 1.007 1.007 0 00.813-1.17zM221.8 163a1.011 1.011 0 00-1.166.819q-.339 1.968-.791 3.891a1.01 1.01 0 00.755 1.21.958.958 0 00.225.025 1 1 0 00.98-.776q.465-1.983.813-4A1.009 1.009 0 00221.8 163zM89.325 175.675a69.066 69.066 0 01-1.26-3.76 1.007 1.007 0 10-1.927.583q.59 1.962 1.3 3.873a1 1 0 00.944.659.993.993 0 00.35-.062 1.007 1.007 0 00.594-1.3zm129.549-.958a1.007 1.007 0 00-1.289.605 61.59 61.59 0 01-1.458 3.694 1.012 1.012 0 00.529 1.326 1.086 1.086 0 00.4.08 1 1 0 00.921-.608 64.184 64.184 0 001.5-3.8 1 1 0 00-.6-1.29zM94.389 186.43c-.659-1.137-1.3-2.3-1.891-3.48a1.009 1.009 0 00-1.8.911q.924 1.826 1.953 3.585a1 1 0 101.734-1.013zm119.56-.689a1 1 0 00-1.374.372q-.988 1.72-2.08 3.384a1 1 0 101.679 1.1 72.056 72.056 0 002.146-3.483 1 1 0 00-.371-1.373zm-112.7 10.394c-.849-1-1.676-2.04-2.47-3.1a1.007 1.007 0 10-1.61 1.209q1.219 1.634 2.543 3.192a1 1 0 00.765.36 1.019 1.019 0 00.652-.237 1 1 0 00.116-1.42zm105.934-.4a1.006 1.006 0 00-1.417.128q-1.273 1.524-2.63 2.965a1.007 1.007 0 00.04 1.428 1.033 1.033 0 00.692.27 1 1 0 00.736-.321 69.843 69.843 0 002.71-3.053 1.008 1.008 0 00-.127-1.417zm-97.5 8.784q-1.524-1.273-2.973-2.63a1 1 0 10-1.377 1.464c1 .933 2.015 1.84 3.06 2.711a1.017 1.017 0 00.649.237 1.009 1.009 0 00.641-1.782zm89.11-.109a1.008 1.008 0 00-1.417-.124 73.48 73.48 0 01-3.1 2.474 1.008 1.008 0 00.6 1.814 1.025 1.025 0 00.6-.2 72.203 72.203 0 003.195-2.543 1 1 0 00.117-1.418zm-79.35 6.911q-1.721-.99-3.384-2.08a1.006 1.006 0 10-1.1 1.683q1.7 1.12 3.483 2.138a.988.988 0 00.5.135 1.007 1.007 0 00.5-1.88zm69.6.178a1.009 1.009 0 00-1.377-.364c-1.137.66-2.3 1.3-3.483 1.891a1.007 1.007 0 00.459 1.9 1.028 1.028 0 00.455-.109q1.82-.924 3.582-1.949a1.008 1.008 0 00.367-1.377zm-58.8 4.824a66.354 66.354 0 01-3.694-1.457 1.008 1.008 0 10-.8 1.851 67.598 67.598 0 003.807 1.5 1.007 1.007 0 10.685-1.895zm47.959.47a1.022 1.022 0 00-1.3-.6q-1.857.682-3.763 1.257a1.009 1.009 0 00.291 1.974.99.99 0 00.288-.043q1.962-.591 3.873-1.3a1.013 1.013 0 00.6-1.29zm-36.461 2.569a72.274 72.274 0 01-3.888-.787 1.008 1.008 0 10-.455 1.963c1.319.306 2.652.58 4 .809a1.428 1.428 0 00.172.015 1 1 0 00.171-1.993zm24.858.746a1.008 1.008 0 00-1.17-.819c-1.3.233-2.6.43-3.927.583a1.009 1.009 0 00.12 2.011.547.547 0 00.116-.008c1.363-.16 2.7-.36 4.044-.593a1.011 1.011 0 00.813-1.17zm-13.2.241c-1.264 0-2.524-.037-3.77-.106a.994.994 0 00-1.064.955 1.009 1.009 0 00.951 1.06q1.929.1 3.887.106h.2a.929.929 0 00.911-1.006 1.1 1.1 0 00-1.108-1.006z"
          fill="#737783"
          opacity={0.2}
        />
      </g>
      <g data-name="Group 5510" opacity={0.4} fill="#3a4354">
        <path
          data-name="Path 5583"
          d="M153.245 87.538l-.025 13.156c-.576 0-1.148.014-1.724.04l-.415-13.163a59.73 59.73 0 012.16-.036z"
        />
        <path
          data-name="Path 5584"
          d="M185.543 96.121l-6.562 11.309c-.5-.288-1.005-.565-1.515-.827l6.186-11.538q.948.508 1.891 1.056z"
        />
        <path
          data-name="Path 5585"
          d="M209.227 119.7l-11.294 6.493c-.288-.5-.586-.991-.9-1.476l11.083-6.875a64.65 64.65 0 011.111 1.858z"
        />
        <path
          data-name="Path 5586"
          d="M217.946 151.961l-13.01-.029c0-.576-.015-1.155-.04-1.727l13.017-.408c.025.718.036 1.439.036 2.168z"
        />
        <path
          data-name="Path 5587"
          d="M210.418 182.364a69.019 69.019 0 01-1.053 1.891l-11.265-6.529c.287-.5.568-1.005.838-1.516l11.483 6.158z"
        />
        <path
          data-name="Path 5588"
          d="M187.644 206.824c-.612.379-1.231.747-1.858 1.112l-6.517-11.336c.5-.288.991-.587 1.479-.893l6.9 11.119z"
        />
        <path
          data-name="Path 5589"
          d="M155.69 216.625c-.718.022-1.439.036-2.161.029l.026-13.152c.575 0 1.147-.008 1.723-.037l.415 13.156z"
        />
        <path
          data-name="Path 5590"
          d="M129.367 197.475l-6.248 11.651a67.48 67.48 0 01-1.89-1.052l6.627-11.433c.5.288 1 .568 1.511.831z"
        />
        <path
          data-name="Path 5591"
          d="M109.942 179.358l-11.287 7a70.714 70.714 0 01-1.111-1.859l11.5-6.608c.287.5.583.987.892 1.472z"
        />
        <path
          data-name="Path 5592"
          d="M102.16 153.983l-13.3.419a53.573 53.573 0 01-.029-2.16l13.294.025c0 .576.007 1.148.037 1.716z"
        />
        <path
          data-name="Path 5593"
          d="M108.882 126.6c-.288.5-.565 1-.827 1.5l-11.7-6.27c.339-.637.692-1.267 1.053-1.894l11.477 6.656z"
        />
        <path
          data-name="Path 5594"
          d="M127.575 107.721c-.5.288-.987.587-1.472.893l-6.973-11.247a70.652 70.652 0 011.858-1.111l6.587 11.461z"
        />
        <path
          data-name="Path 5595"
          d="M153.245 87.538l-.025 13.156c-.576 0-1.148.014-1.724.04l-.415-13.163a59.73 59.73 0 012.16-.036z"
        />
      </g>
      <path
        data-name="Path 5596"
        d="M96.652 186.63a.99.99 0 01.466-.783l55.745-34.593a.992.992 0 111.046 1.687l-55.745 34.593a.993.993 0 01-1.366-.321.969.969 0 01-.146-.583z"
        fill="#c4f2ea"
      />
      <path
        data-name="Path 5597"
        d="M151.414 151.9a1.982 1.982 0 012.925-1.537l47.144 25.812a1.985 1.985 0 01-1.906 3.483l-47.143-25.812a1.989 1.989 0 01-1.024-1.942z"
        fill="#263238"
      />
      <path
        data-name="Path 5598"
        d="M152.084 153.6a1.964 1.964 0 01-.681-1.443l-1.035-37.86a1.983 1.983 0 113.964-.106l1.034 37.86a1.983 1.983 0 01-3.282 1.552z"
        fill="#263238"
      />
      <path
        data-name="Path 5599"
        d="M148.688 149.994a5.148 5.148 0 112.594 6.8 5.148 5.148 0 01-2.594-6.8z"
        fill="#3e4a74"
      />
      <path
        data-name="Path 5600"
        d="M175.177 141.906h-9.1l.266-1.92 4.849-5.2a13.611 13.611 0 001.549-2.04 4.486 4.486 0 00.6-1.563 2.557 2.557 0 00-.149-1.552 1.106 1.106 0 00-1.079-.55 1.634 1.634 0 00-1.333.729 3.737 3.737 0 00-.7 1.832h-2.828l-.021-.062a5.436 5.436 0 011.668-3.41 4.929 4.929 0 013.527-1.348 3.51 3.51 0 013.818 4.35 5.4 5.4 0 01-.984 2.492 33.531 33.531 0 01-2.7 3.064l-2.379 2.878.021.051h5.3z"
        fill="#263238"
      />
      <path
        data-name="Path 5601"
        d="M186.784 136.517a7.17 7.17 0 01-1.862 4.164 4.846 4.846 0 01-3.537 1.439 3.519 3.519 0 01-3.09-1.5 5.447 5.447 0 01-.677-4.1l.612-4.073a7.215 7.215 0 011.869-4.161 4.855 4.855 0 013.563-1.453 3.513 3.513 0 013.056 1.515 5.513 5.513 0 01.678 4.1zm-2.237-4.328a4.561 4.561 0 00-.106-2.317 1.152 1.152 0 00-1.129-.787 1.641 1.641 0 00-1.359.823 5.266 5.266 0 00-.8 2.281l-.685 4.565a4.6 4.6 0 00.091 2.342 1.162 1.162 0 001.155.78 1.643 1.643 0 001.334-.816 5.525 5.525 0 00.812-2.306z"
        fill="#263238"
      />
      <path
        data-name="Path 5602"
        d="M167.985 146.981a1.973 1.973 0 01.627-.561 1.592 1.592 0 01.783-.2 1.042 1.042 0 01.67.219 1.121 1.121 0 01.379.659 2.066 2.066 0 01.641-.648 1.535 1.535 0 01.824-.23 1.033 1.033 0 01.961.568 2.8 2.8 0 01.15 1.716l-.474 3.155h-1.391l.473-3.155a2.05 2.05 0 000-.943.4.4 0 00-.4-.244.67.67 0 00-.4.131 1.377 1.377 0 00-.336.357 1.6 1.6 0 01-.014.175 5.311 5.311 0 01-.026.2l-.524 3.479h-1.388l.473-3.155a2.019 2.019 0 000-.94.4.4 0 00-.408-.247.736.736 0 00-.379.1 1.162 1.162 0 00-.324.3l-.586 3.934h-1.392l.8-5.34h1.3l-.043.663z"
        fill="#263238"
      />
      <path
        data-name="Path 5603"
        d="M174.94 151.659h-1.392l.8-5.341h1.391l-.8 5.341zm1-6.638h-1.392l.157-1.06h1.391z"
        fill="#263238"
      />
      <path
        data-name="Path 5604"
        d="M177.963 147.036a2.239 2.239 0 01.645-.6 1.481 1.481 0 01.765-.211 1.061 1.061 0 01.977.536 2.561 2.561 0 01.153 1.661l-.489 3.242h-1.391l.488-3.242a1.755 1.755 0 00-.018-.863.409.409 0 00-.408-.237.862.862 0 00-.43.116 1.275 1.275 0 00-.365.325l-.586 3.9h-1.392l.8-5.341h1.3l-.048.714z"
        fill="#263238"
      />
      <path
        data-name="Path 5605"
        d="M52.514 110.972H5.181A5.18 5.18 0 000 116.152v28.96a5.18 5.18 0 005.181 5.181h47.333a5.18 5.18 0 005.181-5.181v-28.96a5.18 5.18 0 00-5.181-5.18z"
        fill="#263238"
      />
      <path
        data-name="Path 5606"
        d="M52.371 112.859H5.323a3.417 3.417 0 00-3.417 3.417v28.713a3.417 3.417 0 003.417 3.417h47.048a3.417 3.417 0 003.417-3.417v-28.713a3.417 3.417 0 00-3.417-3.417z"
        fill="#edeffb"
      />
      <path
        data-name="Path 5607"
        d="M8.467 113.85h-.324v33.562h.324z"
        fill="#dfe5f7"
      />
      <path
        data-name="Path 5608"
        d="M16.763 113.85h-.324v33.562h.324z"
        fill="#dfe5f7"
      />
      <path
        data-name="Path 5609"
        d="M25.055 113.85h-.325v33.562h.324z"
        fill="#dfe5f7"
      />
      <path
        data-name="Path 5610"
        d="M33.351 113.85h-.324v33.562h.324z"
        fill="#dfe5f7"
      />
      <path
        data-name="Path 5611"
        d="M41.646 113.85h-.324v33.562h.324z"
        fill="#dfe5f7"
      />
      <path
        data-name="Path 5612"
        d="M49.941 113.85h-.324v33.562h.324z"
        fill="#dfe5f7"
      />
      <path
        data-name="Path 5613"
        d="M54.069 117.155H3.625v.266h50.444z"
        fill="#dfe5f7"
      />
      <path
        data-name="Path 5614"
        d="M54.069 123.578H3.625v.266h50.444z"
        fill="#dfe5f7"
      />
      <path
        data-name="Path 5615"
        d="M54.069 130H3.625v.266h50.444z"
        fill="#dfe5f7"
      />
      <path
        data-name="Path 5616"
        d="M54.069 136.423H3.625v.266h50.444z"
        fill="#dfe5f7"
      />
      <path
        data-name="Path 5617"
        d="M54.069 142.847H3.625v.266h50.444z"
        fill="#dfe5f7"
      />
      <path
        data-name="Path 5618"
        d="M15.834 130.033c.444.015.925.856 2.958 4.718l3.818-5.727a.576.576 0 01.976.022l2.477 6.6 4.281-12.238a.575.575 0 011.038.007l4.212 10.431 2.106-3.629a.6.6 0 01.525-.288c2.532.135 3.279-.051 7.25-.018.022-.269.033-.543.033-.82a10.06 10.06 0 00-9.808-10.3 9.574 9.574 0 00-7.21 3.319 9.58 9.58 0 00-7.21-3.319 10.062 10.062 0 00-9.807 10.3 10.806 10.806 0 00.073 1.243c2.262-.128 4.288-.295 4.288-.295z"
        fill="#6aa097"
        opacity={0.4}
      />
      <path
        data-name="Path 5619"
        d="M38.356 131.378l-2.313 3.989a.54.54 0 01-.485.288h-.051a.572.572 0 01-.485-.328L30.854 125l-4.223 12.886a.577.577 0 01-1.016.04l-2.685-7.4-3.73 5.635a.535.535 0 01-.5.262.567.567 0 01-.488-.306l-2.616-4.674-3.895-.157a10.336 10.336 0 004.08 6.332l12.711 8.194 12.708-8.194a10.366 10.366 0 004.172-6.831l-7.017.594z"
        fill="#6aa097"
        opacity={0.4}
      />
      <path
        data-name="Path 5620"
        d="M306.772 60.561a25.246 25.246 0 11-50.492 0V60.4a25.259 25.259 0 0118.541-24.187 25.53 25.53 0 011.676-.4c.375-.076.757-.146 1.14-.2l.215-.033.142-.022c.047-.007.1-.014.146-.018s.08-.011.12-.015.091-.014.138-.018l.288-.033c.048 0 .091-.011.139-.014.258-.029.521-.051.783-.073.069 0 .142-.011.215-.015.207-.015.415-.026.626-.033s.4-.014.609-.018h.463a24.63 24.63 0 012.018.081 34.537 34.537 0 01.896.087 23.807 23.807 0 011.938.299c.62.12 1.232.266 1.833.43a25.251 25.251 0 0118.559 24.348z"
        fill="#626d99"
      />
      <path
        data-name="Path 5621"
        d="M306.145 60.247a24.931 24.931 0 01-49.861.157v-.157a24.945 24.945 0 0118.293-24.038q.924-.257 1.876-.441h.018c.314-.066.631-.12.948-.168.145-.022.287-.044.437-.062.051-.007.1-.015.145-.018l.266-.033c.048-.007.092-.011.139-.015l.291-.033c.048 0 .091-.011.139-.015.262-.026.524-.047.79-.062.07 0 .139-.011.208-.011.208-.015.419-.022.627-.029s.393-.011.594-.011h.324c.528 0 1.053.022 1.574.058.153.011.309.022.462.036a22.98 22.98 0 011.014.109l.335.044a24.213 24.213 0 013.129.656 24.943 24.943 0 0118.26 24.027z"
        fill="#263238"
      />
      <path
        data-name="Path 5622"
        d="M281.794 83.36a22.533 22.533 0 10-22.533-22.533 22.534 22.534 0 0022.533 22.533z"
        fill="#6a75a0"
      />
      <path
        data-name="Path 5623"
        d="M281.528 83.094a22.533 22.533 0 10-22.534-22.533 22.534 22.534 0 0022.534 22.533z"
        fill="#edfbf9"
      />
      <path
        data-name="Path 5624"
        d="M281.527 38.024v22.533l19.313-11.618a22.516 22.516 0 00-19.313-10.919z"
        fill="#c6e8e2"
      />
      <path
        data-name="Path 5625"
        d="M287.766 47.649h-3.632l.105-.765 1.935-2.073a4.982 4.982 0 00.616-.816 1.8 1.8 0 00.237-.623 1.047 1.047 0 00-.059-.619.442.442 0 00-.43-.219.659.659 0 00-.532.291 1.5 1.5 0 00-.28.732H284.6l-.007-.026a2.155 2.155 0 01.667-1.359 1.977 1.977 0 011.406-.539 1.4 1.4 0 011.523 1.734 2.141 2.141 0 01-.393.995 12.951 12.951 0 01-1.079 1.221l-.947 1.148.007.022h2.113l-.127.9z"
        fill="#263238"
      />
      <path
        data-name="Path 5626"
        d="M284.9 49.656a.749.749 0 01.237-.211.528.528 0 01.273-.073.454.454 0 01.412.226 1.065 1.065 0 01.069.689l-.189 1.253h-.554l.189-1.257a.867.867 0 000-.375.166.166 0 00-.164-.1.411.411 0 00-.175.04.507.507 0 00-.138.113l-.237 1.577h-.554l.459-3.071h.554l-.178 1.188z"
        fill="#263238"
      />
      <path
        data-name="Path 5627"
        d="M286.156 50.457a1.414 1.414 0 01.346-.791.9.9 0 01.692-.3.646.646 0 01.59.306 1.1 1.1 0 01.124.78l-.007.044a1.484 1.484 0 01-.346.791.891.891 0 01-.689.291.647.647 0 01-.594-.3 1.125 1.125 0 01-.124-.78zm.546.044a1.291 1.291 0 000 .477.212.212 0 00.226.168.311.311 0 00.27-.179 1.348 1.348 0 00.149-.47l.007-.044a1.253 1.253 0 000-.477.212.212 0 00-.222-.175.312.312 0 00-.273.182 1.355 1.355 0 00-.146.466l-.007.044z"
        fill="#263238"
      />
      <path
        data-name="Path 5628"
        d="M289.2 51.248a.727.727 0 01-.248.248.569.569 0 01-.309.084.438.438 0 01-.412-.233 1.143 1.143 0 01-.062-.71l.182-1.228h.554l-.186 1.231a.9.9 0 000 .4.156.156 0 00.164.1.408.408 0 00.175-.04.38.38 0 00.142-.113l.237-1.585h.558l-.321 2.131h-.455l-.015-.3z"
        fill="#263238"
      />
      <path
        data-name="Path 5629"
        d="M291.275 49.889l-.19-.007a.269.269 0 00-.16.051.421.421 0 00-.12.146l-.219 1.461h-.554l.321-2.131h.517l-.018.277a.893.893 0 01.189-.233.357.357 0 01.234-.084.213.213 0 01.069.007.318.318 0 01.062.018z"
        fill="#263238"
      />
      <path
        data-name="Path 5630"
        d="M292.32 50.986a.2.2 0 00-.048-.164.983.983 0 00-.258-.164 1.2 1.2 0 01-.452-.273.452.452 0 01-.109-.39.666.666 0 01.269-.448.9.9 0 01.576-.179.739.739 0 01.539.193.515.515 0 01.146.477c0 .011-.543.011-.543.011a.333.333 0 00-.029-.219.186.186 0 00-.168-.08.258.258 0 00-.171.066.235.235 0 00-.087.153.157.157 0 00.04.153 1.17 1.17 0 00.262.16 1.125 1.125 0 01.466.273.473.473 0 01.106.408.648.648 0 01-.281.452 1 1 0 01-.6.167.7.7 0 01-.55-.215.542.542 0 01-.146-.481c0-.011.51-.011.51-.011a.3.3 0 00.047.248.26.26 0 00.208.076.276.276 0 00.186-.058.252.252 0 00.087-.157z"
        fill="#263238"
      />
      <path
        data-name="Path 5631"
        d="M285.35 80.806a.318.318 0 01-.179-.222L281.2 60.557a.31.31 0 01.609-.12l3.971 20.027a.314.314 0 01-.244.364.291.291 0 01-.186-.022z"
        fill="#c4f2ea"
      />
      <path
        data-name="Path 5632"
        d="M281.109 61.133a.738.738 0 01-.189-.208.709.709 0 01.24-.973l16.475-9.913a.711.711 0 01.736 1.217L281.9 61.169a.71.71 0 01-.783-.033z"
        fill="#8cd1c6"
      />
      <path
        data-name="Path 5633"
        d="M281.048 61.082a.708.708 0 01-.23-.521V47.012a.709.709 0 111.418 0v13.549a.709.709 0 01-1.188.525z"
        fill="#8cd1c6"
      />
      <path
        data-name="Path 5634"
        d="M279.849 59.807a1.842 1.842 0 11.929 2.434 1.841 1.841 0 01-.929-2.434z"
        fill="#263238"
      />
      <g data-name="Group 5511" opacity={0.6} fill="#263238">
        <path
          data-name="Path 5635"
          d="M301.456 60.517l-4.014-.011c0-.179 0-.357-.011-.532l4.018-.128c.007.222.011.444.011.67z"
        />
        <path
          data-name="Path 5636"
          d="M299.136 69.9c-.106.2-.215.39-.325.583l-3.479-2.015c.087-.153.175-.31.259-.466l3.545 1.9z"
        />
        <path
          data-name="Path 5637"
          d="M292.105 77.454c-.19.117-.379.229-.572.342l-2.012-3.5c.154-.088.307-.182.456-.277z"
        />
        <path
          data-name="Path 5638"
          d="M282.239 80.479q-.333.011-.667.011l.008-4.059c.178 0 .353 0 .531-.011l.128 4.062z"
        />
        <path
          data-name="Path 5639"
          d="M274.114 74.569l-1.928 3.6c-.2-.106-.389-.215-.582-.324l2.047-3.53c.153.088.31.175.466.259z"
        />
        <path
          data-name="Path 5640"
          d="M268.117 68.973l-3.483 2.16a31.994 31.994 0 01-.342-.572l3.552-2.04c.088.153.179.306.277.455z"
        />
        <path
          data-name="Path 5641"
          d="M265.716 61.14l-4.105.127a18.508 18.508 0 01-.011-.667l4.1.007c0 .179 0 .353.011.532z"
        />
        <path
          data-name="Path 5642"
          d="M267.789 52.688c-.087.153-.175.31-.255.466l-3.61-1.935c.1-.2.215-.39.324-.583l3.541 2.055z"
        />
        <path
          data-name="Path 5643"
          d="M273.561 46.862c-.153.087-.306.182-.456.277l-2.153-3.472c.19-.117.379-.23.572-.342l2.033 3.538z"
        />
      </g>
      <g data-name="Group 5512">
        <path
          data-name="Path 5644"
          d="M186.724 70.39c-9.8-2.7-11.243-2.193-28.174-2.226.066 0-5.985-.015-6.663-.015a82.828 82.828 0 00-13.187 2.886c16.311.3 36.381.251 50.113-.036-.7-.211-1.392-.415-2.091-.6z"
          fill="#778f97"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5645"
        d="M175.128 27.8c-1.494-1.374-4.459-.55-4.918 1.4a4.506 4.506 0 00.477 3.122c1.8 3.6 9.443 7.979 14.358 9.491a4.24 4.24 0 003.621-.51 1.6 1.6 0 00.853-1.191c.032-1.184-1.476-2.015-4.212-3.989-1.873-1.352-3.625-2.864-5.447-4.288a78.507 78.507 0 01-4.732-4.026z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5646"
        d="M183.252 39.8a119.449 119.449 0 003.374-21.036c1.034-.036 1.65-.284 2.685-.324 1.053 15.629 1.282 17.207.1 21.637l-1.089 1.148-5.07-1.425z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5647"
        d="M189.143 114.735a7.272 7.272 0 00.878-1.828c.459-1.465.324-2.747.615-2.784.2-.025.438.554.449.547s-.667-1.035-.551-1.144c.19-.179 2.594 2.058 4.656 4.04.529 1.046 1.05 2.128 1.582 3.232.8 1.665 1.632 3.428 1.727 3.818a2.065 2.065 0 01-1.021 2.79 5.291 5.291 0 01-5.089-.932 3.614 3.614 0 01-1.261-1.622c-.448-1.118-1.224-3.031-1.825-4.346a5.925 5.925 0 01-.164-1.767z"
        fill="#606895"
      />
      <path
        data-name="Path 5648"
        d="M189.143 114.735a7.272 7.272 0 00.878-1.828c.459-1.465.324-2.747.615-2.784.2-.025.438.554.449.547s-.667-1.035-.551-1.144c.19-.179 2.594 2.058 4.656 4.04.529 1.046 1.05 2.128 1.582 3.232.8 1.665 1.632 3.428 1.727 3.818a2.065 2.065 0 01-1.021 2.79 5.291 5.291 0 01-5.089-.932 3.614 3.614 0 01-1.261-1.622c-.448-1.118-1.224-3.031-1.825-4.346a5.925 5.925 0 01-.164-1.767z"
        fill="#547771"
      />
      <path
        data-name="Path 5649"
        d="M194.113 111.022a4.776 4.776 0 01.9.419 10.567 10.567 0 00.069 1.465 21.8 21.8 0 001.505 4.943c.619 1.582-.459 2.609-2.121 1.235s-1.9-6.568-1.9-6.568l1.549-1.49z"
        fill="#a0bfba"
      />
      <path
        data-name="Path 5650"
        d="M192.116 121a5.285 5.285 0 002.951 1.993 3.71 3.71 0 002.991-.612 3.014 3.014 0 00.645-.765 2.973 2.973 0 01-.357 1.075 1.9 1.9 0 01-.47.579 2.106 2.106 0 01-.539.306 5.468 5.468 0 01-4.875-.852 10.036 10.036 0 01-1.417-1.8 20.366 20.366 0 01-2.033-4.007 2.528 2.528 0 01-.193-1.286 2.381 2.381 0 01.324-.9 13.259 13.259 0 002.973 6.263z"
        fill="#262222"
      />
      <path
        data-name="Path 5651"
        d="M190.874 111.736l-.379-4.514 4.135-.346-.12 5.1a2.809 2.809 0 01-3.64-.244z"
        fill="#ffa78a"
      />
      <path
        data-name="Path 5652"
        d="M195.293 114.643a15.968 15.968 0 01-.043-3.235c.076-.834-.066-1.825-1.246-1.6a1.942 1.942 0 00-1.316.684c-.309.445-.375.977-.087 2.5 0 0 .667 3.541 2.113 5.115.466.507.736.477.827.456a.681.681 0 00.408-.387c-.218-1.176-.437-2.357-.652-3.534z"
        fill="#5f6e75"
      />
      <path
        data-name="Path 5653"
        d="M174.986 57.664s21.156 14.715 22.551 17.136-2.867 38-2.867 38c-.284.857-.878-.269-1.038-.185a3.561 3.561 0 01-4.113-1.378 62.676 62.676 0 00.2-12.948c-.719-5.169-2.179-9.949-.874-16.589.178-.911.368-1.65.5-2.12-9.87-5.807-17.171-10.35-19.965-12.351a2.677 2.677 0 01-1.057-1.337c-1.054-3.346 6.663-8.228 6.663-8.228z"
        fill="#263238"
      />
      <g data-name="Group 5513">
        <path
          data-name="Path 5654"
          d="M173.692 66c2.259.222 19.073 12.238 17.994 12.831s-3.075 9.509-1.384 14.413.106 15.415.783 17.422c.521 1.545 2.671 1.691 3.636 1.673l-.055.459c-.284.856-.878-.27-1.038-.186a3.56 3.56 0 01-4.113-1.377 62.682 62.682 0 00.2-12.948c-.717-5.173-2.178-9.953-.874-16.591.178-.911.368-1.65.5-2.12-7.25-4.266-13.116-7.851-16.824-10.245-.001-1.874.268-3.419 1.175-3.331z"
          fill="#3c2908"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5655"
        d="M195.293 114.644a15.968 15.968 0 01-.043-3.235c.076-.834-.066-1.825-1.246-1.6a1.947 1.947 0 00-1.316.685c-.309.445-.375.977-.087 2.5 0 0 .667 3.541 2.113 5.115.466.507.736.477.827.456a.681.681 0 00.408-.387c-.218-1.176-.437-2.357-.652-3.534z"
        fill="#a0bfba"
      />
      <path
        data-name="Path 5656"
        d="M192.786 115.544h.033l2.845-.47a.174.174 0 00.132-.193.156.156 0 00-.172-.146l-2.845.47a.172.172 0 00-.131.193.16.16 0 00.138.146z"
        fill="#e8eff3"
      />
      <path
        data-name="Path 5657"
        d="M192.94 116.593h.032l2.973-.51a.174.174 0 00.131-.2.151.151 0 00-.171-.142l-2.973.51a.174.174 0 00-.131.2.163.163 0 00.139.146z"
        fill="#e8eff3"
      />
      <path
        data-name="Path 5658"
        d="M193.409 117.792h.037l2.812-.576a.178.178 0 00.128-.2.156.156 0 00-.175-.139l-2.813.576a.178.178 0 00-.127.2.158.158 0 00.138.142z"
        fill="#e8eff3"
      />
      <path
        data-name="Path 5659"
        d="M178.516 115.6a7.281 7.281 0 00.878-1.829c.459-1.465.324-2.747.615-2.784.2-.025.438.554.449.547s-.667-1.035-.551-1.144c.19-.179 2.594 2.058 4.657 4.04.528 1.046 1.049 2.128 1.581 3.232.8 1.665 1.632 3.428 1.727 3.818a2.067 2.067 0 01-1.021 2.791 5.292 5.292 0 01-5.089-.933 3.607 3.607 0 01-1.261-1.625c-.448-1.118-1.224-3.031-1.825-4.346a5.925 5.925 0 01-.164-1.767z"
        fill="#606895"
      />
      <path
        data-name="Path 5660"
        d="M178.516 115.6a7.281 7.281 0 00.878-1.829c.459-1.465.324-2.747.615-2.784.2-.025.438.554.449.547s-.667-1.035-.551-1.144c.19-.179 2.594 2.058 4.657 4.04.528 1.046 1.049 2.128 1.581 3.232.8 1.665 1.632 3.428 1.727 3.818a2.067 2.067 0 01-1.021 2.791 5.292 5.292 0 01-5.089-.933 3.607 3.607 0 01-1.261-1.625c-.448-1.118-1.224-3.031-1.825-4.346a5.925 5.925 0 01-.164-1.767z"
        fill="#547771"
      />
      <path
        data-name="Path 5661"
        d="M183.485 111.886a4.775 4.775 0 01.9.419 10.571 10.571 0 00.069 1.465 21.875 21.875 0 001.505 4.944c.619 1.581-.459 2.608-2.121 1.235s-1.9-6.569-1.9-6.569l1.548-1.49z"
        fill="#a0bfba"
      />
      <path
        data-name="Path 5662"
        d="M181.248 121.964c2.492 3.173 6.463.965 6.8.765-.142.63-.179 1.169-1.137 1.566a5.557 5.557 0 01-5.294-.932 3.612 3.612 0 01-1.26-1.625c-.448-1.119-1.224-3.031-1.826-4.347a2.229 2.229 0 01-.014-1.788 12.072 12.072 0 002.736 6.361z"
        fill="#262222"
      />
      <path
        data-name="Path 5663"
        d="M179.86 112.014a2.9 2.9 0 011.953-.47 7.3 7.3 0 011.884.422 4.371 4.371 0 01.685.339v.08c-.343.4-2.135 2.219-4.726-.288a.316.316 0 00.204-.083z"
        fill="#262222"
      />
      <path
        data-name="Path 5664"
        d="M180.246 112.6l-.379-4.514 4.135-.346-.12 5.1a2.809 2.809 0 01-3.64-.244z"
        fill="#ffa78a"
      />
      <path
        data-name="Path 5665"
        d="M184.665 115.507a15.967 15.967 0 01-.043-3.235c.076-.834-.066-1.825-1.246-1.6a1.943 1.943 0 00-1.316.685c-.309.444-.375.976-.087 2.495 0 0 .667 3.542 2.113 5.115.466.507.736.478.827.456a.682.682 0 00.408-.386c-.218-1.177-.437-2.358-.652-3.534z"
        fill="#5f6e75"
      />
      <path
        data-name="Path 5666"
        d="M175.652 55.256a17.909 17.909 0 01-.907 9.385c-.8 2.051-1.3 3.315-2.612 4.066-2.525 1.436-4.565-1.027-9.195-.109-2.321.459-3.3 1.388-4.212.747-1.4-.984-.776-4.1-.579-5.082.827-4.157 3.333-5.407 3.792-9.658a1.989 1.989 0 01.2-.918c1.705-2.864 13.516 1.574 13.516 1.574z"
        fill="#263238"
      />
      <path
        data-name="Path 5667"
        d="M164.883 59.216s20.85 15.961 22.209 18.4-3.013 37.343-3.013 37.343c-.167 1.5-.575-.211-1.96 0a3.154 3.154 0 01-2.743-1.1 99.919 99.919 0 00-.875-15.094c-.521-3.807-1.391-8.368.124-14.1.266-1.009.547-1.825.747-2.372-3.6-1.709-6.743-3.33-9.356-4.74 0 0-3.107-1.512-10.969-7.753-3.542-2.813 2.2-7.851 5.832-10.584z"
        fill="#263238"
      />
      <g data-name="Group 5514">
        <path
          data-name="Path 5668"
          d="M159.036 69.708c-1.531-1.213-1.327-3.275-.893-5.45.55-2.754 1.833-4.23 2.769-6.15a17.658 17.658 0 01-.791 3.563s-3.053 4.222.259 7.031 19.2 12.154 21.637 12.307c0 0-2.219 1.275-2.357 9.469s1.089 16.974.586 22.125c0 0 .168 2.073 3.819 2.266-.168 1.5-.576-.211-1.961 0a3.154 3.154 0 01-2.743-1.1 99.937 99.937 0 00-.874-15.093c-.521-3.807-1.392-8.368.124-14.1.266-1.009.546-1.825.746-2.372-3.6-1.709-6.743-3.33-9.355-4.74 0 0-3.108-1.512-10.97-7.753z"
          fill="#3c2908"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5669"
        d="M184.665 115.507a15.967 15.967 0 01-.043-3.235c.076-.834-.066-1.825-1.246-1.6a1.943 1.943 0 00-1.316.685c-.309.444-.375.976-.087 2.495 0 0 .667 3.542 2.113 5.115.466.507.736.478.827.456a.682.682 0 00.408-.386c-.218-1.177-.437-2.358-.652-3.534z"
        fill="#a0bfba"
      />
      <path
        data-name="Path 5670"
        d="M182.155 116.408h.033l2.846-.47a.173.173 0 00.131-.193.156.156 0 00-.172-.146l-2.845.47a.172.172 0 00-.131.193.16.16 0 00.138.146z"
        fill="#e8eff3"
      />
      <path
        data-name="Path 5671"
        d="M182.312 117.46h.032l2.973-.51a.173.173 0 00.131-.2.151.151 0 00-.171-.143l-2.973.511a.174.174 0 00-.131.2.163.163 0 00.139.146z"
        fill="#e8eff3"
      />
      <path
        data-name="Path 5672"
        d="M182.782 118.655h.037l2.812-.575a.178.178 0 00.128-.2.155.155 0 00-.175-.138l-2.813.576a.177.177 0 00-.127.2.158.158 0 00.138.142z"
        fill="#e8eff3"
      />
      <path
        data-name="Path 5673"
        d="M165.888 1.748s-2.16-3.13-4.988-1.013-6.918 10.456 0 10.849 4.988-9.833 4.988-9.833z"
        fill="#402a22"
      />
      <path
        data-name="Path 5674"
        d="M165.142 20.2a7.193 7.193 0 002.6 1.69c1.56.557 5.83-4.787 2.922-6.671s-2.433-1.669-2.433-1.669-8.58-.714-3.093 6.645z"
        fill="#402a22"
      />
      <path
        data-name="Path 5675"
        d="M170.6 23.946a10.517 10.517 0 013.9 3.4c.631.94.667 1.381 2.106 3.876a15.743 15.743 0 011.275 2.277 6.74 6.74 0 01.15 4.507 6.3 6.3 0 01-2.164 2.907c.393 4.343.553 7.975.623 10.657a36.479 36.479 0 01-.58 6.678 30.582 30.582 0 01-8.033 2.955 26.685 26.685 0 01-4.357.579 19.9 19.9 0 01-4.558-.292c3.661-7.982 3.607-13.706 2.08-19.455-1.694-6.376-4.288-9.407-3-12.912.707-1.924 2.583-3.953 7.108-5.428l5.454.24z"
        fill="#60bcad"
      />
      <path
        data-name="Path 5676"
        d="M165.142 23.705S174.086 33.75 174 46.486a6.482 6.482 0 01-3.592 1.873s-2.973 1.246-5.068 0c0 0 .7-20.3-3.727-23.12.002 0 .487-1.814 3.529-1.534z"
        fill="#86d2c5"
      />
      <path
        data-name="Path 5677"
        d="M157.837 28.882c.423-1.88 3.3-2.765 4.787-1.446a4.442 4.442 0 011.4 2.747c.674 4.31-4.11 13.3-7.37 16.333-.977.117-2.787.561-3.432-.288-.707-.929.04-2.379 1.129-5.388.743-2.055 1.3-4.182 1.957-6.27.444-1.414 1-3.33 1.53-5.687z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5678"
        d="M158.612 44.384c-.965 2.514-1.9 5.771-2.721 8.86-1.108 4.182-2 12.176-2.408 15.644-1.009-.117-2.507-.117-3.512-.233.63-4.558 1.115-21.207 3.118-25.055l.736-.893 4.784 1.672z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5679"
        d="M150.525 64.921s-.178 3.151-.554 3.151a34.494 34.494 0 00-4.652.208 10.132 10.132 0 00-2.62 1.57c-.149.226.824.525 3.145 0a7.627 7.627 0 014.127.189s-3.322.408-3.424.783 3.187.674 4.911 0a3.163 3.163 0 002.029-1.931l-2.962-3.967z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5680"
        d="M165.542 11.891l-.2 6.008-.2 5.807c1.618 1.873 3.633 2.412 4.656 1.709a2.091 2.091 0 00.8-1.468q-.132-2.251-.259-4.5-5.245-9.208-5.439-9.1a6.2 6.2 0 00.645 1.556z"
        fill="#fab38b"
      />
      <g data-name="Group 5515">
        <path
          data-name="Path 5681"
          d="M165.342 19.155s2.838 1.359 5.057 2.638l.109 1.909c-4.882-1.158-5.166-4.547-5.166-4.547z"
          fill="#ba937f"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5682"
        d="M166.234 4.334a7.392 7.392 0 00-2.241 2.324c-1.763 2.907-.892 6.2-.433 7.949.55 2.088 1.519 5.76 4.893 7.465.422.215 3.5 1.771 6.157.3 2.16-1.2 2.721-3.669 3.075-5.224.991-4.361.386-11.779-4.314-13.64a8.092 8.092 0 00-7.137.831z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5683"
        d="M173.867 20.416a.561.561 0 00.484-.962.511.511 0 00-.193-.12.6.6 0 00-.477.047.474.474 0 00-.146.131.629.629 0 00.146.823.566.566 0 00.186.081z"
        fill="#701c25"
      />
      <path
        data-name="Path 5684"
        d="M169.346 18.768a2.131 2.131 0 10-2.131-2.131 2.131 2.131 0 002.131 2.131z"
        fill="#fff"
        opacity={0.3}
      />
      <path
        data-name="Path 5685"
        d="M176.873 14.805a2.131 2.131 0 011.13.324 16.68 16.68 0 01-.317 2.018 16.862 16.862 0 01-.517 1.9 1.95 1.95 0 01-.3.022 2.131 2.131 0 010-4.263z"
        fill="#fff"
        opacity={0.3}
      />
      <g data-name="Group 5516">
        <path
          data-name="Path 5686"
          d="M173.529 5.329s0 2.175-2.842 5.02a7.322 7.322 0 01-5.418 2.153 5.579 5.579 0 00-2.226.39c-.236-.7.66 2.259.518 1.716a14.128 14.128 0 01-.605-4.58l3.1-1.789 7.473-2.915z"
          fill="#c7785c"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5687"
        d="M174.162 12.014a.1.1 0 00-.058.062 6.147 6.147 0 001.213 4.7.375.375 0 01.131.441c-.2.393-1.158.765-1.57.929 1.038 0 2.59-.678 1.687-1.68a8.3 8.3 0 01-1.443-4.383.1.1 0 01.022-.058l.014-.011z"
        fill="#c7785c"
      />
      <path
        data-name="Path 5688"
        d="M172.355 5.253a8.769 8.769 0 012.853 1.65 9.207 9.207 0 012.9 5.057 7.8 7.8 0 00.55-5.213 7.618 7.618 0 00-1.657-3c-.587-.641-2.11-2.317-3.95-2.058-.171.026-1.73.266-1.981 1.381a2.207 2.207 0 001.278 2.175z"
        fill="#402a22"
      />
      <g data-name="Group 5517">
        <path
          data-name="Path 5689"
          d="M177.255 4.837a22.9 22.9 0 011.253 3.72c-.116.047-1.133-4.048-3.756-4.671a3.834 3.834 0 00-1.45-.051 7.272 7.272 0 011.953 1.053 7.986 7.986 0 012.834 4.354 9.1 9.1 0 00-1.482-2.4c-.886-1.024-1.84-1.65-2.354-1.6-.353.033-.75.1-.75.1-.328.055-.365.077-.416.073-.262-.029-.546-.751-.685-3.559a6.44 6.44 0 011.9.485 6.77 6.77 0 012.955 2.5z"
          fill="#c7785c"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5690"
        d="M165.444 2.039A6.549 6.549 0 01168.482.8a8.3 8.3 0 014.208.885c.281 1.282.561 2.361.838 3.643a44.613 44.613 0 01-1.767 2.241c-.918 1.093-1.508 1.683-2.109 2.335a22.917 22.917 0 00-3.392 4.306c-.572 1.064-1 2.9-1 6.11 0-1.064-3.836-3.228-4.474-7.374a11.575 11.575 0 014.654-10.907z"
        fill="#402a22"
      />
      <path
        data-name="Path 5691"
        d="M166.511 13.781s-2.036-2.765-2.965-.885.914 4.689 2.138 4.437.827-3.552.827-3.552z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5692"
        d="M177.787 12.513a1.876 1.876 0 00-2.55-.55.107.107 0 01-.146-.066l-.135-.324a.159.159 0 01.077-.2 2.248 2.248 0 012.947.958.148.148 0 01.019.106c-.022.12-.15.168-.212.076z"
        fill="#402a22"
      />
      <path
        data-name="Path 5693"
        d="M168.366 12.105a2.566 2.566 0 013.126-.124.142.142 0 00.185-.04l.223-.3a.146.146 0 00-.048-.215 3.089 3.089 0 00-3.679.459.151.151 0 00-.044.1.144.144 0 00.237.109z"
        fill="#402a22"
      />
      <g data-name="Group 5518">
        <path
          data-name="Path 5694"
          d="M168.8 8.557s2.82-3.9 4.463-4.408c0 0-3.06-.011-4.463 1.592 0 0 2.259-2.966 4.193-2.736.179.765.361 1.5.539 2.328 0 0-1.792-.448-4.732 3.228z"
          fill="#c7785c"
          opacity={0.2}
        />
      </g>
      <g data-name="Group 5519">
        <path
          data-name="Path 5695"
          d="M167.116 3.026a6.153 6.153 0 015.305-1.443c.1.044.2.08.269.1.1.437.19.853.288 1.261a7.11 7.11 0 00-5.862.082z"
          fill="#c7785c"
          opacity={0.2}
        />
      </g>
      <g data-name="Group 5520">
        <path
          data-name="Path 5696"
          d="M163.954 16.011a5 5 0 011.228 1.323s2.885 5.075 7.428 4.674a6.963 6.963 0 004.416-2.583 5.558 5.558 0 01-2.419 2.947c-2.656 1.472-5.735-.087-6.157-.3-2.7-1.366-3.862-4-4.5-6.062z"
          fill="#ba937f"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5697"
        d="M175.711 14.426a.852.852 0 00.6 1.035c.4.044.779-.346.849-.871.165-1.257-1.281-1.425-1.449-.164z"
        fill="#402a22"
      />
      <path
        data-name="Path 5698"
        d="M176.393 13.748c.273.044.736-.266.838-1.057.1.849-.31 1.341-.78 1.446l-.058-.394z"
        fill="#402a22"
      />
      <path
        data-name="Path 5699"
        d="M176.247 13.8a1.312 1.312 0 00.222-1.4 1.508 1.508 0 01.292.958 1.536 1.536 0 01-.182.656z"
        fill="#402a22"
      />
      <path
        data-name="Path 5700"
        d="M175.948 13.93a1.3 1.3 0 00-.2-1.4 1.51 1.51 0 01.583 1.512z"
        fill="#402a22"
      />
      <path
        data-name="Path 5701"
        d="M170.071 14.189a.85.85 0 00.6 1.035c.4.047.78-.346.849-.871.164-1.253-1.282-1.424-1.449-.164z"
        fill="#402a22"
      />
      <path
        data-name="Path 5702"
        d="M170.748 13.508c.284.044.736-.266.838-1.057.1.856-.317 1.344-.78 1.446l-.058-.393z"
        fill="#402a22"
      />
      <path
        data-name="Path 5703"
        d="M170.6 13.562a1.31 1.31 0 00.222-1.4 1.515 1.515 0 01.291.958 1.543 1.543 0 01-.182.656z"
        fill="#402a22"
      />
      <path
        data-name="Path 5704"
        d="M170.308 13.69a1.31 1.31 0 00-.2-1.4 1.514 1.514 0 01.582 1.512z"
        fill="#402a22"
      />
      <path
        data-name="Path 5705"
        d="M191.9 16.9c.379-.08.434-1.3.128-2.714s-.864-2.5-1.239-2.419-.434 1.3-.128 2.714.865 2.502 1.239 2.419z"
        fill="#92d9f4"
      />
      <path
        data-name="Path 5706"
        d="M181.351 13.821a32.562 32.562 0 019.436-2.047l1.114 5.133a32.917 32.917 0 01-9.436 2.048z"
        fill="#92d9f4"
      />
      <path
        data-name="Path 5707"
        d="M182.469 18.976c.378-.08.433-1.3.127-2.714s-.863-2.5-1.239-2.419-.433 1.3-.127 2.714.863 2.499 1.239 2.419z"
        fill="#6b497e"
      />
      <path
        data-name="Path 5708"
        d="M177.255 14.732s2.587.842 4.1-.889l1.114 5.133a3.553 3.553 0 00-4.1.889z"
        fill="#356b62"
      />
      <g data-name="Group 5521">
        <path
          data-name="Path 5709"
          d="M191.9 16.9a33.032 33.032 0 01-9.367 2.044.275.275 0 01-.065.029.342.342 0 01-.285-.117 3.624 3.624 0 00-3.814 1.009l-.164-.747c.138-.062.3-.124.477-.189a4.827 4.827 0 013.1-.674c2.995.761 8.981-1.144 10.154-1.366a.144.144 0 01-.037.011z"
          fill="#9b9b9b"
          opacity={0.3}
        />
      </g>
      <g data-name="Group 5522">
        <path
          data-name="Path 5710"
          d="M177.4 14.772a4.114 4.114 0 003.749-.718.317.317 0 01.2-.211v-.026a32.478 32.478 0 019.433-2.047c-.011 0-6.992.885-9.3 2.681s-3.891.794-3.891.794a4.889 4.889 0 01-.193-.474z"
          fill="#9b9b9b"
          opacity={0.3}
        />
      </g>
      <path
        data-name="Path 5711"
        d="M178.366 19.84c.379-.08.434-1.3.128-2.714s-.864-2.5-1.239-2.419-.434 1.3-.128 2.714.864 2.499 1.239 2.419z"
        fill="#92d9f4"
      />
      <path
        data-name="Path 5712"
        d="M176.345 14.907a1.132 1.132 0 011.045-.175c.489.146 1.053 5.068 1.053 5.068a1 1 0 01-.983.241c-.594-.183-1.115-5.134-1.115-5.134z"
        fill="#92d9f4"
      />
      <path
        data-name="Path 5713"
        d="M177.46 20.036c.379-.08.433-1.3.127-2.714s-.863-2.5-1.238-2.419c-.886.193.2 5.33 1.114 5.133z"
        fill="#6b497e"
      />
      <path
        data-name="Path 5714"
        d="M175.834 20.131c.343-.073.39-1.173.113-2.452-.667-3.075-1.9-2.813-1.235.27.277 1.279.78 2.259 1.119 2.182z"
        fill="#6b497e"
      />
      <path
        data-name="Path 5715"
        d="M174.825 15.5a5.053 5.053 0 011.519-.59c.908-.2 1.115 5.133 1.115 5.133a3.716 3.716 0 01-1.628.095c-.926-.146-1.006-4.634-1.006-4.634z"
        fill="#356b62"
      />
      <path
        data-name="Path 5716"
        d="M175.219 18.073L174 19.333l.178.827a2.244 2.244 0 001.975-.211 4.634 4.634 0 01-.934-1.876z"
        fill="#356b62"
      />
      <g data-name="Group 5523">
        <path
          data-name="Path 5717"
          d="M175.831 19.5c.441-.419.841.452 1.33 0s.083-3.574-.817-4.594a.244.244 0 01.212.058 4.621 4.621 0 011.031 2.361c.306 1.417.251 2.634-.128 2.714a3.716 3.716 0 01-1.628.095.135.135 0 01-.062-.018 2.46 2.46 0 01-1.213.153l.018-.208a2.823 2.823 0 001.253-.557z"
          fill="#9b9b9b"
          opacity={0.3}
        />
      </g>
      <path
        data-name="Path 5718"
        d="M175.35 19.195a7.143 7.143 0 011.107 1.585c.186.364-.091.521-.379.215a9.151 9.151 0 01-1.093-1.556c-.229-.383.059-.579.365-.248z"
        fill="#c4b6cb"
      />
      <path
        data-name="Path 5719"
        d="M174.825 15.5a2.421 2.421 0 00-.543 2.372 2.549 2.549 0 01.776-1.3c.664-.62-.233-1.072-.233-1.072z"
        fill="#6b497e"
      />
      <g data-name="Group 5524">
        <path
          data-name="Path 5720"
          d="M174.363 18.958l.477-.5a8.366 8.366 0 01-.262-1.3 2.178 2.178 0 00-.295.707 2.587 2.587 0 01.011-1.465c.248-.328.626-.721.925-.561.492.262.117 1.494 0 2.23a1.1 1.1 0 01-.765.9.691.691 0 01-.091-.011z"
          fill="#9b9b9b"
          opacity={0.3}
        />
      </g>
      <path
        data-name="Path 5721"
        d="M175.529 19.537s-.94-1.425-.569-2.284.226-2.186-.342-1.832-1.039 1.647.594 4.346z"
        fill="#c4b6cb"
      />
      <path
        data-name="Path 5722"
        d="M175.521 19.614a3.817 3.817 0 01.59.845c.1.193-.047.277-.2.113a4.892 4.892 0 01-.583-.827c-.12-.204.029-.31.193-.131z"
        fill="#938998"
      />
      <path
        data-name="Path 5723"
        d="M181.351 13.821s.138-.058.4-.153a7.275 7.275 0 01.918.353 2.092 2.092 0 00.674.226 3.608 3.608 0 00.7-.026 2.74 2.74 0 011.028.284 5.774 5.774 0 001.566.3c.6.047.678-.029 1.534.036a5.5 5.5 0 01.816.113 2.873 2.873 0 01.98.372c.4.259.354.423.747.638a2.195 2.195 0 00.71.226 3.154 3.154 0 00.787.025c-.036.4-.142.652-.306.689a32.921 32.921 0 01-9.436 2.048l-1.114-5.133z"
        fill="#ace5fb"
      />
      <path
        data-name="Path 5724"
        d="M186.626 18.769c-.459-.273-1.45-.408-1.9-1.177s-1.188-1.945-.63-2.066 1.377 1.195 1.978 1.621 3.122-.463 3.239 1.3-2.687.322-2.687.322z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5725"
        d="M183.456 12.6a.635.635 0 00-.131.783c.117.222.295.474.5.466.36-.011 1.2-.419.466-1.151-.372-.367-.649-.279-.835-.098z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5726"
        d="M184.772 12.047a.635.635 0 00-.328.721c.058.244.164.532.361.579.353.084 1.271-.095.746-.991-.262-.448-.553-.434-.779-.306z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5727"
        d="M186.4 11.781a.633.633 0 00-.427.667c.022.251.088.55.274.623.335.131 1.271.084.878-.878-.2-.481-.489-.506-.729-.415z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5728"
        d="M187.89 11.61a.514.514 0 00-.459.444c-.03.2-.033.448.1.539.24.164.983.3.852-.525-.064-.414-.283-.487-.493-.458z"
        fill="#fab38b"
      />
      <g data-name="Group 5525">
        <path
          data-name="Path 5729"
          d="M165.6 14.616s-.7 1.709-1.075.929-.208-2 .27-2.058.805 1.129.805 1.129z"
          fill="#ba937f"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5730"
        d="M250.268 245.126c-1.745.193-34.134 1.68-19.448 11.859s61.174 2.514 61.4-4.321-12.628-10.755-41.949-7.538z"
        fill="rgba(229,225,252,0.24)"
      />
      <path
        data-name="Path 5731"
        d="M251.158 241.534a17.452 17.452 0 00.8 3.345c.456 1.315.758 1.672.645 2.138-.186.776-1.468 1.636-6.55 1.848a15.466 15.466 0 00.739-2.205 16.346 16.346 0 00.011-7.774l4.35 2.652z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5732"
        d="M256.2 251.229a4.31 4.31 0 01.481 1.923c-.014 1.031-4.507 2.478-6.62 1.042 0 0-4.284 4.1-11.428 1.975a2.026 2.026 0 01-1.458-1.756.964.964 0 01.2-.762c.586-.615 18.824-2.426 18.824-2.426z"
        fill="#ece3ea"
      />
      <path
        data-name="Path 5733"
        d="M238.636 256.169c6.317 1.876 10.4-1.111 11.257-1.825a.318.318 0 01.361-.029c2.051 1.158 5.909 0 6.379-.977a2.659 2.659 0 01.018.39c-.011 1.031-4.426 2.463-6.514 1.024 0 0-4.208 4.08-11.243 1.938a2.05 2.05 0 01-1.33-1.257 2.069 2.069 0 001.064.736z"
        fill="#424866"
      />
      <path
        data-name="Path 5734"
        d="M256.1 252.231a1.923 1.923 0 01-1.312.9 13.126 13.126 0 01-4.386.532s-.19.069-2.215 1.319-8.649 1.5-10.376-.365a1.491 1.491 0 01-.128-1.089 1.626 1.626 0 01.74-.867c2.077-1.326 4.492-1.392 5.294-2.882a11.126 11.126 0 00.918-1.956 1.122 1.122 0 01.444-.74.927.927 0 01.649-.069c1.176.226 1.876 1.034 2.954 1.2a4.317 4.317 0 002.026-.342 6.32 6.32 0 001.894-.857c.463-.32.492-.451.722-.47.779-.069 1.494 1.341 1.869 2.081a11.961 11.961 0 01.725 2.087c.28.962.295 1.246.178 1.516z"
        fill="#6a787e"
      />
      <path
        data-name="Path 5735"
        d="M241.528 253.589c.481 1.272 4.154-.258 5.188-1.348A6.64 6.64 0 00248 249l6.237-1.939a8.108 8.108 0 01.954 1.56 11.8 11.8 0 01.725 2.087c.281.962.3 1.246.179 1.516a1.914 1.914 0 01-1.312.9 13.073 13.073 0 01-4.386.532s-.189.069-2.215 1.319-8.649 1.505-10.376-.364a1.5 1.5 0 01-.128-1.09 1.63 1.63 0 01.74-.867 8.739 8.739 0 011.242-.652 2.779 2.779 0 011.862 1.585z"
        fill="#505a5f"
      />
      <g data-name="Group 5526">
        <path
          data-name="Path 5736"
          d="M237.812 254.617a1.487 1.487 0 01-.128-1.089 1.622 1.622 0 01.74-.867s-1.49 1.854 1.76 2.153 7.807-.521 9.4-2.536c0 0 4.022 1.949 6.386-1.37.226.809.234 1.071.124 1.326a1.916 1.916 0 01-1.311.9 13.117 13.117 0 01-4.387.531s-.189.07-2.215 1.319-8.649 1.5-10.376-.364z"
          fill="#e1e1df"
          opacity={0.3}
        />
      </g>
      <g data-name="Group 5527">
        <path
          data-name="Path 5737"
          d="M247.321 247.68s-.576 1.5-3.6 2.1c-.003-.001 2.471.993 3.6-2.1z"
          fill="#e1e1df"
        />
      </g>
      <path
        data-name="Path 5738"
        d="M243.408 249.586l1.34 1.06-.284.43-1.337-1.14a.224.224 0 01.284-.346z"
        fill="#ebebea"
      />
      <path
        data-name="Path 5739"
        d="M242.494 250.271l1.34 1.06-.284.43-1.337-1.141a.224.224 0 01.284-.346z"
        fill="#ebebea"
      />
      <path
        data-name="Path 5740"
        d="M246.968 248.449a4.7 4.7 0 00.306-.794 3.3 3.3 0 003.432.222 6.315 6.315 0 001.894-.856c.463-.321.492-.452.722-.47.451-.04.878.415 1.235.947-1 .743-4.569 3.086-7.589.955z"
        fill="#ebebea"
      />
      <path
        data-name="Path 5741"
        d="M275.225 241.505a17.346 17.346 0 00.765 3.352c.441 1.319.739 1.683.623 2.146-.2.772-1.487 1.617-6.569 1.77a15.576 15.576 0 00.765-2.2 16.358 16.358 0 00.1-7.774q2.158 1.35 4.321 2.7z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5742"
        d="M280.161 251.254a4.338 4.338 0 01.459 1.931c-.025 1.031-4.532 2.426-6.631.969 0 0-4.331 4.044-11.45 1.843a2.026 2.026 0 01-1.439-1.774.953.953 0 01.207-.758c.594-.608 18.85-2.211 18.85-2.211z"
        fill="#ece3ea"
      />
      <path
        data-name="Path 5743"
        d="M262.539 256a12.09 12.09 0 0011.279-1.7.318.318 0 01.361-.025c2.037 1.18 5.909.062 6.39-.9a3.368 3.368 0 01.015.39c-.022 1.031-4.456 2.415-6.525.951 0 0-4.252 4.033-11.261 1.814a2.045 2.045 0 01-1.316-1.271 2.053 2.053 0 001.057.746z"
        fill="#424866"
      />
      <path
        data-name="Path 5744"
        d="M280.044 252.256a1.91 1.91 0 01-1.322.882 13.009 13.009 0 01-4.39.481s-.19.065-2.23 1.3-8.663 1.41-10.372-.481a1.491 1.491 0 01-.113-1.09 1.644 1.644 0 01.75-.859c2.092-1.3 4.511-1.341 5.327-2.82a11.414 11.414 0 00.94-1.946 1.114 1.114 0 01.452-.736.933.933 0 01.648-.062c1.177.237 1.862 1.053 2.94 1.235a4.266 4.266 0 002.029-.32 6.309 6.309 0 001.906-.834c.466-.317.5-.445.725-.463.78-.058 1.479 1.359 1.843 2.1a12 12 0 01.7 2.1c.269.965.28 1.249.164 1.519z"
        fill="#6a787e"
      />
      <path
        data-name="Path 5745"
        d="M265.46 253.451c.467 1.279 4.154-.211 5.2-1.289a6.671 6.671 0 001.319-3.225l6.259-1.869a8.081 8.081 0 01.936 1.571 12.038 12.038 0 01.7 2.1c.269.966.28 1.25.164 1.519a1.909 1.909 0 01-1.323.882 13.024 13.024 0 01-4.39.481s-.189.065-2.23 1.3-8.663 1.41-10.372-.481a1.487 1.487 0 01-.113-1.089 1.64 1.64 0 01.751-.86 9.031 9.031 0 011.249-.638 2.787 2.787 0 011.844 1.607z"
        fill="#505a5f"
      />
      <g data-name="Group 5528">
        <path
          data-name="Path 5746"
          d="M261.734 254.435a1.487 1.487 0 01-.113-1.089 1.643 1.643 0 01.75-.86s-1.508 1.84 1.735 2.171 7.811-.43 9.428-2.43c0 0 4 2 6.4-1.3.219.813.219 1.075.11 1.326a1.909 1.909 0 01-1.323.882 13.024 13.024 0 01-4.39.481s-.189.065-2.23 1.3-8.663 1.41-10.372-.481z"
          fill="#e1e1df"
          opacity={0.3}
        />
      </g>
      <g data-name="Group 5529">
        <path
          data-name="Path 5747"
          d="M271.319 247.6s-.59 1.494-3.625 2.058c0 .004 2.459 1.025 3.625-2.058z"
          fill="#e1e1df"
        />
      </g>
      <path
        data-name="Path 5748"
        d="M267.385 249.465l1.326 1.075-.292.426-1.326-1.158a.225.225 0 01.288-.346z"
        fill="#ebebea"
      />
      <path
        data-name="Path 5749"
        d="M266.463 250.143l1.326 1.075-.291.426-1.326-1.159a.225.225 0 01.287-.346z"
        fill="#ebebea"
      />
      <path
        data-name="Path 5750"
        d="M270.958 248.372a4.572 4.572 0 00.317-.79 3.3 3.3 0 003.432.259 6.274 6.274 0 001.9-.835c.467-.317.5-.444.725-.462.452-.037.875.426 1.224.961-1 .733-4.605 3.035-7.6.867z"
        fill="#ebebea"
      />
      <path
        data-name="Path 5751"
        d="M252.549 127.611c.171.612-.725 1.417-.663 2.382a4.866 4.866 0 01-.937 4.89 24.3 24.3 0 01-6.28 5.093c-11.2 5.8-14.664 5.348-16.125 4.969a2.662 2.662 0 01-1.534-.918c-1.556-2.088 1.348-6.642 2.018-7.687a13.266 13.266 0 011.818-2.3 10.067 10.067 0 013.516-2.426 8.038 8.038 0 014-.6 7.731 7.731 0 013.152 1.093 8.742 8.742 0 014-4.609c3-1.526 6.754-.878 7.031.121z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5752"
        d="M250.246 126.037s-6.113-.292-9.7 3.457a19.482 19.482 0 00-7.29 2.645 26.446 26.446 0 013.053 11.618l7.017-2.4s7.57-8.9 7.927-8.9-1.009-6.427-1.009-6.427z"
        fill="#60bcad"
      />
      <g data-name="Group 5530">
        <path
          data-name="Path 5753"
          d="M243.328 141.356s.433-.51 1.1-1.289l-2.142-4.689-1.618 4.929-2.787-6c1.213 3.057 0 7.006 0 7.006-1.213-8-4.623-9.174-4.623-9.174a26.448 26.448 0 013.053 11.619l7.017-2.4z"
          fill="#917e85"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5754"
        d="M234.431 141.99a110.927 110.927 0 01-9-25.258l-3.829.645s2.226 16.179 2.838 19.444a29.568 29.568 0 002.051 6.073 3.872 3.872 0 001.319 1.588l.776.54z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5755"
        d="M232.216 114.964l.03-3.679a1.635 1.635 0 00-.809-1.425l-3.174-1.86a1.64 1.64 0 00-1.635-.015l-3.2 1.815a1.631 1.631 0 00-.83 1.41l-.03 3.679a1.635 1.635 0 00.809 1.425l3.174 1.865a1.638 1.638 0 001.635.015l3.2-1.815a1.63 1.63 0 00.83-1.415z"
        fill="#606376"
      />
      <path
        data-name="Path 5756"
        d="M231.837 115.176l.03-3.68a1.635 1.635 0 00-.809-1.424l-3.173-1.866a1.64 1.64 0 00-1.636-.014l-3.2 1.814a1.631 1.631 0 00-.83 1.41l-.029 3.68a1.632 1.632 0 00.808 1.424l3.174 1.866a1.638 1.638 0 001.635.014l3.2-1.814a1.631 1.631 0 00.83-1.41z"
        fill="#383c54"
      />
      <path
        data-name="Path 5757"
        d="M222.929 119.235a6.617 6.617 0 01-.6-4.667c.641-2.379 2.881-4.562 4.146-4.135 1.289.433 1.712 3.625.757 5.92a6.023 6.023 0 01-1.129 1.756z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5758"
        d="M226.518 112.3a1.086 1.086 0 101.487-.386 1.088 1.088 0 00-1.487.386z"
        fill="#888a98"
      />
      <path
        data-name="Path 5759"
        d="M227.214 111.824l-5.534 1.713.561 2.109 5.308-1.705z"
        fill="#888a98"
      />
      <path
        data-name="Path 5760"
        d="M226.479 110.436s2.6 1.443 2.859 2.051-1.176 2.973-1.388 2.969-.75.226-.608-.5.7-1.64.663-1.778-1.734-1.137-1.851-1.3.328-1.439.328-1.439z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5761"
        d="M226.479 110.436s2.6 1.443 2.859 2.051-1.176 2.973-1.388 2.969-.75.226-.608-.5.7-1.64.663-1.778-1.734-1.137-1.851-1.3.328-1.439.328-1.439z"
        fill="#fab38b"
      />
      <g data-name="Group 5531">
        <path
          data-name="Path 5762"
          d="M228.773 112.742c.3.405-.12 1.388-.612 2.146-.306.47-.237.539-.138.521a.152.152 0 01-.073.044 1.411 1.411 0 01-.467.011l.565-1.057-.295-.6a2.455 2.455 0 00.251-.638 4.982 4.982 0 00-.878-.63l-.63-1.271a13.755 13.755 0 012.277 1.474z"
          fill="#ba937f"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5763"
        d="M225.789 110.862s2.6 1.443 2.86 2.051-1.177 2.973-1.388 2.97-.594.12-.608-.5c-.019-.74.7-1.64.663-1.778s-1.735-1.137-1.851-1.3.328-1.439.328-1.439z"
        fill="#fab38b"
      />
      <g data-name="Group 5532">
        <path
          data-name="Path 5764"
          d="M225.644 112.451l.182-.776a4.9 4.9 0 011.88 1.1c.6.7-.365 1.85-.729 2.524-.266.489 0 .572.168.58-.212.011-.489.018-.5-.507-.018-.739.7-1.639.664-1.778a18.836 18.836 0 00-1.665-1.151z"
          fill="#ba937f"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5765"
        d="M224.7 111.015s2.594 1.45 2.874 2.022-1.016 2.7-1.22 2.685-.722.175-.616-.492.608-1.486.568-1.614-1.738-1.129-1.861-1.286.255-1.315.255-1.315z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5766"
        d="M227.652 116.32l.029-3.76a1.674 1.674 0 00-.824-1.453l-3.242-1.906a1.67 1.67 0 00-1.672-.014l-3.272 1.854a1.678 1.678 0 00-.849 1.443l-.029 3.76a1.673 1.673 0 00.823 1.453l3.243 1.906a1.673 1.673 0 001.672.014l3.272-1.854a1.68 1.68 0 00.849-1.443z"
        fill="#888a98"
      />
      <path
        data-name="Path 5767"
        d="M227.141 116.615l.029-3.76a1.685 1.685 0 00-.823-1.457l-3.243-1.905a1.67 1.67 0 00-1.672-.015l-3.272 1.854a1.682 1.682 0 00-.849 1.443l-.029 3.76a1.676 1.676 0 00.824 1.454l3.242 1.9a1.673 1.673 0 001.672.015l3.272-1.855a1.677 1.677 0 00.849-1.442z"
        fill="#383c54"
      />
      <path
        data-name="Path 5768"
        d="M243.671 168.64s-.157 2.128-.354 4.97c-.51 7.315 8.194 11.02 10.478 12.2 2.084 1.079 10.358 5.637 11.415 1.92 4.313-15.174-3.363-20-3.363-20z"
        fill="#263238"
      />
      <path
        data-name="Path 5769"
        d="M256.451 127.33c.8.277 2.929.612 4.783 1.224a4.855 4.855 0 012.929 2.055 5.247 5.247 0 011.37 3.25c-.477 11.341-3.891 25.724-3.683 33.874a35.14 35.14 0 01-10.576 1.654 36.738 36.738 0 01-7.6-.583c-1.232-9.916-3.858-17.866-4.11-24.373-.178-4.707-1.016-9.137 1.953-12.329 2.168-2.331 9.538-5.49 9.961-4.98a.41.41 0 01.04.1 3.411 3.411 0 00.838 1.188c.473.44 1.439.859 4.095-1.072z"
        fill="#60bcad"
      />
      <g data-name="Group 5533">
        <path
          data-name="Path 5770"
          d="M262.327 137.651s-.258 24.909-2.16 27.547-16.5 3.472-16.5 3.472a.768.768 0 000 .127 36.537 36.537 0 007.6.583 35.045 35.045 0 0010.576-1.654c-.149-5.9 1.6-15.061 2.751-23.972l-2.273-6.107z"
          fill="#917e85"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5771"
        d="M259.515 112.921a7.732 7.732 0 11-6.4-8.872 7.732 7.732 0 016.4 8.872z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5772"
        d="M257.315 118.972a12.466 12.466 0 00-.857 3.581 11.533 11.533 0 001.086 5.192 8.536 8.536 0 01-5.385 2.31s-1.712-.944-2.1-1.272l-.091-4.532s-1.064-16.26 7.345-5.279z"
        fill="#fab38b"
      />
      <g data-name="Group 5534">
        <path
          data-name="Path 5773"
          d="M256.815 120.189l-3.847-1.829-2.987 2.441a29.934 29.934 0 00-.011 3.45l.047 2.485c3.891.539 6.798-6.547 6.798-6.547z"
          fill="#ba937f"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5774"
        d="M259.424 113.489s-2.069 10.416-8.988 11.9a4.626 4.626 0 01-4.987-2.226c-1.206-2.113-2.161-6.066-1.086-13.411a12.2 12.2 0 0115.061 3.746z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5775"
        d="M259.424 113.489s-2.069 10.416-8.988 11.9a4.626 4.626 0 01-4.987-2.226c-1.206-2.113-2.161-6.066-1.086-13.411a12.2 12.2 0 0115.061 3.746z"
        fill="#fab38b"
      />
      <g data-name="Group 5535">
        <path
          data-name="Path 5776"
          d="M250.436 125.384c6.918-1.479 8.988-11.9 8.988-11.9a1.622 1.622 0 01-.051-.062 11.727 11.727 0 00-2.529 4.409c-4.08 10.864-11.4 5.322-11.4 5.322a4.627 4.627 0 004.992 2.231z"
          fill="#ba937f"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5777"
        d="M246.3 114.776c-.095.59-.514 1.009-.933.943s-.685-.6-.59-1.188.514-1.009.933-.943.69.601.59 1.188z"
        fill="#380e13"
      />
      <path
        data-name="Path 5778"
        d="M252.025 114.848c-.044.594-.423 1.053-.849 1.02-1.013-.073-.864-2.23.156-2.153.427.029.736.539.693 1.133z"
        fill="#380e13"
      />
      <path
        data-name="Path 5779"
        d="M247.678 112.95a3.7 3.7 0 01-.386 4.193c-.219.219-.744.612-.736.933 0 .513 1.9.71 2.437.79-2.233.27-3.694-.419-2.3-1.759.475-.463 1.659-1.385.985-4.157z"
        fill="#c7785c"
      />
      <path
        data-name="Path 5780"
        d="M244.814 108.549s1.367-1.06 2-.63 2.667.484 4.445-.1c.317-.106 4.962 1.093 5.588 3.869.354 1.556-.714 2.962.066 3.723a1.674 1.674 0 001.293.346q-.693 2.22-1.388 4.434s3.37-5.221 4.059-6.765-3.155-12.187-11.352-9.105a6.058 6.058 0 00-4.708 4.226z"
        fill="#402a22"
      />
      <path
        data-name="Path 5781"
        d="M256.844 117.092c.342-1.614 1.377-2.535 2.12-2.411.758.127 1.377 1.377 1.159 2.4-.2.936-1.159 1.949-2.092 1.7a1.887 1.887 0 01-1.187-1.69z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5782"
        d="M251.161 111.2a3.646 3.646 0 012.733 1.123c.189.16.233.393.094.5l-.076.058a.418.418 0 01-.456-.044 6.619 6.619 0 00-2.076-.958c-.248-.055-.459-.3-.423-.5a.223.223 0 01.204-.179z"
        fill="#701c25"
      />
      <path
        data-name="Path 5783"
        d="M243.86 111.344a3.778 3.778 0 012.929-.379c.244.043.394.215.324.371l-.04.084a.423.423 0 01-.419.182 6.937 6.937 0 00-2.277.2.52.52 0 01-.612-.211.21.21 0 01.091-.248z"
        fill="#701c25"
      />
      <g data-name="Group 5536">
        <path
          data-name="Path 5784"
          d="M258.039 116.367s.2-.87 1.155-.429-2.16 3.762-1.155.429z"
          fill="#ba937f"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5785"
        d="M247.295 120.215a2.981 2.981 0 003.141-.255.338.338 0 01.5.415c-.437 1.02-1.206 2.251-2.3 1.989a2.568 2.568 0 01-1.8-1.727.336.336 0 01.466-.419z"
        fill="#f0f1f2"
      />
      <g data-name="Group 5537">
        <path
          data-name="Path 5786"
          d="M257.132 118.014a1.528 1.528 0 00.9.769c.929.248 1.887-.765 2.091-1.7a2.429 2.429 0 00-.19-1.49c-.134 3.56-2.058 2.835-2.8 2.419z"
          fill="#ba937f"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5787"
        d="M261.526 130.645a1.448 1.448 0 012.4-.514 159.707 159.707 0 0112.048 13.753c.853 1.155 2.194 3.064 1.574 4.788a3.744 3.744 0 01-3.173 2.255c-1.206.084-2.2-.507-5.614-3.993-2.991-3.061-4.733-5.083-7.523-7.972a165.438 165.438 0 00-2.012-2.043c.9-2.106 1.527-4.187 2.292-6.278z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5788"
        d="M257.7 127.668s5.512-.1 8.172 4.073c0 0 10.161 6.376 11.57 14.642l-6.572 1.833s-5.534-3.7-7.749-8.755-5.425-11.793-5.425-11.793z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5789"
        d="M266.32 162.942a15.194 15.194 0 01-3.049 3.283l-4.226-.211a6.218 6.218 0 00-2.281.142 18.436 18.436 0 00-2.055 1.967c-.1.2.182 1.042 1.527-.007l.885-.641s1.374-.438 1.6-.132-3.588 1.88-3.694 2.336.2.732.71.728 3.491-2.149 3.975-2.04-3.235 2.212-3.465 2.419-.094 1.221.718.86 3.326-2.026 3.326-2.026.306.15.128.383-2.616 2-2.394 2.456 2.2-.751 3.163-1.545c2.382.215 3.2-.044 3.869-.871a1.68 1.68 0 00.164-.244s.032-.058.156-.233a9.412 9.412 0 011.188-1.33 47.046 47.046 0 003.4-3.84l-3.636-1.454z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5790"
        d="M277.655 148.326s1.3 6.871-12.6 21.717a19.59 19.59 0 01-.988-4.5s4.3-4.809 6.777-16.351c2.191-10.197 6.811-.866 6.811-.866z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5791"
        d="M252.134 181.6c1.679 5.13 2.554 17.622 11.884 33.008 0 0 5.7 3.767 5.734.3.106-10.995.74-16.066-3.063-32.235-.467-1.975.331-5.844-1.05-5.421q-6.755 2.175-13.505 4.346z"
        fill="#263238"
      />
      <path
        data-name="Path 5792"
        d="M243.317 173.609s-3.2 26.5 1.191 39.489c0 0 1.993 3.957 6.453.153 0 0 5.883-15.108 2.834-29.335-1.595-7.416-10.478-10.307-10.478-10.307z"
        fill="#263238"
      />
      <g data-name="Group 5539">
        <g data-name="Group 5538" opacity={0.2}>
          <path
            data-name="Path 5793"
            d="M256.76 166.159a18.618 18.618 0 00-2.055 1.968c-.1.2.183 1.042 1.527-.008l.885-.641s1.374-.437 1.6-.131-3.588 1.88-3.694 2.335.2.733.71.729 3.491-2.149 3.975-2.04-3.235 2.211-3.465 2.419-.094 1.22.718.86 3.326-2.026 3.326-2.026.307.15.128.383-2.616 2-2.394 2.455 2.2-.75 3.163-1.545l1.136-1.18c.048-.918-.5-1.14-.5-1.14-.04-.962-.616-1.192-.616-1.192-.106-.794-.634-.8-.634-.8a.843.843 0 00-.182-.521l-1.348-.066a6.24 6.24 0 00-2.281.142z"
            fill="#796b80"
          />
        </g>
      </g>
      <path
        data-name="Path 5794"
        d="M257.544 127.829a40.165 40.165 0 00-5.953 6.055 1.053 1.053 0 01-1.9-.579c0-.073-.007-.146-.007-.223a18.97 18.97 0 01.532-4.86c.379-.422.936-.3 1.73-.652a7.051 7.051 0 015.598.259z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5795"
        d="M246.807 107.919c0 .025.113.065.168.022.313-.237-2.044-2.576-1.53-4.179.44-1.377 2.856-2.008 4.572-2.274a11.218 11.218 0 015.224.43 9.852 9.852 0 013.5 2.124c3.527 3.316 2.591 8.806 1.939 9.768a.249.249 0 01-.139.113c-.892.218-3.231-6.733-3.231-6.733-7.844.379-10.507.6-10.5.725z"
        fill="#402a22"
      />
      <g data-name="Group 5540">
        <path
          data-name="Path 5796"
          d="M256.91 115.409a1.189 1.189 0 00.492.281 3.532 3.532 0 01.284-.379c-.16-.59.146-1.8.149-3.968.008-3.093-3.872-4.831-5.326-4.831a19.529 19.529 0 00-3.807.554c-2.525.554-3.254-3.3-3.254-3.3a3.351 3.351 0 00.627 2.5 6.162 6.162 0 00-1.261 2.288s1.367-1.06 2-.63c0 .011.025.026.055.033a6.83 6.83 0 004.39-.139c.317-.1 4.962 1.093 5.588 3.869.354 1.556-.714 2.962.066 3.724z"
          fill="#402a22"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5797"
        d="M245.543 104.388a4.409 4.409 0 00-1.9 2.182c-.142.376-.681 1.808.058 2.7a1.7 1.7 0 00.656.477s.736-1.861 1.8-1.894a.248.248 0 00.19-.058c.426-.288-.131-1.869-.8-3.407z"
        fill="#402a22"
      />
      <path
        data-name="Path 5798"
        d="M247.517 171.657a.557.557 0 10-.557-.558.558.558 0 00.557.558z"
        fill="#767275"
      />
      <path
        data-name="Path 5799"
        d="M252.031 171.657a.557.557 0 10-.557-.558.557.557 0 00.557.558z"
        fill="#767275"
      />
      <path
        data-name="Path 5800"
        d="M247.533 183.719a.23.23 0 01-.146-.054.368.368 0 01-.077-.448c.008-.011.791-1.629-.036-6.547-.853-5.068-.066-5.782.2-5.88a.26.26 0 01.331.215.351.351 0 01-.142.389c-.051.059-.6.795.135 5.148.882 5.243 0 6.963-.037 7.032a.255.255 0 01-.222.145z"
        fill="#c8c7c8"
      />
      <path
        data-name="Path 5801"
        d="M252.032 181.453a.254.254 0 01-.226-.207 10.63 10.63 0 01-.011-4.474 20.657 20.657 0 000-5.611.335.335 0 01.189-.382c.131-.037.259.076.288.251a21.044 21.044 0 010 5.884 10.137 10.137 0 00-.011 4.1.356.356 0 01-.142.415.187.187 0 01-.087.022z"
        fill="#c8c7c8"
      />
      <path
        data-name="Path 5802"
        d="M265.876 131.5c-4.2-5.468-7.629-4.845-8.9-5.075.124.339.408.886.506 1.152.073.029.15.062.226.094a69.12 69.12 0 00-1.2 1.046l1.492 8.515 9.578 8.576c.819-1.949 1.228-2.871 1.7-4.131 1.045-2.747 1.716-4.926 1.938-5.739-1.625-1.42-2.35-2.16-5.345-4.437z"
        fill="#60bcad"
      />
      <path
        data-name="Path 5803"
        d="M267.72 208.782s.335.295.849.8c1.6 1.574 4.266 5.352 4.484 8.5.292 4.229 3.039 19.629 3.549 27.331a4.477 4.477 0 01-2.5 2.2 4.529 4.529 0 01-3.655-.386c-.757-4.015-1.61-8.092-2.484-12.249-1.785-8.467-5.669-23.156-5.669-23.156l5.425-3.05z"
        fill="#263238"
      />
      <path
        data-name="Path 5804"
        d="M249.926 208.606s.284.347.707.929c1.315 1.811 3.334 5.975 3.035 9.123-.4 4.219-.208 19.863-.962 27.547a4.469 4.469 0 01-2.823 1.759 4.55 4.55 0 01-3.545-.976c-.091-4.084-.266-8.245-.452-12.489-.375-8.646-1.811-23.772-1.811-23.772z"
        fill="#263238"
      />
      <g data-name="Group 5541">
        <path
          data-name="Path 5805"
          d="M273.108 243.979c-.215-3.4-6.711-27.5-9.043-33.758s-10.274-26.3-10.274-26.3a10.29 10.29 0 01-3.191.225c.961.558 1.839 1 2.5 1.33 1.275 5.826 3.114 15.2 9.272 26.312l-.088.047s3.884 14.689 5.669 23.156c.874 4.157 1.727 8.234 2.485 12.249a4.36 4.36 0 006.153-1.811s-3.279 1.957-3.494-1.439z"
          fill="#626b94"
          opacity={0.2}
        />
      </g>
      <g data-name="Group 5542">
        <path
          data-name="Path 5806"
          d="M244.2 212.126c.361 3.942 1.373 15.316 1.679 22.373.186 4.244.361 8.405.452 12.489a4.538 4.538 0 003.545.976 4.485 4.485 0 002.824-1.76c.04-.389.072-.8.109-1.231-.456.368-1.432 1.774-3.13-.485-1.869-2.481.66-27.768-2.564-34.862-3.764-8.281-3.316-27.484-3.443-40.826v-.127c-.019.269-.168 2.295-.35 4.936 0 0-3.049 25.223.885 38.517z"
          fill="#626b94"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5807"
        d="M277.287 145.765a2.434 2.434 0 01.266 3.792c-2.008 2.062-.266-3.792-.266-3.792z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5808"
        d="M109.046 238.616c1.537.211 22.285 5.286 9.738 12.026s-18.639 4.984-29.277 9.666-23.758-1.734-24.7-8.059 19.411-17.018 44.243-13.633z"
        fill="rgba(229,225,252,0.24)"
      />
      <path
        data-name="Path 5809"
        d="M87.825 105.4s-3.7-6.132-8.427-1.4-4.561 26.607 0 35.766l3.483-1.035s-4.682-8.026-3.49-25.429 14.741 3.275 14.741 3.275z"
        fill="#402a22"
      />
      <path
        data-name="Path 5810"
        d="M91.912 129.2c-1.177.211-1.326-1.487-1.971-.222a4.688 4.688 0 00-.368 3.57 23.214 23.214 0 003.727 7.522 88.721 88.721 0 0011.648 12.661 2.851 2.851 0 002.346-1.061c1.075-1.264.1-3.708-3.133-10.23-3.159-6.368-8.136-12.988-12.249-12.245z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5811"
        d="M103.01 139.254c-1.425 1.177-2.849 1.075-4.274 2.252l-11.472-8.165.306-6.164h2.27a8.58 8.58 0 015.847.67c.648.354 1.72 1.068 3.658 4.084a38.741 38.741 0 013.661 7.32z"
        fill="#60bcad"
      />
      <path
        data-name="Path 5812"
        d="M101.629 145.976A134.957 134.957 0 00126.3 133.8c.791 1.053 1.243 1.432 2.033 2.485-14.915 12.346-17.047 14.106-21.473 15.92a3.951 3.951 0 01-2.084.252l-3.14-6.474z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5813"
        d="M123.4 127.8l1.559-2.623a1.36 1.36 0 011.184-.663l3.053.04a1.359 1.359 0 011.166.693l1.494 2.663a1.363 1.363 0 01-.018 1.359l-1.56 2.623a1.358 1.358 0 01-1.184.663l-3.053-.04a1.359 1.359 0 01-1.165-.692l-1.494-2.664a1.36 1.36 0 01.018-1.359z"
        fill="#606376"
      />
      <path
        data-name="Path 5814"
        d="M123.576 128.117l1.559-2.623a1.356 1.356 0 011.184-.663l3.053.04a1.356 1.356 0 011.166.692l1.494 2.663a1.363 1.363 0 01-.019 1.359l-1.559 2.623a1.355 1.355 0 01-1.184.663l-3.053-.04a1.356 1.356 0 01-1.166-.692l-1.494-2.663a1.363 1.363 0 01.019-1.359z"
        fill="#383c54"
      />
      <path
        data-name="Path 5815"
        d="M128.33 136.281a6.321 6.321 0 002.791-3.508c.652-2.255-.1-5.137-1.337-5.414-1.265-.281-3.181 2.109-3.538 4.452a5.7 5.7 0 00.055 1.986l2.033 2.484z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5816"
        d="M128.826 128.864a1.033 1.033 0 11-1.021-1.046 1.034 1.034 0 011.021 1.046z"
        fill="#888a98"
      />
      <path
        data-name="Path 5817"
        d="M128.5 128.131l3.661 4.124-1.494 1.44-3.486-4.008z"
        fill="#888a98"
      />
      <path
        data-name="Path 5818"
        d="M129.784 127.359s-2.827-.106-3.341.259-.507 3.005-.332 3.1.5.553.744-.11.24-1.679.338-1.774 1.975-.073 2.15-.149.441-1.334.441-1.334z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5819"
        d="M129.784 127.359s-2.827-.106-3.341.259-.507 3.005-.332 3.1.5.553.744-.11.24-1.679.338-1.774 1.975-.073 2.15-.149.441-1.334.441-1.334z"
        fill="#fab38b"
      />
      <g data-name="Group 5543">
        <path
          data-name="Path 5820"
          d="M126.774 128.11c-.444.178-.59 1.191-.561 2.051.019.535-.072.553-.142.492a.118.118 0 00.04.072c.1.055.23.208.376.241l.062-1.137.535-.342a2.306 2.306 0 01.109-.642 4.734 4.734 0 011.024-.08l1.14-.725a13.267 13.267 0 00-2.583.073z"
          fill="#ba937f"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5821"
        d="M130.133 128.048s-2.827-.106-3.341.259-.506 3-.335 3.1.426.393.743-.11c.379-.594.241-1.679.339-1.774s1.975-.073 2.15-.149.441-1.334.441-1.334z"
        fill="#fab38b"
      />
      <g data-name="Group 5544">
        <path
          data-name="Path 5822"
          d="M129.467 129.414l.233-.725a4.6 4.6 0 00-2.076-.026c-.842.277-.62 1.687-.653 2.416-.025.528-.284.466-.422.389.167.117.386.255.656-.163.379-.594.24-1.68.338-1.775a17.731 17.731 0 011.928-.116z"
          fill="#ba937f"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5823"
        d="M130.942 128.711s-2.827-.1-3.341.23-.5 2.7-.327 2.79.5.5.743-.094.237-1.509.335-1.6 1.975-.062 2.15-.131.44-1.195.44-1.195z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5824"
        d="M126.672 131.739l1.56-2.624a1.358 1.358 0 011.184-.663l3.053.04a1.36 1.36 0 011.166.693l1.493 2.663a1.36 1.36 0 01-.018 1.359l-1.559 2.623a1.36 1.36 0 01-1.184.663l-3.053-.04a1.358 1.358 0 01-1.166-.692l-1.494-2.664a1.361 1.361 0 01.018-1.358z"
        fill="#888a98"
      />
      <path
        data-name="Path 5825"
        d="M126.9 132.161l1.559-2.623a1.356 1.356 0 011.184-.663l3.053.04a1.356 1.356 0 011.166.692l1.494 2.663a1.363 1.363 0 01-.018 1.359l-1.56 2.623a1.355 1.355 0 01-1.184.663l-3.053-.04a1.357 1.357 0 01-1.166-.692l-1.493-2.663a1.36 1.36 0 01.018-1.359z"
        fill="#383c54"
      />
      <path
        data-name="Path 5826"
        d="M101.067 171.57a89.014 89.014 0 01.055 16.092c-.707 7.148-1.421 5.217-2.07 12-.353 3.687-.4 6.944-2.67 8.336-.3.182-2.237 1.37-3.6.656a1.813 1.813 0 01-.718-.656c-.594-7.3-2.864-14.609-2.809-22.806q.038-5.952.328-11.575c3.228-.517 8.256-1.53 11.487-2.048z"
        fill="#263238"
      />
      <path
        data-name="Path 5827"
        d="M99.06 160.44l-14.58.142a9.579 9.579 0 01-.914 2.743 9.234 9.234 0 01-1.315 1.917l-.015-.051s-4.889 2.973-3.3 12.791c.058.35.12.7.193 1.057a16.787 16.787 0 01.071 4.561c-.168 1.228 1.162 2.041 2.732 2.569a2.363 2.363 0 002.856.677c1.009.164 1.752.226 1.752.226l-.3-1.264a8.7 8.7 0 001.184-1.472l-1.162-4.288a73.239 73.239 0 0011.888-5.027 16.009 16.009 0 002.226-1.432c.55-.43.681-.445.805-.569-.157-4.841-2.124-12.576-2.124-12.576z"
        fill="#263238"
      />
      <path
        data-name="Path 5828"
        d="M92.96 236.722a17.7 17.7 0 01-.434 3.436c-.31 1.366-.572 1.76-.408 2.211.273.754 1.65 1.472 6.758 1.119a16.082 16.082 0 01-.987-2.124 16.5 16.5 0 01-.874-7.779q-2.028 1.569-4.059 3.137z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5829"
        d="M88.985 246.978a4.37 4.37 0 00-.27 1.978c.128 1.028 4.784 1.978 6.74.31 0 0 4.743 3.621 11.651.707a2.037 2.037 0 001.264-1.92.962.962 0 00-.284-.74c-.655-.55-19.101-.335-19.101-.335z"
        fill="#f4eef2"
      />
      <path
        data-name="Path 5830"
        d="M95.642 249.393a.325.325 0 00-.364.011c-1.924 1.384-5.913.652-6.492-.27a2.92 2.92 0 00.025.394c.124 1.027 4.7 1.975 6.631.3 0 0 4.66 3.614 11.462.692a2.054 2.054 0 001.191-1.406c-1.042 1.756-7.927 3.265-12.449.277z"
        fill="#424866"
      />
      <path
        data-name="Path 5831"
        d="M89.2 247.969c.67 1.2 4.452 1 5.858.794 0 0 .2.048 2.361 1.075 2.667 1.264 11.549.175 10.347-2.62a1.675 1.675 0 00-.838-.787c-2.226-1.1-4.649-.892-5.614-2.295a11.107 11.107 0 01-1.133-1.854 1.138 1.138 0 00-.525-.692.95.95 0 00-.656 0c-1.155.357-1.76 1.242-2.824 1.53a4.325 4.325 0 01-2.061-.12 6.356 6.356 0 01-1.993-.648c-.5-.27-.543-.4-.772-.39-.787.018-1.344 1.508-1.64 2.288a11.786 11.786 0 00-.492 2.171c-.175.991-.157 1.279-.011 1.538z"
        fill="#505a5f"
      />
      <path
        data-name="Path 5832"
        d="M97.393 245.961a5.368 5.368 0 01-2.995.722c-1.592-.153-2.372-.955-3.253-.769s-2.055 1.581-2.055 1.581c-.069.408-.029.561.091.707a1.961 1.961 0 001.137.5 2.09 2.09 0 011.26-1.384c5.326 1.231 6.073-.262 6.073-.262a18.863 18.863 0 017.3 2.8l1.038-.208c-2.277-2.208-8.594-3.676-8.594-3.676z"
        fill="#2d2f3f"
      />
      <g data-name="Group 5545">
        <path
          data-name="Path 5833"
          d="M107.766 247.222a1.671 1.671 0 00-.838-.787c2.944 2.94-8.3 3.8-11.21.856 0 0-3.807 2.4-6.54-.659-.138.834-.113 1.1.022 1.341.67 1.194 4.452 1 5.858.794 0 0 .2.047 2.361 1.074 2.667 1.265 11.549.175 10.347-2.619z"
          fill="#e1e1df"
          opacity={0.3}
        />
      </g>
      <g data-name="Group 5546">
        <path
          data-name="Path 5834"
          d="M97.918 242.438s-.022 1.618 2.591 3.3c0 .005-2.682.016-2.591-3.3z"
          fill="#e1e1df"
        />
      </g>
      <path
        data-name="Path 5835"
        d="M101.605 243.914l-1.224 1.209.331.4 1.214-1.29a.23.23 0 00.021-.284.224.224 0 00-.342-.029z"
        fill="#ebebea"
      />
      <path
        data-name="Path 5836"
        d="M102.592 244.5l-1.224 1.21.332.4 1.213-1.29a.23.23 0 00.022-.284.226.226 0 00-.343-.029z"
        fill="#ebebea"
      />
      <path
        data-name="Path 5837"
        d="M103.966 245.051l-1.224 1.209.332.4 1.213-1.289a.232.232 0 00.022-.285.226.226 0 00-.343-.029z"
        fill="#ebebea"
      />
      <path
        data-name="Path 5838"
        d="M97.915 243.174a4.643 4.643 0 01-.4-.761 4.243 4.243 0 01-1.344.718 4.325 4.325 0 01-2.066-.117 6.355 6.355 0 01-1.993-.648c-.5-.27-.543-.4-.772-.39-.455.011-.834.514-1.129 1.086 1.078.633 4.915 2.579 7.7.112z"
        fill="#ebebea"
      />
      <path
        data-name="Path 5839"
        d="M92.509 201.04a21.662 21.662 0 00-3.184 11.272c-.383 9.319 3.862 18.168 2.791 28.869a3.886 3.886 0 002.66.94 5.043 5.043 0 003.126-1.093c-.062-3.91-.4-7.87-.382-11.885.033-9.049.736-17.844 1.137-26.369l-6.146-1.727z"
        fill="#263238"
      />
      <g data-name="Group 5547">
        <path
          data-name="Path 5840"
          d="M96.4 241.1c-.765-.386-.918-1.508-.976-1.941-2.324-17.513-5.217-21.459-3.824-29.426a17.353 17.353 0 011.913-5.473 1.906 1.906 0 00.193-1.41 44.538 44.538 0 01-1.494-9.381 109.112 109.112 0 01.233-14.449c.918-.069 3.261-.368 4.146-1.676 0 0-3.334 1.06-4.288.816a.141.141 0 00-.175.106c-.27 1.159-1.836 8.172-2.689 11.385.39 4.6 1.315 8.966 1.989 13.243a23.383 23.383 0 00-2.106 9.414c-.383 9.32 3.862 18.169 2.791 28.869a3.881 3.881 0 002.66.94 5.037 5.037 0 003.126-1.093 1.8 1.8 0 01-1.5.084z"
          fill="#626b94"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5841"
        d="M92.214 176.459A87.223 87.223 0 0190 192.354c-1.647 6.992-2.1 4.981-3.647 11.626-.838 3.607-1.319 6.831-3.756 7.906-.321.142-2.4 1.06-3.654.171a1.845 1.845 0 01-.627-.743c.382-7.312-.9-14.861.244-22.978.554-3.931 1.02-7.9 1.7-11.586 3.268-.083 8.678-.2 11.95-.287z"
        fill="#263238"
      />
      <path
        data-name="Path 5842"
        d="M74.264 248.475a8.557 8.557 0 001.078-2.171c.572-1.746 3.742-1.534 6.175.87.616 1.257 1.22 2.561 1.84 3.891.933 2 1.895 4.124 2.007 4.594 1.366 3-2.893 5.33-7.338 2.124-1.545-1.114-1.41-2.229-3.6-7.188a7.022 7.022 0 01-.168-2.116z"
        fill="#505a5f"
      />
      <path
        data-name="Path 5843"
        d="M74.265 248.475s1.639-1.876 2.058-1.538-.124 3.159 1.461 4.208a29.984 29.984 0 01.831 6.07l-.557-.415s-.587-4.86-1.053-5.655a5.218 5.218 0 01-1.068-2.943.284.284 0 00-.5-.186l-1.173 1.319v-.864z"
        fill="#2d2f3f"
      />
      <g data-name="Group 5548">
        <path
          data-name="Path 5844"
          d="M80.272 244.114a5.416 5.416 0 011.067.514 12.846 12.846 0 00.058 1.752 25.005 25.005 0 001.5 5.607c.084.306.219.8.3 1.108.262 1.942-.885 2.16-2.638.67-1.959-1.665-2.159-7.887-2.159-7.887l1.876-1.756z"
          fill="#e1e1df"
        />
      </g>
      <path
        data-name="Path 5845"
        d="M77.438 256.126a6.1 6.1 0 005.246 2.043 6.16 6.16 0 002.9-1.246 2.338 2.338 0 01.12 1.09c-.273 1.147-2.652 1.73-4.481 1.461a6.669 6.669 0 01-3.37-1.672c-2.073-1.76-1.84-2.74-2.678-4.219-.67-1.184-2.048-1.906-.911-5.112a5.492 5.492 0 00.492 2.765 10.078 10.078 0 001.093 1.563c1.18 1.658.82 2.274 1.585 3.323z"
        fill="#f4eef2"
      />
      <path
        data-name="Path 5846"
        d="M74.264 248.475a.323.323 0 01-.015.04v.138a1.408 1.408 0 01.015-.178z"
        fill="#262222"
      />
      <path
        data-name="Path 5847"
        d="M85.7 257.5c-.273 1.148-2.652 1.73-4.481 1.461a6.669 6.669 0 01-3.37-1.672c-2.073-1.76-1.843-2.744-2.678-4.219-.488-.86-.736-.98-.991-1.461a2.983 2.983 0 01-.335-1.246c-.1 1.73.7 2.1 1.326 3.22.831 1.469.6 2.456 2.678 4.219a6.66 6.66 0 003.37 1.673c1.829.269 4.212-.31 4.481-1.461a1.673 1.673 0 000-.543.06.06 0 010 .025z"
        fill="#424866"
      />
      <path
        data-name="Path 5848"
        d="M76.382 244.916l-.379-5.4 4.951-.346-.226 6.1c-.827.6-2.368 1.2-4.346-.35z"
        fill="#ffa78a"
      />
      <path
        data-name="Path 5849"
        d="M80.684 244.092a1.667 1.667 0 01.044.583c-.033.335-.149.477-.073.561a13.068 13.068 0 01.78 1.421l-.033-.281s.6-2.328-.714-2.288z"
        fill="#ebebea"
      />
      <path
        data-name="Path 5850"
        d="M76.315 243.972a2.656 2.656 0 00-.627 1.527c.055.714 1.148 1.526 2.922 1.158s-.215-.787-.215-.787-2.24-.619-2.08-1.898z"
        fill="#ebebea"
      />
      <path
        data-name="Path 5851"
        d="M82.182 250.169a13.757 13.757 0 01-.069-3.417c.1-.878-.091-1.928-1.625-1.735a2.6 2.6 0 00-1.7.678c-.4.459-.485 1.016-.106 2.634 0 0 .878 3.76 2.762 5.476.608.554.958.532 1.075.51a.3.3 0 00.058-.011.574.574 0 00.4-.689q-.398-1.72-.795-3.446z"
        fill="#d6ccd5"
      />
      <path
        data-name="Path 5852"
        d="M78.61 249.5h.04l3.41-.518a.2.2 0 00.16-.229.183.183 0 00-.2-.175l-3.41.517a.206.206 0 00-.16.23.191.191 0 00.164.178z"
        fill="#e8eff3"
      />
      <path
        data-name="Path 5853"
        d="M78.936 250.759h.04l3.563-.565a.206.206 0 00.16-.233.186.186 0 00-.2-.175l-3.563.565a.207.207 0 00-.16.233.187.187 0 00.16.175z"
        fill="#e8eff3"
      />
      <path
        data-name="Path 5854"
        d="M79.4 252.2h.044l3.374-.641a.205.205 0 00.153-.237.181.181 0 00-.208-.167l-3.374.641a.205.205 0 00-.153.237.194.194 0 00.164.171z"
        fill="#e8eff3"
      />
      <path
        data-name="Path 5855"
        d="M79.675 204.538s-.321.36-.8.976a19.143 19.143 0 00-3.57 9.8c-.022 4.634 1.443 20.472.066 28.224a3.856 3.856 0 001.741 1.235 4.229 4.229 0 002.5 0 5.479 5.479 0 001.669-.728 174.582 174.582 0 011.195-18.522 127.967 127.967 0 012.845-18.34q-2.82-1.323-5.643-2.645z"
        fill="#263238"
      />
      <g data-name="Group 5549">
        <path
          data-name="Path 5856"
          d="M82.236 165.194s-4.889 2.973-3.3 12.791c.058.35.12.7.193 1.057a16.8 16.8 0 01.071 4.558c-.215 1.571-.423 3.155-.645 4.733-.878 6.248-.324 12.161-.193 17.885a19.161 19.161 0 00-3.062 9.092c-.022 4.634 1.443 20.471.066 28.224 2.791-11.134 1.2-21.24 1.075-26.635s3.581-10.792 3.581-10.792-1.945-9.618-.237-17.593 1.3-8.678 1.3-8.678c-2.284-8.678 1.235-14.649 1.235-14.649a.217.217 0 00-.065.051l-.015-.051z"
          fill="#626b94"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5857"
        d="M91.11 125.975a178.226 178.226 0 005.509 5.17c2.182 1.956 2.824 2.433 3.672 3.672a10.508 10.508 0 012.153 6.336c-.072 1.562-.557 1.69-1.391 4.94 0 0-.478 1.861-.886 4.561a66.7 66.7 0 00-.083 14.391 17.8 17.8 0 01-17.768.149c1.5-7.7 1.741-13.472.776-17.3-1.811-7.155-5.141-10.919-3.549-15.258.834-2.273 2.036-4.671 7.388-6.412l4.186-.248z"
        fill="#60bcad"
      />
      <path
        data-name="Path 5858"
        d="M94.039 140c4.332-.926 5.7-3.326 2.044-9.341-1.217-1.1-2.8-2.565-4.627-4.347L88.9 126.1l-.627.036a14.231 14.231 0 00-3.5.984c.996 3.012 4.884 13.814 9.266 12.88z"
        fill="#60bcad"
      />
      <path
        data-name="Path 5859"
        d="M86.542 120.539s-.656 5.046-1.206 6.944c0 0 3.549 2.525 6.576 1.716 0 0-.146-5.049-.131-6.208s-5.239-2.452-5.239-2.452z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5860"
        d="M85.336 127.483s5.323 10.1 8.624 7.822-2.845-9.458-2.845-9.458z"
        fill="#fab38b"
      />
      <g data-name="Group 5550">
        <path
          data-name="Path 5861"
          d="M86.542 120.539a9.185 9.185 0 005.323 6.948c-.022-.871-.047-1.931-.066-2.827-2.375-2.011-5.257-4.121-5.257-4.121z"
          fill="#ba937f"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5862"
        d="M99.169 112.761a7.378 7.378 0 00-14.682 1.439 14.623 14.623 0 003.027 8.871 7.812 7.812 0 003.6 2.784 6.806 6.806 0 005.829-.663 6.369 6.369 0 002.266-3.072 8.7 8.7 0 00.357-4.12 26.529 26.529 0 01-.463-3.756 14.523 14.523 0 01.069-1.476z"
        fill="#fab38b"
      />
      <g data-name="Group 5551">
        <path
          data-name="Path 5863"
          d="M99.206 122.113a8.7 8.7 0 00.357-4.121 6.787 6.787 0 01-3.192 6.442 6.517 6.517 0 01-5.275.083c-4.4-1.679-6.281-7.279-6.2-6.925a13.434 13.434 0 002.612 5.472 7.8 7.8 0 003.6 2.783 6.8 6.8 0 005.829-.663 6.363 6.363 0 002.269-3.071z"
          fill="#ba937f"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5864"
        d="M96.966 116.338c.055.572.448 1 .878.944a.961.961 0 00.685-1.122c-.129-1.366-1.694-1.192-1.563.178z"
        fill="#402a22"
      />
      <path
        data-name="Path 5865"
        d="M97.517 115.457a.866.866 0 00.561-.547l.015-.036a.162.162 0 01.007-.018v-.019a1.663 1.663 0 00.047-.695 1.335 1.335 0 01-.364 1.65c-.044.029-.066.044-.08.051s-.182-.386-.182-.386z"
        fill="#402a22"
      />
      <path
        data-name="Path 5866"
        d="M97.378 115.544a1.413 1.413 0 00-.106-1.526 1.629 1.629 0 01.506 1.675l-.4-.153z"
        fill="#402a22"
      />
      <path
        data-name="Path 5867"
        d="M97.094 115.756a1.418 1.418 0 00-.554-1.425 1.422 1.422 0 01.241.131 1.627 1.627 0 01.74 1.323l-.426-.026z"
        fill="#402a22"
      />
      <path
        data-name="Path 5868"
        d="M91.107 117.482c.055.572.448.995.878.944a.964.964 0 00.685-1.122c-.127-1.363-1.694-1.191-1.563.178z"
        fill="#402a22"
      />
      <path
        data-name="Path 5869"
        d="M91.658 116.6c.31-.022.71-.473.627-1.315a1.308 1.308 0 01-.467 1.715c-.007 0-.16-.4-.16-.4z"
        fill="#402a22"
      />
      <path
        data-name="Path 5870"
        d="M91.516 116.692a1.414 1.414 0 00-.106-1.527 1.634 1.634 0 01.506 1.676l-.4-.153z"
        fill="#402a22"
      />
      <path
        data-name="Path 5871"
        d="M91.235 116.9a1.416 1.416 0 00-.554-1.424 1.63 1.63 0 01.98 1.45z"
        fill="#402a22"
      />
      <path
        data-name="Path 5872"
        d="M89.125 121.126a2.235 2.235 0 102.007-2.441 2.236 2.236 0 00-2.007 2.441z"
        fill="#fff"
        opacity={0.3}
      />
      <path
        data-name="Path 5873"
        d="M99.326 121.763a9.072 9.072 0 00.24-3.774 10.459 10.459 0 00-.095-.689 2.667 2.667 0 00-.379 0 2.236 2.236 0 00.234 4.463z"
        fill="#fff"
        opacity={0.3}
      />
      <path
        data-name="Path 5874"
        d="M95.322 114.069c-.208.051-.069 1.1-.033 1.315a5.312 5.312 0 001.905 3.494.964.964 0 01.091.069c.627.543-.823 1.159-1.6 1.512l-.087.04a.606.606 0 00.095-.011c1.334-.218 2.842-.947 1.887-1.865a3.669 3.669 0 01-1.217-1.406c-.255-.459-1.352-2.97-1.046-3.148z"
        fill="#c7785c"
      />
      <path
        data-name="Path 5875"
        d="M97.829 106.939a7.432 7.432 0 00-2.518-2.416 8.147 8.147 0 00-3.9-1.045 9.676 9.676 0 00-9.68 6.929 11.134 11.134 0 001.027 9.159 23.294 23.294 0 003.406 3.658c.168-1.086.3-2.036.353-2.455.022-.15.029-.23.029-.23l.131.033a8.492 8.492 0 01-.393-2.434c0-.309.015-.667.022-.761a12.73 12.73 0 01.885-4.554 5.363 5.363 0 012.266-2.937 4.938 4.938 0 012.186-.477c1.362-.022 1.548.47 2.594.379 1.443-.124 1.8-1.177 2.667-1 1.093.229 1.756 1.7 2.1 2.878a7.8 7.8 0 00-1.173-4.733z"
        fill="#402a22"
      />
      <path
        data-name="Path 5876"
        d="M99.031 111.664s-6.026-3.974-12.748 6.474L84.163 116a12 12 0 015.367-7.159 9.8 9.8 0 016.714-1.14 3.692 3.692 0 012.532 1.519 3.3 3.3 0 01.255 2.438z"
        fill="#edf9fd"
      />
      <g data-name="Group 5552">
        <path
          data-name="Path 5877"
          d="M99.126 110.276s-8.394-4.455-13.509 6.724c-.051.109-.1.218-.142.324l.805.812c6.725-10.448 12.748-6.474 12.748-6.474a3.826 3.826 0 00.098-1.386z"
          fill="#7cd3f4"
          opacity={0.3}
        />
      </g>
      <path
        data-name="Path 5878"
        d="M86.075 123.752c.27-1.687.466-3.213.466-3.213s.914-5.88-2.383-4.536a10.993 10.993 0 00-.335 4.5 3.817 3.817 0 00.627 1.847 6.641 6.641 0 001.625 1.402z"
        fill="#edf9fd"
      />
      <g data-name="Group 5553">
        <path
          data-name="Path 5879"
          d="M84.641 122.579a7.093 7.093 0 001.435 1.173c.27-1.686.466-3.213.466-3.213s.492-3.166-.55-4.321a22.13 22.13 0 00-.375.784 10.428 10.428 0 00-.98 5.574z"
          fill="#7cd3f4"
          opacity={0.3}
        />
      </g>
      <path
        data-name="Path 5880"
        d="M87.234 117.562s-2.171-2.2-2.9-.422 1.417 4.178 2.619 3.854.281-3.432.281-3.432z"
        fill="#fab38b"
      />
      <g data-name="Group 5554">
        <path
          data-name="Path 5881"
          d="M86.28 118.138s-1.279-1.446-1.377-.55.481 2.044.973 1.938.408-1.392.408-1.392z"
          fill="#ba937f"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 5882"
        d="M92.4 113.912a5.715 5.715 0 00-3.224 2.1c-.106.127-.339.055-.3-.1a4.162 4.162 0 01.306-.878c.43-.919 3.567-1.709 3.221-1.115z"
        fill="#402a22"
      />
      <path
        data-name="Path 5883"
        d="M96.113 113.14a4.227 4.227 0 013.224.339.135.135 0 00.149-.219 5.073 5.073 0 00-.66-.612c-.765-.594-3.253.138-2.711.492z"
        fill="#402a22"
      />
      <path
        data-name="Path 5884"
        d="M79.062 163.686a24.3 24.3 0 002.55 3.049c1.352.237 2.7.47 4.051.707 0 0 1.807.248 2.131.627a18.185 18.185 0 011.527 2.306c.051.215-.4.947-1.446-.335l-.7-.8s-1.21-.707-1.49-.47 3 2.554 3 3.006-.346.652-.831.539S85 169.53 84.52 169.53s2.594 2.79 2.765 3.034-.171 1.177-.863.664-2.718-2.635-2.718-2.635-.324.077-.2.332 2.051 2.456 1.745 2.842-1.927-1.184-2.667-2.143c-2.306-.306-3.028-.728-3.479-1.654-.084-.174-.055-.171-.2-.521a12.415 12.415 0 00-2.015-3.009 8.616 8.616 0 01-1.337-2.783c1.271 0 2.244.022 3.516.022z"
        fill="#fab38b"
      />
      <g data-name="Group 5556">
        <g data-name="Group 5555" opacity={0.2}>
          <path
            data-name="Path 5885"
            d="M87.8 168.068a18.184 18.184 0 011.526 2.306c.051.215-.4.948-1.446-.335l-.7-.8s-1.21-.707-1.49-.47 3 2.554 3 3.006-.346.652-.831.539-2.849-2.787-3.334-2.787 2.594 2.791 2.765 3.035-.171 1.177-.864.663-2.718-2.634-2.718-2.634-.324.076-.2.331 2.051 2.456 1.745 2.842-1.927-1.184-2.667-2.142l-.827-1.363c.153-.881.721-.972.721-.972.244-.9.842-.995.842-.995.27-.729.772-.619.772-.619a.836.836 0 01.284-.456c.43.077.86.15 1.293.226 0 0 1.807.248 2.131.627z"
            fill="#796b80"
          />
        </g>
      </g>
      <path
        data-name="Path 5886"
        d="M85.544 132.649a2.547 2.547 0 00-1.854-2.157c-.969-.441-1.749-.146-3.224.332a23.228 23.228 0 00-7.337 4.084c-4.033 3.239-9.738 8.212-12.456 11.705a2.863 2.863 0 001.17 2.3c1.315 1.012 3.709-.077 10.07-3.618 6.209-3.462 14.567-8.573 13.631-12.646z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5887"
        d="M67.87 142.559a134.775 134.775 0 0013.338 24.06c-1.013.841-1.37 1.308-2.383 2.149-14.052-15.2-14.671-15.87-16.923-20.693a3.94 3.94 0 01-.35-2.073l6.317-3.447z"
        fill="#fab38b"
      />
      <path
        data-name="Path 5888"
        d="M82.852 128.132a135.806 135.806 0 00-12.981 8.59l5.6 7.137 10.165-5.647s3.658-3.5-1.177-9.053c-.776-.893-.55-1.57-1.6-1.027z"
        fill="#60bcad"
      />
      <path
        data-name="Path 5889"
        d="M97.516 121.184c-.277 1.436-2.78 1.986-3.556.543a2.845 2.845 0 003.556-.543z"
        fill="#701c25"
      />
      <g data-name="Group 5557">
        <path
          data-name="Path 5890"
          d="M100.3 134.817c1.559 4.536 1.02 5.786-.616 9.043s-11.053 4-11.053 4c10.769-.481 11.053-2.124 11.053-2.124s-.944 13.629-2.124 17.924-15.24 1.527-15.24 1.527a17.8 17.8 0 0017.768-.15 66.77 66.77 0 01.084-14.39c.408-2.7.886-4.562.886-4.562.834-3.249 1.318-3.377 1.391-4.94a10.508 10.508 0 00-2.153-6.336z"
          fill="#7cd3f4"
          opacity={0.3}
        />
      </g>
      <g data-name="Group 5560" opacity={0.3}>
        <g data-name="Group 5558">
          <path
            data-name="Path 5891"
            d="M84.265 136.791a1.205 1.205 0 00.186-.295s-.073.104-.186.295z"
            fill="#7cd3f4"
          />
        </g>
        <g data-name="Group 5559">
          <path
            data-name="Path 5892"
            d="M82.44 143.145c-.944-1.636 1.166-5.29 1.822-6.354-1.359 1.723-8.8 7.068-8.8 7.068l5.283-2.8a52.833 52.833 0 012.339 6.838q1.454 5.75-.776 17.305c4.394-3.65 1.235-20.121.127-22.045z"
            fill="#7cd3f4"
          />
        </g>
      </g>
      <path
        data-name="Path 5893"
        d="M228.868 44.956v-3.967a4.407 4.407 0 00-4.4-4.4h-4.788a4.406 4.406 0 00-4.4 4.4v3.938a10.838 10.838 0 00-3.414 12.125 2.111 2.111 0 001.985 1.381h16.435a2.126 2.126 0 002-1.4 10.779 10.779 0 00-3.418-12.074zm-2.8-1.647a10.64 10.64 0 00-3.418-.765 10.789 10.789 0 00-4.561.747v-2.3a1.6 1.6 0 011.6-1.6h4.787a1.6 1.6 0 011.6 1.6v2.319z"
        fill="#dff7f3"
      />
      <path
        data-name="Path 5894"
        d="M219.4 54.024h-1.377l.885-5.895-1.3.033.156-1.056 2.718-.273-1.082 7.187z"
        fill="#263238"
      />
      <path
        data-name="Path 5895"
        d="M226.208 51.455a3.427 3.427 0 01-.889 1.986 2.3 2.3 0 01-1.687.685 1.674 1.674 0 01-1.472-.718 2.584 2.584 0 01-.324-1.953l.291-1.942a3.435 3.435 0 01.889-1.982 2.312 2.312 0 011.7-.692 1.673 1.673 0 011.457.721 2.623 2.623 0 01.324 1.953l-.291 1.942zm-1.068-2.065a2.128 2.128 0 00-.051-1.1.548.548 0 00-.539-.375.783.783 0 00-.649.393 2.469 2.469 0 00-.378 1.089l-.325 2.175a2.161 2.161 0 00.044 1.118.557.557 0 00.55.372.777.777 0 00.634-.39 2.607 2.607 0 00.386-1.1l.328-2.175z"
        fill="#263238"
      />
    </SvgIcon>
  );
}
export function LoginImageIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 258,
    height: 164.49,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 258 164.49"
      {...rest}
      sx={rootSx}
    >
      <g data-name="Group 102581" transform="translate(-59 -47)">
        <circle
          data-name="Ellipse 39441"
          cx={18}
          cy={18}
          r={18}
          transform="translate(281 126)"
          fill="rgba(90,197,179,0.1)"
        />
        <g data-name="Sign in illustration" transform="translate(59 44)">
          <path
            data-name="Path 4558"
            d="M240.628 4.273a2.546 2.546 0 014.409 0l18.005 31.186a2.546 2.546 0 01-2.2 3.819h-36.015a2.546 2.546 0 01-2.2-3.819z"
            transform="translate(-33.655)"
            fill="rgba(90,197,179,0.1)"
          />
          <path
            data-name="Path 4559"
            d="M177.284 157.273a2.546 2.546 0 014.409 0l14.331 24.821a2.546 2.546 0 01-2.205 3.819h-28.66a2.546 2.546 0 01-2.206-3.819z"
            transform="translate(-24.62 -23.165)"
            fill="rgba(90,197,179,0.1)"
          />
          <circle
            data-name="Ellipse 39442"
            cx={25.458}
            cy={25.458}
            r={25.458}
            transform="translate(0 102.285)"
            fill="rgba(90,197,179,0.1)"
          />
          <circle
            data-name="Ellipse 39443"
            cx={16.123}
            cy={16.123}
            r={16.123}
            transform="translate(36.489 12.335)"
            fill="rgba(90,197,179,0.1)"
          />
          <path
            data-name="Path 4560"
            d="M29.524 138.1a4.229 4.229 0 00-1.517-2.6c-1.517-1.517-2.49-2.384-2.49-2.384s-.76 2.492.648 4.007a26.652 26.652 0 003.353 2.926z"
            transform="translate(-3.832 -19.701)"
            fill="#4cc5b1"
          />
          <path
            data-name="Path 4561"
            d="M26.932 146.075a4.234 4.234 0 00-1.515-2.6c-1.515-1.517-2.493-2.384-2.493-2.384s-.757 2.492.651 4.01a26.685 26.685 0 003.356 2.917z"
            transform="translate(-3.44 -20.908)"
            fill="#4cc5b1"
          />
          <path
            data-name="Path 4562"
            d="M30.126 140.357a4.226 4.226 0 011.783-2.426c1.668-1.347 2.73-2.107 2.73-2.107s.492 2.557-1.07 3.912a26.584 26.584 0 01-3.65 2.554z"
            transform="translate(-4.53 -20.111)"
            fill="#4cc5b1"
          />
          <path
            data-name="Path 4563"
            d="M26.95 149.85s.229-1.059 2.029-2.235 2.937-1.808 2.937-1.808.218 2.6-1.475 3.784a26.768 26.768 0 01-3.912 2.157z"
            transform="translate(-4.017 -21.622)"
            fill="#4cc5b1"
          />
          <path
            data-name="Path 4564"
            d="M27.618 159.958a4.231 4.231 0 011.517-2.6c1.517-1.517 2.493-2.384 2.493-2.384s.757 2.493-.651 4.01a26.588 26.588 0 01-3.353 2.925z"
            transform="translate(-4.182 -23.01)"
            fill="#4cc5b1"
          />
          <path
            data-name="Path 4565"
            d="M26.924 162.371a4.266 4.266 0 00-1.118-2.794c-1.272-1.722-2.127-2.714-2.127-2.714s-1.118 2.359.073 4.061a26.693 26.693 0 002.909 3.373z"
            transform="translate(-3.513 -23.296)"
            fill="#4cc5b1"
          />
          <path
            data-name="Path 4566"
            d="M25.826 169.891a4.223 4.223 0 011.517-2.6c1.517-1.515 2.493-2.384 2.493-2.384s.757 2.49-.651 4.007a26.592 26.592 0 01-3.353 2.926z"
            transform="translate(-3.91 -24.514)"
            fill="#4cc5b1"
          />
          <path
            data-name="Path 4567"
            d="M27.019 176.472a4.2 4.2 0 01.808-2.9c1.087-1.852 1.808-2.937 1.808-2.937s1.364 2.219.386 4.044a26.48 26.48 0 01-2.515 3.68z"
            transform="translate(-4.086 -25.381)"
            fill="#4cc5b1"
          />
          <path
            data-name="Path 4568"
            d="M25.828 118.123a31.02 31.02 0 01-.414 3.353c-.6 3.1-2.1 5.1-2.7 7.894s1.118 6.4.662 10-1.861 5.589-1.462 7.992 2.5 8.892 2.5 8.892"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4569"
            d="M25.582 120.965l1.635-1.252"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4570"
            d="M25.658 119.52l-.685-1.216"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4571"
            d="M22.807 129.253s1.366-1.026 2.775-2.054"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4572"
            d="M23.492 127.11a21.876 21.876 0 00-2.431-3.719"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4573"
            d="M23.492 138.488a16.9 16.9 0 012.926-3.912"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4574"
            d="M23.212 140.012a19.258 19.258 0 00-1.481-2.814c-.8-1.18-.914-1.331-.914-1.331"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4575"
            d="M21.916 147.369a18.018 18.018 0 011.232-2.492 15.829 15.829 0 011.6-2.09"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4576"
            d="M23.424 152.978a4.656 4.656 0 01.411-2.4c.559-1.1 1.216-2.546 1.481-3.115"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4577"
            d="M18.571 155.412a2.7 2.7 0 01.668-1.8 36.669 36.669 0 011.305-1.763 2.907 2.907 0 01.028 2.585 16.854 16.854 0 01-1.788 2.2z"
            transform="translate(-2.811 -22.537)"
            fill="#4cc5b1"
          />
          <path
            data-name="Path 4578"
            d="M21.064 160.142a2.7 2.7 0 01.668-1.8c.785-1.115 1.316-1.774 1.316-1.774a2.9 2.9 0 01.025 2.582 16.931 16.931 0 01-1.788 2.2z"
            transform="translate(-3.188 -23.252)"
            fill="#4cc5b1"
          />
          <path
            data-name="Path 4579"
            d="M18.286 156.977s-.19-.663-1.38-1.327-1.942-1.026-1.942-1.026a2.9 2.9 0 001.1 2.342 17.028 17.028 0 002.565 1.2z"
            transform="translate(-2.266 -22.957)"
            fill="#4cc5b1"
          />
          <path
            data-name="Path 4580"
            d="M21.232 162.607s-.257-.64-1.512-1.174-2.037-.815-2.037-.815a2.894 2.894 0 001.336 2.21 16.819 16.819 0 002.68.931z"
            transform="translate(-2.677 -23.865)"
            fill="#4cc5b1"
          />
          <path
            data-name="Path 4581"
            d="M22.063 168.983s-.117-.679-1.232-1.464-1.822-1.225-1.822-1.225a2.917 2.917 0 00.838 2.443 16.96 16.96 0 002.423 1.47z"
            transform="translate(-2.876 -24.724)"
            fill="#4cc5b1"
          />
          <path
            data-name="Path 4582"
            d="M22.9 170.354a2.679 2.679 0 01.405-1.872c.62-1.215 1.04-1.934 1.04-1.934a2.91 2.91 0 01.4 2.554 17.023 17.023 0 01-1.459 2.431z"
            transform="translate(-3.461 -24.763)"
            fill="#6552cc"
          />
          <path
            data-name="Path 4583"
            d="M25.118 176.98s.078-.685 1.149-1.534 1.746-1.327 1.746-1.327a2.9 2.9 0 01-.7 2.486 16.844 16.844 0 01-2.336 1.607z"
            transform="translate(-3.782 -25.909)"
            fill="#6552cc"
          />
          <path
            data-name="Path 4584"
            d="M24.264 175.019s-.117-.679-1.232-1.467-1.822-1.224-1.822-1.224a2.914 2.914 0 00.838 2.442 16.836 16.836 0 002.417 1.47z"
            transform="translate(-3.209 -25.638)"
            fill="#4cc5b1"
          />
          <path
            data-name="Path 4585"
            d="M24.351 179.247a2.685 2.685 0 00-.822-1.729c-.88-1.043-1.453-1.646-1.453-1.646a2.908 2.908 0 00.2 2.576 16.966 16.966 0 001.973 2.037z"
            transform="translate(-3.309 -26.174)"
            fill="#4cc5b1"
          />
          <path
            data-name="Path 4586"
            d="M15.643 132.715a19.837 19.837 0 00.626 2.065c.713 1.875 1.87 2.968 2.549 4.656s0 4.139.671 6.34 1.774 3.306 1.783 4.854-.6 5.846-.6 5.846"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4587"
            d="M16.107 134.47l-1.16-.609"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4588"
            d="M15.903 133.572l.3-.838"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4589"
            d="M18.742 139.366s-.97-.495-1.956-.986"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4590"
            d="M18.086 138.1a13.825 13.825 0 011.118-2.6"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4591"
            d="M19.32 145.231a10.848 10.848 0 00-2.255-2.138"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4592"
            d="M19.653 146.156a12.307 12.307 0 01.623-1.925c.374-.824.428-.933.428-.933"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4593"
            d="M21.221 151.807a10.069 10.069 0 011.246-1.3 6.831 6.831 0 00.813-.707"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4594"
            d="M21.271 150.631a11.593 11.593 0 00-1.042-1.431 10.054 10.054 0 00-1.227-1.132"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4595"
            d="M20.935 154.311a2.943 2.943 0 00-.517-1.461c-.478-.629-1.04-1.465-1.269-1.794"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4596"
            d="M25.398 166.79h-6.331a.5.5 0 01-.5-.5l-1.57-10.484h10.47l-1.57 10.484a.5.5 0 01-.5.5z"
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <g
            data-name="Group 5433"
            opacity={0.3}
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          >
            <path
              data-name="Path 4597"
              d="M52.985 121.78H0V25.82A25.82 25.82 0 0125.82 0a27.149 27.149 0 0127.15 27.15v94.63z"
              opacity={0.3}
              transform="translate(203.081 7.243)"
            />
            <path
              data-name="Path 4598"
              d="M46.99 121.495V27.363a20.51 20.51 0 00-20.51-20.51h0a20.51 20.51 0 00-20.5 20.51v94.148"
              opacity={0.3}
              transform="translate(203.081 7.243)"
            />
            <path
              data-name="Path 4599"
              d="M26.491 0v121.637"
              opacity={0.3}
              transform="translate(203.081 7.243)"
            />
            <path
              data-name="Path 4600"
              d="M52.697 23.431H.354"
              opacity={0.3}
              transform="translate(203.081 7.243)"
            />
            <path
              data-name="Path 4601"
              d="M52.697 39.953H.354"
              opacity={0.3}
              transform="translate(203.081 7.243)"
            />
            <path
              data-name="Path 4602"
              d="M52.697 56.473H.354"
              opacity={0.3}
              transform="translate(203.081 7.243)"
            />
            <path
              data-name="Path 4603"
              d="M52.697 72.998H.354"
              opacity={0.3}
              transform="translate(203.081 7.243)"
            />
            <path
              data-name="Path 4604"
              d="M52.697 89.521H.354"
              opacity={0.3}
              transform="translate(203.081 7.243)"
            />
            <path
              data-name="Path 4605"
              d="M52.697 106.042H.354"
              opacity={0.3}
              transform="translate(203.081 7.243)"
            />
            <path
              data-name="Path 4606"
              d="M45.698 8.266l-4.744 4.324"
              opacity={0.3}
              transform="translate(203.081 7.243)"
            />
            <path
              data-name="Path 4607"
              d="M7.48 8.266l4.748 4.324"
              opacity={0.3}
              transform="translate(203.081 7.243)"
            />
          </g>
          <g
            data-name="Group 5434"
            opacity={0.3}
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          >
            <path
              data-name="Path 4608"
              d="M52.981 121.78H0V25.82A25.82 25.82 0 0125.82 0a27.15 27.15 0 0127.15 27.15v94.63z"
              opacity={0.3}
              transform="translate(8.486 7.243)"
            />
            <path
              data-name="Path 4609"
              d="M46.999 121.494V27.362a20.51 20.51 0 00-20.51-20.525h0A20.51 20.51 0 005.963 27.362v94.148"
              opacity={0.3}
              transform="translate(8.486 7.243)"
            />
            <path
              data-name="Path 4610"
              d="M26.488 0v121.637"
              opacity={0.3}
              transform="translate(8.486 7.243)"
            />
            <path
              data-name="Path 4611"
              d="M52.697 23.431H.351"
              opacity={0.3}
              transform="translate(8.486 7.243)"
            />
            <path
              data-name="Path 4612"
              d="M52.697 39.953H.351"
              opacity={0.3}
              transform="translate(8.486 7.243)"
            />
            <path
              data-name="Path 4613"
              d="M52.697 56.473H.351"
              opacity={0.3}
              transform="translate(8.486 7.243)"
            />
            <path
              data-name="Path 4614"
              d="M52.697 72.998H.351"
              opacity={0.3}
              transform="translate(8.486 7.243)"
            />
            <path
              data-name="Path 4615"
              d="M52.697 89.52H.351"
              opacity={0.3}
              transform="translate(8.486 7.243)"
            />
            <path
              data-name="Path 4616"
              d="M52.697 106.041H.351"
              opacity={0.3}
              transform="translate(8.486 7.243)"
            />
            <path
              data-name="Path 4617"
              d="M45.694 8.266l-4.748 4.324"
              opacity={0.3}
              transform="translate(8.486 7.243)"
            />
            <path
              data-name="Path 4618"
              d="M7.481 8.266l4.744 4.324"
              opacity={0.3}
              transform="translate(8.486 7.243)"
            />
          </g>
          <path
            data-name="Path 4619"
            d="M97.529 71.217a27.085 27.085 0 015.546 4.786c3.153 3.4 4.913 13.735 1.383 15.75s-5.669-1.888-5.669 1.133 3.4 4.79-.385 7.939-11.846 2.9-12.853-2.643 3.527-8.948 4.282-12.6-.25-10.837.5-13.608 3.038-2.915 7.196-.757z"
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4620"
            d="M40.716 37.119a3.735 3.735 0 00-1.468-.771c-.513 0-.736.647-1.472 1.222s-1.838.859-1.179 1.156a2.131 2.131 0 002.135-.358c.59-.5.59-.216 1.029-.146l.443.073z"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4621"
            d="M39.537 38.768s-1.985-.358-2.135.216a1.156 1.156 0 00.385 1.295 1.469 1.469 0 001.029.143z"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4622"
            d="M37.259 39.416s-1.1.432-.809 1.222 1.541.933 1.541.933l.443-.933a2.443 2.443 0 01-1.175-1.222z"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4623"
            d="M36.525 40.926a1.306 1.306 0 00-.146.933c.146.432 1.029.79 1.029.79l.59-1.079s-1.4-.359-1.473-.644z"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4624"
            d="M36.378 41.859s-.513.289-.293.717a1.241 1.241 0 00.879.509l.439-.432s-.952-.505-1.025-.794z"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4625"
            d="M88.708 69.68s-4.914-3.526-6.937-4.659-6.549-1.897-6.549-1.897L63.751 54.68s-6.8-5.041-10.2-6.937-9.2-5.781-9.2-5.781l-3.268-4.663-3.653 6.3 6.166 1.387s11.48 10.211 14.366 12.858a19.253 19.253 0 005.041 3.53s5.673 5.669 8.066 7.557a19.843 19.843 0 003.526 2.393 57.737 57.737 0 01-.771 7.438c-.52 2.019-1.26 3.653-2.393 4.031a5.955 5.955 0 01-1.509.387s-.771 7.434 1.761 11.465 8.066 3.908 9.577 3.908 4.914-4.536 4.914-4.536a21.662 21.662 0 004.913-2.648c1.383-1.26 3.711-6.713 3.711-6.713a34.63 34.63 0 008.008 1.045c4.158 0 9.955-2.143 9.955-2.143s7.939 0 11.719-1.133 13.608-4.536 13.608-4.536a23.971 23.971 0 006.3.883 21.521 21.521 0 005.919-.771 2.147 2.147 0 001.01-1.133.98.98 0 00.771-.385 9.225 9.225 0 00.489-.871s.629 0 .629-.5-1.889-1.26-1.889-1.26 2.143-.771 1.26-1.006-8.316-.385-8.316-.385-.25-.632.771-.883 2.648-1.387 1.892-1.511l-.771-.127a8.683 8.683 0 01-2.267.771 4.243 4.243 0 00-2.143.882c-.5.385-3.148 3.025-3.148 3.025a39.58 39.58 0 01-8.443 1.006c-5.165.127-6.937 0-10.205.632s-6.678 1.376-6.678 1.376l-8.948.5a35.376 35.376 0 01-4.408-.385 10.672 10.672 0 01-4.914-3.025 52.549 52.549 0 00-5.42-4.542z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4626"
            d="M151.333 73.845l-3.4.127"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4627"
            d="M152.591 75.61l-4.786-.251"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4628"
            d="M151.333 76.87l-3.025.127"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4629"
            d="M147.93 73.467l.378 4.035"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4630"
            d="M144.404 73.349a5.6 5.6 0 01-.255 1.384c-.25.883-3.021 1.01-3.021 1.01"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4631"
            d="M112.778 83.549l7.056-1.888"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4632"
            d="M94.812 84.647l1.079-2.231"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4633"
            d="M74.591 71.324l2.4 1.515"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4634"
            d="M76.739 70.319l.5 3.4"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4635"
            d="M106.163 87.79s.771-1.888 1.765-4.031 2.393-2.015 2.9-1.765 2.393.882 2.9.385 3.021-4.536 3.021-4.536 1.26 0 1.642-.628l-1.01-2.648a2.684 2.684 0 00.771-1.511v-2.014s.5-2.775.5-3.4-2.52-1.387-5.041-.254-9.576 4.035-10.332 5.781a23.914 23.914 0 00-1.01 5.673s-.385 1.638-1.133 4.031"
            transform="translate(-15.313 -9.66)"
            fill="#fff"
          />
          <path
            data-name="Path 4636"
            d="M90.85 78.13s.771-1.888 1.765-4.031 2.393-2.015 2.9-1.765 2.393.882 2.9.385 3.021-4.536 3.021-4.536 1.26 0 1.642-.628l-1.01-2.648a2.684 2.684 0 00.771-1.511v-2.014s.5-2.775.5-3.4-2.52-1.387-5.041-.254-9.576 4.035-10.332 5.781a23.914 23.914 0 00-1.01 5.673s-.385 1.638-1.133 4.031"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4637"
            d="M92.739 64.665s-.385-3.152-2.015-2.4-1.383 3.152-.883 3.908 1.387.628-.25 1.638-3.148 1.638-4.285 0-3.149-5.041-.771-9.072 7.689-7.322 12.224-6.937 4.408 2.139 4.408 2.139a3.724 3.724 0 015.292 1.387c2.143 3.4 1.26 5.291.385 5.291s-1.26-1.006-1.26-1.006-.629 1.26-1.26 1.511a4.817 4.817 0 01-1.511.254l-.385-2.52s-3.78-.632-4.285.879-.771 3.4-2.266 4.158a7.892 7.892 0 01-3.138.77z"
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4638"
            d="M119.006 75.657c0 .42-.2.771-.443.771s-.44-.335-.44-.771.2-.771.44-.771.443.355.443.771z"
            transform="translate(-17.885 -10.884)"
            fill="#263238"
          />
          <path
            data-name="Path 4639"
            d="M99.672 63.263a1.3 1.3 0 012.143 0"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4640"
            d="M98.033 68.303a1.743 1.743 0 001.639 1.133"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4641"
            d="M95.515 72.334l-3.153-2.9.5 4.031a1.9 1.9 0 012.653-1.131z"
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4642"
            d="M69.937 83.164l-1.137-.127a15.324 15.324 0 00-6.551-3.781c-3.9-1.006-9.827.385-9.827.385s-6.551-3.653-10.837-6.424-8.945-5.291-8.945-5.291 4.659-9.577 5.418-14.617 1.761-8.3 2.393-9.453 1.26-2.393 1.26-2.393 2.52 1.006 3.4.123.5-4.031.632-5.041.385-3.777.385-4.914v-1.649s.771-1.383-.251-1.133a3.91 3.91 0 00-2.143 1.888c-.5.755-2.771 5.781-4.413 8.444s-6.551 10.586-9.7 16.128-5.3 12.617-6.436 15.138-.123 4.914.385 5.291 6.551 6.679 11.719 9.827 8.066 5.418 9.7 6.05 6.3 4.031 6.8 5.781-2.015 11.087-.123 17.261 2.393 10.459 2.266 12.852-1.888 5.292-1.888 9.828 2.266 12.717 2.52 14.112a76.853 76.853 0 011.26 8.317c0 1.765-.5 5.781-.254 6.3s3.4.883 4.413.628a10.728 10.728 0 012.771-.5c1.006 0 3.526.385 5.041.385s2.9.127 3.021-.385-1.26-1.133-1.761-1.26a12.847 12.847 0 01-5.168-3.021c-1.511-1.762-3.149-3.4-3.526-4.413s.385-13.353.883-17.512 1.133-8.822 1.384-9.955a45.033 45.033 0 002.015-8.193c.628-4.663 1.638-17.388 1.765-18.394a29.528 29.528 0 01.771-3.148s7.434-1.387 9.2-1.387 4.285-.127 5.546-.771 1.511-2.648.123-4.158-5.781-3.53-7.322-6.167a24.4 24.4 0 00-2.52-3.78z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4643"
            d="M69.224 83.091l-.424-.046a15.323 15.323 0 00-6.551-3.781c-3.9-1.006-9.827.385-9.827.385s-6.552-3.653-10.838-6.426-8.945-5.291-8.945-5.291 4.659-9.577 5.418-14.617c.17-1.156.355-2.181.543-3.137a17.069 17.069 0 00-4.5-2.47c-1.541 2.582-3.176 5.3-4.486 7.611-3.152 5.546-5.291 12.6-6.428 15.122s-.123 4.914.385 5.291 6.551 6.679 11.719 9.828 8.066 5.418 9.7 6.05 6.3 4.031 6.8 5.781-2.015 11.087-.123 17.261 2.393 10.459 2.266 12.852-1.877 5.292-1.877 9.829 2.266 12.717 2.52 14.112c.035.2.089.482.15.817a9.266 9.266 0 005.653-.328c.189-4.15.574-9.492.875-11.946.5-4.159 1.133-8.822 1.384-9.955a45.033 45.033 0 002.015-8.193c.628-4.663 1.638-17.388 1.765-18.394a29.528 29.528 0 01.771-3.148s1.037-.2 2.428-.435c-3.469-6.398-1.403-13.916-.393-16.772z"
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4644"
            d="M92.912 88.443c1.9-4.709 1.086-5.75 1.086-7.415 0-2.52.127-7.056.127-7.056l-.146-.224-.386-.328a21.88 21.88 0 01-.994 5.341c-.883 2.517-3.025 4.031-6.428 1.638s-1.006-6.3-1.006-6.3 1.334-4.239 1.287-5.993l-1.36-.937c.031 1.6-.115 4.752-1.565 6.937-2.015 3.021-4.285 4.914-6.679 4.536a10.484 10.484 0 01-2.836-.859c-.058.385-.119.713-.189.987-.5 2.016-1.26 3.653-2.393 4.031a5.952 5.952 0 01-1.511.385s-.771 7.434 1.761 11.465 8.066 3.908 9.577 3.908 4.914-4.536 4.914-4.536a21.644 21.644 0 004.913-2.648 8.61 8.61 0 001.828-2.932z"
            fill="#38c5ae"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4645"
            d="M75.228 83.676a4.647 4.647 0 003.653 4.282"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4646"
            d="M163.991 97.614s11.848 6.87 14.379 8.465 6.271 2.458 7.9 4.1c1.26 1.268 7.681 6.028 9.831 6.564s2.706-7.47 2.706-7.47-9.934-6.758-12.442-8.227-20.514-7.423-20.514-7.423z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4647"
            d="M157.473 96.157s2.149 1.876 2.74 1.935 4.052-.521 4.052-.521l1.935-3.754s-3.3-2.62-4.064-3.027-5.3-1.8-5.3-1.8a.4.4 0 00-.148.092.394.394 0 00-.093.147.384.384 0 00-.022.172.406.406 0 00.054.165s-1.513-.959-1.99-.083a.353.353 0 00-.159-.068.353.353 0 00-.317.11.353.353 0 00-.082.153 1.017 1.017 0 00.034.836s-.594.558-.187 1.1a35.74 35.74 0 003.453 2.69l1.377 1.424s-1.219-.931-1.695-.92-.4.571-.4.571z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4648"
            d="M185.923 109.074a47.627 47.627 0 01-4.375-2.907 47.162 47.162 0 014.375 2.907z"
            transform="translate(-27.488 -15.62)"
            fill="#eb996e"
          />
          <path
            data-name="Path 4649"
            d="M186.7 107.7a4.114 4.114 0 01-.655-.371l-1.547-.953a71.383 71.383 0 01-1.536-.97 3.865 3.865 0 01-.613-.44 4.231 4.231 0 01.666.351c.4.234.956.558 1.558.936s1.142.725 1.527.989a3.731 3.731 0 01.6.457z"
            transform="translate(-27.609 -15.438)"
            fill="#263238"
          />
          <path
            data-name="Path 4650"
            d="M188.054 106.73c-.022.036-.766-.393-1.7-.875s-1.717-.836-1.7-.877a2.054 2.054 0 01.535.178c.323.131.761.328 1.232.571s.887.485 1.179.672a2.168 2.168 0 01.457.331z"
            transform="translate(-27.958 -15.44)"
            fill="#263238"
          />
          <path
            data-name="Path 4651"
            d="M189.191 112.981a1.718 1.718 0 01-.6-.086 4.941 4.941 0 01-2.452-1.519 1.93 1.93 0 01-.345-.5 8.653 8.653 0 001.533 1.315 8.41 8.41 0 001.862.786z"
            transform="translate(-28.131 -16.334)"
            fill="#eb996e"
          />
          <path
            data-name="Path 4652"
            d="M219.436 125.231l-5.349-17a10.4 10.4 0 00-9.32 4.481 14.548 14.548 0 00-2.244 10.352c.234 1.689.705 3.344.87 5.039a7.445 7.445 0 01-.962 4.919c-.961 1.416-2.633 2.356-3.283 3.949-.836 2.035.3 4.279 1.188 6.288s1.449 4.657-.148 6.165a3.647 3.647 0 002.954-1.578 3.4 3.4 0 01-.212 2.609c2.462.615 5.053-.382 7.2-1.745a21.549 21.549 0 009.309-23.491z"
            transform="translate(-30.108 -15.925)"
            fill="#263238"
          />
          <path
            data-name="Path 4653"
            d="M177.252 98.017l-.435 1.371c-.025 1.115.527 3.18 1.152 3.643l14.215 9.993a5.41 5.41 0 003.326.978l1.257-.053a3.954 3.954 0 003.389-5.741 1.764 1.764 0 00-.228-.349 3.325 3.325 0 00-.279-.278 12.548 12.548 0 00-2.062-1.639c-1.215-.961-1.718-1.348-1.706-1.341s1.566-2.917-1.394-6.056a45.591 45.591 0 00-6.647-5.193 4.653 4.653 0 00-1.547-.613 7.732 7.732 0 00-9.041 5.278z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4654"
            d="M223.824 112.782a.558.558 0 01.114.755.509.509 0 01-.144.148.526.526 0 01-.191.08.532.532 0 01-.207 0 .513.513 0 01-.19-.081.556.556 0 01-.117-.755.5.5 0 01.146-.147.526.526 0 01.191-.08.535.535 0 01.208 0 .527.527 0 01.19.08z"
            transform="translate(-33.763 -16.608)"
            fill="#263238"
          />
          <path
            data-name="Path 4655"
            d="M222.24 111.453c.016.1-.479.239-.837.7s-.39.989-.485 1c-.045 0-.1-.128-.1-.36a1.5 1.5 0 01.317-.849 1.434 1.434 0 01.739-.507c.226-.059.362-.029.366.016z"
            transform="translate(-33.434 -16.413)"
            fill="#263238"
          />
          <path
            data-name="Path 4656"
            d="M219.908 118a.558.558 0 01.114.755.509.509 0 01-.144.148.524.524 0 01-.192.08.519.519 0 01-.4-.082.557.557 0 01-.117-.755.512.512 0 01.146-.147.526.526 0 01.191-.08.536.536 0 01.208 0 .543.543 0 01.191.081z"
            transform="translate(-33.17 -17.398)"
            fill="#263238"
          />
          <path
            data-name="Path 4657"
            d="M218.183 116.928c.014.1-.482.237-.836.7s-.39.987-.485.993c-.044 0-.1-.126-.1-.36a1.5 1.5 0 01.318-.836 1.449 1.449 0 01.738-.5c.22-.081.359-.045.365.003z"
            transform="translate(-32.82 -17.242)"
            fill="#263238"
          />
          <path
            data-name="Path 4658"
            d="M223.322 117.586a3.949 3.949 0 01.446-.861c.078-.128.142-.26.078-.34a.768.768 0 00-.415-.2l-1.177-.345a19.37 19.37 0 01-2.976-1.037 18.244 18.244 0 013.052.794l1.171.365a.884.884 0 01.515.3.384.384 0 01.05.163.4.4 0 01-.027.169.911.911 0 01-.129.222 3.769 3.769 0 01-.588.767z"
            transform="translate(-33.2 -16.927)"
            fill="#263238"
          />
          <path
            data-name="Path 4659"
            d="M229.992 122.714a10.855 10.855 0 01-4.691 3.59s3.21.666 5.5-2.954z"
            transform="translate(-34.112 -18.126)"
            fill="#263238"
          />
          <path
            data-name="Path 4660"
            d="M223.174 119.9c.053-.078.558.31 1.252.154s1.054-.736 1.115-.686 0 .2-.162.429a1.583 1.583 0 01-.911.593 1.369 1.369 0 01-1.025-.161c-.219-.147-.3-.3-.269-.329z"
            transform="translate(-33.789 -17.618)"
            fill="#263238"
          />
          <path
            data-name="Path 4661"
            d="M216.149 115.538c.092.145-.326.558-.683 1.16s-.558 1.153-.716 1.14c-.078 0-.139-.178-.126-.451a2.349 2.349 0 011.068-1.751c.237-.136.408-.165.457-.098z"
            transform="translate(-32.495 -17.034)"
            fill="#263238"
          />
          <path
            data-name="Path 4662"
            d="M219.719 109.754c.045.165-.315.4-.616.783s-.479.767-.647.756c-.081 0-.145-.143-.137-.36a1.361 1.361 0 01.321-.775 1.4 1.4 0 01.7-.466c.212-.052.36-.013.379.062z"
            transform="translate(-33.055 -16.15)"
            fill="#263238"
          />
          <path
            data-name="Path 4663"
            d="M216.882 124.848c-.25-.2-1.068-.36-1.3-.143a1.847 1.847 0 00.192 3.127 2.181 2.181 0 003.551-.933c-.071-.056-1.573-1.385-2.443-2.051z"
            transform="translate(-32.523 -18.412)"
            fill="#ffbe9d"
          />
          <path
            data-name="Path 4664"
            d="M218.07 127.146c-.014 0 0 .061-.025.154a.51.51 0 01-.226.3 1.254 1.254 0 01-1.243-.238 1.709 1.709 0 01-.485-.558.573.573 0 01-.1-.261.59.59 0 01.032-.279.259.259 0 01.12-.126.253.253 0 01.172-.021c.09.02.123.07.137.059s0-.078-.109-.133a.334.334 0 00-.215-.023.385.385 0 00-.231.176.709.709 0 00.031.694 1.724 1.724 0 00.53.638 1.312 1.312 0 001.443.189.54.54 0 00.223-.412c-.002-.122-.043-.176-.054-.159z"
            transform="translate(-32.677 -18.625)"
            fill="#eb996e"
          />
          <path
            data-name="Path 4665"
            d="M218.895 132.574l2.129 17.06-3.553.479v-19.379z"
            transform="translate(-32.927 -19.34)"
            fill="#455a64"
          />
          <path
            data-name="Path 4666"
            d="M218.895 132.574l2.129 17.06-3.553.479v-19.379z"
            transform="translate(-32.927 -19.34)"
            opacity={0.3}
          />
          <path
            data-name="Path 4667"
            d="M214.129 128.947l-.145 25.852s.257.434 1.555 0 2.3 1.014 2.3 1.014l-.4-24.566-.5-4.387z"
            transform="translate(-32.399 -18.753)"
            fill="#455a64"
          />
          <path
            data-name="Path 4668"
            d="M212.131 116.656s.279-4.549 1.62-6.185 4.228-1.823 4.228-1.823-1.162-1.142-4.145-.524a6.4 6.4 0 00-4.459 3.127 11.22 11.22 0 00-1 4.025z"
            transform="translate(-31.55 -15.889)"
            fill="#263238"
          />
          <path
            data-name="Path 4669"
            d="M193.973 108.861s12.052-1.595 14.714.574 9.906 8.208 12.325 12.116c1.092 1.762 2.637 8.266 2.246 12.874l-14.289.474-.837-7.063-9.889-5.084s-6.809-2.982-7.219-7.541a6.444 6.444 0 012.949-6.35z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4670"
            d="M193.974 108.86s8.949 3.949 9.552 5.6a7.671 7.671 0 01.605 3.791l-3.775 5.6 7 3.6 8.328-12.152-5.5-5.535a9.242 9.242 0 00-2.787-1.836 30.733 30.733 0 00-3.205-.516c-1.193-.17-5.1-.126-5.1-.126z"
            fill="#38c5ae"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 4671"
            d="M250.673 149.151a25.649 25.649 0 01-2.671.49 26.372 26.372 0 01-2.692.345 50.158 50.158 0 015.362-.836z"
            transform="translate(-37.142 -22.128)"
            fill="#263238"
          />
          <path
            data-name="Path 4672"
            d="M247.316 131.275c-.023 0-.162-.3-.457-.764a7 7 0 00-3.238-2.69c-.507-.206-.837-.278-.837-.312a.851.851 0 01.24.034 4.562 4.562 0 01.632.183 6.326 6.326 0 013.289 2.732 4.482 4.482 0 01.3.588c.055.154.082.229.071.229z"
            transform="translate(-36.759 -18.852)"
            fill="#263238"
          />
          <path
            data-name="Path 4673"
            d="M250.329 132.975l-8.421 13.077 2.076 1.068 8.326-12.152z"
            transform="translate(-36.627 -19.679)"
            fill="#263238"
          />
          <path
            data-name="Path 4674"
            d="M193.985 184.57l-6.41.558-1.452-1.566c-.705-.732-1.168-.025-1.9.681l-8.966 8.593s.44 1.3 1.371.95 8.612-2.383 8.612-2.383l6.53-.357z"
            transform="translate(-26.535 -27.292)"
            fill="#fafafa"
          />
          <path
            data-name="Path 4675"
            d="M194.058 184.626a.537.537 0 01-.034.109l-.105.329-.427 1.28c-.382 1.129-.928 2.756-1.608 4.774v.033h-.036l-6.536.371-4.763 1.285-2.567.72c-.434.125-.87.25-1.307.4a.86.86 0 01-.725-.083 1.6 1.6 0 01-.494-.535 2.4 2.4 0 01-.187-.4l-.014-.042.033-.034 6.787-6.5c1.037-.992 2.018-1.918 2.927-2.8a1.274 1.274 0 01.415-.25.613.613 0 01.247-.033.631.631 0 01.241.066 1.268 1.268 0 01.367.278l.3.323 1.115 1.219-.039-.014 4.716-.387 1.257-.1.323-.025h.106a1.1 1.1 0 01-.117.014l-.332.033-1.271.126-4.674.44h-.025l-.017-.02-1.131-1.203a2.694 2.694 0 00-.633-.585.509.509 0 00-.2-.053.522.522 0 00-.2.028 1.225 1.225 0 00-.377.232c-.892.877-1.878 1.814-2.91 2.809l-6.769 6.516.02-.075a2.2 2.2 0 00.172.367 1.454 1.454 0 00.443.485.711.711 0 00.608.07c.432-.148.876-.278 1.31-.4l2.567-.716 4.78-1.285 6.533-.34-.045.034 1.651-4.719.454-1.285c.05-.142.092-.254.12-.337z"
            transform="translate(-26.535 -27.292)"
            fill="#263238"
          />
          <path
            data-name="Path 4676"
            d="M185.215 185.285c.017-.02.2.137.535.312a3.345 3.345 0 002.851.154c.355-.14.558-.279.558-.254a1.433 1.433 0 01-.521.354 3.093 3.093 0 01-2.949-.159 1.476 1.476 0 01-.474-.407z"
            transform="translate(-28.043 -27.599)"
            fill="#263238"
          />
          <path
            data-name="Path 4677"
            d="M178.474 191.628a.96.96 0 01.4.245 1.983 1.983 0 01.605.961 2.725 2.725 0 01.061 1.129 1.209 1.209 0 01-.12.451 1.74 1.74 0 010-.46 3.445 3.445 0 00-.1-1.079 2.231 2.231 0 00-.532-.925c-.188-.196-.329-.302-.314-.322z"
            transform="translate(-27.022 -28.56)"
            fill="#263238"
          />
          <path
            data-name="Path 4678"
            d="M237.614 154.279l.462 2.269-2.188 2a10.475 10.475 0 00-4.912 9.917l-7.845 9.1s-12.559 1.779-15.912 2.3c-2.788.432-13.387.248-13.387.248l.388 6.617s26.182 1.939 27.858 1.791c3.345-.278 5.9.5 8.64-1.791 1.981-1.648 15.556-15.149 15.556-15.149l-.109-18.445z"
            transform="translate(-29.348 -22.731)"
            fill="#263238"
          />
          <path
            data-name="Path 4679"
            d="M161.692 98.927s11.857 6.874 14.379 8.479 6.274 2.461 7.9 4.1c1.263 1.265 7.685 6.028 9.831 6.561s2.706-7.47 2.706-7.47-9.928-6.759-12.428-8.227-20.513-7.423-20.513-7.423z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4680"
            d="M232.643 136.836c-.022 0-.162-.337-.432-.872a11.831 11.831 0 00-2.868-3.646c-.454-.39-.758-.605-.744-.627a1 1 0 01.229.128 6.86 6.86 0 01.582.418 10.179 10.179 0 012.907 3.681c.1.216.2.438.278.664a.889.889 0 01.048.254z"
            transform="translate(-34.612 -19.485)"
            fill="#263238"
          />
          <path
            data-name="Path 4681"
            d="M155.173 97.472s2.149 1.873 2.74 1.935a40.366 40.366 0 004.052-.524l1.937-3.74s-3.3-2.623-4.066-3.03-5.3-1.792-5.3-1.792a.412.412 0 00-.148.092.4.4 0 00-.115.318.393.393 0 00.054.165s-1.51-.959-1.987-.084a.351.351 0 00-.162-.075.355.355 0 00-.412.27 1 1 0 00-.072.423 1.02 1.02 0 00.108.414s-.6.558-.187 1.1a35.677 35.677 0 003.484 2.681l1.374 1.425s-1.215-.931-1.695-.92-.4.571-.4.571z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4682"
            d="M183.216 110.626a48.67 48.67 0 01-4.379-2.9 48.511 48.511 0 014.379 2.9z"
            transform="translate(-27.077 -15.856)"
            fill="#263238"
          />
          <path
            data-name="Path 4683"
            d="M183.99 109.246a4.454 4.454 0 01-.655-.373l-1.538-.95c-.6-.376-1.148-.716-1.536-.972a3.871 3.871 0 01-.614-.44 3.852 3.852 0 01.666.354c.4.232.956.558 1.558.933s1.146.725 1.527.989a3.412 3.412 0 01.591.46z"
            transform="translate(-27.2 -15.672)"
            fill="#263238"
          />
          <path
            data-name="Path 4684"
            d="M185.33 108.17a1.345 1.345 0 01-.248-.122l-.692-.362c-.6-.3-1.454-.728-2.489-1.21l-.031-.014v-.034a1.393 1.393 0 01-.017-.309.339.339 0 01.056-.187.343.343 0 01.15-.123h.02l2.788.909 1.407.465c.229.076.451.145.67.226a4.47 4.47 0 01.6.349c.73.5 1.359.981 1.886 1.393s.95.742 1.237.976l.332.278a.74.74 0 01.109.1.654.654 0 01-.128-.081l-.345-.253-1.254-.948c-.535-.393-1.17-.867-1.9-1.354a4.618 4.618 0 00-.558-.332c-.212-.076-.44-.145-.666-.221l-1.393-.462-2.788-.92h.031c-.042 0-.092.106-.1.193a.955.955 0 000 .278l-.037-.048a54.7 54.7 0 012.472 1.26l.675.39a1.4 1.4 0 01.215.159z"
            transform="translate(-27.534 -15.566)"
            fill="#263238"
          />
          <path
            data-name="Path 4685"
            d="M186.48 114.532a1.868 1.868 0 01-.6-.089 4.918 4.918 0 01-2.456-1.519 1.773 1.773 0 01-.343-.5 6.581 6.581 0 003.392 2.1z"
            transform="translate(-27.721 -16.568)"
            fill="#263238"
          />
          <path
            data-name="Path 4686"
            d="M281.223 181.845l.367 8.821-.044 2.135c0 1.017.836.837 1.839.837l12.417.061s.591-1.246-.323-1.639-7.838-4.259-7.838-4.259l.451-6.522z"
            transform="translate(-42.579 -26.993)"
            fill="#fafafa"
          />
          <path
            data-name="Path 4687"
            d="M281.222 181.836a.52.52 0 01.115-.017l.345-.033 1.352-.123 5.053-.446h.059v.059c-.126 1.851-.279 4.066-.438 6.525l-.033-.062 4.5 2.478c.794.435 1.608.878 2.441 1.319l.632.326c.109.053.21.1.323.156a.853.853 0 01.165.1.534.534 0 01.137.139 1.028 1.028 0 01.193.733 2.29 2.29 0 01-.19.73l-.031.034h-.8l-9.727-.053h-2.182a4.968 4.968 0 01-1.059-.042.7.7 0 01-.258-.1.685.685 0 01-.2-.193.964.964 0 01-.134-.513q.025-1 .042-1.926c0-.616-.036-1.213-.053-1.778-.081-2.258-.15-4.086-.2-5.36l-.05-1.449v-.373a.746.746 0 010-.123v.134a3.048 3.048 0 00.02.382c.02.339.042.836.076 1.46l.25 5.34c.02.558.07 1.151.062 1.767s-.02 1.257-.031 1.923a.807.807 0 00.114.446.584.584 0 00.166.16.6.6 0 00.216.083 5.023 5.023 0 001.029.033h2.185l9.727.042h.755l-.064.039a2.121 2.121 0 00.175-.677.883.883 0 00-.159-.632 1.528 1.528 0 00-.577-.36l-.632-.329c-.837-.44-1.651-.886-2.445-1.32l-4.492-2.489-.034-.02v-.039l.466-6.522.053.053-5.017.388-1.363.1-.356.025z"
            transform="translate(-42.579 -26.984)"
            fill="#263238"
          />
          <path
            data-name="Path 4688"
            d="M284.348 195.238c-.025 0-.048-.234-.167-.6a3.407 3.407 0 00-.736-1.263 3.454 3.454 0 00-1.2-.836c-.351-.143-.588-.184-.586-.21a1.447 1.447 0 01.622.109 3.09 3.09 0 012.009 2.162 1.371 1.371 0 01.061.633z"
            transform="translate(-42.645 -28.666)"
            fill="#263238"
          />
          <path
            data-name="Path 4689"
            d="M294.063 195.414a.948.948 0 01-.115-.455 2.021 2.021 0 01.232-1.115 2.759 2.759 0 01.744-.849 1.222 1.222 0 01.4-.243 2.921 2.921 0 01-.332.323 3.386 3.386 0 00-.677.836 2.21 2.21 0 00-.26 1.034 2.469 2.469 0 01.006.468z"
            transform="translate(-44.505 -28.73)"
            fill="#263238"
          />
          <path
            data-name="Path 4690"
            d="M260.186 151.847l.254 2.043s13.88-3.551 18.683-3.551c2.767 0 5.641 3.155 5.092 8.2-.608 5.574-2.045 24.249-2.045 24.249l-6.327.44s-1.617-10.951-1.74-15.051a25.833 25.833 0 01.343-5.5 47.284 47.284 0 01-6.753 3.9c-2.539 1.115-9.658 5.068-15.516 4.716-5.574-.332-8.69-4.4-8.1-8.981.666-5.178 3.311-7.219 3.311-7.219l6.382-2.355z"
            transform="translate(-36.944 -22.308)"
            fill="#263238"
          />
          <path
            data-name="Path 4691"
            d="M253.872 172.37a1.1 1.1 0 01-.209.042 5.19 5.19 0 01-.605.075 8 8 0 01-2.23-.142 9.166 9.166 0 01-1.488-.443 9.292 9.292 0 01-1.581-.817 8.083 8.083 0 01-3.8-6.856 9.4 9.4 0 01.145-1.773 9.105 9.105 0 01.421-1.492 7.886 7.886 0 011.066-1.964 5.111 5.111 0 01.384-.471 1.263 1.263 0 01.145-.156 1.226 1.226 0 01-.123.172c-.077.115-.22.279-.359.488a8.35 8.35 0 00-1.014 1.967 8.8 8.8 0 00-.527 3.227 8.043 8.043 0 003.738 6.754 8.812 8.812 0 003.016 1.265 8.533 8.533 0 002.207.187c.262 0 .466-.042.6-.05a1.27 1.27 0 01.212-.012z"
            transform="translate(-36.938 -23.524)"
            fill="#263238"
          />
          <path
            data-name="Path 4692"
            d="M264.535 153.882c0 .039-1.324.451-2.982.926s-3.011.822-3.022.783 1.324-.451 2.983-.922 3.021-.826 3.021-.787z"
            transform="translate(-39.144 -22.844)"
            fill="#263238"
          />
          <path
            data-name="Path 4693"
            d="M282.342 159.536a6.816 6.816 0 01-.557.693A12.725 12.725 0 00280.6 162a12.974 12.974 0 00-.861 1.951 8.152 8.152 0 01-.293.837.832.832 0 01.034-.238 6.462 6.462 0 01.159-.632 10.309 10.309 0 012.062-3.743 5.783 5.783 0 01.449-.474c.12-.101.184-.165.192-.165z"
            transform="translate(-42.311 -23.701)"
            fill="#263238"
          />
          <path
            data-name="Path 4694"
            d="M200.717 166.99h55.148"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4695"
            d="M8.486 166.99h186.717"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export function GetHelpBoxImage(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 335,
    height: 53.274,
    ...rootStyle,
  };

  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 335 53.274"
    {...rest}
    sx={rootSx}
  >
  <g id="Group_105745" data-name="Group 105745" transform="translate(-20 -237.863)">
    <g id="Rectangle_44597" data-name="Rectangle 44597" transform="translate(20 238)" fill="#fff" stroke="#ffe0e2" strokeWidth="1">
      <rect width="335" height="53" rx="8" stroke="none"/>
      <rect x="0.5" y="0.5" width="334" height="52" rx="7.5" fill="none"/>
    </g>
    <path id="Path_96907" data-name="Path 96907" d="M8.126,0H72.473c4,0,7.25,3.582,7.25,8V45c0,4.418-3.246,8-7.25,8H-10Z" transform="translate(275.277 238)" fill="#ffe0e2"/>
    <path id="Path_96908" data-name="Path 96908" d="M5.682,1.7,0,18" transform="translate(263.5 272.5)" fill="none" stroke="#ffe0e2" strokeLinecap="round" strokeWidth="1"/>
    <line id="Line_1340" data-name="Line 1340" x1="7" y2="20" transform="translate(274.5 238.5)" fill="none" stroke="#ffe0e2" strokeLinecap="round" strokeWidth="1"/>
    <line id="Line_1341" data-name="Line 1341" x1="2" y2="6" transform="translate(276.5 238.5)" fill="none" stroke="#ffe0e2" strokeLinecap="round" strokeWidth="1"/>
  </g>
  </SvgIcon>;
}

export function ReportEmptyState(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 128.252,
    height: 118.438,
    ...rootStyle,
  };

  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 128.252 118.438"
    {...rest}
    sx={rootSx}
  >
   <g id="Notebook-bro" transform="translate(-77.798 -112.187)">
    <g id="freepik--background-simple--inject-1--inject-7" transform="translate(77.798 112.187)">
      <path id="Path_20625" data-name="Path 20625" d="M199.688,152.67c.327-1.875.852-3.73,1.228-5.64a33.34,33.34,0,0,0,.157-11.169,43.873,43.873,0,0,0-8.233-19.6c-4.586-6.152-11.482-11.134-18.894-9.252-7.711,1.949-14.238,7.9-21.737,10.609-12.7,4.593-25.557-3.779-38.355-3.48-11.051.24-22.645,4.207-29.924,14.016-2.972,4-5.042,9.395-4.339,14.7.859,6.462,5.6,11.378,9.137,16.159,5.421,7.328,7.474,15.31,2.912,23.863-3.083,5.8-7.23,10.919-6.872,18.118.574,11.517,11.208,18.473,19.976,21.573,8.908,3.152,19.023,3.48,27.878-.07,7.867-3.166,13.358-10.091,20.529-14.51a32.45,32.45,0,0,1,21.055-4.621c7.578.9,15.564,2.5,22.888-.769,7.008-3.132,10.327-11.5,10.588-19.52a32.063,32.063,0,0,0-1.778-11.775c-1.625-4.544-5.219-8.09-6.232-12.909a14.962,14.962,0,0,1,.014-5.717Z" transform="translate(-79.454 -106.601)" fill="#c5e8e2"/>
      <path id="Path_20626" data-name="Path 20626" d="M199.688,152.67c.327-1.875.852-3.73,1.228-5.64a33.34,33.34,0,0,0,.157-11.169,43.873,43.873,0,0,0-8.233-19.6c-4.586-6.152-11.482-11.134-18.894-9.252-7.711,1.949-14.238,7.9-21.737,10.609-12.7,4.593-25.557-3.779-38.355-3.48-11.051.24-22.645,4.207-29.924,14.016-2.972,4-5.042,9.395-4.339,14.7.859,6.462,5.6,11.378,9.137,16.159,5.421,7.328,7.474,15.31,2.912,23.863-3.083,5.8-7.23,10.919-6.872,18.118.574,11.517,11.208,18.473,19.976,21.573,8.908,3.152,19.023,3.48,27.878-.07,7.867-3.166,13.358-10.091,20.529-14.51a32.45,32.45,0,0,1,21.055-4.621c7.578.9,15.564,2.5,22.888-.769,7.008-3.132,10.327-11.5,10.588-19.52a32.063,32.063,0,0,0-1.778-11.775c-1.625-4.544-5.219-8.09-6.232-12.909a14.962,14.962,0,0,1,.014-5.717Z" transform="translate(-79.454 -106.601)" fill="#fff" opacity="0.7"/>
    </g>
    <path id="icons8-delete-file" d="M16.558,4A8.569,8.569,0,0,0,8,12.558V71.515a8.569,8.569,0,0,0,8.558,8.558H41.549a24.847,24.847,0,0,1-4.112-5.705H16.558a2.856,2.856,0,0,1-2.853-2.853V12.558a2.856,2.856,0,0,1,2.853-2.853H38.429V25.871a8.569,8.569,0,0,0,8.558,8.558H63.153v4.127a24.415,24.415,0,0,1,5.705,1.586V31.577a2.842,2.842,0,0,0-.836-2.017L43.3,4.836A2.842,2.842,0,0,0,41.282,4Zm27.577,9.739L59.119,28.724H46.988a2.856,2.856,0,0,1-2.853-2.853Zm15.215,28.3a20.92,20.92,0,1,0,20.92,20.92A20.92,20.92,0,0,0,59.349,42.037ZM49.84,51.546a1.9,1.9,0,0,1,1.345.557l8.165,8.164L67.514,52.1A1.9,1.9,0,1,1,70.2,54.792l-8.164,8.165L70.2,71.121a1.9,1.9,0,1,1-2.689,2.689l-8.165-8.164-8.165,8.164A1.9,1.9,0,0,1,48.5,71.121l8.164-8.165L48.5,54.792a1.9,1.9,0,0,1,1.345-3.246Z" transform="translate(97.905 127.252)" fill="#8fb7b0"/>
  </g>
  </SvgIcon>;
}
